var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}
parcelRequire.register("4zpiX", function(module, exports) {

module.exports = (parcelRequire("dO5NA"));

});
parcelRequire.register("dO5NA", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $dzKYE = parcelRequire("dzKYE");

var $4i3Tl = parcelRequire("4i3Tl");

var $6iqUa = parcelRequire("6iqUa");

var $1X85b = parcelRequire("1X85b");

var $a0d4716803010cf7$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $a0d4716803010cf7$var$_decode = $iHLHC((parcelRequire("42E6z")));

var $a0d4716803010cf7$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $a0d4716803010cf7$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $a0d4716803010cf7$var$_CryptoController = $iHLHC((parcelRequire("hf5sb")));

var $a0d4716803010cf7$var$_EventuallyQueue = $iHLHC((parcelRequire("cJKeG")));

var $a0d4716803010cf7$var$_InstallationController = $iHLHC((parcelRequire("i5Nxa")));

var $a0d4716803010cf7$var$ParseOp = $a0d4716803010cf7$var$_interopRequireWildcard((parcelRequire("3l0Qd")));

var $a0d4716803010cf7$var$_RESTController = $iHLHC((parcelRequire("dcLeF")));
function $a0d4716803010cf7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof $1X85b !== "function") return null;
    var cacheBabelInterop = new $1X85b();
    var cacheNodeInterop = new $1X85b();
    return ($a0d4716803010cf7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a0d4716803010cf7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $6iqUa(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a0d4716803010cf7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = $4i3Tl && $dzKYE ? $dzKYE(obj, key) : null;
        if (desc && (desc.get || desc.set)) $4i3Tl(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ /**
 * Contains all Parse API classes and functions.
 *
 * @static
 * @global
 * @class
 * @hideconstructor
 */ var $a0d4716803010cf7$var$Parse = {
    /**
   * Call this method first to set up your authentication tokens for Parse.
   *
   * @param {string} applicationId Your Parse Application ID.
   * @param {string} [javaScriptKey] Your Parse JavaScript Key (Not needed for parse-server)
   * @param {string} [masterKey] Your Parse Master Key. (Node.js only!)
   * @static
   */ initialize: function(applicationId, javaScriptKey) {
        if ($a0d4716803010cf7$var$_CoreManager.default.get("IS_NODE") && true) /* eslint-disable no-console */ console.log("It looks like you're using the browser version of the SDK in a node.js environment. You should require('parse/node') instead.");
        $a0d4716803010cf7$var$Parse._initialize(applicationId, javaScriptKey);
    },
    _initialize: function(applicationId, javaScriptKey, masterKey) {
        $a0d4716803010cf7$var$_CoreManager.default.set("APPLICATION_ID", applicationId);
        $a0d4716803010cf7$var$_CoreManager.default.set("JAVASCRIPT_KEY", javaScriptKey);
        $a0d4716803010cf7$var$_CoreManager.default.set("MASTER_KEY", masterKey);
        $a0d4716803010cf7$var$_CoreManager.default.set("USE_MASTER_KEY", false);
    },
    /**
   * Call this method to set your AsyncStorage engine
   * Starting Parse@1.11, the ParseSDK do not provide a React AsyncStorage as the ReactNative module
   * is not provided at a stable path and changes over versions.
   *
   * @param {AsyncStorage} storage a react native async storage.
   * @static
   */ setAsyncStorage: function(storage) {
        $a0d4716803010cf7$var$_CoreManager.default.setAsyncStorage(storage);
    },
    /**
   * Call this method to set your LocalDatastoreStorage engine
   * If using React-Native use {@link Parse.setAsyncStorage Parse.setAsyncStorage()}
   *
   * @param {LocalDatastoreController} controller a data storage.
   * @static
   */ setLocalDatastoreController: function(controller) {
        $a0d4716803010cf7$var$_CoreManager.default.setLocalDatastoreController(controller);
    },
    /**
   * Returns information regarding the current server's health
   *
   * @returns {Promise}
   * @static
   */ getServerHealth: function() {
        return $a0d4716803010cf7$var$_CoreManager.default.getRESTController().request("GET", "health");
    },
    /**
   * @member {string} Parse.applicationId
   * @static
   */ set applicationId (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("APPLICATION_ID", value);
    },
    get applicationId () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("APPLICATION_ID");
    },
    /**
   * @member {string} Parse.javaScriptKey
   * @static
   */ set javaScriptKey (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("JAVASCRIPT_KEY", value);
    },
    get javaScriptKey () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("JAVASCRIPT_KEY");
    },
    /**
   * @member {string} Parse.masterKey
   * @static
   */ set masterKey (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("MASTER_KEY", value);
    },
    get masterKey () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("MASTER_KEY");
    },
    /**
   * @member {string} Parse.serverURL
   * @static
   */ set serverURL (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("SERVER_URL", value);
    },
    get serverURL () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("SERVER_URL");
    },
    /**
   * @member {string} Parse.serverAuthToken
   * @static
   */ set serverAuthToken (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("SERVER_AUTH_TOKEN", value);
    },
    get serverAuthToken () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("SERVER_AUTH_TOKEN");
    },
    /**
   * @member {string} Parse.serverAuthType
   * @static
   */ set serverAuthType (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("SERVER_AUTH_TYPE", value);
    },
    get serverAuthType () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("SERVER_AUTH_TYPE");
    },
    /**
   * @member {string} Parse.liveQueryServerURL
   * @static
   */ set liveQueryServerURL (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("LIVEQUERY_SERVER_URL", value);
    },
    get liveQueryServerURL () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("LIVEQUERY_SERVER_URL");
    },
    /**
   * @member {string} Parse.encryptedUser
   * @static
   */ set encryptedUser (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("ENCRYPTED_USER", value);
    },
    get encryptedUser () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("ENCRYPTED_USER");
    },
    /**
   * @member {string} Parse.secret
   * @static
   */ set secret (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("ENCRYPTED_KEY", value);
    },
    get secret () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("ENCRYPTED_KEY");
    },
    /**
   * @member {boolean} Parse.idempotency
   * @static
   */ set idempotency (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("IDEMPOTENCY", value);
    },
    get idempotency () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("IDEMPOTENCY");
    },
    /**
   * @member {boolean} Parse.allowCustomObjectId
   * @static
   */ set allowCustomObjectId (value){
        $a0d4716803010cf7$var$_CoreManager.default.set("ALLOW_CUSTOM_OBJECT_ID", value);
    },
    get allowCustomObjectId () {
        return $a0d4716803010cf7$var$_CoreManager.default.get("ALLOW_CUSTOM_OBJECT_ID");
    }
};

$a0d4716803010cf7$var$Parse.ACL = (parcelRequire("2xGBa")).default;

$a0d4716803010cf7$var$Parse.Analytics = (parcelRequire("54Znm"));

$a0d4716803010cf7$var$Parse.AnonymousUtils = (parcelRequire("ffqks")).default;

$a0d4716803010cf7$var$Parse.Cloud = (parcelRequire("2YVFi"));

$a0d4716803010cf7$var$Parse.CLP = (parcelRequire("hnFLk")).default;

$a0d4716803010cf7$var$Parse.CoreManager = (parcelRequire("73D0B"));

$a0d4716803010cf7$var$Parse.Config = (parcelRequire("5K5Co")).default;

$a0d4716803010cf7$var$Parse.Error = (parcelRequire("6ilM0")).default;
$a0d4716803010cf7$var$Parse.EventuallyQueue = $a0d4716803010cf7$var$_EventuallyQueue.default;

$a0d4716803010cf7$var$Parse.FacebookUtils = (parcelRequire("iRjYO")).default;

$a0d4716803010cf7$var$Parse.File = (parcelRequire("59JWU")).default;

$a0d4716803010cf7$var$Parse.GeoPoint = (parcelRequire("jtZTC")).default;

$a0d4716803010cf7$var$Parse.Polygon = (parcelRequire("i8AKq")).default;

$a0d4716803010cf7$var$Parse.Installation = (parcelRequire("7nsYD")).default;

$a0d4716803010cf7$var$Parse.LocalDatastore = (parcelRequire("xW8Bi"));

$a0d4716803010cf7$var$Parse.Object = (parcelRequire("fMBjE")).default;
$a0d4716803010cf7$var$Parse.Op = {
    Set: $a0d4716803010cf7$var$ParseOp.SetOp,
    Unset: $a0d4716803010cf7$var$ParseOp.UnsetOp,
    Increment: $a0d4716803010cf7$var$ParseOp.IncrementOp,
    Add: $a0d4716803010cf7$var$ParseOp.AddOp,
    Remove: $a0d4716803010cf7$var$ParseOp.RemoveOp,
    AddUnique: $a0d4716803010cf7$var$ParseOp.AddUniqueOp,
    Relation: $a0d4716803010cf7$var$ParseOp.RelationOp
};

$a0d4716803010cf7$var$Parse.Push = (parcelRequire("3Jcx2"));

$a0d4716803010cf7$var$Parse.Query = (parcelRequire("4FVCr")).default;

$a0d4716803010cf7$var$Parse.Relation = (parcelRequire("967gW")).default;

$a0d4716803010cf7$var$Parse.Role = (parcelRequire("7MXHA")).default;

$a0d4716803010cf7$var$Parse.Schema = (parcelRequire("9xpH4")).default;

$a0d4716803010cf7$var$Parse.Session = (parcelRequire("b7rpJ")).default;

$a0d4716803010cf7$var$Parse.Storage = (parcelRequire("7GXKV"));

$a0d4716803010cf7$var$Parse.User = (parcelRequire("iQ4JH")).default;

$a0d4716803010cf7$var$Parse.LiveQuery = (parcelRequire("heN8G")).default;

$a0d4716803010cf7$var$Parse.LiveQueryClient = (parcelRequire("b2fSd")).default;

$a0d4716803010cf7$var$Parse.IndexedDB = (parcelRequire("b4vvz"));
$a0d4716803010cf7$var$Parse._request = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return $a0d4716803010cf7$var$_CoreManager.default.getRESTController().request.apply(null, args);
};
$a0d4716803010cf7$var$Parse._ajax = function() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    return $a0d4716803010cf7$var$_CoreManager.default.getRESTController().ajax.apply(null, args);
}; // We attempt to match the signatures of the legacy versions of these methods
$a0d4716803010cf7$var$Parse._decode = function(_, value1) {
    return (0, $a0d4716803010cf7$var$_decode.default)(value1);
};
$a0d4716803010cf7$var$Parse._encode = function(value1, _, disallowObjects) {
    return (0, $a0d4716803010cf7$var$_encode.default)(value1, disallowObjects);
};
$a0d4716803010cf7$var$Parse._getInstallationId = function() {
    return $a0d4716803010cf7$var$_CoreManager.default.getInstallationController().currentInstallationId();
};
/**
 * Enable pinning in your application.
 * This must be called after `Parse.initialize` in your application.
 *
 * @param [polling] Allow pinging the server /health endpoint. Default true
 * @param [ms] Milliseconds to ping the server. Default 2000ms
 * @static
 */ $a0d4716803010cf7$var$Parse.enableLocalDatastore = function() {
    var polling = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
    if (!$a0d4716803010cf7$var$Parse.applicationId) {
        console.log("'enableLocalDataStore' must be called after 'initialize'");
        return;
    }
    if (!$a0d4716803010cf7$var$Parse.LocalDatastore.isEnabled) {
        $a0d4716803010cf7$var$Parse.LocalDatastore.isEnabled = true;
        if (polling) $a0d4716803010cf7$var$_EventuallyQueue.default.poll(ms);
    }
};
/**
 * Flag that indicates whether Local Datastore is enabled.
 *
 * @static
 * @returns {boolean}
 */ $a0d4716803010cf7$var$Parse.isLocalDatastoreEnabled = function() {
    return $a0d4716803010cf7$var$Parse.LocalDatastore.isEnabled;
};
/**
 * Gets all contents from Local Datastore
 *
 * <pre>
 * await Parse.dumpLocalDatastore();
 * </pre>
 *
 * @static
 * @returns {object}
 */ $a0d4716803010cf7$var$Parse.dumpLocalDatastore = function() {
    if (!$a0d4716803010cf7$var$Parse.LocalDatastore.isEnabled) {
        console.log("Parse.enableLocalDatastore() must be called first"); // eslint-disable-line no-console
        return $a0d4716803010cf7$var$_promise.default.resolve({});
    } else return $a0d4716803010cf7$var$Parse.LocalDatastore._getAllContents();
};
/**
 * Enable the current user encryption.
 * This must be called before login any user.
 *
 * @static
 */ $a0d4716803010cf7$var$Parse.enableEncryptedUser = function() {
    $a0d4716803010cf7$var$Parse.encryptedUser = true;
};
/**
 * Flag that indicates whether Encrypted User is enabled.
 *
 * @static
 * @returns {boolean}
 */ $a0d4716803010cf7$var$Parse.isEncryptedUserEnabled = function() {
    return $a0d4716803010cf7$var$Parse.encryptedUser;
};
$a0d4716803010cf7$var$_CoreManager.default.setCryptoController($a0d4716803010cf7$var$_CryptoController.default);
$a0d4716803010cf7$var$_CoreManager.default.setInstallationController($a0d4716803010cf7$var$_InstallationController.default);
$a0d4716803010cf7$var$_CoreManager.default.setRESTController($a0d4716803010cf7$var$_RESTController.default);
// For legacy requires, of the form `var Parse = require('parse').Parse`
$a0d4716803010cf7$var$Parse.Parse = $a0d4716803010cf7$var$Parse;
module.exports = $a0d4716803010cf7$var$Parse;

});
parcelRequire.register("iHLHC", function(module, exports) {
function $d9e13eddec1cce9d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $d9e13eddec1cce9d$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("dzKYE", function(module, exports) {

module.exports = (parcelRequire("jDHFu"));

});
parcelRequire.register("jDHFu", function(module, exports) {

var $ji3LA = parcelRequire("ji3LA");
module.exports = $ji3LA;

});
parcelRequire.register("ji3LA", function(module, exports) {
parcelRequire("hFHob");

var $ly30u = parcelRequire("ly30u");
var $e0b29eb8ac6b80f9$var$Object = $ly30u.Object;
var $e0b29eb8ac6b80f9$var$getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
    return $e0b29eb8ac6b80f9$var$Object.getOwnPropertyDescriptor(it, key);
};
if ($e0b29eb8ac6b80f9$var$Object.getOwnPropertyDescriptor.sham) $e0b29eb8ac6b80f9$var$getOwnPropertyDescriptor.sham = true;

});
parcelRequire.register("hFHob", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $77TPA = parcelRequire("77TPA");

var $bYkAs = parcelRequire("bYkAs");

var $fTFId = parcelRequire("fTFId");
var $cdd7ec27ab46eac9$require$nativeGetOwnPropertyDescriptor = $fTFId.f;

var $jeZ4p = parcelRequire("jeZ4p");
var $cdd7ec27ab46eac9$var$FORCED = !$jeZ4p || $77TPA(function() {
    $cdd7ec27ab46eac9$require$nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$ggcsv({
    target: "Object",
    stat: true,
    forced: $cdd7ec27ab46eac9$var$FORCED,
    sham: !$jeZ4p
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return $cdd7ec27ab46eac9$require$nativeGetOwnPropertyDescriptor($bYkAs(it), key);
    }
});

});
parcelRequire.register("ggcsv", function(module, exports) {
"use strict";

var $3pyVf = parcelRequire("3pyVf");

var $2JOsI = parcelRequire("2JOsI");

var $5FNR6 = parcelRequire("5FNR6");

var $e6Rz5 = parcelRequire("e6Rz5");

var $fTFId = parcelRequire("fTFId");
var $bd67cdff1139f731$require$getOwnPropertyDescriptor = $fTFId.f;

var $iaZZ9 = parcelRequire("iaZZ9");

var $ly30u = parcelRequire("ly30u");

var $b5UsH = parcelRequire("b5UsH");

var $k4kcW = parcelRequire("k4kcW");

var $heVlo = parcelRequire("heVlo");
var $bd67cdff1139f731$var$wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $2JOsI(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $3pyVf : STATIC ? $3pyVf[TARGET] : ($3pyVf[TARGET] || {}).prototype;
    var target = GLOBAL ? $ly30u : $ly30u[TARGET] || $k4kcW($ly30u, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $iaZZ9(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $heVlo(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $bd67cdff1139f731$require$getOwnPropertyDescriptor(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $b5UsH(sourceProperty, $3pyVf);
        else if (options.wrap && USE_NATIVE) resultProperty = $bd67cdff1139f731$var$wrapConstructor(sourceProperty);
        else if (PROTO && $e6Rz5(sourceProperty)) resultProperty = $5FNR6(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $k4kcW(resultProperty, "sham", true);
        $k4kcW(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + "Prototype";
            if (!$heVlo($ly30u, VIRTUAL_PROTOTYPE)) $k4kcW($ly30u, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $k4kcW($ly30u[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $k4kcW(targetPrototype, key, sourceProperty);
        }
    }
};

});
parcelRequire.register("3pyVf", function(module, exports) {
var $27becbbd8683e291$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$27becbbd8683e291$var$check(typeof globalThis == "object" && globalThis) || $27becbbd8683e291$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$27becbbd8683e291$var$check(typeof self == "object" && self) || $27becbbd8683e291$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || module.exports || Function("return this")();

});

parcelRequire.register("2JOsI", function(module, exports) {

var $4abbf = parcelRequire("4abbf");
var $1fe6ed77f53bfcf9$var$FunctionPrototype = Function.prototype;
var $1fe6ed77f53bfcf9$var$apply = $1fe6ed77f53bfcf9$var$FunctionPrototype.apply;
var $1fe6ed77f53bfcf9$var$call = $1fe6ed77f53bfcf9$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == "object" && Reflect.apply || ($4abbf ? $1fe6ed77f53bfcf9$var$call.bind($1fe6ed77f53bfcf9$var$apply) : function() {
    return $1fe6ed77f53bfcf9$var$call.apply($1fe6ed77f53bfcf9$var$apply, arguments);
});

});
parcelRequire.register("4abbf", function(module, exports) {

var $77TPA = parcelRequire("77TPA");
module.exports = !$77TPA(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});

});
parcelRequire.register("77TPA", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});



parcelRequire.register("5FNR6", function(module, exports) {

var $bTsfg = parcelRequire("bTsfg");

var $f518o = parcelRequire("f518o");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($bTsfg(fn) === "Function") return $f518o(fn);
};

});
parcelRequire.register("bTsfg", function(module, exports) {

var $f518o = parcelRequire("f518o");
var $8a8abdadef2cf5c0$var$toString = $f518o({}.toString);
var $8a8abdadef2cf5c0$var$stringSlice = $f518o("".slice);
module.exports = function(it) {
    return $8a8abdadef2cf5c0$var$stringSlice($8a8abdadef2cf5c0$var$toString(it), 8, -1);
};

});
parcelRequire.register("f518o", function(module, exports) {

var $4abbf = parcelRequire("4abbf");
var $afa833e25d010c4e$var$FunctionPrototype = Function.prototype;
var $afa833e25d010c4e$var$call = $afa833e25d010c4e$var$FunctionPrototype.call;
var $afa833e25d010c4e$var$uncurryThisWithBind = $4abbf && $afa833e25d010c4e$var$FunctionPrototype.bind.bind($afa833e25d010c4e$var$call, $afa833e25d010c4e$var$call);
module.exports = $4abbf ? $afa833e25d010c4e$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $afa833e25d010c4e$var$call.apply(fn, arguments);
    };
};

});



parcelRequire.register("e6Rz5", function(module, exports) {

var $5PUjQ = parcelRequire("5PUjQ");
var $a45b2d1e9ff03254$var$documentAll = $5PUjQ.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $5PUjQ.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $a45b2d1e9ff03254$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};

});
parcelRequire.register("5PUjQ", function(module, exports) {
var $43fd66fa6c912cd2$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $43fd66fa6c912cd2$var$IS_HTMLDDA = typeof $43fd66fa6c912cd2$var$documentAll == "undefined" && $43fd66fa6c912cd2$var$documentAll !== undefined;
module.exports = {
    all: $43fd66fa6c912cd2$var$documentAll,
    IS_HTMLDDA: $43fd66fa6c912cd2$var$IS_HTMLDDA
};

});


parcelRequire.register("fTFId", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $b92c593844a00ebc$export$2d1720544b23b823; }, function (v) { return $b92c593844a00ebc$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $b92c593844a00ebc$export$2d1720544b23b823;

var $jeZ4p = parcelRequire("jeZ4p");

var $aELZY = parcelRequire("aELZY");

var $d5uYy = parcelRequire("d5uYy");

var $8c6fn = parcelRequire("8c6fn");

var $bYkAs = parcelRequire("bYkAs");

var $eBk19 = parcelRequire("eBk19");

var $heVlo = parcelRequire("heVlo");

var $9E0l8 = parcelRequire("9E0l8");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b92c593844a00ebc$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$b92c593844a00ebc$export$2d1720544b23b823 = $jeZ4p ? $b92c593844a00ebc$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $bYkAs(O);
    P = $eBk19(P);
    if ($9E0l8) try {
        return $b92c593844a00ebc$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($heVlo(O, P)) return $8c6fn(!$aELZY($d5uYy.f, O, P), O[P]);
};

});
parcelRequire.register("jeZ4p", function(module, exports) {

var $77TPA = parcelRequire("77TPA");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$77TPA(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});

});

parcelRequire.register("aELZY", function(module, exports) {

var $4abbf = parcelRequire("4abbf");
var $7c22df5888774151$var$call = Function.prototype.call;
module.exports = $4abbf ? $7c22df5888774151$var$call.bind($7c22df5888774151$var$call) : function() {
    return $7c22df5888774151$var$call.apply($7c22df5888774151$var$call, arguments);
};

});

parcelRequire.register("d5uYy", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $9873c51cd09bc8e8$export$2d1720544b23b823; }, function (v) { return $9873c51cd09bc8e8$export$2d1720544b23b823 = v; });
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $9873c51cd09bc8e8$export$2d1720544b23b823;
"use strict";
var $9873c51cd09bc8e8$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9873c51cd09bc8e8$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $9873c51cd09bc8e8$var$NASHORN_BUG = $9873c51cd09bc8e8$var$getOwnPropertyDescriptor && !$9873c51cd09bc8e8$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$9873c51cd09bc8e8$export$2d1720544b23b823 = $9873c51cd09bc8e8$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $9873c51cd09bc8e8$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $9873c51cd09bc8e8$var$$propertyIsEnumerable;

});

parcelRequire.register("8c6fn", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRequire.register("bYkAs", function(module, exports) {
// toObject with fallback for non-array-like ES3 strings

var $lEtn3 = parcelRequire("lEtn3");

var $cBWnS = parcelRequire("cBWnS");
module.exports = function(it) {
    return $lEtn3($cBWnS(it));
};

});
parcelRequire.register("lEtn3", function(module, exports) {

var $f518o = parcelRequire("f518o");

var $77TPA = parcelRequire("77TPA");

var $bTsfg = parcelRequire("bTsfg");
var $fc341dd70e1b0620$var$$Object = Object;
var $fc341dd70e1b0620$var$split = $f518o("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $77TPA(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$fc341dd70e1b0620$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $bTsfg(it) == "String" ? $fc341dd70e1b0620$var$split(it, "") : $fc341dd70e1b0620$var$$Object(it);
} : $fc341dd70e1b0620$var$$Object;

});

parcelRequire.register("cBWnS", function(module, exports) {

var $6exeg = parcelRequire("6exeg");
var $92e63aa0587dfa53$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($6exeg(it)) throw $92e63aa0587dfa53$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRequire.register("6exeg", function(module, exports) {
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});



parcelRequire.register("eBk19", function(module, exports) {

var $axnyg = parcelRequire("axnyg");

var $jpeSb = parcelRequire("jpeSb");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $axnyg(argument, "string");
    return $jpeSb(key) ? key : key + "";
};

});
parcelRequire.register("axnyg", function(module, exports) {

var $aELZY = parcelRequire("aELZY");

var $1WYwK = parcelRequire("1WYwK");

var $jpeSb = parcelRequire("jpeSb");

var $k0Syp = parcelRequire("k0Syp");

var $abNh0 = parcelRequire("abNh0");

var $fq7H3 = parcelRequire("fq7H3");
var $7abf4150ed03b059$var$$TypeError = TypeError;
var $7abf4150ed03b059$var$TO_PRIMITIVE = $fq7H3("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$1WYwK(input) || $jpeSb(input)) return input;
    var exoticToPrim = $k0Syp(input, $7abf4150ed03b059$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $aELZY(exoticToPrim, input, pref);
        if (!$1WYwK(result) || $jpeSb(result)) return result;
        throw $7abf4150ed03b059$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $abNh0(input, pref);
};

});
parcelRequire.register("1WYwK", function(module, exports) {

var $e6Rz5 = parcelRequire("e6Rz5");

var $5PUjQ = parcelRequire("5PUjQ");
var $16ba28a4edcb36df$var$documentAll = $5PUjQ.all;
module.exports = $5PUjQ.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $e6Rz5(it) || it === $16ba28a4edcb36df$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $e6Rz5(it);
};

});

parcelRequire.register("jpeSb", function(module, exports) {

var $5Pobw = parcelRequire("5Pobw");

var $e6Rz5 = parcelRequire("e6Rz5");

var $8hsAO = parcelRequire("8hsAO");

var $73gki = parcelRequire("73gki");
var $e20be38f1a7713cb$var$$Object = Object;
module.exports = $73gki ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $5Pobw("Symbol");
    return $e6Rz5($Symbol) && $8hsAO($Symbol.prototype, $e20be38f1a7713cb$var$$Object(it));
};

});
parcelRequire.register("5Pobw", function(module, exports) {

var $ly30u = parcelRequire("ly30u");

var $3pyVf = parcelRequire("3pyVf");

var $e6Rz5 = parcelRequire("e6Rz5");
var $43e479c85e4cf48d$var$aFunction = function(variable) {
    return $e6Rz5(variable) ? variable : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $43e479c85e4cf48d$var$aFunction($ly30u[namespace]) || $43e479c85e4cf48d$var$aFunction($3pyVf[namespace]) : $ly30u[namespace] && $ly30u[namespace][method] || $3pyVf[namespace] && $3pyVf[namespace][method];
};

});
parcelRequire.register("ly30u", function(module, exports) {
module.exports = {};

});


parcelRequire.register("8hsAO", function(module, exports) {

var $f518o = parcelRequire("f518o");
module.exports = $f518o({}.isPrototypeOf);

});

parcelRequire.register("73gki", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $e1lwM = parcelRequire("e1lwM");
module.exports = $e1lwM && !Symbol.sham && typeof Symbol.iterator == "symbol";

});
parcelRequire.register("e1lwM", function(module, exports) {
/* eslint-disable es/no-symbol -- required for testing */ 
var $1MzR6 = parcelRequire("1MzR6");

var $77TPA = parcelRequire("77TPA");

var $3pyVf = parcelRequire("3pyVf");
var $a351dba3dcb94263$var$$String = $3pyVf.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$77TPA(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$a351dba3dcb94263$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $1MzR6 && $1MzR6 < 41;
});

});
parcelRequire.register("1MzR6", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");

var $4Hrut = parcelRequire("4Hrut");
var $14c6164d9c9bce80$var$process = $3pyVf.process;
var $14c6164d9c9bce80$var$Deno = $3pyVf.Deno;
var $14c6164d9c9bce80$var$versions = $14c6164d9c9bce80$var$process && $14c6164d9c9bce80$var$process.versions || $14c6164d9c9bce80$var$Deno && $14c6164d9c9bce80$var$Deno.version;
var $14c6164d9c9bce80$var$v8 = $14c6164d9c9bce80$var$versions && $14c6164d9c9bce80$var$versions.v8;
var $14c6164d9c9bce80$var$match, $14c6164d9c9bce80$var$version;
if ($14c6164d9c9bce80$var$v8) {
    $14c6164d9c9bce80$var$match = $14c6164d9c9bce80$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $14c6164d9c9bce80$var$version = $14c6164d9c9bce80$var$match[0] > 0 && $14c6164d9c9bce80$var$match[0] < 4 ? 1 : +($14c6164d9c9bce80$var$match[0] + $14c6164d9c9bce80$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$14c6164d9c9bce80$var$version && $4Hrut) {
    $14c6164d9c9bce80$var$match = $4Hrut.match(/Edge\/(\d+)/);
    if (!$14c6164d9c9bce80$var$match || $14c6164d9c9bce80$var$match[1] >= 74) {
        $14c6164d9c9bce80$var$match = $4Hrut.match(/Chrome\/(\d+)/);
        if ($14c6164d9c9bce80$var$match) $14c6164d9c9bce80$var$version = +$14c6164d9c9bce80$var$match[1];
    }
}
module.exports = $14c6164d9c9bce80$var$version;

});
parcelRequire.register("4Hrut", function(module, exports) {
module.exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";

});





parcelRequire.register("k0Syp", function(module, exports) {

var $8GsPx = parcelRequire("8GsPx");

var $6exeg = parcelRequire("6exeg");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $6exeg(func) ? undefined : $8GsPx(func);
};

});
parcelRequire.register("8GsPx", function(module, exports) {

var $e6Rz5 = parcelRequire("e6Rz5");

var $k9gzN = parcelRequire("k9gzN");
var $65289c1234f4e46d$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($e6Rz5(argument)) return argument;
    throw $65289c1234f4e46d$var$$TypeError($k9gzN(argument) + " is not a function");
};

});
parcelRequire.register("k9gzN", function(module, exports) {
var $eab181a387a9eaa1$var$$String = String;
module.exports = function(argument) {
    try {
        return $eab181a387a9eaa1$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};

});



parcelRequire.register("abNh0", function(module, exports) {

var $aELZY = parcelRequire("aELZY");

var $e6Rz5 = parcelRequire("e6Rz5");

var $1WYwK = parcelRequire("1WYwK");
var $76b127166c30fd75$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $e6Rz5(fn = input.toString) && !$1WYwK(val = $aELZY(fn, input))) return val;
    if ($e6Rz5(fn = input.valueOf) && !$1WYwK(val = $aELZY(fn, input))) return val;
    if (pref !== "string" && $e6Rz5(fn = input.toString) && !$1WYwK(val = $aELZY(fn, input))) return val;
    throw $76b127166c30fd75$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRequire.register("fq7H3", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");

var $3hwUC = parcelRequire("3hwUC");

var $heVlo = parcelRequire("heVlo");

var $kuKGb = parcelRequire("kuKGb");

var $e1lwM = parcelRequire("e1lwM");

var $73gki = parcelRequire("73gki");
var $b39f40790c8b3bef$var$Symbol = $3pyVf.Symbol;
var $b39f40790c8b3bef$var$WellKnownSymbolsStore = $3hwUC("wks");
var $b39f40790c8b3bef$var$createWellKnownSymbol = $73gki ? $b39f40790c8b3bef$var$Symbol["for"] || $b39f40790c8b3bef$var$Symbol : $b39f40790c8b3bef$var$Symbol && $b39f40790c8b3bef$var$Symbol.withoutSetter || $kuKGb;
module.exports = function(name) {
    if (!$heVlo($b39f40790c8b3bef$var$WellKnownSymbolsStore, name)) $b39f40790c8b3bef$var$WellKnownSymbolsStore[name] = $e1lwM && $heVlo($b39f40790c8b3bef$var$Symbol, name) ? $b39f40790c8b3bef$var$Symbol[name] : $b39f40790c8b3bef$var$createWellKnownSymbol("Symbol." + name);
    return $b39f40790c8b3bef$var$WellKnownSymbolsStore[name];
};

});
parcelRequire.register("3hwUC", function(module, exports) {

var $7phdw = parcelRequire("7phdw");

var $bEwnT = parcelRequire("bEwnT");
(module.exports = function(key, value) {
    return $bEwnT[key] || ($bEwnT[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.31.0",
    mode: $7phdw ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});

});
parcelRequire.register("7phdw", function(module, exports) {
module.exports = true;

});

parcelRequire.register("bEwnT", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");

var $hvWkx = parcelRequire("hvWkx");
var $87bc8d05060220af$var$SHARED = "__core-js_shared__";
var $87bc8d05060220af$var$store = $3pyVf[$87bc8d05060220af$var$SHARED] || $hvWkx($87bc8d05060220af$var$SHARED, {});
module.exports = $87bc8d05060220af$var$store;

});
parcelRequire.register("hvWkx", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $cc029411f908d311$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $cc029411f908d311$var$defineProperty($3pyVf, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $3pyVf[key] = value;
    }
    return value;
};

});



parcelRequire.register("heVlo", function(module, exports) {

var $f518o = parcelRequire("f518o");

var $iJNxK = parcelRequire("iJNxK");
var $c8d039cb715f1306$var$hasOwnProperty = $f518o({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $c8d039cb715f1306$var$hasOwnProperty($iJNxK(it), key);
};

});
parcelRequire.register("iJNxK", function(module, exports) {

var $cBWnS = parcelRequire("cBWnS");
var $da42dc3c0500dd4c$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $da42dc3c0500dd4c$var$$Object($cBWnS(argument));
};

});


parcelRequire.register("kuKGb", function(module, exports) {

var $f518o = parcelRequire("f518o");
var $eebad18d7b7b98cf$var$id = 0;
var $eebad18d7b7b98cf$var$postfix = Math.random();
var $eebad18d7b7b98cf$var$toString = $f518o(1.0.toString);
module.exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $eebad18d7b7b98cf$var$toString(++$eebad18d7b7b98cf$var$id + $eebad18d7b7b98cf$var$postfix, 36);
};

});




parcelRequire.register("9E0l8", function(module, exports) {

var $jeZ4p = parcelRequire("jeZ4p");

var $77TPA = parcelRequire("77TPA");

var $kHYxY = parcelRequire("kHYxY");
// Thanks to IE8 for its funny defineProperty
module.exports = !$jeZ4p && !$77TPA(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($kHYxY("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRequire.register("kHYxY", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");

var $1WYwK = parcelRequire("1WYwK");
var $f136ca29978a4a35$var$document = $3pyVf.document;
// typeof document.createElement is 'object' in old IE
var $f136ca29978a4a35$var$EXISTS = $1WYwK($f136ca29978a4a35$var$document) && $1WYwK($f136ca29978a4a35$var$document.createElement);
module.exports = function(it) {
    return $f136ca29978a4a35$var$EXISTS ? $f136ca29978a4a35$var$document.createElement(it) : {};
};

});



parcelRequire.register("iaZZ9", function(module, exports) {

var $77TPA = parcelRequire("77TPA");

var $e6Rz5 = parcelRequire("e6Rz5");
var $d3b93e2220965ba3$var$replacement = /#|\.prototype\./;
var $d3b93e2220965ba3$var$isForced = function(feature, detection) {
    var value = $d3b93e2220965ba3$var$data[$d3b93e2220965ba3$var$normalize(feature)];
    return value == $d3b93e2220965ba3$var$POLYFILL ? true : value == $d3b93e2220965ba3$var$NATIVE ? false : $e6Rz5(detection) ? $77TPA(detection) : !!detection;
};
var $d3b93e2220965ba3$var$normalize = $d3b93e2220965ba3$var$isForced.normalize = function(string) {
    return String(string).replace($d3b93e2220965ba3$var$replacement, ".").toLowerCase();
};
var $d3b93e2220965ba3$var$data = $d3b93e2220965ba3$var$isForced.data = {};
var $d3b93e2220965ba3$var$NATIVE = $d3b93e2220965ba3$var$isForced.NATIVE = "N";
var $d3b93e2220965ba3$var$POLYFILL = $d3b93e2220965ba3$var$isForced.POLYFILL = "P";
module.exports = $d3b93e2220965ba3$var$isForced;

});

parcelRequire.register("b5UsH", function(module, exports) {

var $5FNR6 = parcelRequire("5FNR6");

var $8GsPx = parcelRequire("8GsPx");

var $4abbf = parcelRequire("4abbf");
var $813bf57ad4cb3874$var$bind = $5FNR6($5FNR6.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $8GsPx(fn);
    return that === undefined ? fn : $4abbf ? $813bf57ad4cb3874$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});

parcelRequire.register("k4kcW", function(module, exports) {

var $jeZ4p = parcelRequire("jeZ4p");

var $diq7r = parcelRequire("diq7r");

var $8c6fn = parcelRequire("8c6fn");
module.exports = $jeZ4p ? function(object, key, value) {
    return $diq7r.f(object, key, $8c6fn(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRequire.register("diq7r", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $9ae1377901c67661$export$2d1720544b23b823; }, function (v) { return $9ae1377901c67661$export$2d1720544b23b823 = v; });
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $9ae1377901c67661$export$2d1720544b23b823;

var $jeZ4p = parcelRequire("jeZ4p");

var $9E0l8 = parcelRequire("9E0l8");

var $5Shx3 = parcelRequire("5Shx3");

var $l3LMJ = parcelRequire("l3LMJ");

var $eBk19 = parcelRequire("eBk19");
var $9ae1377901c67661$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $9ae1377901c67661$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9ae1377901c67661$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9ae1377901c67661$var$ENUMERABLE = "enumerable";
var $9ae1377901c67661$var$CONFIGURABLE = "configurable";
var $9ae1377901c67661$var$WRITABLE = "writable";
$9ae1377901c67661$export$2d1720544b23b823 = $jeZ4p ? $5Shx3 ? function defineProperty(O, P, Attributes) {
    $l3LMJ(O);
    P = $eBk19(P);
    $l3LMJ(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $9ae1377901c67661$var$WRITABLE in Attributes && !Attributes[$9ae1377901c67661$var$WRITABLE]) {
        var current = $9ae1377901c67661$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$9ae1377901c67661$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $9ae1377901c67661$var$CONFIGURABLE in Attributes ? Attributes[$9ae1377901c67661$var$CONFIGURABLE] : current[$9ae1377901c67661$var$CONFIGURABLE],
                enumerable: $9ae1377901c67661$var$ENUMERABLE in Attributes ? Attributes[$9ae1377901c67661$var$ENUMERABLE] : current[$9ae1377901c67661$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $9ae1377901c67661$var$$defineProperty(O, P, Attributes);
} : $9ae1377901c67661$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $l3LMJ(O);
    P = $eBk19(P);
    $l3LMJ(Attributes);
    if ($9E0l8) try {
        return $9ae1377901c67661$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $9ae1377901c67661$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRequire.register("5Shx3", function(module, exports) {

var $jeZ4p = parcelRequire("jeZ4p");

var $77TPA = parcelRequire("77TPA");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $jeZ4p && $77TPA(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});

});

parcelRequire.register("l3LMJ", function(module, exports) {

var $1WYwK = parcelRequire("1WYwK");
var $f54ef1e9b84b33bb$var$$String = String;
var $f54ef1e9b84b33bb$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($1WYwK(argument)) return argument;
    throw $f54ef1e9b84b33bb$var$$TypeError($f54ef1e9b84b33bb$var$$String(argument) + " is not an object");
};

});








parcelRequire.register("4i3Tl", function(module, exports) {

module.exports = (parcelRequire("iizpp"));

});
parcelRequire.register("iizpp", function(module, exports) {

var $gwRSD = parcelRequire("gwRSD");
module.exports = $gwRSD;

});
parcelRequire.register("gwRSD", function(module, exports) {
parcelRequire("dbXU8");

var $ly30u = parcelRequire("ly30u");
var $c0896dfc3ce18d01$var$Object = $ly30u.Object;
var $c0896dfc3ce18d01$var$defineProperty = module.exports = function defineProperty(it, key, desc) {
    return $c0896dfc3ce18d01$var$Object.defineProperty(it, key, desc);
};
if ($c0896dfc3ce18d01$var$Object.defineProperty.sham) $c0896dfc3ce18d01$var$defineProperty.sham = true;

});
parcelRequire.register("dbXU8", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $jeZ4p = parcelRequire("jeZ4p");

var $diq7r = parcelRequire("diq7r");
var $99aac538dbdc1bf0$require$defineProperty = $diq7r.f;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$ggcsv({
    target: "Object",
    stat: true,
    forced: Object.defineProperty !== $99aac538dbdc1bf0$require$defineProperty,
    sham: !$jeZ4p
}, {
    defineProperty: $99aac538dbdc1bf0$require$defineProperty
});

});




parcelRequire.register("6iqUa", function(module, exports) {

var $3nM7d = parcelRequire("3nM7d");

var $afsHL = parcelRequire("afsHL");
function $49594b40b1cfa2a1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $49594b40b1cfa2a1$var$_typeof = "function" == typeof $3nM7d && "symbol" == typeof $afsHL ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof $3nM7d && obj.constructor === $3nM7d && obj !== $3nM7d.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $49594b40b1cfa2a1$var$_typeof(obj);
}
module.exports = $49594b40b1cfa2a1$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("3nM7d", function(module, exports) {

module.exports = (parcelRequire("4UwFI"));

});
parcelRequire.register("4UwFI", function(module, exports) {

module.exports = (parcelRequire("clgUG"));

});
parcelRequire.register("clgUG", function(module, exports) {

var $dnFMy = parcelRequire("dnFMy");
parcelRequire("8QfZZ");
parcelRequire("h8IOe");
parcelRequire("5oSUb");
parcelRequire("1kp86");
parcelRequire("i3G8Z");
parcelRequire("fVjjW");
parcelRequire("6Vj7u");
parcelRequire("kSb0Q");
parcelRequire("4IO6j");
parcelRequire("9RLNS");
module.exports = $dnFMy;

});
parcelRequire.register("dnFMy", function(module, exports) {

var $feUJs = parcelRequire("feUJs");
parcelRequire("jgM91");
parcelRequire("il9RF");
parcelRequire("ec6Rp");
module.exports = $feUJs;

});
parcelRequire.register("feUJs", function(module, exports) {

var $aT1j7 = parcelRequire("aT1j7");
parcelRequire("jXhxH");
module.exports = $aT1j7;

});
parcelRequire.register("aT1j7", function(module, exports) {
parcelRequire("isTuv");
parcelRequire("iYyco");
parcelRequire("ko4d9");
parcelRequire("8uxl4");
parcelRequire("fqhMK");
parcelRequire("8awQv");
parcelRequire("5w9fi");
parcelRequire("5qCPf");
parcelRequire("9t2TR");
parcelRequire("6x2NK");
parcelRequire("1X7iO");
parcelRequire("bKaho");
parcelRequire("1mNbp");
parcelRequire("dNcSW");
parcelRequire("8m2Pj");
parcelRequire("549n2");
parcelRequire("hvBC6");
parcelRequire("5wzrh");
parcelRequire("diqsM");
parcelRequire("iQ4e6");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Symbol;

});
parcelRequire.register("isTuv", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $77TPA = parcelRequire("77TPA");

var $5zZFa = parcelRequire("5zZFa");

var $1WYwK = parcelRequire("1WYwK");

var $iJNxK = parcelRequire("iJNxK");

var $6ocdr = parcelRequire("6ocdr");

var $c8xJJ = parcelRequire("c8xJJ");

var $b1Dzg = parcelRequire("b1Dzg");

var $cU9IX = parcelRequire("cU9IX");

var $PdD5d = parcelRequire("PdD5d");

var $fq7H3 = parcelRequire("fq7H3");

var $1MzR6 = parcelRequire("1MzR6");
var $d715e2e4c4a00cf5$var$IS_CONCAT_SPREADABLE = $fq7H3("isConcatSpreadable");
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $d715e2e4c4a00cf5$var$IS_CONCAT_SPREADABLE_SUPPORT = $1MzR6 >= 51 || !$77TPA(function() {
    var array = [];
    array[$d715e2e4c4a00cf5$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $d715e2e4c4a00cf5$var$isConcatSpreadable = function(O) {
    if (!$1WYwK(O)) return false;
    var spreadable = O[$d715e2e4c4a00cf5$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $5zZFa(O);
};
var $d715e2e4c4a00cf5$var$FORCED = !$d715e2e4c4a00cf5$var$IS_CONCAT_SPREADABLE_SUPPORT || !$PdD5d("concat");
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$ggcsv({
    target: "Array",
    proto: true,
    arity: 1,
    forced: $d715e2e4c4a00cf5$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $iJNxK(this);
        var A = $cU9IX(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if ($d715e2e4c4a00cf5$var$isConcatSpreadable(E)) {
                len = $6ocdr(E);
                $c8xJJ(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $b1Dzg(A, n, E[k]);
            } else {
                $c8xJJ(n + 1);
                $b1Dzg(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});

});
parcelRequire.register("5zZFa", function(module, exports) {

var $bTsfg = parcelRequire("bTsfg");
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
    return $bTsfg(argument) == "Array";
};

});

parcelRequire.register("6ocdr", function(module, exports) {

var $8xt01 = parcelRequire("8xt01");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $8xt01(obj.length);
};

});
parcelRequire.register("8xt01", function(module, exports) {

var $3ZmxQ = parcelRequire("3ZmxQ");
var $019ab543e8c37611$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    return argument > 0 ? $019ab543e8c37611$var$min($3ZmxQ(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});
parcelRequire.register("3ZmxQ", function(module, exports) {

var $61khJ = parcelRequire("61khJ");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $61khJ(number);
};

});
parcelRequire.register("61khJ", function(module, exports) {
var $4622923b6f763fec$var$ceil = Math.ceil;
var $4622923b6f763fec$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $4622923b6f763fec$var$floor : $4622923b6f763fec$var$ceil)(n);
};

});




parcelRequire.register("c8xJJ", function(module, exports) {
var $8d6066c31eba0f0a$var$$TypeError = TypeError;
var $8d6066c31eba0f0a$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
module.exports = function(it) {
    if (it > $8d6066c31eba0f0a$var$MAX_SAFE_INTEGER) throw $8d6066c31eba0f0a$var$$TypeError("Maximum allowed index exceeded");
    return it;
};

});

parcelRequire.register("b1Dzg", function(module, exports) {
"use strict";

var $eBk19 = parcelRequire("eBk19");

var $diq7r = parcelRequire("diq7r");

var $8c6fn = parcelRequire("8c6fn");
module.exports = function(object, key, value) {
    var propertyKey = $eBk19(key);
    if (propertyKey in object) $diq7r.f(object, propertyKey, $8c6fn(0, value));
    else object[propertyKey] = value;
};

});

parcelRequire.register("cU9IX", function(module, exports) {

var $9pV7u = parcelRequire("9pV7u");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray, length) {
    return new ($9pV7u(originalArray))(length === 0 ? 0 : length);
};

});
parcelRequire.register("9pV7u", function(module, exports) {

var $5zZFa = parcelRequire("5zZFa");

var $iQLrm = parcelRequire("iQLrm");

var $1WYwK = parcelRequire("1WYwK");

var $fq7H3 = parcelRequire("fq7H3");
var $6db2c1a99ea8d015$var$SPECIES = $fq7H3("species");
var $6db2c1a99ea8d015$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray) {
    var C;
    if ($5zZFa(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($iQLrm(C) && (C === $6db2c1a99ea8d015$var$$Array || $5zZFa(C.prototype))) C = undefined;
        else if ($1WYwK(C)) {
            C = C[$6db2c1a99ea8d015$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $6db2c1a99ea8d015$var$$Array : C;
};

});
parcelRequire.register("iQLrm", function(module, exports) {

var $f518o = parcelRequire("f518o");

var $77TPA = parcelRequire("77TPA");

var $e6Rz5 = parcelRequire("e6Rz5");

var $aHxiP = parcelRequire("aHxiP");

var $5Pobw = parcelRequire("5Pobw");

var $fgsf9 = parcelRequire("fgsf9");
var $db91e1f52262defb$var$noop = function() {};
var $db91e1f52262defb$var$empty = [];
var $db91e1f52262defb$var$construct = $5Pobw("Reflect", "construct");
var $db91e1f52262defb$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $db91e1f52262defb$var$exec = $f518o($db91e1f52262defb$var$constructorRegExp.exec);
var $db91e1f52262defb$var$INCORRECT_TO_STRING = !$db91e1f52262defb$var$constructorRegExp.exec($db91e1f52262defb$var$noop);
var $db91e1f52262defb$var$isConstructorModern = function isConstructor(argument) {
    if (!$e6Rz5(argument)) return false;
    try {
        $db91e1f52262defb$var$construct($db91e1f52262defb$var$noop, $db91e1f52262defb$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $db91e1f52262defb$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$e6Rz5(argument)) return false;
    switch($aHxiP(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $db91e1f52262defb$var$INCORRECT_TO_STRING || !!$db91e1f52262defb$var$exec($db91e1f52262defb$var$constructorRegExp, $fgsf9(argument));
    } catch (error) {
        return true;
    }
};
$db91e1f52262defb$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$db91e1f52262defb$var$construct || $77TPA(function() {
    var called;
    return $db91e1f52262defb$var$isConstructorModern($db91e1f52262defb$var$isConstructorModern.call) || !$db91e1f52262defb$var$isConstructorModern(Object) || !$db91e1f52262defb$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $db91e1f52262defb$var$isConstructorLegacy : $db91e1f52262defb$var$isConstructorModern;

});
parcelRequire.register("aHxiP", function(module, exports) {

var $6WE3a = parcelRequire("6WE3a");

var $e6Rz5 = parcelRequire("e6Rz5");

var $bTsfg = parcelRequire("bTsfg");

var $fq7H3 = parcelRequire("fq7H3");
var $7ca7c0c7b62cb973$var$TO_STRING_TAG = $fq7H3("toStringTag");
var $7ca7c0c7b62cb973$var$$Object = Object;
// ES3 wrong here
var $7ca7c0c7b62cb973$var$CORRECT_ARGUMENTS = $bTsfg(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $7ca7c0c7b62cb973$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $6WE3a ? $bTsfg : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $7ca7c0c7b62cb973$var$tryGet(O = $7ca7c0c7b62cb973$var$$Object(it), $7ca7c0c7b62cb973$var$TO_STRING_TAG)) == "string" ? tag : $7ca7c0c7b62cb973$var$CORRECT_ARGUMENTS ? $bTsfg(O) : (result = $bTsfg(O)) == "Object" && $e6Rz5(O.callee) ? "Arguments" : result;
};

});
parcelRequire.register("6WE3a", function(module, exports) {

var $fq7H3 = parcelRequire("fq7H3");
var $50e739fb2ec827de$var$TO_STRING_TAG = $fq7H3("toStringTag");
var $50e739fb2ec827de$var$test = {};
$50e739fb2ec827de$var$test[$50e739fb2ec827de$var$TO_STRING_TAG] = "z";
module.exports = String($50e739fb2ec827de$var$test) === "[object z]";

});


parcelRequire.register("fgsf9", function(module, exports) {

var $f518o = parcelRequire("f518o");

var $e6Rz5 = parcelRequire("e6Rz5");

var $bEwnT = parcelRequire("bEwnT");
var $b1ce423370fb74c6$var$functionToString = $f518o(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$e6Rz5($bEwnT.inspectSource)) $bEwnT.inspectSource = function(it) {
    return $b1ce423370fb74c6$var$functionToString(it);
};
module.exports = $bEwnT.inspectSource;

});




parcelRequire.register("PdD5d", function(module, exports) {

var $77TPA = parcelRequire("77TPA");

var $fq7H3 = parcelRequire("fq7H3");

var $1MzR6 = parcelRequire("1MzR6");
var $099f560b79cb257e$var$SPECIES = $fq7H3("species");
module.exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $1MzR6 >= 51 || !$77TPA(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$099f560b79cb257e$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};

});


parcelRequire.register("iYyco", function(module, exports) {
// empty

});

parcelRequire.register("ko4d9", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
parcelRequire("fX6Qo");
parcelRequire("6nSVj");
parcelRequire("a7I9i");
parcelRequire("kvPdS");
parcelRequire("jKKLo");

});
parcelRequire.register("fX6Qo", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $3pyVf = parcelRequire("3pyVf");

var $aELZY = parcelRequire("aELZY");

var $f518o = parcelRequire("f518o");

var $7phdw = parcelRequire("7phdw");

var $jeZ4p = parcelRequire("jeZ4p");

var $e1lwM = parcelRequire("e1lwM");

var $77TPA = parcelRequire("77TPA");

var $heVlo = parcelRequire("heVlo");

var $8hsAO = parcelRequire("8hsAO");

var $l3LMJ = parcelRequire("l3LMJ");

var $bYkAs = parcelRequire("bYkAs");

var $eBk19 = parcelRequire("eBk19");

var $l2Ut5 = parcelRequire("l2Ut5");

var $8c6fn = parcelRequire("8c6fn");

var $fhVPP = parcelRequire("fhVPP");

var $3Ut0t = parcelRequire("3Ut0t");

var $9hUhV = parcelRequire("9hUhV");

var $cMezS = parcelRequire("cMezS");

var $4BK7o = parcelRequire("4BK7o");

var $fTFId = parcelRequire("fTFId");

var $diq7r = parcelRequire("diq7r");

var $a965u = parcelRequire("a965u");

var $d5uYy = parcelRequire("d5uYy");

var $kY5Tb = parcelRequire("kY5Tb");

var $7kUwJ = parcelRequire("7kUwJ");

var $3hwUC = parcelRequire("3hwUC");

var $aUKPz = parcelRequire("aUKPz");

var $lKGD2 = parcelRequire("lKGD2");

var $kuKGb = parcelRequire("kuKGb");

var $fq7H3 = parcelRequire("fq7H3");

var $knUX7 = parcelRequire("knUX7");

var $cHa91 = parcelRequire("cHa91");

var $bPU03 = parcelRequire("bPU03");

var $dheYH = parcelRequire("dheYH");

var $fmQ29 = parcelRequire("fmQ29");

var $igsV9 = parcelRequire("igsV9");
var $b9d1acc5cb3a14b5$require$$forEach = $igsV9.forEach;
var $b9d1acc5cb3a14b5$var$HIDDEN = $aUKPz("hidden");
var $b9d1acc5cb3a14b5$var$SYMBOL = "Symbol";
var $b9d1acc5cb3a14b5$var$PROTOTYPE = "prototype";
var $b9d1acc5cb3a14b5$var$setInternalState = $fmQ29.set;
var $b9d1acc5cb3a14b5$var$getInternalState = $fmQ29.getterFor($b9d1acc5cb3a14b5$var$SYMBOL);
var $b9d1acc5cb3a14b5$var$ObjectPrototype = Object[$b9d1acc5cb3a14b5$var$PROTOTYPE];
var $b9d1acc5cb3a14b5$var$$Symbol = $3pyVf.Symbol;
var $b9d1acc5cb3a14b5$var$SymbolPrototype = $b9d1acc5cb3a14b5$var$$Symbol && $b9d1acc5cb3a14b5$var$$Symbol[$b9d1acc5cb3a14b5$var$PROTOTYPE];
var $b9d1acc5cb3a14b5$var$TypeError = $3pyVf.TypeError;
var $b9d1acc5cb3a14b5$var$QObject = $3pyVf.QObject;
var $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyDescriptor = $fTFId.f;
var $b9d1acc5cb3a14b5$var$nativeDefineProperty = $diq7r.f;
var $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyNames = $cMezS.f;
var $b9d1acc5cb3a14b5$var$nativePropertyIsEnumerable = $d5uYy.f;
var $b9d1acc5cb3a14b5$var$push = $f518o([].push);
var $b9d1acc5cb3a14b5$var$AllSymbols = $3hwUC("symbols");
var $b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols = $3hwUC("op-symbols");
var $b9d1acc5cb3a14b5$var$WellKnownSymbolsStore = $3hwUC("wks");
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $b9d1acc5cb3a14b5$var$USE_SETTER = !$b9d1acc5cb3a14b5$var$QObject || !$b9d1acc5cb3a14b5$var$QObject[$b9d1acc5cb3a14b5$var$PROTOTYPE] || !$b9d1acc5cb3a14b5$var$QObject[$b9d1acc5cb3a14b5$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $b9d1acc5cb3a14b5$var$setSymbolDescriptor = $jeZ4p && $77TPA(function() {
    return $fhVPP($b9d1acc5cb3a14b5$var$nativeDefineProperty({}, "a", {
        get: function() {
            return $b9d1acc5cb3a14b5$var$nativeDefineProperty(this, "a", {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyDescriptor($b9d1acc5cb3a14b5$var$ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete $b9d1acc5cb3a14b5$var$ObjectPrototype[P];
    $b9d1acc5cb3a14b5$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $b9d1acc5cb3a14b5$var$ObjectPrototype) $b9d1acc5cb3a14b5$var$nativeDefineProperty($b9d1acc5cb3a14b5$var$ObjectPrototype, P, ObjectPrototypeDescriptor);
} : $b9d1acc5cb3a14b5$var$nativeDefineProperty;
var $b9d1acc5cb3a14b5$var$wrap = function(tag, description) {
    var symbol = $b9d1acc5cb3a14b5$var$AllSymbols[tag] = $fhVPP($b9d1acc5cb3a14b5$var$SymbolPrototype);
    $b9d1acc5cb3a14b5$var$setInternalState(symbol, {
        type: $b9d1acc5cb3a14b5$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$jeZ4p) symbol.description = description;
    return symbol;
};
var $b9d1acc5cb3a14b5$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $b9d1acc5cb3a14b5$var$ObjectPrototype) $b9d1acc5cb3a14b5$var$$defineProperty($b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols, P, Attributes);
    $l3LMJ(O);
    var key = $eBk19(P);
    $l3LMJ(Attributes);
    if ($heVlo($b9d1acc5cb3a14b5$var$AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!$heVlo(O, $b9d1acc5cb3a14b5$var$HIDDEN)) $b9d1acc5cb3a14b5$var$nativeDefineProperty(O, $b9d1acc5cb3a14b5$var$HIDDEN, $8c6fn(1, {}));
            O[$b9d1acc5cb3a14b5$var$HIDDEN][key] = true;
        } else {
            if ($heVlo(O, $b9d1acc5cb3a14b5$var$HIDDEN) && O[$b9d1acc5cb3a14b5$var$HIDDEN][key]) O[$b9d1acc5cb3a14b5$var$HIDDEN][key] = false;
            Attributes = $fhVPP(Attributes, {
                enumerable: $8c6fn(0, false)
            });
        }
        return $b9d1acc5cb3a14b5$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $b9d1acc5cb3a14b5$var$nativeDefineProperty(O, key, Attributes);
};
var $b9d1acc5cb3a14b5$var$$defineProperties = function defineProperties(O, Properties) {
    $l3LMJ(O);
    var properties = $bYkAs(Properties);
    var keys = $3Ut0t(properties).concat($b9d1acc5cb3a14b5$var$$getOwnPropertySymbols(properties));
    $b9d1acc5cb3a14b5$require$$forEach(keys, function(key) {
        if (!$jeZ4p || $aELZY($b9d1acc5cb3a14b5$var$$propertyIsEnumerable, properties, key)) $b9d1acc5cb3a14b5$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $b9d1acc5cb3a14b5$var$$create = function create(O, Properties) {
    return Properties === undefined ? $fhVPP(O) : $b9d1acc5cb3a14b5$var$$defineProperties($fhVPP(O), Properties);
};
var $b9d1acc5cb3a14b5$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $eBk19(V);
    var enumerable = $aELZY($b9d1acc5cb3a14b5$var$nativePropertyIsEnumerable, this, P);
    if (this === $b9d1acc5cb3a14b5$var$ObjectPrototype && $heVlo($b9d1acc5cb3a14b5$var$AllSymbols, P) && !$heVlo($b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$heVlo(this, P) || !$heVlo($b9d1acc5cb3a14b5$var$AllSymbols, P) || $heVlo(this, $b9d1acc5cb3a14b5$var$HIDDEN) && this[$b9d1acc5cb3a14b5$var$HIDDEN][P] ? enumerable : true;
};
var $b9d1acc5cb3a14b5$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $bYkAs(O);
    var key = $eBk19(P);
    if (it === $b9d1acc5cb3a14b5$var$ObjectPrototype && $heVlo($b9d1acc5cb3a14b5$var$AllSymbols, key) && !$heVlo($b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && $heVlo($b9d1acc5cb3a14b5$var$AllSymbols, key) && !($heVlo(it, $b9d1acc5cb3a14b5$var$HIDDEN) && it[$b9d1acc5cb3a14b5$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $b9d1acc5cb3a14b5$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyNames($bYkAs(O));
    var result = [];
    $b9d1acc5cb3a14b5$require$$forEach(names, function(key) {
        if (!$heVlo($b9d1acc5cb3a14b5$var$AllSymbols, key) && !$heVlo($lKGD2, key)) $b9d1acc5cb3a14b5$var$push(result, key);
    });
    return result;
};
var $b9d1acc5cb3a14b5$var$$getOwnPropertySymbols = function(O) {
    var IS_OBJECT_PROTOTYPE = O === $b9d1acc5cb3a14b5$var$ObjectPrototype;
    var names = $b9d1acc5cb3a14b5$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols : $bYkAs(O));
    var result = [];
    $b9d1acc5cb3a14b5$require$$forEach(names, function(key) {
        if ($heVlo($b9d1acc5cb3a14b5$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $heVlo($b9d1acc5cb3a14b5$var$ObjectPrototype, key))) $b9d1acc5cb3a14b5$var$push(result, $b9d1acc5cb3a14b5$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$e1lwM) {
    $b9d1acc5cb3a14b5$var$$Symbol = function Symbol() {
        if ($8hsAO($b9d1acc5cb3a14b5$var$SymbolPrototype, this)) throw $b9d1acc5cb3a14b5$var$TypeError("Symbol is not a constructor");
        var description = !arguments.length || arguments[0] === undefined ? undefined : $l2Ut5(arguments[0]);
        var tag = $kuKGb(description);
        var setter = function(value) {
            if (this === $b9d1acc5cb3a14b5$var$ObjectPrototype) $aELZY(setter, $b9d1acc5cb3a14b5$var$ObjectPrototypeSymbols, value);
            if ($heVlo(this, $b9d1acc5cb3a14b5$var$HIDDEN) && $heVlo(this[$b9d1acc5cb3a14b5$var$HIDDEN], tag)) this[$b9d1acc5cb3a14b5$var$HIDDEN][tag] = false;
            $b9d1acc5cb3a14b5$var$setSymbolDescriptor(this, tag, $8c6fn(1, value));
        };
        if ($jeZ4p && $b9d1acc5cb3a14b5$var$USE_SETTER) $b9d1acc5cb3a14b5$var$setSymbolDescriptor($b9d1acc5cb3a14b5$var$ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return $b9d1acc5cb3a14b5$var$wrap(tag, description);
    };
    $b9d1acc5cb3a14b5$var$SymbolPrototype = $b9d1acc5cb3a14b5$var$$Symbol[$b9d1acc5cb3a14b5$var$PROTOTYPE];
    $kY5Tb($b9d1acc5cb3a14b5$var$SymbolPrototype, "toString", function toString() {
        return $b9d1acc5cb3a14b5$var$getInternalState(this).tag;
    });
    $kY5Tb($b9d1acc5cb3a14b5$var$$Symbol, "withoutSetter", function(description) {
        return $b9d1acc5cb3a14b5$var$wrap($kuKGb(description), description);
    });
    $d5uYy.f = $b9d1acc5cb3a14b5$var$$propertyIsEnumerable;
    $diq7r.f = $b9d1acc5cb3a14b5$var$$defineProperty;
    $a965u.f = $b9d1acc5cb3a14b5$var$$defineProperties;
    $fTFId.f = $b9d1acc5cb3a14b5$var$$getOwnPropertyDescriptor;
    $9hUhV.f = $cMezS.f = $b9d1acc5cb3a14b5$var$$getOwnPropertyNames;
    $4BK7o.f = $b9d1acc5cb3a14b5$var$$getOwnPropertySymbols;
    $knUX7.f = function(name) {
        return $b9d1acc5cb3a14b5$var$wrap($fq7H3(name), name);
    };
    if ($jeZ4p) {
        // https://github.com/tc39/proposal-Symbol-description
        $7kUwJ($b9d1acc5cb3a14b5$var$SymbolPrototype, "description", {
            configurable: true,
            get: function description() {
                return $b9d1acc5cb3a14b5$var$getInternalState(this).description;
            }
        });
        if (!$7phdw) $kY5Tb($b9d1acc5cb3a14b5$var$ObjectPrototype, "propertyIsEnumerable", $b9d1acc5cb3a14b5$var$$propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$ggcsv({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$e1lwM,
    sham: !$e1lwM
}, {
    Symbol: $b9d1acc5cb3a14b5$var$$Symbol
});
$b9d1acc5cb3a14b5$require$$forEach($3Ut0t($b9d1acc5cb3a14b5$var$WellKnownSymbolsStore), function(name) {
    $cHa91(name);
});
$ggcsv({
    target: $b9d1acc5cb3a14b5$var$SYMBOL,
    stat: true,
    forced: !$e1lwM
}, {
    useSetter: function() {
        $b9d1acc5cb3a14b5$var$USE_SETTER = true;
    },
    useSimple: function() {
        $b9d1acc5cb3a14b5$var$USE_SETTER = false;
    }
});
$ggcsv({
    target: "Object",
    stat: true,
    forced: !$e1lwM,
    sham: !$jeZ4p
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $b9d1acc5cb3a14b5$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $b9d1acc5cb3a14b5$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $b9d1acc5cb3a14b5$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $b9d1acc5cb3a14b5$var$$getOwnPropertyDescriptor
});
$ggcsv({
    target: "Object",
    stat: true,
    forced: !$e1lwM
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $b9d1acc5cb3a14b5$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$bPU03();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$dheYH($b9d1acc5cb3a14b5$var$$Symbol, $b9d1acc5cb3a14b5$var$SYMBOL);
$lKGD2[$b9d1acc5cb3a14b5$var$HIDDEN] = true;

});
parcelRequire.register("l2Ut5", function(module, exports) {

var $aHxiP = parcelRequire("aHxiP");
var $f52596499fa10f8b$var$$String = String;
module.exports = function(argument) {
    if ($aHxiP(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $f52596499fa10f8b$var$$String(argument);
};

});

parcelRequire.register("fhVPP", function(module, exports) {
/* global ActiveXObject -- old IE, WSH */ 
var $l3LMJ = parcelRequire("l3LMJ");

var $a965u = parcelRequire("a965u");

var $4mKOn = parcelRequire("4mKOn");

var $lKGD2 = parcelRequire("lKGD2");

var $f0Cl9 = parcelRequire("f0Cl9");

var $kHYxY = parcelRequire("kHYxY");

var $aUKPz = parcelRequire("aUKPz");
var $b2154e617ce55b74$var$GT = ">";
var $b2154e617ce55b74$var$LT = "<";
var $b2154e617ce55b74$var$PROTOTYPE = "prototype";
var $b2154e617ce55b74$var$SCRIPT = "script";
var $b2154e617ce55b74$var$IE_PROTO = $aUKPz("IE_PROTO");
var $b2154e617ce55b74$var$EmptyConstructor = function() {};
var $b2154e617ce55b74$var$scriptTag = function(content) {
    return $b2154e617ce55b74$var$LT + $b2154e617ce55b74$var$SCRIPT + $b2154e617ce55b74$var$GT + content + $b2154e617ce55b74$var$LT + "/" + $b2154e617ce55b74$var$SCRIPT + $b2154e617ce55b74$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $b2154e617ce55b74$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($b2154e617ce55b74$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $b2154e617ce55b74$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $kHYxY("iframe");
    var JS = "java" + $b2154e617ce55b74$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $f0Cl9.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($b2154e617ce55b74$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $b2154e617ce55b74$var$activeXDocument;
var $b2154e617ce55b74$var$NullProtoObject = function() {
    try {
        $b2154e617ce55b74$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $b2154e617ce55b74$var$NullProtoObject = typeof document != "undefined" ? document.domain && $b2154e617ce55b74$var$activeXDocument ? $b2154e617ce55b74$var$NullProtoObjectViaActiveX($b2154e617ce55b74$var$activeXDocument) // old IE
     : $b2154e617ce55b74$var$NullProtoObjectViaIFrame() : $b2154e617ce55b74$var$NullProtoObjectViaActiveX($b2154e617ce55b74$var$activeXDocument); // WSH
    var length = $4mKOn.length;
    while(length--)delete $b2154e617ce55b74$var$NullProtoObject[$b2154e617ce55b74$var$PROTOTYPE][$4mKOn[length]];
    return $b2154e617ce55b74$var$NullProtoObject();
};
$lKGD2[$b2154e617ce55b74$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $b2154e617ce55b74$var$EmptyConstructor[$b2154e617ce55b74$var$PROTOTYPE] = $l3LMJ(O);
        result = new $b2154e617ce55b74$var$EmptyConstructor();
        $b2154e617ce55b74$var$EmptyConstructor[$b2154e617ce55b74$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$b2154e617ce55b74$var$IE_PROTO] = O;
    } else result = $b2154e617ce55b74$var$NullProtoObject();
    return Properties === undefined ? result : $a965u.f(result, Properties);
};

});
parcelRequire.register("a965u", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $762f7781ac324761$export$2d1720544b23b823; }, function (v) { return $762f7781ac324761$export$2d1720544b23b823 = v; });
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $762f7781ac324761$export$2d1720544b23b823;

var $jeZ4p = parcelRequire("jeZ4p");

var $5Shx3 = parcelRequire("5Shx3");

var $diq7r = parcelRequire("diq7r");

var $l3LMJ = parcelRequire("l3LMJ");

var $bYkAs = parcelRequire("bYkAs");

var $3Ut0t = parcelRequire("3Ut0t");
$762f7781ac324761$export$2d1720544b23b823 = $jeZ4p && !$5Shx3 ? Object.defineProperties : function defineProperties(O, Properties) {
    $l3LMJ(O);
    var props = $bYkAs(Properties);
    var keys = $3Ut0t(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$diq7r.f(O, key = keys[index++], props[key]);
    return O;
};

});
parcelRequire.register("3Ut0t", function(module, exports) {

var $4aJsK = parcelRequire("4aJsK");

var $4mKOn = parcelRequire("4mKOn");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $4aJsK(O, $4mKOn);
};

});
parcelRequire.register("4aJsK", function(module, exports) {

var $f518o = parcelRequire("f518o");

var $heVlo = parcelRequire("heVlo");

var $bYkAs = parcelRequire("bYkAs");

var $3NUiQ = parcelRequire("3NUiQ");
var $309b5c8313a5777b$require$indexOf = $3NUiQ.indexOf;

var $lKGD2 = parcelRequire("lKGD2");
var $309b5c8313a5777b$var$push = $f518o([].push);
module.exports = function(object, names) {
    var O = $bYkAs(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$heVlo($lKGD2, key) && $heVlo(O, key) && $309b5c8313a5777b$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($heVlo(O, key = names[i++])) ~$309b5c8313a5777b$require$indexOf(result, key) || $309b5c8313a5777b$var$push(result, key);
    return result;
};

});
parcelRequire.register("3NUiQ", function(module, exports) {

var $bYkAs = parcelRequire("bYkAs");

var $2s0YW = parcelRequire("2s0YW");

var $6ocdr = parcelRequire("6ocdr");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $2c519f5086e10272$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $bYkAs($this);
        var length = $6ocdr(O);
        var index = $2s0YW(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $2c519f5086e10272$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $2c519f5086e10272$var$createMethod(false)
};

});
parcelRequire.register("2s0YW", function(module, exports) {

var $3ZmxQ = parcelRequire("3ZmxQ");
var $1c8ef54373f1e5b2$var$max = Math.max;
var $1c8ef54373f1e5b2$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $3ZmxQ(index);
    return integer < 0 ? $1c8ef54373f1e5b2$var$max(integer + length, 0) : $1c8ef54373f1e5b2$var$min(integer, length);
};

});


parcelRequire.register("lKGD2", function(module, exports) {
module.exports = {};

});


parcelRequire.register("4mKOn", function(module, exports) {
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

});



parcelRequire.register("f0Cl9", function(module, exports) {

var $5Pobw = parcelRequire("5Pobw");
module.exports = $5Pobw("document", "documentElement");

});

parcelRequire.register("aUKPz", function(module, exports) {

var $3hwUC = parcelRequire("3hwUC");

var $kuKGb = parcelRequire("kuKGb");
var $7f2375f10522f278$var$keys = $3hwUC("keys");
module.exports = function(key) {
    return $7f2375f10522f278$var$keys[key] || ($7f2375f10522f278$var$keys[key] = $kuKGb(key));
};

});


parcelRequire.register("9hUhV", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $6c315d3c53f090a4$export$2d1720544b23b823; }, function (v) { return $6c315d3c53f090a4$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $6c315d3c53f090a4$export$2d1720544b23b823;

var $4aJsK = parcelRequire("4aJsK");

var $4mKOn = parcelRequire("4mKOn");
var $6c315d3c53f090a4$var$hiddenKeys = $4mKOn.concat("length", "prototype");
$6c315d3c53f090a4$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $4aJsK(O, $6c315d3c53f090a4$var$hiddenKeys);
};

});

parcelRequire.register("cMezS", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $94d5468708b48bdd$export$2d1720544b23b823; }, function (v) { return $94d5468708b48bdd$export$2d1720544b23b823 = v; });
/* eslint-disable es/no-object-getownpropertynames -- safe */ // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $94d5468708b48bdd$export$2d1720544b23b823;

var $bTsfg = parcelRequire("bTsfg");

var $bYkAs = parcelRequire("bYkAs");

var $9hUhV = parcelRequire("9hUhV");
var $94d5468708b48bdd$require$$getOwnPropertyNames = $9hUhV.f;

var $9SxVM = parcelRequire("9SxVM");
var $94d5468708b48bdd$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $94d5468708b48bdd$var$getWindowNames = function(it) {
    try {
        return $94d5468708b48bdd$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $9SxVM($94d5468708b48bdd$var$windowNames);
    }
};
$94d5468708b48bdd$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $94d5468708b48bdd$var$windowNames && $bTsfg(it) == "Window" ? $94d5468708b48bdd$var$getWindowNames(it) : $94d5468708b48bdd$require$$getOwnPropertyNames($bYkAs(it));
};

});
parcelRequire.register("9SxVM", function(module, exports) {

var $2s0YW = parcelRequire("2s0YW");

var $6ocdr = parcelRequire("6ocdr");

var $b1Dzg = parcelRequire("b1Dzg");
var $73137a2b0e213d8f$var$$Array = Array;
var $73137a2b0e213d8f$var$max = Math.max;
module.exports = function(O, start, end) {
    var length = $6ocdr(O);
    var k = $2s0YW(start, length);
    var fin = $2s0YW(end === undefined ? length : end, length);
    var result = $73137a2b0e213d8f$var$$Array($73137a2b0e213d8f$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$b1Dzg(result, n, O[k]);
    result.length = n;
    return result;
};

});


parcelRequire.register("4BK7o", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $35ae643adc7aa6b6$export$2d1720544b23b823; }, function (v) { return $35ae643adc7aa6b6$export$2d1720544b23b823 = v; });
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $35ae643adc7aa6b6$export$2d1720544b23b823;
$35ae643adc7aa6b6$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRequire.register("kY5Tb", function(module, exports) {

var $k4kcW = parcelRequire("k4kcW");
module.exports = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else $k4kcW(target, key, value);
    return target;
};

});

parcelRequire.register("7kUwJ", function(module, exports) {

var $diq7r = parcelRequire("diq7r");
module.exports = function(target, name, descriptor) {
    return $diq7r.f(target, name, descriptor);
};

});

parcelRequire.register("knUX7", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $ed72223cb1d16ce4$export$2d1720544b23b823; }, function (v) { return $ed72223cb1d16ce4$export$2d1720544b23b823 = v; });
var $ed72223cb1d16ce4$export$2d1720544b23b823;

var $fq7H3 = parcelRequire("fq7H3");
$ed72223cb1d16ce4$export$2d1720544b23b823 = $fq7H3;

});

parcelRequire.register("cHa91", function(module, exports) {

var $ly30u = parcelRequire("ly30u");

var $heVlo = parcelRequire("heVlo");

var $knUX7 = parcelRequire("knUX7");

var $diq7r = parcelRequire("diq7r");
var $93e15eaad2755601$require$defineProperty = $diq7r.f;
module.exports = function(NAME) {
    var Symbol = $ly30u.Symbol || ($ly30u.Symbol = {});
    if (!$heVlo(Symbol, NAME)) $93e15eaad2755601$require$defineProperty(Symbol, NAME, {
        value: $knUX7.f(NAME)
    });
};

});

parcelRequire.register("bPU03", function(module, exports) {

var $aELZY = parcelRequire("aELZY");

var $5Pobw = parcelRequire("5Pobw");

var $fq7H3 = parcelRequire("fq7H3");

var $kY5Tb = parcelRequire("kY5Tb");
module.exports = function() {
    var Symbol = $5Pobw("Symbol");
    var SymbolPrototype = Symbol && Symbol.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $fq7H3("toPrimitive");
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $kY5Tb(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $aELZY(valueOf, this);
    }, {
        arity: 1
    });
};

});

parcelRequire.register("dheYH", function(module, exports) {

var $6WE3a = parcelRequire("6WE3a");

var $diq7r = parcelRequire("diq7r");
var $9aa87b38f09a974a$require$defineProperty = $diq7r.f;

var $k4kcW = parcelRequire("k4kcW");

var $heVlo = parcelRequire("heVlo");

var $akp1c = parcelRequire("akp1c");

var $fq7H3 = parcelRequire("fq7H3");
var $9aa87b38f09a974a$var$TO_STRING_TAG = $fq7H3("toStringTag");
module.exports = function(it, TAG, STATIC, SET_METHOD) {
    if (it) {
        var target = STATIC ? it : it.prototype;
        if (!$heVlo(target, $9aa87b38f09a974a$var$TO_STRING_TAG)) $9aa87b38f09a974a$require$defineProperty(target, $9aa87b38f09a974a$var$TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !$6WE3a) $k4kcW(target, "toString", $akp1c);
    }
};

});
parcelRequire.register("akp1c", function(module, exports) {
"use strict";

var $6WE3a = parcelRequire("6WE3a");

var $aHxiP = parcelRequire("aHxiP");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = $6WE3a ? ({}).toString : function toString() {
    return "[object " + $aHxiP(this) + "]";
};

});


parcelRequire.register("fmQ29", function(module, exports) {

var $3rZfY = parcelRequire("3rZfY");

var $3pyVf = parcelRequire("3pyVf");

var $1WYwK = parcelRequire("1WYwK");

var $k4kcW = parcelRequire("k4kcW");

var $heVlo = parcelRequire("heVlo");

var $bEwnT = parcelRequire("bEwnT");

var $aUKPz = parcelRequire("aUKPz");

var $lKGD2 = parcelRequire("lKGD2");
var $b30145e9256ae915$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $b30145e9256ae915$var$TypeError = $3pyVf.TypeError;
var $b30145e9256ae915$var$WeakMap = $3pyVf.WeakMap;
var $b30145e9256ae915$var$set, $b30145e9256ae915$var$get, $b30145e9256ae915$var$has;
var $b30145e9256ae915$var$enforce = function(it) {
    return $b30145e9256ae915$var$has(it) ? $b30145e9256ae915$var$get(it) : $b30145e9256ae915$var$set(it, {});
};
var $b30145e9256ae915$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$1WYwK(it) || (state = $b30145e9256ae915$var$get(it)).type !== TYPE) throw $b30145e9256ae915$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($3rZfY || $bEwnT.state) {
    var $b30145e9256ae915$var$store = $bEwnT.state || ($bEwnT.state = new $b30145e9256ae915$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $b30145e9256ae915$var$store.get = $b30145e9256ae915$var$store.get;
    $b30145e9256ae915$var$store.has = $b30145e9256ae915$var$store.has;
    $b30145e9256ae915$var$store.set = $b30145e9256ae915$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $b30145e9256ae915$var$set = function(it, metadata) {
        if ($b30145e9256ae915$var$store.has(it)) throw $b30145e9256ae915$var$TypeError($b30145e9256ae915$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $b30145e9256ae915$var$store.set(it, metadata);
        return metadata;
    };
    $b30145e9256ae915$var$get = function(it) {
        return $b30145e9256ae915$var$store.get(it) || {};
    };
    $b30145e9256ae915$var$has = function(it) {
        return $b30145e9256ae915$var$store.has(it);
    };
} else {
    var $b30145e9256ae915$var$STATE = $aUKPz("state");
    $lKGD2[$b30145e9256ae915$var$STATE] = true;
    $b30145e9256ae915$var$set = function(it, metadata) {
        if ($heVlo(it, $b30145e9256ae915$var$STATE)) throw $b30145e9256ae915$var$TypeError($b30145e9256ae915$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $k4kcW(it, $b30145e9256ae915$var$STATE, metadata);
        return metadata;
    };
    $b30145e9256ae915$var$get = function(it) {
        return $heVlo(it, $b30145e9256ae915$var$STATE) ? it[$b30145e9256ae915$var$STATE] : {};
    };
    $b30145e9256ae915$var$has = function(it) {
        return $heVlo(it, $b30145e9256ae915$var$STATE);
    };
}
module.exports = {
    set: $b30145e9256ae915$var$set,
    get: $b30145e9256ae915$var$get,
    has: $b30145e9256ae915$var$has,
    enforce: $b30145e9256ae915$var$enforce,
    getterFor: $b30145e9256ae915$var$getterFor
};

});
parcelRequire.register("3rZfY", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");

var $e6Rz5 = parcelRequire("e6Rz5");
var $283368fe873ec799$var$WeakMap = $3pyVf.WeakMap;
module.exports = $e6Rz5($283368fe873ec799$var$WeakMap) && /native code/.test(String($283368fe873ec799$var$WeakMap));

});


parcelRequire.register("igsV9", function(module, exports) {

var $b5UsH = parcelRequire("b5UsH");

var $f518o = parcelRequire("f518o");

var $lEtn3 = parcelRequire("lEtn3");

var $iJNxK = parcelRequire("iJNxK");

var $6ocdr = parcelRequire("6ocdr");

var $cU9IX = parcelRequire("cU9IX");
var $d4c027b2f08881b7$var$push = $f518o([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $d4c027b2f08881b7$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $iJNxK($this);
        var self = $lEtn3(O);
        var boundFunction = $b5UsH(callbackfn, that);
        var length = $6ocdr(self);
        var index = 0;
        var create = specificCreate || $cU9IX;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $d4c027b2f08881b7$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $d4c027b2f08881b7$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $d4c027b2f08881b7$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $d4c027b2f08881b7$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $d4c027b2f08881b7$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $d4c027b2f08881b7$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $d4c027b2f08881b7$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $d4c027b2f08881b7$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $d4c027b2f08881b7$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $d4c027b2f08881b7$var$createMethod(7)
};

});


parcelRequire.register("6nSVj", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $5Pobw = parcelRequire("5Pobw");

var $heVlo = parcelRequire("heVlo");

var $l2Ut5 = parcelRequire("l2Ut5");

var $3hwUC = parcelRequire("3hwUC");

var $lCnHq = parcelRequire("lCnHq");
var $4a5f7eb962eeacc9$var$StringToSymbolRegistry = $3hwUC("string-to-symbol-registry");
var $4a5f7eb962eeacc9$var$SymbolToStringRegistry = $3hwUC("symbol-to-string-registry");
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$ggcsv({
    target: "Symbol",
    stat: true,
    forced: !$lCnHq
}, {
    "for": function(key) {
        var string = $l2Ut5(key);
        if ($heVlo($4a5f7eb962eeacc9$var$StringToSymbolRegistry, string)) return $4a5f7eb962eeacc9$var$StringToSymbolRegistry[string];
        var symbol = $5Pobw("Symbol")(string);
        $4a5f7eb962eeacc9$var$StringToSymbolRegistry[string] = symbol;
        $4a5f7eb962eeacc9$var$SymbolToStringRegistry[symbol] = string;
        return symbol;
    }
});

});
parcelRequire.register("lCnHq", function(module, exports) {

var $e1lwM = parcelRequire("e1lwM");
/* eslint-disable es/no-symbol -- safe */ module.exports = $e1lwM && !!Symbol["for"] && !!Symbol.keyFor;

});


parcelRequire.register("a7I9i", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $heVlo = parcelRequire("heVlo");

var $jpeSb = parcelRequire("jpeSb");

var $k9gzN = parcelRequire("k9gzN");

var $3hwUC = parcelRequire("3hwUC");

var $lCnHq = parcelRequire("lCnHq");
var $75eccde7a410c69b$var$SymbolToStringRegistry = $3hwUC("symbol-to-string-registry");
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$ggcsv({
    target: "Symbol",
    stat: true,
    forced: !$lCnHq
}, {
    keyFor: function keyFor(sym) {
        if (!$jpeSb(sym)) throw TypeError($k9gzN(sym) + " is not a symbol");
        if ($heVlo($75eccde7a410c69b$var$SymbolToStringRegistry, sym)) return $75eccde7a410c69b$var$SymbolToStringRegistry[sym];
    }
});

});

parcelRequire.register("kvPdS", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $5Pobw = parcelRequire("5Pobw");

var $2JOsI = parcelRequire("2JOsI");

var $aELZY = parcelRequire("aELZY");

var $f518o = parcelRequire("f518o");

var $77TPA = parcelRequire("77TPA");

var $e6Rz5 = parcelRequire("e6Rz5");

var $jpeSb = parcelRequire("jpeSb");

var $hF40G = parcelRequire("hF40G");

var $7cIyi = parcelRequire("7cIyi");

var $e1lwM = parcelRequire("e1lwM");
var $eeee6fa84fef6c89$var$$String = String;
var $eeee6fa84fef6c89$var$$stringify = $5Pobw("JSON", "stringify");
var $eeee6fa84fef6c89$var$exec = $f518o(/./.exec);
var $eeee6fa84fef6c89$var$charAt = $f518o("".charAt);
var $eeee6fa84fef6c89$var$charCodeAt = $f518o("".charCodeAt);
var $eeee6fa84fef6c89$var$replace = $f518o("".replace);
var $eeee6fa84fef6c89$var$numberToString = $f518o(1.0.toString);
var $eeee6fa84fef6c89$var$tester = /[\uD800-\uDFFF]/g;
var $eeee6fa84fef6c89$var$low = /^[\uD800-\uDBFF]$/;
var $eeee6fa84fef6c89$var$hi = /^[\uDC00-\uDFFF]$/;
var $eeee6fa84fef6c89$var$WRONG_SYMBOLS_CONVERSION = !$e1lwM || $77TPA(function() {
    var symbol = $5Pobw("Symbol")();
    // MS Edge converts symbol values to JSON as {}
    return $eeee6fa84fef6c89$var$$stringify([
        symbol
    ]) != "[null]" || $eeee6fa84fef6c89$var$$stringify({
        a: symbol
    }) != "{}" || $eeee6fa84fef6c89$var$$stringify(Object(symbol)) != "{}";
});
// https://github.com/tc39/proposal-well-formed-stringify
var $eeee6fa84fef6c89$var$ILL_FORMED_UNICODE = $77TPA(function() {
    return $eeee6fa84fef6c89$var$$stringify("\uDF06\uD834") !== '"\udf06\ud834"' || $eeee6fa84fef6c89$var$$stringify("\uDEAD") !== '"\udead"';
});
var $eeee6fa84fef6c89$var$stringifyWithSymbolsFix = function(it, replacer) {
    var args = $hF40G(arguments);
    var $replacer = $7cIyi(replacer);
    if (!$e6Rz5($replacer) && (it === undefined || $jpeSb(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($e6Rz5($replacer)) value = $aELZY($replacer, this, $eeee6fa84fef6c89$var$$String(key), value);
        if (!$jpeSb(value)) return value;
    };
    return $2JOsI($eeee6fa84fef6c89$var$$stringify, null, args);
};
var $eeee6fa84fef6c89$var$fixIllFormed = function(match, offset, string) {
    var prev = $eeee6fa84fef6c89$var$charAt(string, offset - 1);
    var next = $eeee6fa84fef6c89$var$charAt(string, offset + 1);
    if ($eeee6fa84fef6c89$var$exec($eeee6fa84fef6c89$var$low, match) && !$eeee6fa84fef6c89$var$exec($eeee6fa84fef6c89$var$hi, next) || $eeee6fa84fef6c89$var$exec($eeee6fa84fef6c89$var$hi, match) && !$eeee6fa84fef6c89$var$exec($eeee6fa84fef6c89$var$low, prev)) return "\\u" + $eeee6fa84fef6c89$var$numberToString($eeee6fa84fef6c89$var$charCodeAt(match, 0), 16);
    return match;
};
if ($eeee6fa84fef6c89$var$$stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$ggcsv({
    target: "JSON",
    stat: true,
    arity: 3,
    forced: $eeee6fa84fef6c89$var$WRONG_SYMBOLS_CONVERSION || $eeee6fa84fef6c89$var$ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = $hF40G(arguments);
        var result = $2JOsI($eeee6fa84fef6c89$var$WRONG_SYMBOLS_CONVERSION ? $eeee6fa84fef6c89$var$stringifyWithSymbolsFix : $eeee6fa84fef6c89$var$$stringify, null, args);
        return $eeee6fa84fef6c89$var$ILL_FORMED_UNICODE && typeof result == "string" ? $eeee6fa84fef6c89$var$replace(result, $eeee6fa84fef6c89$var$tester, $eeee6fa84fef6c89$var$fixIllFormed) : result;
    }
});

});
parcelRequire.register("hF40G", function(module, exports) {

var $f518o = parcelRequire("f518o");
module.exports = $f518o([].slice);

});

parcelRequire.register("7cIyi", function(module, exports) {

var $f518o = parcelRequire("f518o");

var $5zZFa = parcelRequire("5zZFa");

var $e6Rz5 = parcelRequire("e6Rz5");

var $bTsfg = parcelRequire("bTsfg");

var $l2Ut5 = parcelRequire("l2Ut5");
var $53ec368500e5db3b$var$push = $f518o([].push);
module.exports = function(replacer) {
    if ($e6Rz5(replacer)) return replacer;
    if (!$5zZFa(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == "string") $53ec368500e5db3b$var$push(keys, element);
        else if (typeof element == "number" || $bTsfg(element) == "Number" || $bTsfg(element) == "String") $53ec368500e5db3b$var$push(keys, $l2Ut5(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($5zZFa(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};

});


parcelRequire.register("jKKLo", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $e1lwM = parcelRequire("e1lwM");

var $77TPA = parcelRequire("77TPA");

var $4BK7o = parcelRequire("4BK7o");

var $iJNxK = parcelRequire("iJNxK");
// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $e616966c6146c7ae$var$FORCED = !$e1lwM || $77TPA(function() {
    $4BK7o.f(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$ggcsv({
    target: "Object",
    stat: true,
    forced: $e616966c6146c7ae$var$FORCED
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $4BK7o.f;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($iJNxK(it)) : [];
    }
});

});


parcelRequire.register("8uxl4", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$cHa91("asyncIterator");

});

parcelRequire.register("fqhMK", function(module, exports) {
// empty

});

parcelRequire.register("8awQv", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$cHa91("hasInstance");

});

parcelRequire.register("5w9fi", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$cHa91("isConcatSpreadable");

});

parcelRequire.register("5qCPf", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$cHa91("iterator");

});

parcelRequire.register("9t2TR", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$cHa91("match");

});

parcelRequire.register("6x2NK", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
$cHa91("matchAll");

});

parcelRequire.register("1X7iO", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$cHa91("replace");

});

parcelRequire.register("bKaho", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$cHa91("search");

});

parcelRequire.register("1mNbp", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$cHa91("species");

});

parcelRequire.register("dNcSW", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$cHa91("split");

});

parcelRequire.register("8m2Pj", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");

var $bPU03 = parcelRequire("bPU03");
// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$cHa91("toPrimitive");
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$bPU03();

});

parcelRequire.register("549n2", function(module, exports) {

var $5Pobw = parcelRequire("5Pobw");

var $cHa91 = parcelRequire("cHa91");

var $dheYH = parcelRequire("dheYH");
// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$cHa91("toStringTag");
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$dheYH($5Pobw("Symbol"), "Symbol");

});

parcelRequire.register("hvBC6", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$cHa91("unscopables");

});

parcelRequire.register("5wzrh", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");

var $dheYH = parcelRequire("dheYH");
// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$dheYH($3pyVf.JSON, "JSON", true);

});

parcelRequire.register("diqsM", function(module, exports) {
// empty

});

parcelRequire.register("iQ4e6", function(module, exports) {
// empty

});


parcelRequire.register("jXhxH", function(module, exports) {
parcelRequire("5xrGR");

var $gmmG5 = parcelRequire("gmmG5");

var $3pyVf = parcelRequire("3pyVf");

var $aHxiP = parcelRequire("aHxiP");

var $k4kcW = parcelRequire("k4kcW");

var $lmV2R = parcelRequire("lmV2R");

var $fq7H3 = parcelRequire("fq7H3");
var $e871229cc66a3590$var$TO_STRING_TAG = $fq7H3("toStringTag");
for(var $e871229cc66a3590$var$COLLECTION_NAME in $gmmG5){
    var $e871229cc66a3590$var$Collection = $3pyVf[$e871229cc66a3590$var$COLLECTION_NAME];
    var $e871229cc66a3590$var$CollectionPrototype = $e871229cc66a3590$var$Collection && $e871229cc66a3590$var$Collection.prototype;
    if ($e871229cc66a3590$var$CollectionPrototype && $aHxiP($e871229cc66a3590$var$CollectionPrototype) !== $e871229cc66a3590$var$TO_STRING_TAG) $k4kcW($e871229cc66a3590$var$CollectionPrototype, $e871229cc66a3590$var$TO_STRING_TAG, $e871229cc66a3590$var$COLLECTION_NAME);
    $lmV2R[$e871229cc66a3590$var$COLLECTION_NAME] = $lmV2R.Array;
}

});
parcelRequire.register("5xrGR", function(module, exports) {
"use strict";

var $bYkAs = parcelRequire("bYkAs");

var $ajzxw = parcelRequire("ajzxw");

var $lmV2R = parcelRequire("lmV2R");

var $fmQ29 = parcelRequire("fmQ29");

var $diq7r = parcelRequire("diq7r");
var $408583899c0cb4a1$require$defineProperty = $diq7r.f;

var $5KUYO = parcelRequire("5KUYO");

var $5IrwJ = parcelRequire("5IrwJ");

var $7phdw = parcelRequire("7phdw");

var $jeZ4p = parcelRequire("jeZ4p");
var $408583899c0cb4a1$var$ARRAY_ITERATOR = "Array Iterator";
var $408583899c0cb4a1$var$setInternalState = $fmQ29.set;
var $408583899c0cb4a1$var$getInternalState = $fmQ29.getterFor($408583899c0cb4a1$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $5KUYO(Array, "Array", function(iterated, kind) {
    $408583899c0cb4a1$var$setInternalState(this, {
        type: $408583899c0cb4a1$var$ARRAY_ITERATOR,
        target: $bYkAs(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $408583899c0cb4a1$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $5IrwJ(undefined, true);
    }
    if (kind == "keys") return $5IrwJ(index, false);
    if (kind == "values") return $5IrwJ(target[index], false);
    return $5IrwJ([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $408583899c0cb4a1$var$values = $lmV2R.Arguments = $lmV2R.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$ajzxw("keys");
$ajzxw("values");
$ajzxw("entries");
// V8 ~ Chrome 45- bug
if (!$7phdw && $jeZ4p && $408583899c0cb4a1$var$values.name !== "values") try {
    $408583899c0cb4a1$require$defineProperty($408583899c0cb4a1$var$values, "name", {
        value: "values"
    });
} catch (error) {}

});
parcelRequire.register("ajzxw", function(module, exports) {
module.exports = function() {};

});

parcelRequire.register("lmV2R", function(module, exports) {
module.exports = {};

});

parcelRequire.register("5KUYO", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $7phdw = parcelRequire("7phdw");

var $3mtHt = parcelRequire("3mtHt");

var $e6Rz5 = parcelRequire("e6Rz5");

var $c713e = parcelRequire("c713e");

var $2pQL6 = parcelRequire("2pQL6");

var $6e7Qv = parcelRequire("6e7Qv");

var $dheYH = parcelRequire("dheYH");

var $k4kcW = parcelRequire("k4kcW");

var $kY5Tb = parcelRequire("kY5Tb");

var $fq7H3 = parcelRequire("fq7H3");

var $lmV2R = parcelRequire("lmV2R");

var $5cZ5h = parcelRequire("5cZ5h");
var $430d72a5b73e012e$var$PROPER_FUNCTION_NAME = $3mtHt.PROPER;
var $430d72a5b73e012e$var$CONFIGURABLE_FUNCTION_NAME = $3mtHt.CONFIGURABLE;
var $430d72a5b73e012e$var$IteratorPrototype = $5cZ5h.IteratorPrototype;
var $430d72a5b73e012e$var$BUGGY_SAFARI_ITERATORS = $5cZ5h.BUGGY_SAFARI_ITERATORS;
var $430d72a5b73e012e$var$ITERATOR = $fq7H3("iterator");
var $430d72a5b73e012e$var$KEYS = "keys";
var $430d72a5b73e012e$var$VALUES = "values";
var $430d72a5b73e012e$var$ENTRIES = "entries";
var $430d72a5b73e012e$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $c713e(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$430d72a5b73e012e$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $430d72a5b73e012e$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $430d72a5b73e012e$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $430d72a5b73e012e$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$430d72a5b73e012e$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$430d72a5b73e012e$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $2pQL6(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$7phdw && $2pQL6(CurrentIteratorPrototype) !== $430d72a5b73e012e$var$IteratorPrototype) {
                if ($6e7Qv) $6e7Qv(CurrentIteratorPrototype, $430d72a5b73e012e$var$IteratorPrototype);
                else if (!$e6Rz5(CurrentIteratorPrototype[$430d72a5b73e012e$var$ITERATOR])) $kY5Tb(CurrentIteratorPrototype, $430d72a5b73e012e$var$ITERATOR, $430d72a5b73e012e$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $dheYH(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($7phdw) $lmV2R[TO_STRING_TAG] = $430d72a5b73e012e$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($430d72a5b73e012e$var$PROPER_FUNCTION_NAME && DEFAULT == $430d72a5b73e012e$var$VALUES && nativeIterator && nativeIterator.name !== $430d72a5b73e012e$var$VALUES) {
        if (!$7phdw && $430d72a5b73e012e$var$CONFIGURABLE_FUNCTION_NAME) $k4kcW(IterablePrototype, "name", $430d72a5b73e012e$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $aELZY(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($430d72a5b73e012e$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($430d72a5b73e012e$var$KEYS),
            entries: getIterationMethod($430d72a5b73e012e$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($430d72a5b73e012e$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $kY5Tb(IterablePrototype, KEY, methods[KEY]);
        } else $ggcsv({
            target: NAME,
            proto: true,
            forced: $430d72a5b73e012e$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$7phdw || FORCED) && IterablePrototype[$430d72a5b73e012e$var$ITERATOR] !== defaultIterator) $kY5Tb(IterablePrototype, $430d72a5b73e012e$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $lmV2R[NAME] = defaultIterator;
    return methods;
};

});
parcelRequire.register("3mtHt", function(module, exports) {

var $jeZ4p = parcelRequire("jeZ4p");

var $heVlo = parcelRequire("heVlo");
var $272a77017ce23a3f$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $272a77017ce23a3f$var$getDescriptor = $jeZ4p && Object.getOwnPropertyDescriptor;
var $272a77017ce23a3f$var$EXISTS = $heVlo($272a77017ce23a3f$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $272a77017ce23a3f$var$PROPER = $272a77017ce23a3f$var$EXISTS && (function something() {}).name === "something";
var $272a77017ce23a3f$var$CONFIGURABLE = $272a77017ce23a3f$var$EXISTS && (!$jeZ4p || $jeZ4p && $272a77017ce23a3f$var$getDescriptor($272a77017ce23a3f$var$FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: $272a77017ce23a3f$var$EXISTS,
    PROPER: $272a77017ce23a3f$var$PROPER,
    CONFIGURABLE: $272a77017ce23a3f$var$CONFIGURABLE
};

});

parcelRequire.register("c713e", function(module, exports) {
"use strict";

var $5cZ5h = parcelRequire("5cZ5h");
var $8d16f43a61fa9285$require$IteratorPrototype = $5cZ5h.IteratorPrototype;

var $fhVPP = parcelRequire("fhVPP");

var $8c6fn = parcelRequire("8c6fn");

var $dheYH = parcelRequire("dheYH");

var $lmV2R = parcelRequire("lmV2R");
var $8d16f43a61fa9285$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $fhVPP($8d16f43a61fa9285$require$IteratorPrototype, {
        next: $8c6fn(+!ENUMERABLE_NEXT, next)
    });
    $dheYH(IteratorConstructor, TO_STRING_TAG, false, true);
    $lmV2R[TO_STRING_TAG] = $8d16f43a61fa9285$var$returnThis;
    return IteratorConstructor;
};

});
parcelRequire.register("5cZ5h", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");

var $e6Rz5 = parcelRequire("e6Rz5");

var $1WYwK = parcelRequire("1WYwK");

var $fhVPP = parcelRequire("fhVPP");

var $2pQL6 = parcelRequire("2pQL6");

var $kY5Tb = parcelRequire("kY5Tb");

var $fq7H3 = parcelRequire("fq7H3");

var $7phdw = parcelRequire("7phdw");
var $3cad74ce71fd0eea$var$ITERATOR = $fq7H3("iterator");
var $3cad74ce71fd0eea$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $3cad74ce71fd0eea$var$IteratorPrototype, $3cad74ce71fd0eea$var$PrototypeOfArrayIteratorPrototype, $3cad74ce71fd0eea$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $3cad74ce71fd0eea$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $3cad74ce71fd0eea$var$arrayIterator)) $3cad74ce71fd0eea$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $3cad74ce71fd0eea$var$PrototypeOfArrayIteratorPrototype = $2pQL6($2pQL6($3cad74ce71fd0eea$var$arrayIterator));
        if ($3cad74ce71fd0eea$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $3cad74ce71fd0eea$var$IteratorPrototype = $3cad74ce71fd0eea$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $3cad74ce71fd0eea$var$NEW_ITERATOR_PROTOTYPE = !$1WYwK($3cad74ce71fd0eea$var$IteratorPrototype) || $77TPA(function() {
    var test = {};
    // FF44- legacy iterators case
    return $3cad74ce71fd0eea$var$IteratorPrototype[$3cad74ce71fd0eea$var$ITERATOR].call(test) !== test;
});
if ($3cad74ce71fd0eea$var$NEW_ITERATOR_PROTOTYPE) $3cad74ce71fd0eea$var$IteratorPrototype = {};
else if ($7phdw) $3cad74ce71fd0eea$var$IteratorPrototype = $fhVPP($3cad74ce71fd0eea$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$e6Rz5($3cad74ce71fd0eea$var$IteratorPrototype[$3cad74ce71fd0eea$var$ITERATOR])) $kY5Tb($3cad74ce71fd0eea$var$IteratorPrototype, $3cad74ce71fd0eea$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $3cad74ce71fd0eea$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $3cad74ce71fd0eea$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRequire.register("2pQL6", function(module, exports) {

var $heVlo = parcelRequire("heVlo");

var $e6Rz5 = parcelRequire("e6Rz5");

var $iJNxK = parcelRequire("iJNxK");

var $aUKPz = parcelRequire("aUKPz");

var $lss67 = parcelRequire("lss67");
var $1c26d7549f99106c$var$IE_PROTO = $aUKPz("IE_PROTO");
var $1c26d7549f99106c$var$$Object = Object;
var $1c26d7549f99106c$var$ObjectPrototype = $1c26d7549f99106c$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $lss67 ? $1c26d7549f99106c$var$$Object.getPrototypeOf : function(O) {
    var object = $iJNxK(O);
    if ($heVlo(object, $1c26d7549f99106c$var$IE_PROTO)) return object[$1c26d7549f99106c$var$IE_PROTO];
    var constructor = object.constructor;
    if ($e6Rz5(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $1c26d7549f99106c$var$$Object ? $1c26d7549f99106c$var$ObjectPrototype : null;
};

});
parcelRequire.register("lss67", function(module, exports) {

var $77TPA = parcelRequire("77TPA");
module.exports = !$77TPA(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});




parcelRequire.register("6e7Qv", function(module, exports) {
/* eslint-disable no-proto -- safe */ 
var $bDN0F = parcelRequire("bDN0F");

var $l3LMJ = parcelRequire("l3LMJ");

var $9Vbk9 = parcelRequire("9Vbk9");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $bDN0F(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $l3LMJ(O);
        $9Vbk9(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRequire.register("bDN0F", function(module, exports) {

var $f518o = parcelRequire("f518o");

var $8GsPx = parcelRequire("8GsPx");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $f518o($8GsPx(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRequire.register("9Vbk9", function(module, exports) {

var $e6Rz5 = parcelRequire("e6Rz5");
var $739238a3929f6003$var$$String = String;
var $739238a3929f6003$var$$TypeError = TypeError;
module.exports = function(argument) {
    if (typeof argument == "object" || $e6Rz5(argument)) return argument;
    throw $739238a3929f6003$var$$TypeError("Can't set " + $739238a3929f6003$var$$String(argument) + " as a prototype");
};

});



parcelRequire.register("5IrwJ", function(module, exports) {
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});


parcelRequire.register("gmmG5", function(module, exports) {
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});



parcelRequire.register("jgM91", function(module, exports) {

var $fq7H3 = parcelRequire("fq7H3");

var $diq7r = parcelRequire("diq7r");
var $e074db730ad1cf64$require$defineProperty = $diq7r.f;
var $e074db730ad1cf64$var$METADATA = $fq7H3("metadata");
var $e074db730ad1cf64$var$FunctionPrototype = Function.prototype;
// Function.prototype[@@metadata]
// https://github.com/tc39/proposal-decorator-metadata
if ($e074db730ad1cf64$var$FunctionPrototype[$e074db730ad1cf64$var$METADATA] === undefined) $e074db730ad1cf64$require$defineProperty($e074db730ad1cf64$var$FunctionPrototype, $e074db730ad1cf64$var$METADATA, {
    value: null
});

});

parcelRequire.register("il9RF", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$cHa91("dispose");

});

parcelRequire.register("ec6Rp", function(module, exports) {
// TODO: Remove from `core-js@4`

var $cHa91 = parcelRequire("cHa91");
// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
$cHa91("metadata");

});


parcelRequire.register("8QfZZ", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-async-explicit-resource-management
$cHa91("asyncDispose");

});

parcelRequire.register("h8IOe", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $aI91n = parcelRequire("aI91n");
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$ggcsv({
    target: "Symbol",
    stat: true
}, {
    isRegisteredSymbol: $aI91n
});

});
parcelRequire.register("aI91n", function(module, exports) {

var $5Pobw = parcelRequire("5Pobw");

var $f518o = parcelRequire("f518o");
var $7cc502dc9bbe7b43$var$Symbol = $5Pobw("Symbol");
var $7cc502dc9bbe7b43$var$keyFor = $7cc502dc9bbe7b43$var$Symbol.keyFor;
var $7cc502dc9bbe7b43$var$thisSymbolValue = $f518o($7cc502dc9bbe7b43$var$Symbol.prototype.valueOf);
// `Symbol.isRegisteredSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
module.exports = $7cc502dc9bbe7b43$var$Symbol.isRegisteredSymbol || function isRegisteredSymbol(value) {
    try {
        return $7cc502dc9bbe7b43$var$keyFor($7cc502dc9bbe7b43$var$thisSymbolValue(value)) !== undefined;
    } catch (error) {
        return false;
    }
};

});


parcelRequire.register("5oSUb", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $f31wA = parcelRequire("f31wA");
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$ggcsv({
    target: "Symbol",
    stat: true,
    forced: true
}, {
    isWellKnownSymbol: $f31wA
});

});
parcelRequire.register("f31wA", function(module, exports) {

var $3hwUC = parcelRequire("3hwUC");

var $5Pobw = parcelRequire("5Pobw");

var $f518o = parcelRequire("f518o");

var $jpeSb = parcelRequire("jpeSb");

var $fq7H3 = parcelRequire("fq7H3");
var $af485198f762da41$var$Symbol = $5Pobw("Symbol");
var $af485198f762da41$var$$isWellKnownSymbol = $af485198f762da41$var$Symbol.isWellKnownSymbol;
var $af485198f762da41$var$getOwnPropertyNames = $5Pobw("Object", "getOwnPropertyNames");
var $af485198f762da41$var$thisSymbolValue = $f518o($af485198f762da41$var$Symbol.prototype.valueOf);
var $af485198f762da41$var$WellKnownSymbolsStore = $3hwUC("wks");
for(var $af485198f762da41$var$i = 0, $af485198f762da41$var$symbolKeys = $af485198f762da41$var$getOwnPropertyNames($af485198f762da41$var$Symbol), $af485198f762da41$var$symbolKeysLength = $af485198f762da41$var$symbolKeys.length; $af485198f762da41$var$i < $af485198f762da41$var$symbolKeysLength; $af485198f762da41$var$i++)// some old engines throws on access to some keys like `arguments` or `caller`
try {
    var $af485198f762da41$var$symbolKey = $af485198f762da41$var$symbolKeys[$af485198f762da41$var$i];
    if ($jpeSb($af485198f762da41$var$Symbol[$af485198f762da41$var$symbolKey])) $fq7H3($af485198f762da41$var$symbolKey);
} catch (error) {}
// `Symbol.isWellKnownSymbol` method
// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
module.exports = function isWellKnownSymbol(value) {
    if ($af485198f762da41$var$$isWellKnownSymbol && $af485198f762da41$var$$isWellKnownSymbol(value)) return true;
    try {
        var symbol = $af485198f762da41$var$thisSymbolValue(value);
        for(var j = 0, keys = $af485198f762da41$var$getOwnPropertyNames($af485198f762da41$var$WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++){
            if ($af485198f762da41$var$WellKnownSymbolsStore[keys[j]] == symbol) return true;
        }
    } catch (error) {}
    return false;
};

});


parcelRequire.register("1kp86", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$cHa91("matcher");

});

parcelRequire.register("i3G8Z", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$cHa91("observable");

});

parcelRequire.register("fVjjW", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $aI91n = parcelRequire("aI91n");
// `Symbol.isRegistered` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
$ggcsv({
    target: "Symbol",
    stat: true,
    name: "isRegisteredSymbol"
}, {
    isRegistered: $aI91n
});

});

parcelRequire.register("6Vj7u", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $f31wA = parcelRequire("f31wA");
// `Symbol.isWellKnown` method
// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
$ggcsv({
    target: "Symbol",
    stat: true,
    name: "isWellKnownSymbol",
    forced: true
}, {
    isWellKnown: $f31wA
});

});

parcelRequire.register("kSb0Q", function(module, exports) {

var $cHa91 = parcelRequire("cHa91");
// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
$cHa91("metadataKey");

});

parcelRequire.register("4IO6j", function(module, exports) {
// TODO: remove from `core-js@4`

var $cHa91 = parcelRequire("cHa91");
// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$cHa91("patternMatch");

});

parcelRequire.register("9RLNS", function(module, exports) {
// TODO: remove from `core-js@4`

var $cHa91 = parcelRequire("cHa91");
$cHa91("replaceAll");

});




parcelRequire.register("afsHL", function(module, exports) {

module.exports = (parcelRequire("g71bB"));

});
parcelRequire.register("g71bB", function(module, exports) {

module.exports = (parcelRequire("4zyOz"));

});
parcelRequire.register("4zyOz", function(module, exports) {

var $hk00C = parcelRequire("hk00C");
module.exports = $hk00C;

});
parcelRequire.register("hk00C", function(module, exports) {

var $gjewt = parcelRequire("gjewt");
module.exports = $gjewt;

});
parcelRequire.register("gjewt", function(module, exports) {

var $leuHo = parcelRequire("leuHo");
parcelRequire("jXhxH");
module.exports = $leuHo;

});
parcelRequire.register("leuHo", function(module, exports) {
parcelRequire("5xrGR");
parcelRequire("iYyco");
parcelRequire("ja2zQ");
parcelRequire("5qCPf");

var $knUX7 = parcelRequire("knUX7");
module.exports = $knUX7.f("iterator");

});
parcelRequire.register("ja2zQ", function(module, exports) {
"use strict";

var $4TFls = parcelRequire("4TFls");
var $df30f33d6e780b35$require$charAt = $4TFls.charAt;

var $l2Ut5 = parcelRequire("l2Ut5");

var $fmQ29 = parcelRequire("fmQ29");

var $5KUYO = parcelRequire("5KUYO");

var $5IrwJ = parcelRequire("5IrwJ");
var $df30f33d6e780b35$var$STRING_ITERATOR = "String Iterator";
var $df30f33d6e780b35$var$setInternalState = $fmQ29.set;
var $df30f33d6e780b35$var$getInternalState = $fmQ29.getterFor($df30f33d6e780b35$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$5KUYO(String, "String", function(iterated) {
    $df30f33d6e780b35$var$setInternalState(this, {
        type: $df30f33d6e780b35$var$STRING_ITERATOR,
        string: $l2Ut5(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $df30f33d6e780b35$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $5IrwJ(undefined, true);
    point = $df30f33d6e780b35$require$charAt(string, index);
    state.index += point.length;
    return $5IrwJ(point, false);
});

});
parcelRequire.register("4TFls", function(module, exports) {

var $f518o = parcelRequire("f518o");

var $3ZmxQ = parcelRequire("3ZmxQ");

var $l2Ut5 = parcelRequire("l2Ut5");

var $cBWnS = parcelRequire("cBWnS");
var $390c5ec511d9538f$var$charAt = $f518o("".charAt);
var $390c5ec511d9538f$var$charCodeAt = $f518o("".charCodeAt);
var $390c5ec511d9538f$var$stringSlice = $f518o("".slice);
var $390c5ec511d9538f$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $l2Ut5($cBWnS($this));
        var position = $3ZmxQ(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $390c5ec511d9538f$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $390c5ec511d9538f$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $390c5ec511d9538f$var$charAt(S, position) : first : CONVERT_TO_STRING ? $390c5ec511d9538f$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $390c5ec511d9538f$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $390c5ec511d9538f$var$createMethod(true)
};

});









parcelRequire.register("1X85b", function(module, exports) {

module.exports = (parcelRequire("bZPfD"));

});
parcelRequire.register("bZPfD", function(module, exports) {

var $9ugx4 = parcelRequire("9ugx4");
parcelRequire("jXhxH");
module.exports = $9ugx4;

});
parcelRequire.register("9ugx4", function(module, exports) {
parcelRequire("5xrGR");
parcelRequire("iYyco");
parcelRequire("15yqC");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.WeakMap;

});
parcelRequire.register("15yqC", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's replaced to module below
parcelRequire("8jHfZ");

});
parcelRequire.register("8jHfZ", function(module, exports) {
"use strict";

var $7DccQ = parcelRequire("7DccQ");

var $3pyVf = parcelRequire("3pyVf");

var $f518o = parcelRequire("f518o");

var $gklY2 = parcelRequire("gklY2");

var $iZE4H = parcelRequire("iZE4H");

var $30YqS = parcelRequire("30YqS");

var $f9bwY = parcelRequire("f9bwY");

var $1WYwK = parcelRequire("1WYwK");

var $fmQ29 = parcelRequire("fmQ29");
var $60e1a7058f7ed582$require$enforceInternalState = $fmQ29.enforce;

var $77TPA = parcelRequire("77TPA");

var $3rZfY = parcelRequire("3rZfY");
var $60e1a7058f7ed582$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $60e1a7058f7ed582$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $60e1a7058f7ed582$var$isExtensible = $60e1a7058f7ed582$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $60e1a7058f7ed582$var$isFrozen = $60e1a7058f7ed582$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $60e1a7058f7ed582$var$isSealed = $60e1a7058f7ed582$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $60e1a7058f7ed582$var$freeze = $60e1a7058f7ed582$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $60e1a7058f7ed582$var$seal = $60e1a7058f7ed582$var$$Object.seal;
var $60e1a7058f7ed582$var$FROZEN = {};
var $60e1a7058f7ed582$var$SEALED = {};
var $60e1a7058f7ed582$var$IS_IE11 = !$3pyVf.ActiveXObject && "ActiveXObject" in $3pyVf;
var $60e1a7058f7ed582$var$InternalWeakMap;
var $60e1a7058f7ed582$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $60e1a7058f7ed582$var$$WeakMap = $30YqS("WeakMap", $60e1a7058f7ed582$var$wrapper, $f9bwY);
var $60e1a7058f7ed582$var$WeakMapPrototype = $60e1a7058f7ed582$var$$WeakMap.prototype;
var $60e1a7058f7ed582$var$nativeSet = $f518o($60e1a7058f7ed582$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $60e1a7058f7ed582$var$hasMSEdgeFreezingBug = function() {
    return $7DccQ && $77TPA(function() {
        var frozenArray = $60e1a7058f7ed582$var$freeze([]);
        $60e1a7058f7ed582$var$nativeSet(new $60e1a7058f7ed582$var$$WeakMap(), frozenArray, 1);
        return !$60e1a7058f7ed582$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($3rZfY) {
    if ($60e1a7058f7ed582$var$IS_IE11) {
        $60e1a7058f7ed582$var$InternalWeakMap = $f9bwY.getConstructor($60e1a7058f7ed582$var$wrapper, "WeakMap", true);
        $iZE4H.enable();
        var $60e1a7058f7ed582$var$nativeDelete = $f518o($60e1a7058f7ed582$var$WeakMapPrototype["delete"]);
        var $60e1a7058f7ed582$var$nativeHas = $f518o($60e1a7058f7ed582$var$WeakMapPrototype.has);
        var $60e1a7058f7ed582$var$nativeGet = $f518o($60e1a7058f7ed582$var$WeakMapPrototype.get);
        $gklY2($60e1a7058f7ed582$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($1WYwK(key) && !$60e1a7058f7ed582$var$isExtensible(key)) {
                    var state = $60e1a7058f7ed582$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $60e1a7058f7ed582$var$InternalWeakMap();
                    return $60e1a7058f7ed582$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $60e1a7058f7ed582$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($1WYwK(key) && !$60e1a7058f7ed582$var$isExtensible(key)) {
                    var state = $60e1a7058f7ed582$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $60e1a7058f7ed582$var$InternalWeakMap();
                    return $60e1a7058f7ed582$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $60e1a7058f7ed582$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($1WYwK(key) && !$60e1a7058f7ed582$var$isExtensible(key)) {
                    var state = $60e1a7058f7ed582$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $60e1a7058f7ed582$var$InternalWeakMap();
                    return $60e1a7058f7ed582$var$nativeHas(this, key) ? $60e1a7058f7ed582$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $60e1a7058f7ed582$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($1WYwK(key) && !$60e1a7058f7ed582$var$isExtensible(key)) {
                    var state = $60e1a7058f7ed582$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $60e1a7058f7ed582$var$InternalWeakMap();
                    $60e1a7058f7ed582$var$nativeHas(this, key) ? $60e1a7058f7ed582$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $60e1a7058f7ed582$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($60e1a7058f7ed582$var$hasMSEdgeFreezingBug()) $gklY2($60e1a7058f7ed582$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($60e1a7058f7ed582$var$isArray(key)) {
                if ($60e1a7058f7ed582$var$isFrozen(key)) arrayIntegrityLevel = $60e1a7058f7ed582$var$FROZEN;
                else if ($60e1a7058f7ed582$var$isSealed(key)) arrayIntegrityLevel = $60e1a7058f7ed582$var$SEALED;
            }
            $60e1a7058f7ed582$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel == $60e1a7058f7ed582$var$FROZEN) $60e1a7058f7ed582$var$freeze(key);
            if (arrayIntegrityLevel == $60e1a7058f7ed582$var$SEALED) $60e1a7058f7ed582$var$seal(key);
            return this;
        }
    });
}

});
parcelRequire.register("7DccQ", function(module, exports) {

var $77TPA = parcelRequire("77TPA");
module.exports = !$77TPA(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});

});

parcelRequire.register("gklY2", function(module, exports) {

var $kY5Tb = parcelRequire("kY5Tb");
module.exports = function(target, src, options) {
    for(var key in src)if (options && options.unsafe && target[key]) target[key] = src[key];
    else $kY5Tb(target, key, src[key], options);
    return target;
};

});

parcelRequire.register("iZE4H", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $f518o = parcelRequire("f518o");

var $lKGD2 = parcelRequire("lKGD2");

var $1WYwK = parcelRequire("1WYwK");

var $heVlo = parcelRequire("heVlo");

var $diq7r = parcelRequire("diq7r");
var $dd3d02812fbc62e5$require$defineProperty = $diq7r.f;

var $9hUhV = parcelRequire("9hUhV");

var $cMezS = parcelRequire("cMezS");

var $CMtyq = parcelRequire("CMtyq");

var $kuKGb = parcelRequire("kuKGb");

var $7DccQ = parcelRequire("7DccQ");
var $dd3d02812fbc62e5$var$REQUIRED = false;
var $dd3d02812fbc62e5$var$METADATA = $kuKGb("meta");
var $dd3d02812fbc62e5$var$id = 0;
var $dd3d02812fbc62e5$var$setMetadata = function(it) {
    $dd3d02812fbc62e5$require$defineProperty(it, $dd3d02812fbc62e5$var$METADATA, {
        value: {
            objectID: "O" + $dd3d02812fbc62e5$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $dd3d02812fbc62e5$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$1WYwK(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$heVlo(it, $dd3d02812fbc62e5$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$CMtyq(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $dd3d02812fbc62e5$var$setMetadata(it);
    // return object ID
    }
    return it[$dd3d02812fbc62e5$var$METADATA].objectID;
};
var $dd3d02812fbc62e5$var$getWeakData = function(it, create) {
    if (!$heVlo(it, $dd3d02812fbc62e5$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$CMtyq(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $dd3d02812fbc62e5$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$dd3d02812fbc62e5$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $dd3d02812fbc62e5$var$onFreeze = function(it) {
    if ($7DccQ && $dd3d02812fbc62e5$var$REQUIRED && $CMtyq(it) && !$heVlo(it, $dd3d02812fbc62e5$var$METADATA)) $dd3d02812fbc62e5$var$setMetadata(it);
    return it;
};
var $dd3d02812fbc62e5$var$enable = function() {
    $dd3d02812fbc62e5$var$meta.enable = function() {};
    $dd3d02812fbc62e5$var$REQUIRED = true;
    var getOwnPropertyNames = $9hUhV.f;
    var splice = $f518o([].splice);
    var test = {};
    test[$dd3d02812fbc62e5$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $9hUhV.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $dd3d02812fbc62e5$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $ggcsv({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $cMezS.f
        });
    }
};
var $dd3d02812fbc62e5$var$meta = module.exports = {
    enable: $dd3d02812fbc62e5$var$enable,
    fastKey: $dd3d02812fbc62e5$var$fastKey,
    getWeakData: $dd3d02812fbc62e5$var$getWeakData,
    onFreeze: $dd3d02812fbc62e5$var$onFreeze
};
$lKGD2[$dd3d02812fbc62e5$var$METADATA] = true;

});
parcelRequire.register("CMtyq", function(module, exports) {

var $77TPA = parcelRequire("77TPA");

var $1WYwK = parcelRequire("1WYwK");

var $bTsfg = parcelRequire("bTsfg");

var $4DiPJ = parcelRequire("4DiPJ");
// eslint-disable-next-line es/no-object-isextensible -- safe
var $074926fc34266401$var$$isExtensible = Object.isExtensible;
var $074926fc34266401$var$FAILS_ON_PRIMITIVES = $77TPA(function() {
    $074926fc34266401$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = $074926fc34266401$var$FAILS_ON_PRIMITIVES || $4DiPJ ? function isExtensible(it) {
    if (!$1WYwK(it)) return false;
    if ($4DiPJ && $bTsfg(it) == "ArrayBuffer") return false;
    return $074926fc34266401$var$$isExtensible ? $074926fc34266401$var$$isExtensible(it) : true;
} : $074926fc34266401$var$$isExtensible;

});
parcelRequire.register("4DiPJ", function(module, exports) {
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it

var $77TPA = parcelRequire("77TPA");
module.exports = $77TPA(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});

});



parcelRequire.register("30YqS", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $3pyVf = parcelRequire("3pyVf");

var $iZE4H = parcelRequire("iZE4H");

var $77TPA = parcelRequire("77TPA");

var $k4kcW = parcelRequire("k4kcW");

var $jUk8Y = parcelRequire("jUk8Y");

var $a95no = parcelRequire("a95no");

var $e6Rz5 = parcelRequire("e6Rz5");

var $1WYwK = parcelRequire("1WYwK");

var $dheYH = parcelRequire("dheYH");

var $diq7r = parcelRequire("diq7r");
var $23203fd0f826b34f$require$defineProperty = $diq7r.f;

var $igsV9 = parcelRequire("igsV9");
var $23203fd0f826b34f$require$forEach = $igsV9.forEach;

var $jeZ4p = parcelRequire("jeZ4p");

var $fmQ29 = parcelRequire("fmQ29");
var $23203fd0f826b34f$var$setInternalState = $fmQ29.set;
var $23203fd0f826b34f$var$internalStateGetterFor = $fmQ29.getterFor;
module.exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $3pyVf[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var exported = {};
    var Constructor;
    if (!$jeZ4p || !$e6Rz5(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$77TPA(function() {
        new NativeConstructor().entries().next();
    }))) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $iZE4H.enable();
    } else {
        Constructor = wrapper(function(target, iterable) {
            $23203fd0f826b34f$var$setInternalState($a95no(target, Prototype), {
                type: CONSTRUCTOR_NAME,
                collection: new NativeConstructor()
            });
            if (iterable != undefined) $jUk8Y(iterable, target[ADDER], {
                that: target,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $23203fd0f826b34f$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        $23203fd0f826b34f$require$forEach([
            "add",
            "clear",
            "delete",
            "forEach",
            "get",
            "has",
            "set",
            "keys",
            "values",
            "entries"
        ], function(KEY) {
            var IS_ADDER = KEY == "add" || KEY == "set";
            if (KEY in NativePrototype && !(IS_WEAK && KEY == "clear")) $k4kcW(Prototype, KEY, function(a, b) {
                var collection = getInternalState(this).collection;
                if (!IS_ADDER && IS_WEAK && !$1WYwK(a)) return KEY == "get" ? undefined : false;
                var result = collection[KEY](a === 0 ? 0 : a, b);
                return IS_ADDER ? this : result;
            });
        });
        IS_WEAK || $23203fd0f826b34f$require$defineProperty(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).collection.size;
            }
        });
    }
    $dheYH(Constructor, CONSTRUCTOR_NAME, false, true);
    exported[CONSTRUCTOR_NAME] = Constructor;
    $ggcsv({
        global: true,
        forced: true
    }, exported);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};

});
parcelRequire.register("jUk8Y", function(module, exports) {

var $b5UsH = parcelRequire("b5UsH");

var $aELZY = parcelRequire("aELZY");

var $l3LMJ = parcelRequire("l3LMJ");

var $k9gzN = parcelRequire("k9gzN");

var $b4lk6 = parcelRequire("b4lk6");

var $6ocdr = parcelRequire("6ocdr");

var $8hsAO = parcelRequire("8hsAO");

var $3Tvts = parcelRequire("3Tvts");

var $7qrIj = parcelRequire("7qrIj");

var $2l0vW = parcelRequire("2l0vW");
var $e7e2df65bcc557ea$var$$TypeError = TypeError;
var $e7e2df65bcc557ea$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $e7e2df65bcc557ea$var$ResultPrototype = $e7e2df65bcc557ea$var$Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $b5UsH(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $2l0vW(iterator, "normal", condition);
        return new $e7e2df65bcc557ea$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $l3LMJ(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $7qrIj(iterable);
        if (!iterFn) throw $e7e2df65bcc557ea$var$$TypeError($k9gzN(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($b4lk6(iterFn)) {
            for(index = 0, length = $6ocdr(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $8hsAO($e7e2df65bcc557ea$var$ResultPrototype, result)) return result;
            }
            return new $e7e2df65bcc557ea$var$Result(false);
        }
        iterator = $3Tvts(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $aELZY(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $2l0vW(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $8hsAO($e7e2df65bcc557ea$var$ResultPrototype, result)) return result;
    }
    return new $e7e2df65bcc557ea$var$Result(false);
};

});
parcelRequire.register("b4lk6", function(module, exports) {

var $fq7H3 = parcelRequire("fq7H3");

var $lmV2R = parcelRequire("lmV2R");
var $80f09bc4b6f9a218$var$ITERATOR = $fq7H3("iterator");
var $80f09bc4b6f9a218$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($lmV2R.Array === it || $80f09bc4b6f9a218$var$ArrayPrototype[$80f09bc4b6f9a218$var$ITERATOR] === it);
};

});

parcelRequire.register("3Tvts", function(module, exports) {

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $l3LMJ = parcelRequire("l3LMJ");

var $k9gzN = parcelRequire("k9gzN");

var $7qrIj = parcelRequire("7qrIj");
var $2d5eec4516fc0054$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $7qrIj(argument) : usingIterator;
    if ($8GsPx(iteratorMethod)) return $l3LMJ($aELZY(iteratorMethod, argument));
    throw $2d5eec4516fc0054$var$$TypeError($k9gzN(argument) + " is not iterable");
};

});
parcelRequire.register("7qrIj", function(module, exports) {

var $aHxiP = parcelRequire("aHxiP");

var $k0Syp = parcelRequire("k0Syp");

var $6exeg = parcelRequire("6exeg");

var $lmV2R = parcelRequire("lmV2R");

var $fq7H3 = parcelRequire("fq7H3");
var $5680757ad4007747$var$ITERATOR = $fq7H3("iterator");
module.exports = function(it) {
    if (!$6exeg(it)) return $k0Syp(it, $5680757ad4007747$var$ITERATOR) || $k0Syp(it, "@@iterator") || $lmV2R[$aHxiP(it)];
};

});


parcelRequire.register("2l0vW", function(module, exports) {

var $aELZY = parcelRequire("aELZY");

var $l3LMJ = parcelRequire("l3LMJ");

var $k0Syp = parcelRequire("k0Syp");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $l3LMJ(iterator);
    try {
        innerResult = $k0Syp(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $aELZY(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $l3LMJ(innerResult);
    return value;
};

});


parcelRequire.register("a95no", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");
var $762eea4538129b77$var$$TypeError = TypeError;
module.exports = function(it, Prototype) {
    if ($8hsAO(Prototype, it)) return it;
    throw $762eea4538129b77$var$$TypeError("Incorrect invocation");
};

});


parcelRequire.register("f9bwY", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $gklY2 = parcelRequire("gklY2");

var $iZE4H = parcelRequire("iZE4H");
var $b070a40e5a3e5284$require$getWeakData = $iZE4H.getWeakData;

var $a95no = parcelRequire("a95no");

var $l3LMJ = parcelRequire("l3LMJ");

var $6exeg = parcelRequire("6exeg");

var $1WYwK = parcelRequire("1WYwK");

var $jUk8Y = parcelRequire("jUk8Y");

var $igsV9 = parcelRequire("igsV9");

var $heVlo = parcelRequire("heVlo");

var $fmQ29 = parcelRequire("fmQ29");
var $b070a40e5a3e5284$var$setInternalState = $fmQ29.set;
var $b070a40e5a3e5284$var$internalStateGetterFor = $fmQ29.getterFor;
var $b070a40e5a3e5284$var$find = $igsV9.find;
var $b070a40e5a3e5284$var$findIndex = $igsV9.findIndex;
var $b070a40e5a3e5284$var$splice = $f518o([].splice);
var $b070a40e5a3e5284$var$id = 0;
// fallback for uncaught frozen keys
var $b070a40e5a3e5284$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $b070a40e5a3e5284$var$UncaughtFrozenStore());
};
var $b070a40e5a3e5284$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $b070a40e5a3e5284$var$findUncaughtFrozen = function(store, key) {
    return $b070a40e5a3e5284$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$b070a40e5a3e5284$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $b070a40e5a3e5284$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$b070a40e5a3e5284$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $b070a40e5a3e5284$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $b070a40e5a3e5284$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $b070a40e5a3e5284$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
module.exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $a95no(that, Prototype);
            $b070a40e5a3e5284$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $b070a40e5a3e5284$var$id++,
                frozen: undefined
            });
            if (!$6exeg(iterable)) $jUk8Y(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $b070a40e5a3e5284$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $b070a40e5a3e5284$require$getWeakData($l3LMJ(key), true);
            if (data === true) $b070a40e5a3e5284$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $gklY2(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$1WYwK(key)) return false;
                var data = $b070a40e5a3e5284$require$getWeakData(key);
                if (data === true) return $b070a40e5a3e5284$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $heVlo(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$1WYwK(key)) return false;
                var data = $b070a40e5a3e5284$require$getWeakData(key);
                if (data === true) return $b070a40e5a3e5284$var$uncaughtFrozenStore(state).has(key);
                return data && $heVlo(data, state.id);
            }
        });
        $gklY2(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($1WYwK(key)) {
                    var data = $b070a40e5a3e5284$require$getWeakData(key);
                    if (data === true) return $b070a40e5a3e5284$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};

});






parcelRequire.register("iH0WI", function(module, exports) {

module.exports = (parcelRequire("5XWAD"));

});
parcelRequire.register("5XWAD", function(module, exports) {

var $iplN3 = parcelRequire("iplN3");
parcelRequire("jXhxH");
module.exports = $iplN3;

});
parcelRequire.register("iplN3", function(module, exports) {
parcelRequire("l3Lsr");
parcelRequire("5xrGR");
parcelRequire("iYyco");
parcelRequire("hwEmk");
parcelRequire("ettPZ");
parcelRequire("hakp0");
parcelRequire("wzhSp");
parcelRequire("ja2zQ");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Promise;

});
parcelRequire.register("l3Lsr", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's replaced to module below
parcelRequire("6wipU");

});
parcelRequire.register("6wipU", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $8hsAO = parcelRequire("8hsAO");

var $2pQL6 = parcelRequire("2pQL6");

var $6e7Qv = parcelRequire("6e7Qv");

var $fNJMH = parcelRequire("fNJMH");

var $fhVPP = parcelRequire("fhVPP");

var $k4kcW = parcelRequire("k4kcW");

var $8c6fn = parcelRequire("8c6fn");

var $2UmSX = parcelRequire("2UmSX");

var $hqQHV = parcelRequire("hqQHV");

var $jUk8Y = parcelRequire("jUk8Y");

var $d1QGz = parcelRequire("d1QGz");

var $fq7H3 = parcelRequire("fq7H3");
var $4bf40474de7b2e05$var$TO_STRING_TAG = $fq7H3("toStringTag");
var $4bf40474de7b2e05$var$$Error = Error;
var $4bf40474de7b2e05$var$push = [].push;
var $4bf40474de7b2e05$var$$AggregateError = function AggregateError(errors, message /* , options */ ) {
    var isInstance = $8hsAO($4bf40474de7b2e05$var$AggregateErrorPrototype, this);
    var that;
    if ($6e7Qv) that = $6e7Qv($4bf40474de7b2e05$var$$Error(), isInstance ? $2pQL6(this) : $4bf40474de7b2e05$var$AggregateErrorPrototype);
    else {
        that = isInstance ? this : $fhVPP($4bf40474de7b2e05$var$AggregateErrorPrototype);
        $k4kcW(that, $4bf40474de7b2e05$var$TO_STRING_TAG, "Error");
    }
    if (message !== undefined) $k4kcW(that, "message", $d1QGz(message));
    $hqQHV(that, $4bf40474de7b2e05$var$$AggregateError, that.stack, 1);
    if (arguments.length > 2) $2UmSX(that, arguments[2]);
    var errorsArray = [];
    $jUk8Y(errors, $4bf40474de7b2e05$var$push, {
        that: errorsArray
    });
    $k4kcW(that, "errors", errorsArray);
    return that;
};
if ($6e7Qv) $6e7Qv($4bf40474de7b2e05$var$$AggregateError, $4bf40474de7b2e05$var$$Error);
else $fNJMH($4bf40474de7b2e05$var$$AggregateError, $4bf40474de7b2e05$var$$Error, {
    name: true
});
var $4bf40474de7b2e05$var$AggregateErrorPrototype = $4bf40474de7b2e05$var$$AggregateError.prototype = $fhVPP($4bf40474de7b2e05$var$$Error.prototype, {
    constructor: $8c6fn(1, $4bf40474de7b2e05$var$$AggregateError),
    message: $8c6fn(1, ""),
    name: $8c6fn(1, "AggregateError")
});
// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$ggcsv({
    global: true,
    constructor: true,
    arity: 2
}, {
    AggregateError: $4bf40474de7b2e05$var$$AggregateError
});

});
parcelRequire.register("fNJMH", function(module, exports) {

var $heVlo = parcelRequire("heVlo");

var $eNGig = parcelRequire("eNGig");

var $fTFId = parcelRequire("fTFId");

var $diq7r = parcelRequire("diq7r");
module.exports = function(target, source, exceptions) {
    var keys = $eNGig(source);
    var defineProperty = $diq7r.f;
    var getOwnPropertyDescriptor = $fTFId.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$heVlo(target, key) && !(exceptions && $heVlo(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRequire.register("eNGig", function(module, exports) {

var $5Pobw = parcelRequire("5Pobw");

var $f518o = parcelRequire("f518o");

var $9hUhV = parcelRequire("9hUhV");

var $4BK7o = parcelRequire("4BK7o");

var $l3LMJ = parcelRequire("l3LMJ");
var $ac6672e9a4de8594$var$concat = $f518o([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $5Pobw("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $9hUhV.f($l3LMJ(it));
    var getOwnPropertySymbols = $4BK7o.f;
    return getOwnPropertySymbols ? $ac6672e9a4de8594$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});


parcelRequire.register("2UmSX", function(module, exports) {

var $1WYwK = parcelRequire("1WYwK");

var $k4kcW = parcelRequire("k4kcW");
// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function(O, options) {
    if ($1WYwK(options) && "cause" in options) $k4kcW(O, "cause", options.cause);
};

});

parcelRequire.register("hqQHV", function(module, exports) {

var $k4kcW = parcelRequire("k4kcW");

var $6Gy1W = parcelRequire("6Gy1W");

var $8Dt96 = parcelRequire("8Dt96");
// non-standard V8
var $cb0dbff8b0356666$var$captureStackTrace = Error.captureStackTrace;
module.exports = function(error, C, stack, dropEntries) {
    if ($8Dt96) {
        if ($cb0dbff8b0356666$var$captureStackTrace) $cb0dbff8b0356666$var$captureStackTrace(error, C);
        else $k4kcW(error, "stack", $6Gy1W(stack, dropEntries));
    }
};

});
parcelRequire.register("6Gy1W", function(module, exports) {

var $f518o = parcelRequire("f518o");
var $4de1100d8939e62c$var$$Error = Error;
var $4de1100d8939e62c$var$replace = $f518o("".replace);
var $4de1100d8939e62c$var$TEST = function(arg) {
    return String($4de1100d8939e62c$var$$Error(arg).stack);
}("zxcasd");
// eslint-disable-next-line redos/no-vulnerable -- safe
var $4de1100d8939e62c$var$V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var $4de1100d8939e62c$var$IS_V8_OR_CHAKRA_STACK = $4de1100d8939e62c$var$V8_OR_CHAKRA_STACK_ENTRY.test($4de1100d8939e62c$var$TEST);
module.exports = function(stack, dropEntries) {
    if ($4de1100d8939e62c$var$IS_V8_OR_CHAKRA_STACK && typeof stack == "string" && !$4de1100d8939e62c$var$$Error.prepareStackTrace) while(dropEntries--)stack = $4de1100d8939e62c$var$replace(stack, $4de1100d8939e62c$var$V8_OR_CHAKRA_STACK_ENTRY, "");
    return stack;
};

});

parcelRequire.register("8Dt96", function(module, exports) {

var $77TPA = parcelRequire("77TPA");

var $8c6fn = parcelRequire("8c6fn");
module.exports = !$77TPA(function() {
    var error = Error("a");
    if (!("stack" in error)) return true;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(error, "stack", $8c6fn(1, 7));
    return error.stack !== 7;
});

});


parcelRequire.register("d1QGz", function(module, exports) {

var $l2Ut5 = parcelRequire("l2Ut5");
module.exports = function(argument, $default) {
    return argument === undefined ? arguments.length < 2 ? "" : $default : $l2Ut5(argument);
};

});



parcelRequire.register("hwEmk", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
parcelRequire("cDoup");
parcelRequire("fRDGg");
parcelRequire("bhLYs");
parcelRequire("fm27z");
parcelRequire("iGB6b");
parcelRequire("doKxr");

});
parcelRequire.register("cDoup", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $7phdw = parcelRequire("7phdw");

var $4jpM3 = parcelRequire("4jpM3");

var $3pyVf = parcelRequire("3pyVf");

var $aELZY = parcelRequire("aELZY");

var $kY5Tb = parcelRequire("kY5Tb");

var $6e7Qv = parcelRequire("6e7Qv");

var $dheYH = parcelRequire("dheYH");

var $13iqA = parcelRequire("13iqA");

var $8GsPx = parcelRequire("8GsPx");

var $e6Rz5 = parcelRequire("e6Rz5");

var $1WYwK = parcelRequire("1WYwK");

var $a95no = parcelRequire("a95no");

var $2FOd2 = parcelRequire("2FOd2");

var $htH5s = parcelRequire("htH5s");
var $932c1fa8a18a7d3b$require$task = $htH5s.set;

var $e02YY = parcelRequire("e02YY");

var $eCofm = parcelRequire("eCofm");

var $7aQOM = parcelRequire("7aQOM");

var $dn6WB = parcelRequire("dn6WB");

var $fmQ29 = parcelRequire("fmQ29");

var $lBL1o = parcelRequire("lBL1o");

var $3kjIC = parcelRequire("3kjIC");

var $1HEKk = parcelRequire("1HEKk");
var $932c1fa8a18a7d3b$var$PROMISE = "Promise";
var $932c1fa8a18a7d3b$var$FORCED_PROMISE_CONSTRUCTOR = $3kjIC.CONSTRUCTOR;
var $932c1fa8a18a7d3b$var$NATIVE_PROMISE_REJECTION_EVENT = $3kjIC.REJECTION_EVENT;
var $932c1fa8a18a7d3b$var$NATIVE_PROMISE_SUBCLASSING = $3kjIC.SUBCLASSING;
var $932c1fa8a18a7d3b$var$getInternalPromiseState = $fmQ29.getterFor($932c1fa8a18a7d3b$var$PROMISE);
var $932c1fa8a18a7d3b$var$setInternalState = $fmQ29.set;
var $932c1fa8a18a7d3b$var$NativePromisePrototype = $lBL1o && $lBL1o.prototype;
var $932c1fa8a18a7d3b$var$PromiseConstructor = $lBL1o;
var $932c1fa8a18a7d3b$var$PromisePrototype = $932c1fa8a18a7d3b$var$NativePromisePrototype;
var $932c1fa8a18a7d3b$var$TypeError = $3pyVf.TypeError;
var $932c1fa8a18a7d3b$var$document = $3pyVf.document;
var $932c1fa8a18a7d3b$var$process = $3pyVf.process;
var $932c1fa8a18a7d3b$var$newPromiseCapability = $1HEKk.f;
var $932c1fa8a18a7d3b$var$newGenericPromiseCapability = $932c1fa8a18a7d3b$var$newPromiseCapability;
var $932c1fa8a18a7d3b$var$DISPATCH_EVENT = !!($932c1fa8a18a7d3b$var$document && $932c1fa8a18a7d3b$var$document.createEvent && $3pyVf.dispatchEvent);
var $932c1fa8a18a7d3b$var$UNHANDLED_REJECTION = "unhandledrejection";
var $932c1fa8a18a7d3b$var$REJECTION_HANDLED = "rejectionhandled";
var $932c1fa8a18a7d3b$var$PENDING = 0;
var $932c1fa8a18a7d3b$var$FULFILLED = 1;
var $932c1fa8a18a7d3b$var$REJECTED = 2;
var $932c1fa8a18a7d3b$var$HANDLED = 1;
var $932c1fa8a18a7d3b$var$UNHANDLED = 2;
var $932c1fa8a18a7d3b$var$Internal, $932c1fa8a18a7d3b$var$OwnPromiseCapability, $932c1fa8a18a7d3b$var$PromiseWrapper, $932c1fa8a18a7d3b$var$nativeThen;
// helpers
var $932c1fa8a18a7d3b$var$isThenable = function(it) {
    var then;
    return $1WYwK(it) && $e6Rz5(then = it.then) ? then : false;
};
var $932c1fa8a18a7d3b$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $932c1fa8a18a7d3b$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $932c1fa8a18a7d3b$var$UNHANDLED) $932c1fa8a18a7d3b$var$onHandleUnhandled(state);
                state.rejection = $932c1fa8a18a7d3b$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($932c1fa8a18a7d3b$var$TypeError("Promise-chain cycle"));
            else if (then = $932c1fa8a18a7d3b$var$isThenable(result)) $aELZY(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $932c1fa8a18a7d3b$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $e02YY(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$932c1fa8a18a7d3b$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $932c1fa8a18a7d3b$var$onUnhandled(state);
    });
};
var $932c1fa8a18a7d3b$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($932c1fa8a18a7d3b$var$DISPATCH_EVENT) {
        event = $932c1fa8a18a7d3b$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $3pyVf.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$932c1fa8a18a7d3b$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $3pyVf["on" + name])) handler(event);
    else if (name === $932c1fa8a18a7d3b$var$UNHANDLED_REJECTION) $eCofm("Unhandled promise rejection", reason);
};
var $932c1fa8a18a7d3b$var$onUnhandled = function(state) {
    $aELZY($932c1fa8a18a7d3b$require$task, $3pyVf, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $932c1fa8a18a7d3b$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $7aQOM(function() {
                if ($4jpM3) $932c1fa8a18a7d3b$var$process.emit("unhandledRejection", value, promise);
                else $932c1fa8a18a7d3b$var$dispatchEvent($932c1fa8a18a7d3b$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $4jpM3 || $932c1fa8a18a7d3b$var$isUnhandled(state) ? $932c1fa8a18a7d3b$var$UNHANDLED : $932c1fa8a18a7d3b$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $932c1fa8a18a7d3b$var$isUnhandled = function(state) {
    return state.rejection !== $932c1fa8a18a7d3b$var$HANDLED && !state.parent;
};
var $932c1fa8a18a7d3b$var$onHandleUnhandled = function(state) {
    $aELZY($932c1fa8a18a7d3b$require$task, $3pyVf, function() {
        var promise = state.facade;
        if ($4jpM3) $932c1fa8a18a7d3b$var$process.emit("rejectionHandled", promise);
        else $932c1fa8a18a7d3b$var$dispatchEvent($932c1fa8a18a7d3b$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $932c1fa8a18a7d3b$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $932c1fa8a18a7d3b$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $932c1fa8a18a7d3b$var$REJECTED;
    $932c1fa8a18a7d3b$var$notify(state, true);
};
var $932c1fa8a18a7d3b$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $932c1fa8a18a7d3b$var$TypeError("Promise can't be resolved itself");
        var then = $932c1fa8a18a7d3b$var$isThenable(value);
        if (then) $e02YY(function() {
            var wrapper = {
                done: false
            };
            try {
                $aELZY(then, value, $932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalResolve, wrapper, state), $932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalReject, wrapper, state));
            } catch (error) {
                $932c1fa8a18a7d3b$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $932c1fa8a18a7d3b$var$FULFILLED;
            $932c1fa8a18a7d3b$var$notify(state, false);
        }
    } catch (error) {
        $932c1fa8a18a7d3b$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($932c1fa8a18a7d3b$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $932c1fa8a18a7d3b$var$PromiseConstructor = function Promise(executor) {
        $a95no(this, $932c1fa8a18a7d3b$var$PromisePrototype);
        $8GsPx(executor);
        $aELZY($932c1fa8a18a7d3b$var$Internal, this);
        var state = $932c1fa8a18a7d3b$var$getInternalPromiseState(this);
        try {
            executor($932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalResolve, state), $932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalReject, state));
        } catch (error) {
            $932c1fa8a18a7d3b$var$internalReject(state, error);
        }
    };
    $932c1fa8a18a7d3b$var$PromisePrototype = $932c1fa8a18a7d3b$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $932c1fa8a18a7d3b$var$Internal = function Promise(executor) {
        $932c1fa8a18a7d3b$var$setInternalState(this, {
            type: $932c1fa8a18a7d3b$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $dn6WB(),
            rejection: false,
            state: $932c1fa8a18a7d3b$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $932c1fa8a18a7d3b$var$Internal.prototype = $kY5Tb($932c1fa8a18a7d3b$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $932c1fa8a18a7d3b$var$getInternalPromiseState(this);
        var reaction = $932c1fa8a18a7d3b$var$newPromiseCapability($2FOd2(this, $932c1fa8a18a7d3b$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $e6Rz5(onFulfilled) ? onFulfilled : true;
        reaction.fail = $e6Rz5(onRejected) && onRejected;
        reaction.domain = $4jpM3 ? $932c1fa8a18a7d3b$var$process.domain : undefined;
        if (state.state == $932c1fa8a18a7d3b$var$PENDING) state.reactions.add(reaction);
        else $e02YY(function() {
            $932c1fa8a18a7d3b$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $932c1fa8a18a7d3b$var$OwnPromiseCapability = function() {
        var promise = new $932c1fa8a18a7d3b$var$Internal();
        var state = $932c1fa8a18a7d3b$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalResolve, state);
        this.reject = $932c1fa8a18a7d3b$var$bind($932c1fa8a18a7d3b$var$internalReject, state);
    };
    $1HEKk.f = $932c1fa8a18a7d3b$var$newPromiseCapability = function(C) {
        return C === $932c1fa8a18a7d3b$var$PromiseConstructor || C === $932c1fa8a18a7d3b$var$PromiseWrapper ? new $932c1fa8a18a7d3b$var$OwnPromiseCapability(C) : $932c1fa8a18a7d3b$var$newGenericPromiseCapability(C);
    };
    if (!$7phdw && $e6Rz5($lBL1o) && $932c1fa8a18a7d3b$var$NativePromisePrototype !== Object.prototype) {
        $932c1fa8a18a7d3b$var$nativeThen = $932c1fa8a18a7d3b$var$NativePromisePrototype.then;
        if (!$932c1fa8a18a7d3b$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $kY5Tb($932c1fa8a18a7d3b$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $932c1fa8a18a7d3b$var$PromiseConstructor(function(resolve, reject) {
                $aELZY($932c1fa8a18a7d3b$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $932c1fa8a18a7d3b$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($6e7Qv) $6e7Qv($932c1fa8a18a7d3b$var$NativePromisePrototype, $932c1fa8a18a7d3b$var$PromisePrototype);
    }
}
$ggcsv({
    global: true,
    constructor: true,
    wrap: true,
    forced: $932c1fa8a18a7d3b$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $932c1fa8a18a7d3b$var$PromiseConstructor
});
$dheYH($932c1fa8a18a7d3b$var$PromiseConstructor, $932c1fa8a18a7d3b$var$PROMISE, false, true);
$13iqA($932c1fa8a18a7d3b$var$PROMISE);

});
parcelRequire.register("4jpM3", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");

var $bTsfg = parcelRequire("bTsfg");
module.exports = typeof $4TNnu != "undefined" && $bTsfg($4TNnu) == "process";

});
parcelRequire.register("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("13iqA", function(module, exports) {
"use strict";

var $5Pobw = parcelRequire("5Pobw");

var $7kUwJ = parcelRequire("7kUwJ");

var $fq7H3 = parcelRequire("fq7H3");

var $jeZ4p = parcelRequire("jeZ4p");
var $0c445d9d3ba4becb$var$SPECIES = $fq7H3("species");
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $5Pobw(CONSTRUCTOR_NAME);
    if ($jeZ4p && Constructor && !Constructor[$0c445d9d3ba4becb$var$SPECIES]) $7kUwJ(Constructor, $0c445d9d3ba4becb$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRequire.register("2FOd2", function(module, exports) {

var $l3LMJ = parcelRequire("l3LMJ");

var $dGyrk = parcelRequire("dGyrk");

var $6exeg = parcelRequire("6exeg");

var $fq7H3 = parcelRequire("fq7H3");
var $1f265ba52a34b575$var$SPECIES = $fq7H3("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = $l3LMJ(O).constructor;
    var S;
    return C === undefined || $6exeg(S = $l3LMJ(C)[$1f265ba52a34b575$var$SPECIES]) ? defaultConstructor : $dGyrk(S);
};

});
parcelRequire.register("dGyrk", function(module, exports) {

var $iQLrm = parcelRequire("iQLrm");

var $k9gzN = parcelRequire("k9gzN");
var $9f69e99df50e84bd$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
module.exports = function(argument) {
    if ($iQLrm(argument)) return argument;
    throw $9f69e99df50e84bd$var$$TypeError($k9gzN(argument) + " is not a constructor");
};

});


parcelRequire.register("htH5s", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");

var $2JOsI = parcelRequire("2JOsI");

var $b5UsH = parcelRequire("b5UsH");

var $e6Rz5 = parcelRequire("e6Rz5");

var $heVlo = parcelRequire("heVlo");

var $77TPA = parcelRequire("77TPA");

var $f0Cl9 = parcelRequire("f0Cl9");

var $hF40G = parcelRequire("hF40G");

var $kHYxY = parcelRequire("kHYxY");

var $10H6z = parcelRequire("10H6z");

var $i2kDi = parcelRequire("i2kDi");

var $4jpM3 = parcelRequire("4jpM3");
var $cb969145f2946e64$var$set = $3pyVf.setImmediate;
var $cb969145f2946e64$var$clear = $3pyVf.clearImmediate;
var $cb969145f2946e64$var$process = $3pyVf.process;
var $cb969145f2946e64$var$Dispatch = $3pyVf.Dispatch;
var $cb969145f2946e64$var$Function = $3pyVf.Function;
var $cb969145f2946e64$var$MessageChannel = $3pyVf.MessageChannel;
var $cb969145f2946e64$var$String = $3pyVf.String;
var $cb969145f2946e64$var$counter = 0;
var $cb969145f2946e64$var$queue = {};
var $cb969145f2946e64$var$ONREADYSTATECHANGE = "onreadystatechange";
var $cb969145f2946e64$var$$location, $cb969145f2946e64$var$defer, $cb969145f2946e64$var$channel, $cb969145f2946e64$var$port;
$77TPA(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $cb969145f2946e64$var$$location = $3pyVf.location;
});
var $cb969145f2946e64$var$run = function(id) {
    if ($heVlo($cb969145f2946e64$var$queue, id)) {
        var fn = $cb969145f2946e64$var$queue[id];
        delete $cb969145f2946e64$var$queue[id];
        fn();
    }
};
var $cb969145f2946e64$var$runner = function(id) {
    return function() {
        $cb969145f2946e64$var$run(id);
    };
};
var $cb969145f2946e64$var$eventListener = function(event) {
    $cb969145f2946e64$var$run(event.data);
};
var $cb969145f2946e64$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $3pyVf.postMessage($cb969145f2946e64$var$String(id), $cb969145f2946e64$var$$location.protocol + "//" + $cb969145f2946e64$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$cb969145f2946e64$var$set || !$cb969145f2946e64$var$clear) {
    $cb969145f2946e64$var$set = function setImmediate(handler) {
        $10H6z(arguments.length, 1);
        var fn = $e6Rz5(handler) ? handler : $cb969145f2946e64$var$Function(handler);
        var args = $hF40G(arguments, 1);
        $cb969145f2946e64$var$queue[++$cb969145f2946e64$var$counter] = function() {
            $2JOsI(fn, undefined, args);
        };
        $cb969145f2946e64$var$defer($cb969145f2946e64$var$counter);
        return $cb969145f2946e64$var$counter;
    };
    $cb969145f2946e64$var$clear = function clearImmediate(id) {
        delete $cb969145f2946e64$var$queue[id];
    };
    // Node.js 0.8-
    if ($4jpM3) $cb969145f2946e64$var$defer = function(id) {
        $cb969145f2946e64$var$process.nextTick($cb969145f2946e64$var$runner(id));
    };
    else if ($cb969145f2946e64$var$Dispatch && $cb969145f2946e64$var$Dispatch.now) $cb969145f2946e64$var$defer = function(id) {
        $cb969145f2946e64$var$Dispatch.now($cb969145f2946e64$var$runner(id));
    };
    else if ($cb969145f2946e64$var$MessageChannel && !$i2kDi) {
        $cb969145f2946e64$var$channel = new $cb969145f2946e64$var$MessageChannel();
        $cb969145f2946e64$var$port = $cb969145f2946e64$var$channel.port2;
        $cb969145f2946e64$var$channel.port1.onmessage = $cb969145f2946e64$var$eventListener;
        $cb969145f2946e64$var$defer = $b5UsH($cb969145f2946e64$var$port.postMessage, $cb969145f2946e64$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($3pyVf.addEventListener && $e6Rz5($3pyVf.postMessage) && !$3pyVf.importScripts && $cb969145f2946e64$var$$location && $cb969145f2946e64$var$$location.protocol !== "file:" && !$77TPA($cb969145f2946e64$var$globalPostMessageDefer)) {
        $cb969145f2946e64$var$defer = $cb969145f2946e64$var$globalPostMessageDefer;
        $3pyVf.addEventListener("message", $cb969145f2946e64$var$eventListener, false);
    // IE8-
    } else if ($cb969145f2946e64$var$ONREADYSTATECHANGE in $kHYxY("script")) $cb969145f2946e64$var$defer = function(id) {
        $f0Cl9.appendChild($kHYxY("script"))[$cb969145f2946e64$var$ONREADYSTATECHANGE] = function() {
            $f0Cl9.removeChild(this);
            $cb969145f2946e64$var$run(id);
        };
    };
    else $cb969145f2946e64$var$defer = function(id) {
        setTimeout($cb969145f2946e64$var$runner(id), 0);
    };
}
module.exports = {
    set: $cb969145f2946e64$var$set,
    clear: $cb969145f2946e64$var$clear
};

});
parcelRequire.register("10H6z", function(module, exports) {
var $0bc73a46a382b3b0$var$$TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw $0bc73a46a382b3b0$var$$TypeError("Not enough arguments");
    return passed;
};

});

parcelRequire.register("i2kDi", function(module, exports) {

var $4Hrut = parcelRequire("4Hrut");
// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($4Hrut);

});


parcelRequire.register("e02YY", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");

var $b5UsH = parcelRequire("b5UsH");

var $fTFId = parcelRequire("fTFId");
var $a31361095d52e233$require$getOwnPropertyDescriptor = $fTFId.f;

var $htH5s = parcelRequire("htH5s");
var $a31361095d52e233$require$macrotask = $htH5s.set;

var $dn6WB = parcelRequire("dn6WB");

var $i2kDi = parcelRequire("i2kDi");

var $9uZ2h = parcelRequire("9uZ2h");

var $iZ6MO = parcelRequire("iZ6MO");

var $4jpM3 = parcelRequire("4jpM3");
var $a31361095d52e233$var$MutationObserver = $3pyVf.MutationObserver || $3pyVf.WebKitMutationObserver;
var $a31361095d52e233$var$document = $3pyVf.document;
var $a31361095d52e233$var$process = $3pyVf.process;
var $a31361095d52e233$var$Promise = $3pyVf.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $a31361095d52e233$var$queueMicrotaskDescriptor = $a31361095d52e233$require$getOwnPropertyDescriptor($3pyVf, "queueMicrotask");
var $a31361095d52e233$var$microtask = $a31361095d52e233$var$queueMicrotaskDescriptor && $a31361095d52e233$var$queueMicrotaskDescriptor.value;
var $a31361095d52e233$var$notify, $a31361095d52e233$var$toggle, $a31361095d52e233$var$node, $a31361095d52e233$var$promise, $a31361095d52e233$var$then;
// modern engines have queueMicrotask method
if (!$a31361095d52e233$var$microtask) {
    var $a31361095d52e233$var$queue = new $dn6WB();
    var $a31361095d52e233$var$flush = function() {
        var parent, fn;
        if ($4jpM3 && (parent = $a31361095d52e233$var$process.domain)) parent.exit();
        while(fn = $a31361095d52e233$var$queue.get())try {
            fn();
        } catch (error) {
            if ($a31361095d52e233$var$queue.head) $a31361095d52e233$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$i2kDi && !$4jpM3 && !$iZ6MO && $a31361095d52e233$var$MutationObserver && $a31361095d52e233$var$document) {
        $a31361095d52e233$var$toggle = true;
        $a31361095d52e233$var$node = $a31361095d52e233$var$document.createTextNode("");
        new $a31361095d52e233$var$MutationObserver($a31361095d52e233$var$flush).observe($a31361095d52e233$var$node, {
            characterData: true
        });
        $a31361095d52e233$var$notify = function() {
            $a31361095d52e233$var$node.data = $a31361095d52e233$var$toggle = !$a31361095d52e233$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$9uZ2h && $a31361095d52e233$var$Promise && $a31361095d52e233$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $a31361095d52e233$var$promise = $a31361095d52e233$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $a31361095d52e233$var$promise.constructor = $a31361095d52e233$var$Promise;
        $a31361095d52e233$var$then = $b5UsH($a31361095d52e233$var$promise.then, $a31361095d52e233$var$promise);
        $a31361095d52e233$var$notify = function() {
            $a31361095d52e233$var$then($a31361095d52e233$var$flush);
        };
    // Node.js without promises
    } else if ($4jpM3) $a31361095d52e233$var$notify = function() {
        $a31361095d52e233$var$process.nextTick($a31361095d52e233$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $a31361095d52e233$require$macrotask = $b5UsH($a31361095d52e233$require$macrotask, $3pyVf);
        $a31361095d52e233$var$notify = function() {
            $a31361095d52e233$require$macrotask($a31361095d52e233$var$flush);
        };
    }
    $a31361095d52e233$var$microtask = function(fn) {
        if (!$a31361095d52e233$var$queue.head) $a31361095d52e233$var$notify();
        $a31361095d52e233$var$queue.add(fn);
    };
}
module.exports = $a31361095d52e233$var$microtask;

});
parcelRequire.register("dn6WB", function(module, exports) {
var $9bc2cf5012c3f636$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$9bc2cf5012c3f636$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
module.exports = $9bc2cf5012c3f636$var$Queue;

});

parcelRequire.register("9uZ2h", function(module, exports) {

var $4Hrut = parcelRequire("4Hrut");
module.exports = /ipad|iphone|ipod/i.test($4Hrut) && typeof Pebble != "undefined";

});

parcelRequire.register("iZ6MO", function(module, exports) {

var $4Hrut = parcelRequire("4Hrut");
module.exports = /web0s(?!.*chrome)/i.test($4Hrut);

});


parcelRequire.register("eCofm", function(module, exports) {
module.exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length == 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};

});

parcelRequire.register("7aQOM", function(module, exports) {
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

});

parcelRequire.register("lBL1o", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");
module.exports = $3pyVf.Promise;

});

parcelRequire.register("3kjIC", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");

var $lBL1o = parcelRequire("lBL1o");

var $e6Rz5 = parcelRequire("e6Rz5");

var $iaZZ9 = parcelRequire("iaZZ9");

var $fgsf9 = parcelRequire("fgsf9");

var $fq7H3 = parcelRequire("fq7H3");

var $8W9cd = parcelRequire("8W9cd");

var $5xdTM = parcelRequire("5xdTM");

var $7phdw = parcelRequire("7phdw");

var $1MzR6 = parcelRequire("1MzR6");
var $26c28911b0a6f2f3$var$NativePromisePrototype = $lBL1o && $lBL1o.prototype;
var $26c28911b0a6f2f3$var$SPECIES = $fq7H3("species");
var $26c28911b0a6f2f3$var$SUBCLASSING = false;
var $26c28911b0a6f2f3$var$NATIVE_PROMISE_REJECTION_EVENT = $e6Rz5($3pyVf.PromiseRejectionEvent);
var $26c28911b0a6f2f3$var$FORCED_PROMISE_CONSTRUCTOR = $iaZZ9("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $fgsf9($lBL1o);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($lBL1o);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $1MzR6 === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($7phdw && !($26c28911b0a6f2f3$var$NativePromisePrototype["catch"] && $26c28911b0a6f2f3$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$1MzR6 || $1MzR6 < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $lBL1o(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$26c28911b0a6f2f3$var$SPECIES] = FakePromise;
        $26c28911b0a6f2f3$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$26c28911b0a6f2f3$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($8W9cd || $5xdTM) && !$26c28911b0a6f2f3$var$NATIVE_PROMISE_REJECTION_EVENT;
});
module.exports = {
    CONSTRUCTOR: $26c28911b0a6f2f3$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $26c28911b0a6f2f3$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $26c28911b0a6f2f3$var$SUBCLASSING
};

});
parcelRequire.register("8W9cd", function(module, exports) {

var $5xdTM = parcelRequire("5xdTM");

var $4jpM3 = parcelRequire("4jpM3");
module.exports = !$5xdTM && !$4jpM3 && typeof window == "object" && typeof document == "object";

});
parcelRequire.register("5xdTM", function(module, exports) {
/* global Deno -- Deno case */ module.exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";

});



parcelRequire.register("1HEKk", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $13d969f6bdce5a90$export$2d1720544b23b823; }, function (v) { return $13d969f6bdce5a90$export$2d1720544b23b823 = v; });
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $13d969f6bdce5a90$export$2d1720544b23b823;
"use strict";

var $8GsPx = parcelRequire("8GsPx");
var $13d969f6bdce5a90$var$$TypeError = TypeError;
var $13d969f6bdce5a90$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw $13d969f6bdce5a90$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $8GsPx(resolve);
    this.reject = $8GsPx(reject);
};
$13d969f6bdce5a90$export$2d1720544b23b823 = function(C) {
    return new $13d969f6bdce5a90$var$PromiseCapability(C);
};

});


parcelRequire.register("fRDGg", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $1HEKk = parcelRequire("1HEKk");

var $7aQOM = parcelRequire("7aQOM");

var $jUk8Y = parcelRequire("jUk8Y");

var $67553 = parcelRequire("67553");
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $67553
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $1HEKk.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $7aQOM(function() {
            var $promiseResolve = $8GsPx(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $jUk8Y(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $aELZY($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});
parcelRequire.register("67553", function(module, exports) {

var $lBL1o = parcelRequire("lBL1o");

var $39DPZ = parcelRequire("39DPZ");

var $3kjIC = parcelRequire("3kjIC");
var $4737566c7a07b7bd$require$FORCED_PROMISE_CONSTRUCTOR = $3kjIC.CONSTRUCTOR;
module.exports = $4737566c7a07b7bd$require$FORCED_PROMISE_CONSTRUCTOR || !$39DPZ(function(iterable) {
    $lBL1o.all(iterable).then(undefined, function() {});
});

});
parcelRequire.register("39DPZ", function(module, exports) {

var $fq7H3 = parcelRequire("fq7H3");
var $24c11d3f184eaea3$var$ITERATOR = $fq7H3("iterator");
var $24c11d3f184eaea3$var$SAFE_CLOSING = false;
try {
    var $24c11d3f184eaea3$var$called = 0;
    var $24c11d3f184eaea3$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$24c11d3f184eaea3$var$called++
            };
        },
        "return": function() {
            $24c11d3f184eaea3$var$SAFE_CLOSING = true;
        }
    };
    $24c11d3f184eaea3$var$iteratorWithReturn[$24c11d3f184eaea3$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($24c11d3f184eaea3$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$24c11d3f184eaea3$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$24c11d3f184eaea3$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});



parcelRequire.register("bhLYs", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $7phdw = parcelRequire("7phdw");

var $3kjIC = parcelRequire("3kjIC");
var $83767ee5defd3650$require$FORCED_PROMISE_CONSTRUCTOR = $3kjIC.CONSTRUCTOR;

var $lBL1o = parcelRequire("lBL1o");

var $5Pobw = parcelRequire("5Pobw");

var $e6Rz5 = parcelRequire("e6Rz5");

var $kY5Tb = parcelRequire("kY5Tb");
var $83767ee5defd3650$var$NativePromisePrototype = $lBL1o && $lBL1o.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$ggcsv({
    target: "Promise",
    proto: true,
    forced: $83767ee5defd3650$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$7phdw && $e6Rz5($lBL1o)) {
    var $83767ee5defd3650$var$method = $5Pobw("Promise").prototype["catch"];
    if ($83767ee5defd3650$var$NativePromisePrototype["catch"] !== $83767ee5defd3650$var$method) $kY5Tb($83767ee5defd3650$var$NativePromisePrototype, "catch", $83767ee5defd3650$var$method, {
        unsafe: true
    });
}

});

parcelRequire.register("fm27z", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $1HEKk = parcelRequire("1HEKk");

var $7aQOM = parcelRequire("7aQOM");

var $jUk8Y = parcelRequire("jUk8Y");

var $67553 = parcelRequire("67553");
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $67553
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $1HEKk.f(C);
        var reject = capability.reject;
        var result = $7aQOM(function() {
            var $promiseResolve = $8GsPx(C.resolve);
            $jUk8Y(iterable, function(promise) {
                $aELZY($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRequire.register("iGB6b", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $1HEKk = parcelRequire("1HEKk");

var $3kjIC = parcelRequire("3kjIC");
var $d9a8ed3f94958e72$require$FORCED_PROMISE_CONSTRUCTOR = $3kjIC.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $d9a8ed3f94958e72$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $1HEKk.f(this);
        $aELZY(capability.reject, undefined, r);
        return capability.promise;
    }
});

});

parcelRequire.register("doKxr", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5Pobw = parcelRequire("5Pobw");

var $7phdw = parcelRequire("7phdw");

var $lBL1o = parcelRequire("lBL1o");

var $3kjIC = parcelRequire("3kjIC");
var $9c119dc8f2c5f0ff$require$FORCED_PROMISE_CONSTRUCTOR = $3kjIC.CONSTRUCTOR;

var $gStD1 = parcelRequire("gStD1");
var $9c119dc8f2c5f0ff$var$PromiseConstructorWrapper = $5Pobw("Promise");
var $9c119dc8f2c5f0ff$var$CHECK_WRAPPER = $7phdw && !$9c119dc8f2c5f0ff$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $7phdw || $9c119dc8f2c5f0ff$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $gStD1($9c119dc8f2c5f0ff$var$CHECK_WRAPPER && this === $9c119dc8f2c5f0ff$var$PromiseConstructorWrapper ? $lBL1o : this, x);
    }
});

});
parcelRequire.register("gStD1", function(module, exports) {

var $l3LMJ = parcelRequire("l3LMJ");

var $1WYwK = parcelRequire("1WYwK");

var $1HEKk = parcelRequire("1HEKk");
module.exports = function(C, x) {
    $l3LMJ(C);
    if ($1WYwK(x) && x.constructor === C) return x;
    var promiseCapability = $1HEKk.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});



parcelRequire.register("ettPZ", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $1HEKk = parcelRequire("1HEKk");

var $7aQOM = parcelRequire("7aQOM");

var $jUk8Y = parcelRequire("jUk8Y");

var $67553 = parcelRequire("67553");
// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $67553
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $1HEKk.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $7aQOM(function() {
            var promiseResolve = $8GsPx(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $jUk8Y(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $aELZY(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRequire.register("hakp0", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $5Pobw = parcelRequire("5Pobw");

var $1HEKk = parcelRequire("1HEKk");

var $7aQOM = parcelRequire("7aQOM");

var $jUk8Y = parcelRequire("jUk8Y");

var $67553 = parcelRequire("67553");
var $c7f3324d588fc2f3$var$PROMISE_ANY_ERROR = "No one promise resolved";
// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$ggcsv({
    target: "Promise",
    stat: true,
    forced: $67553
}, {
    any: function any(iterable) {
        var C = this;
        var AggregateError = $5Pobw("AggregateError");
        var capability = $1HEKk.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $7aQOM(function() {
            var promiseResolve = $8GsPx(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            $jUk8Y(iterable, function(promise) {
                var index = counter++;
                var alreadyRejected = false;
                remaining++;
                $aELZY(promiseResolve, C, promise).then(function(value) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyResolved = true;
                    resolve(value);
                }, function(error) {
                    if (alreadyRejected || alreadyResolved) return;
                    alreadyRejected = true;
                    errors[index] = error;
                    --remaining || reject(new AggregateError(errors, $c7f3324d588fc2f3$var$PROMISE_ANY_ERROR));
                });
            });
            --remaining || reject(new AggregateError(errors, $c7f3324d588fc2f3$var$PROMISE_ANY_ERROR));
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRequire.register("wzhSp", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $7phdw = parcelRequire("7phdw");

var $lBL1o = parcelRequire("lBL1o");

var $77TPA = parcelRequire("77TPA");

var $5Pobw = parcelRequire("5Pobw");

var $e6Rz5 = parcelRequire("e6Rz5");

var $2FOd2 = parcelRequire("2FOd2");

var $gStD1 = parcelRequire("gStD1");

var $kY5Tb = parcelRequire("kY5Tb");
var $061e5c9a4575699d$var$NativePromisePrototype = $lBL1o && $lBL1o.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $061e5c9a4575699d$var$NON_GENERIC = !!$lBL1o && $77TPA(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $061e5c9a4575699d$var$NativePromisePrototype["finally"].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$ggcsv({
    target: "Promise",
    proto: true,
    real: true,
    forced: $061e5c9a4575699d$var$NON_GENERIC
}, {
    "finally": function(onFinally) {
        var C = $2FOd2(this, $5Pobw("Promise"));
        var isFunction = $e6Rz5(onFinally);
        return this.then(isFunction ? function(x) {
            return $gStD1(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $gStD1(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$7phdw && $e6Rz5($lBL1o)) {
    var $061e5c9a4575699d$var$method = $5Pobw("Promise").prototype["finally"];
    if ($061e5c9a4575699d$var$NativePromisePrototype["finally"] !== $061e5c9a4575699d$var$method) $kY5Tb($061e5c9a4575699d$var$NativePromisePrototype, "finally", $061e5c9a4575699d$var$method, {
        unsafe: true
    });
}

});




parcelRequire.register("42E6z", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2f167552ee152234$var$decode;

var $2f167552ee152234$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $2f167552ee152234$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $2f167552ee152234$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $2f167552ee152234$var$_ParseACL = $iHLHC((parcelRequire("2xGBa")));

var $2f167552ee152234$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $2f167552ee152234$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));

var $2f167552ee152234$var$_ParsePolygon = $iHLHC((parcelRequire("i8AKq")));

var $2f167552ee152234$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $3l0Qd = parcelRequire("3l0Qd");

var $2f167552ee152234$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ // eslint-disable-line no-unused-vars
function $2f167552ee152234$var$decode(value) /*: any*/ {
    if (value === null || (0, $2f167552ee152234$var$_typeof2.default)(value) !== "object" || value instanceof Date) return value;
    if ((0, $2f167552ee152234$var$_isArray.default)(value)) {
        var dup = [];
        (0, $2f167552ee152234$var$_forEach.default)(value).call(value, function(v, i) {
            dup[i] = $2f167552ee152234$var$decode(v);
        });
        return dup;
    }
    if (typeof value.__op === "string") return (0, $3l0Qd.opFromJSON)(value);
    if (value.__type === "Pointer" && value.className) return $2f167552ee152234$var$_ParseObject.default.fromJSON(value);
    if (value.__type === "Object" && value.className) return $2f167552ee152234$var$_ParseObject.default.fromJSON(value);
    if (value.__type === "Relation") {
        // The parent and key fields will be populated by the parent
        var relation = new $2f167552ee152234$var$_ParseRelation.default(null, null);
        relation.targetClassName = value.className;
        return relation;
    }
    if (value.__type === "Date") return new Date(value.iso);
    if (value.__type === "File") return $2f167552ee152234$var$_ParseFile.default.fromJSON(value);
    if (value.__type === "GeoPoint") return new $2f167552ee152234$var$_ParseGeoPoint.default({
        latitude: value.latitude,
        longitude: value.longitude
    });
    if (value.__type === "Polygon") return new $2f167552ee152234$var$_ParsePolygon.default(value.coordinates);
    var copy = {};
    for(var k in value)copy[k] = $2f167552ee152234$var$decode(value[k]);
    return copy;
}

});
parcelRequire.register("gW71a", function(module, exports) {

module.exports = (parcelRequire("7pUJQ"));

});
parcelRequire.register("7pUJQ", function(module, exports) {
parcelRequire("jXhxH");

var $aHxiP = parcelRequire("aHxiP");

var $heVlo = parcelRequire("heVlo");

var $8hsAO = parcelRequire("8hsAO");

var $6px0W = parcelRequire("6px0W");
var $5666e1445fcead3a$var$ArrayPrototype = Array.prototype;
var $5666e1445fcead3a$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.forEach;
    return it === $5666e1445fcead3a$var$ArrayPrototype || $8hsAO($5666e1445fcead3a$var$ArrayPrototype, it) && own === $5666e1445fcead3a$var$ArrayPrototype.forEach || $heVlo($5666e1445fcead3a$var$DOMIterables, $aHxiP(it)) ? $6px0W : own;
};

});
parcelRequire.register("6px0W", function(module, exports) {

var $cGPC8 = parcelRequire("cGPC8");
module.exports = $cGPC8;

});
parcelRequire.register("cGPC8", function(module, exports) {
parcelRequire("aNlay");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").forEach;

});
parcelRequire.register("aNlay", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $6uImx = parcelRequire("6uImx");
// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$ggcsv({
    target: "Array",
    proto: true,
    forced: [].forEach != $6uImx
}, {
    forEach: $6uImx
});

});
parcelRequire.register("6uImx", function(module, exports) {
"use strict";

var $igsV9 = parcelRequire("igsV9");
var $4ba7f4e1b90b0672$require$$forEach = $igsV9.forEach;

var $kQPJO = parcelRequire("kQPJO");
var $4ba7f4e1b90b0672$var$STRICT_METHOD = $kQPJO("forEach");
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !$4ba7f4e1b90b0672$var$STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $4ba7f4e1b90b0672$require$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

});
parcelRequire.register("kQPJO", function(module, exports) {
"use strict";

var $77TPA = parcelRequire("77TPA");
module.exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $77TPA(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};

});



parcelRequire.register("99rwM", function(module, exports) {

var $ly30u = parcelRequire("ly30u");
module.exports = function(CONSTRUCTOR) {
    return $ly30u[CONSTRUCTOR + "Prototype"];
};

});





parcelRequire.register("euZIZ", function(module, exports) {

module.exports = (parcelRequire("4hHz8"));

});
parcelRequire.register("4hHz8", function(module, exports) {

var $7wq4z = parcelRequire("7wq4z");
module.exports = $7wq4z;

});
parcelRequire.register("7wq4z", function(module, exports) {
parcelRequire("eZTVb");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Array.isArray;

});
parcelRequire.register("eZTVb", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $5zZFa = parcelRequire("5zZFa");
// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$ggcsv({
    target: "Array",
    stat: true
}, {
    isArray: $5zZFa
});

});




parcelRequire.register("2xGBa", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d9fb5067889164c$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $1d9fb5067889164c$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $1d9fb5067889164c$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $1d9fb5067889164c$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $1d9fb5067889164c$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $1d9fb5067889164c$var$_ParseRole = $iHLHC((parcelRequire("7MXHA")));

var $1d9fb5067889164c$var$_ParseUser = $iHLHC((parcelRequire("iQ4JH")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $1d9fb5067889164c$var$PUBLIC_KEY = "*";
/**
 * Creates a new ACL.
 * If no argument is given, the ACL has no permissions for anyone.
 * If the argument is a Parse.User, the ACL will have read and write
 *   permission for only that user.
 * If the argument is any other JSON object, that object will be interpretted
 *   as a serialized ACL created with toJSON().
 *
 * <p>An ACL, or Access Control List can be added to any
 * <code>Parse.Object</code> to restrict access to only a subset of users
 * of your application.</p>
 *
 * @alias Parse.ACL
 */ var $1d9fb5067889164c$var$ParseACL = /*#__PURE__*/ function() {
    /**
   * @param {(Parse.User | object)} arg1 The user to initialize the ACL for
   */ function ParseACL(arg1) {
        (0, $1d9fb5067889164c$var$_classCallCheck2.default)(this, ParseACL);
        (0, $1d9fb5067889164c$var$_defineProperty2.default)(this, "permissionsById", void 0);
        this.permissionsById = {};
        if (arg1 && (0, $1d9fb5067889164c$var$_typeof2.default)(arg1) === "object") {
            if (arg1 instanceof $1d9fb5067889164c$var$_ParseUser.default) {
                this.setReadAccess(arg1, true);
                this.setWriteAccess(arg1, true);
            } else for(var _userId in arg1){
                var accessList = arg1[_userId];
                this.permissionsById[_userId] = {};
                for(var _permission in accessList){
                    var allowed = accessList[_permission];
                    if (_permission !== "read" && _permission !== "write") throw new TypeError("Tried to create an ACL with an invalid permission type.");
                    if (typeof allowed !== "boolean") throw new TypeError("Tried to create an ACL with an invalid permission value.");
                    this.permissionsById[_userId][_permission] = allowed;
                }
            }
        } else if (typeof arg1 === "function") throw new TypeError("ParseACL constructed with a function. Did you forget ()?");
    }
    /**
   * Returns a JSON-encoded version of the ACL.
   *
   * @returns {object}
   */ (0, $1d9fb5067889164c$var$_createClass2.default)(ParseACL, [
        {
            key: "toJSON",
            value: function() /*: ByIdMap*/ {
                var permissions = {};
                for(var p in this.permissionsById)permissions[p] = this.permissionsById[p];
                return permissions;
            }
        },
        {
            key: "equals",
            value: function(other) /*: boolean*/ {
                if (!(other instanceof ParseACL)) return false;
                var users = (0, $1d9fb5067889164c$var$_keys.default)(this.permissionsById);
                var otherUsers = (0, $1d9fb5067889164c$var$_keys.default)(other.permissionsById);
                if (users.length !== otherUsers.length) return false;
                for(var u in this.permissionsById){
                    if (!other.permissionsById[u]) return false;
                    if (this.permissionsById[u].read !== other.permissionsById[u].read) return false;
                    if (this.permissionsById[u].write !== other.permissionsById[u].write) return false;
                }
                return true;
            }
        },
        {
            key: "_setAccess",
            value: function(accessType, userId, allowed) {
                if (userId instanceof $1d9fb5067889164c$var$_ParseUser.default) userId = userId.id;
                else if (userId instanceof $1d9fb5067889164c$var$_ParseRole.default) {
                    var name = userId.getName();
                    if (!name) throw new TypeError("Role must have a name");
                    userId = "role:" + name;
                }
                if (typeof userId !== "string") throw new TypeError("userId must be a string.");
                if (typeof allowed !== "boolean") throw new TypeError("allowed must be either true or false.");
                var permissions = this.permissionsById[userId];
                if (!permissions) {
                    if (!allowed) // The user already doesn't have this permission, so no action is needed
                    return;
                    else {
                        permissions = {};
                        this.permissionsById[userId] = permissions;
                    }
                }
                if (allowed) this.permissionsById[userId][accessType] = true;
                else {
                    delete permissions[accessType];
                    if ((0, $1d9fb5067889164c$var$_keys.default)(permissions).length === 0) delete this.permissionsById[userId];
                }
            }
        },
        {
            key: "_getAccess",
            value: function(accessType, userId) /*: boolean*/ {
                if (userId instanceof $1d9fb5067889164c$var$_ParseUser.default) {
                    userId = userId.id;
                    if (!userId) throw new Error("Cannot get access for a ParseUser without an ID");
                } else if (userId instanceof $1d9fb5067889164c$var$_ParseRole.default) {
                    var name = userId.getName();
                    if (!name) throw new TypeError("Role must have a name");
                    userId = "role:" + name;
                }
                var permissions = this.permissionsById[userId];
                if (!permissions) return false;
                return !!permissions[accessType];
            }
        },
        {
            key: "setReadAccess",
            value: function(userId, allowed) {
                this._setAccess("read", userId, allowed);
            }
        },
        {
            key: "getReadAccess",
            value: function(userId) /*: boolean*/ {
                return this._getAccess("read", userId);
            }
        },
        {
            key: "setWriteAccess",
            value: function(userId, allowed) {
                this._setAccess("write", userId, allowed);
            }
        },
        {
            key: "getWriteAccess",
            value: function(userId) /*: boolean*/ {
                return this._getAccess("write", userId);
            }
        },
        {
            key: "setPublicReadAccess",
            value: function(allowed) {
                this.setReadAccess($1d9fb5067889164c$var$PUBLIC_KEY, allowed);
            }
        },
        {
            key: "getPublicReadAccess",
            value: function() /*: boolean*/ {
                return this.getReadAccess($1d9fb5067889164c$var$PUBLIC_KEY);
            }
        },
        {
            key: "setPublicWriteAccess",
            value: function(allowed) {
                this.setWriteAccess($1d9fb5067889164c$var$PUBLIC_KEY, allowed);
            }
        },
        {
            key: "getPublicWriteAccess",
            value: function() /*: boolean*/ {
                return this.getWriteAccess($1d9fb5067889164c$var$PUBLIC_KEY);
            }
        },
        {
            key: "getRoleReadAccess",
            value: function(role) /*: boolean*/ {
                if (role instanceof $1d9fb5067889164c$var$_ParseRole.default) // Normalize to the String name
                role = role.getName();
                if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
                return this.getReadAccess("role:" + role);
            }
        },
        {
            key: "getRoleWriteAccess",
            value: function(role) /*: boolean*/ {
                if (role instanceof $1d9fb5067889164c$var$_ParseRole.default) // Normalize to the String name
                role = role.getName();
                if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
                return this.getWriteAccess("role:" + role);
            }
        },
        {
            key: "setRoleReadAccess",
            value: function(role, allowed) {
                if (role instanceof $1d9fb5067889164c$var$_ParseRole.default) // Normalize to the String name
                role = role.getName();
                if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
                this.setReadAccess("role:" + role, allowed);
            }
        },
        {
            key: "setRoleWriteAccess",
            value: function(role, allowed) {
                if (role instanceof $1d9fb5067889164c$var$_ParseRole.default) // Normalize to the String name
                role = role.getName();
                if (typeof role !== "string") throw new TypeError("role must be a ParseRole or a String");
                this.setWriteAccess("role:" + role, allowed);
            }
        }
    ]);
    return ParseACL;
}();
var $1d9fb5067889164c$var$_default = $1d9fb5067889164c$var$ParseACL;
module.exports.default = $1d9fb5067889164c$var$_default;

});
parcelRequire.register("2QmZN", function(module, exports) {

module.exports = (parcelRequire("5gyKS"));

});
parcelRequire.register("5gyKS", function(module, exports) {

var $4irDB = parcelRequire("4irDB");
module.exports = $4irDB;

});
parcelRequire.register("4irDB", function(module, exports) {
parcelRequire("daIoi");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.keys;

});
parcelRequire.register("daIoi", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $iJNxK = parcelRequire("iJNxK");

var $3Ut0t = parcelRequire("3Ut0t");

var $77TPA = parcelRequire("77TPA");
var $996ea4a33c906706$var$FAILS_ON_PRIMITIVES = $77TPA(function() {
    $3Ut0t(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$ggcsv({
    target: "Object",
    stat: true,
    forced: $996ea4a33c906706$var$FAILS_ON_PRIMITIVES
}, {
    keys: function keys(it) {
        return $3Ut0t($iJNxK(it));
    }
});

});




parcelRequire.register("B9w5B", function(module, exports) {
function $06fad69bca4bd2fd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $06fad69bca4bd2fd$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("HRw7E", function(module, exports) {

var $c6AAP = parcelRequire("c6AAP");
function $083d87a6169117d6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        $c6AAP(target, descriptor.key, descriptor);
    }
}
function $083d87a6169117d6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $083d87a6169117d6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $083d87a6169117d6$var$_defineProperties(Constructor, staticProps);
    $c6AAP(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $083d87a6169117d6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("c6AAP", function(module, exports) {

module.exports = (parcelRequire("hV0qA"));

});
parcelRequire.register("hV0qA", function(module, exports) {

module.exports = (parcelRequire("2S1Lk"));

});
parcelRequire.register("2S1Lk", function(module, exports) {

var $aAhWo = parcelRequire("aAhWo");
module.exports = $aAhWo;

});
parcelRequire.register("aAhWo", function(module, exports) {

var $iizpp = parcelRequire("iizpp");
module.exports = $iizpp;

});





parcelRequire.register("4cByw", function(module, exports) {

var $c6AAP = parcelRequire("c6AAP");
function $30f56a30cd5b4ba5$var$_defineProperty(obj, key, value) {
    if (key in obj) $c6AAP(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $30f56a30cd5b4ba5$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("7MXHA", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");

var $oM1qX = parcelRequire("oM1qX");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5abb53a6926c4351$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $5abb53a6926c4351$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $5abb53a6926c4351$var$_get2 = $iHLHC((parcelRequire("a4mHi")));

var $5abb53a6926c4351$var$_inherits2 = $iHLHC((parcelRequire("cNDsY")));

var $5abb53a6926c4351$var$_possibleConstructorReturn2 = $iHLHC((parcelRequire("1C8Dw")));

var $5abb53a6926c4351$var$_getPrototypeOf2 = $iHLHC((parcelRequire("kptbe")));

var $5abb53a6926c4351$var$_ParseACL = $iHLHC((parcelRequire("2xGBa")));

var $5abb53a6926c4351$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $5abb53a6926c4351$var$_ParseObject2 = $iHLHC((parcelRequire("fMBjE")));
function $5abb53a6926c4351$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5abb53a6926c4351$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $5abb53a6926c4351$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $5abb53a6926c4351$var$_getPrototypeOf2.default)(this).constructor;
            result = $oM1qX(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $5abb53a6926c4351$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $5abb53a6926c4351$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$oM1qX) return false;
    if ($oM1qX.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($oM1qX(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Represents a Role on the Parse server. Roles represent groupings of
 * Users for the purposes of granting permissions (e.g. specifying an ACL
 * for an Object). Roles are specified by their sets of child users and
 * child roles, all of which are granted any permissions that the parent
 * role has.
 *
 * <p>Roles must have a name (which cannot be changed after creation of the
 * role), and must specify an ACL.</p>
 *
 * @alias Parse.Role
 * @augments Parse.Object
 */ var $5abb53a6926c4351$var$ParseRole = /*#__PURE__*/ function(_ParseObject) {
    (0, $5abb53a6926c4351$var$_inherits2.default)(ParseRole, _ParseObject);
    var _super = $5abb53a6926c4351$var$_createSuper(ParseRole);
    /**
   * @param {string} name The name of the Role to create.
   * @param {Parse.ACL} acl The ACL for this role. Roles must have an ACL.
   * A Parse.Role is a local representation of a role persisted to the Parse
   * cloud.
   */ function ParseRole(name, acl) {
        var _this;
        (0, $5abb53a6926c4351$var$_classCallCheck2.default)(this, ParseRole);
        _this = _super.call(this, "_Role");
        if (typeof name === "string" && acl instanceof $5abb53a6926c4351$var$_ParseACL.default) {
            _this.setName(name);
            _this.setACL(acl);
        }
        return _this;
    }
    /**
   * Gets the name of the role.  You can alternatively call role.get("name")
   *
   * @returns {string} the name of the role.
   */ (0, $5abb53a6926c4351$var$_createClass2.default)(ParseRole, [
        {
            key: "getName",
            value: function() /*: ?string*/ {
                var name = this.get("name");
                if (name == null || typeof name === "string") return name;
                return "";
            }
        },
        {
            key: "setName",
            value: function(name, options) /*: ParseObject | boolean*/ {
                this._validateName(name);
                return this.set("name", name, options);
            }
        },
        {
            key: "getUsers",
            value: function() /*: ParseRelation*/ {
                return this.relation("users");
            }
        },
        {
            key: "getRoles",
            value: function() /*: ParseRelation*/ {
                return this.relation("roles");
            }
        },
        {
            key: "_validateName",
            value: function(newName) {
                if (typeof newName !== "string") throw new $5abb53a6926c4351$var$_ParseError.default($5abb53a6926c4351$var$_ParseError.default.OTHER_CAUSE, "A role's name must be a String.");
                if (!/^[0-9a-zA-Z\-_ ]+$/.test(newName)) throw new $5abb53a6926c4351$var$_ParseError.default($5abb53a6926c4351$var$_ParseError.default.OTHER_CAUSE, "A role's name can be only contain alphanumeric characters, _, -, and spaces.");
            }
        },
        {
            key: "validate",
            value: function(attrs, options) /*: ParseError | boolean*/ {
                var isInvalid = (0, $5abb53a6926c4351$var$_get2.default)((0, $5abb53a6926c4351$var$_getPrototypeOf2.default)(ParseRole.prototype), "validate", this).call(this, attrs, options);
                if (isInvalid) return isInvalid;
                if ("name" in attrs && attrs.name !== this.getName()) {
                    var newName = attrs.name;
                    if (this.id && this.id !== attrs.objectId) // Check to see if the objectId being set matches this.id
                    // This happens during a fetch -- the id is set before calling fetch
                    // Let the name be set in this case
                    return new $5abb53a6926c4351$var$_ParseError.default($5abb53a6926c4351$var$_ParseError.default.OTHER_CAUSE, "A role's name can only be set before it has been saved.");
                    try {
                        this._validateName(newName);
                    } catch (e) {
                        return e;
                    }
                }
                return false;
            }
        }
    ]);
    return ParseRole;
}($5abb53a6926c4351$var$_ParseObject2.default);
$5abb53a6926c4351$var$_ParseObject2.default.registerSubclass("_Role", $5abb53a6926c4351$var$ParseRole);
var $5abb53a6926c4351$var$_default = $5abb53a6926c4351$var$ParseRole;
module.exports.default = $5abb53a6926c4351$var$_default;

});
parcelRequire.register("oM1qX", function(module, exports) {

module.exports = (parcelRequire("5xQII"));

});
parcelRequire.register("5xQII", function(module, exports) {

var $9fcCg = parcelRequire("9fcCg");
module.exports = $9fcCg;

});
parcelRequire.register("9fcCg", function(module, exports) {
parcelRequire("kvgoU");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Reflect.construct;

});
parcelRequire.register("kvgoU", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $5Pobw = parcelRequire("5Pobw");

var $2JOsI = parcelRequire("2JOsI");

var $jWy7e = parcelRequire("jWy7e");

var $dGyrk = parcelRequire("dGyrk");

var $l3LMJ = parcelRequire("l3LMJ");

var $1WYwK = parcelRequire("1WYwK");

var $fhVPP = parcelRequire("fhVPP");

var $77TPA = parcelRequire("77TPA");
var $eed36cbecff42f25$var$nativeConstruct = $5Pobw("Reflect", "construct");
var $eed36cbecff42f25$var$ObjectPrototype = Object.prototype;
var $eed36cbecff42f25$var$push = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $eed36cbecff42f25$var$NEW_TARGET_BUG = $77TPA(function() {
    function F() {}
    return !($eed36cbecff42f25$var$nativeConstruct(function() {}, [], F) instanceof F);
});
var $eed36cbecff42f25$var$ARGS_BUG = !$77TPA(function() {
    $eed36cbecff42f25$var$nativeConstruct(function() {});
});
var $eed36cbecff42f25$var$FORCED = $eed36cbecff42f25$var$NEW_TARGET_BUG || $eed36cbecff42f25$var$ARGS_BUG;
$ggcsv({
    target: "Reflect",
    stat: true,
    forced: $eed36cbecff42f25$var$FORCED,
    sham: $eed36cbecff42f25$var$FORCED
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        $dGyrk(Target);
        $l3LMJ(args);
        var newTarget = arguments.length < 3 ? Target : $dGyrk(arguments[2]);
        if ($eed36cbecff42f25$var$ARGS_BUG && !$eed36cbecff42f25$var$NEW_TARGET_BUG) return $eed36cbecff42f25$var$nativeConstruct(Target, args, newTarget);
        if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $2JOsI($eed36cbecff42f25$var$push, $args, args);
            return new ($2JOsI($jWy7e, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $fhVPP($1WYwK(proto) ? proto : $eed36cbecff42f25$var$ObjectPrototype);
        var result = $2JOsI(Target, instance, args);
        return $1WYwK(result) ? result : instance;
    }
});

});
parcelRequire.register("jWy7e", function(module, exports) {
"use strict";

var $f518o = parcelRequire("f518o");

var $8GsPx = parcelRequire("8GsPx");

var $1WYwK = parcelRequire("1WYwK");

var $heVlo = parcelRequire("heVlo");

var $hF40G = parcelRequire("hF40G");

var $4abbf = parcelRequire("4abbf");
var $e84de5c07d9c9bde$var$$Function = Function;
var $e84de5c07d9c9bde$var$concat = $f518o([].concat);
var $e84de5c07d9c9bde$var$join = $f518o([].join);
var $e84de5c07d9c9bde$var$factories = {};
var $e84de5c07d9c9bde$var$construct = function(C, argsLength, args) {
    if (!$heVlo($e84de5c07d9c9bde$var$factories, argsLength)) {
        for(var list = [], i = 0; i < argsLength; i++)list[i] = "a[" + i + "]";
        $e84de5c07d9c9bde$var$factories[argsLength] = $e84de5c07d9c9bde$var$$Function("C,a", "return new C(" + $e84de5c07d9c9bde$var$join(list, ",") + ")");
    }
    return $e84de5c07d9c9bde$var$factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = $4abbf ? $e84de5c07d9c9bde$var$$Function.bind : function bind(that /* , ...args */ ) {
    var F = $8GsPx(this);
    var Prototype = F.prototype;
    var partArgs = $hF40G(arguments, 1);
    var boundFunction = function bound() {
        var args = $e84de5c07d9c9bde$var$concat(partArgs, $hF40G(arguments));
        return this instanceof boundFunction ? $e84de5c07d9c9bde$var$construct(F, args.length, args) : F.apply(that, args);
    };
    if ($1WYwK(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};

});





parcelRequire.register("a4mHi", function(module, exports) {

var $hWca0 = parcelRequire("hWca0");

var $9ZQn1 = parcelRequire("9ZQn1");

var $5reLd = parcelRequire("5reLd");
function $754be254bfd9bb9c$var$_get() {
    if (typeof Reflect !== "undefined" && $hWca0) module.exports = $754be254bfd9bb9c$var$_get = $hWca0, module.exports.__esModule = true, module.exports["default"] = module.exports;
    else module.exports = $754be254bfd9bb9c$var$_get = function _get(target, property, receiver) {
        var base = $5reLd(target, property);
        if (!base) return;
        var desc = $9ZQn1(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $754be254bfd9bb9c$var$_get.apply(this, arguments);
}
module.exports = $754be254bfd9bb9c$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("hWca0", function(module, exports) {

module.exports = (parcelRequire("8gN5U"));

});
parcelRequire.register("8gN5U", function(module, exports) {

module.exports = (parcelRequire("65SrB"));

});
parcelRequire.register("65SrB", function(module, exports) {

var $7rZUD = parcelRequire("7rZUD");
module.exports = $7rZUD;

});
parcelRequire.register("7rZUD", function(module, exports) {

var $f9S20 = parcelRequire("f9S20");
module.exports = $f9S20;

});
parcelRequire.register("f9S20", function(module, exports) {

var $gcrvb = parcelRequire("gcrvb");
module.exports = $gcrvb;

});
parcelRequire.register("gcrvb", function(module, exports) {
parcelRequire("9PnGZ");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Reflect.get;

});
parcelRequire.register("9PnGZ", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $1WYwK = parcelRequire("1WYwK");

var $l3LMJ = parcelRequire("l3LMJ");

var $8dPMk = parcelRequire("8dPMk");

var $fTFId = parcelRequire("fTFId");

var $2pQL6 = parcelRequire("2pQL6");
// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function $727b414e0082e42b$var$get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var descriptor, prototype;
    if ($l3LMJ(target) === receiver) return target[propertyKey];
    descriptor = $fTFId.f(target, propertyKey);
    if (descriptor) return $8dPMk(descriptor) ? descriptor.value : descriptor.get === undefined ? undefined : $aELZY(descriptor.get, receiver);
    if ($1WYwK(prototype = $2pQL6(target))) return $727b414e0082e42b$var$get(prototype, propertyKey, receiver);
}
$ggcsv({
    target: "Reflect",
    stat: true
}, {
    get: $727b414e0082e42b$var$get
});

});
parcelRequire.register("8dPMk", function(module, exports) {

var $heVlo = parcelRequire("heVlo");
module.exports = function(descriptor) {
    return descriptor !== undefined && ($heVlo(descriptor, "value") || $heVlo(descriptor, "writable"));
};

});








parcelRequire.register("9ZQn1", function(module, exports) {

module.exports = (parcelRequire("9Jo2E"));

});
parcelRequire.register("9Jo2E", function(module, exports) {

module.exports = (parcelRequire("8tXKk"));

});
parcelRequire.register("8tXKk", function(module, exports) {

var $ed2dX = parcelRequire("ed2dX");
module.exports = $ed2dX;

});
parcelRequire.register("ed2dX", function(module, exports) {

var $jDHFu = parcelRequire("jDHFu");
module.exports = $jDHFu;

});




parcelRequire.register("5reLd", function(module, exports) {

var $kptbe = parcelRequire("kptbe");
function $3f5aec8420fb8554$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $kptbe(object);
        if (object === null) break;
    }
    return object;
}
module.exports = $3f5aec8420fb8554$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("kptbe", function(module, exports) {

var $bUkw5 = parcelRequire("bUkw5");

var $hegXq = parcelRequire("hegXq");
function $edbcc702faac3ddc$var$_getPrototypeOf(o) {
    module.exports = $edbcc702faac3ddc$var$_getPrototypeOf = $bUkw5 ? $hegXq : function _getPrototypeOf(o) {
        return o.__proto__ || $hegXq(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $edbcc702faac3ddc$var$_getPrototypeOf(o);
}
module.exports = $edbcc702faac3ddc$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("bUkw5", function(module, exports) {

module.exports = (parcelRequire("e4xnw"));

});
parcelRequire.register("e4xnw", function(module, exports) {

module.exports = (parcelRequire("yv27y"));

});
parcelRequire.register("yv27y", function(module, exports) {

var $3FOsf = parcelRequire("3FOsf");
module.exports = $3FOsf;

});
parcelRequire.register("3FOsf", function(module, exports) {

var $gm0j3 = parcelRequire("gm0j3");
module.exports = $gm0j3;

});
parcelRequire.register("gm0j3", function(module, exports) {

var $9cfVb = parcelRequire("9cfVb");
module.exports = $9cfVb;

});
parcelRequire.register("9cfVb", function(module, exports) {
parcelRequire("l3Be4");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.setPrototypeOf;

});
parcelRequire.register("l3Be4", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $6e7Qv = parcelRequire("6e7Qv");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$ggcsv({
    target: "Object",
    stat: true
}, {
    setPrototypeOf: $6e7Qv
});

});







parcelRequire.register("hegXq", function(module, exports) {

module.exports = (parcelRequire("w2BUc"));

});
parcelRequire.register("w2BUc", function(module, exports) {

module.exports = (parcelRequire("7xxQp"));

});
parcelRequire.register("7xxQp", function(module, exports) {

var $kcVJ4 = parcelRequire("kcVJ4");
module.exports = $kcVJ4;

});
parcelRequire.register("kcVJ4", function(module, exports) {

var $6Llo9 = parcelRequire("6Llo9");
module.exports = $6Llo9;

});
parcelRequire.register("6Llo9", function(module, exports) {

var $ffvKw = parcelRequire("ffvKw");
module.exports = $ffvKw;

});
parcelRequire.register("ffvKw", function(module, exports) {
parcelRequire("6NONQ");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.getPrototypeOf;

});
parcelRequire.register("6NONQ", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $77TPA = parcelRequire("77TPA");

var $iJNxK = parcelRequire("iJNxK");

var $2pQL6 = parcelRequire("2pQL6");

var $lss67 = parcelRequire("lss67");
var $4f3eba1248c55e3d$var$FAILS_ON_PRIMITIVES = $77TPA(function() {
    $2pQL6(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$ggcsv({
    target: "Object",
    stat: true,
    forced: $4f3eba1248c55e3d$var$FAILS_ON_PRIMITIVES,
    sham: !$lss67
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return $2pQL6($iJNxK(it));
    }
});

});










parcelRequire.register("cNDsY", function(module, exports) {

var $5JKxW = parcelRequire("5JKxW");

var $c6AAP = parcelRequire("c6AAP");

var $f3Brs = parcelRequire("f3Brs");
function $9518accdabb49a65$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = $5JKxW(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    $c6AAP(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f3Brs(subClass, superClass);
}
module.exports = $9518accdabb49a65$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("5JKxW", function(module, exports) {

module.exports = (parcelRequire("fLRIv"));

});
parcelRequire.register("fLRIv", function(module, exports) {

module.exports = (parcelRequire("70dok"));

});
parcelRequire.register("70dok", function(module, exports) {

var $5EhaH = parcelRequire("5EhaH");
module.exports = $5EhaH;

});
parcelRequire.register("5EhaH", function(module, exports) {

var $c9ilJ = parcelRequire("c9ilJ");
module.exports = $c9ilJ;

});
parcelRequire.register("c9ilJ", function(module, exports) {

var $7lNnm = parcelRequire("7lNnm");
module.exports = $7lNnm;

});
parcelRequire.register("7lNnm", function(module, exports) {
parcelRequire("1UOrt");

var $ly30u = parcelRequire("ly30u");
var $55a0cb8cc2353868$var$Object = $ly30u.Object;
module.exports = function create(P, D) {
    return $55a0cb8cc2353868$var$Object.create(P, D);
};

});
parcelRequire.register("1UOrt", function(module, exports) {
// TODO: Remove from `core-js@4`

var $ggcsv = parcelRequire("ggcsv");

var $jeZ4p = parcelRequire("jeZ4p");

var $fhVPP = parcelRequire("fhVPP");
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$ggcsv({
    target: "Object",
    stat: true,
    sham: !$jeZ4p
}, {
    create: $fhVPP
});

});







parcelRequire.register("f3Brs", function(module, exports) {

var $bUkw5 = parcelRequire("bUkw5");
function $af642e02c1b9309c$var$_setPrototypeOf(o, p) {
    module.exports = $af642e02c1b9309c$var$_setPrototypeOf = $bUkw5 || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $af642e02c1b9309c$var$_setPrototypeOf(o, p);
}
module.exports = $af642e02c1b9309c$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("1C8Dw", function(module, exports) {

var $6iqUa = parcelRequire("6iqUa");
var $12d00a1128051746$var$_typeof = $6iqUa.default;

var $ePpfW = parcelRequire("ePpfW");
function $12d00a1128051746$var$_possibleConstructorReturn(self, call) {
    if (call && ($12d00a1128051746$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ePpfW(self);
}
module.exports = $12d00a1128051746$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("ePpfW", function(module, exports) {
function $acb96b72f7c070ab$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $acb96b72f7c070ab$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("6ilM0", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");


var $oM1qX = parcelRequire("oM1qX");
(parcelRequire("4i3Tl"))(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4955503c9c2a41c0$var$_defineProperty = $iHLHC((parcelRequire("4i3Tl")));

var $4955503c9c2a41c0$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $4955503c9c2a41c0$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $4955503c9c2a41c0$var$_assertThisInitialized2 = $iHLHC((parcelRequire("ePpfW")));

var $4955503c9c2a41c0$var$_inherits2 = $iHLHC((parcelRequire("cNDsY")));

var $4955503c9c2a41c0$var$_possibleConstructorReturn2 = $iHLHC((parcelRequire("1C8Dw")));

var $4955503c9c2a41c0$var$_getPrototypeOf2 = $iHLHC((parcelRequire("kptbe")));

var $4955503c9c2a41c0$var$_wrapNativeSuper2 = $iHLHC((parcelRequire("78RoH")));
function $4955503c9c2a41c0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4955503c9c2a41c0$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $4955503c9c2a41c0$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $4955503c9c2a41c0$var$_getPrototypeOf2.default)(this).constructor;
            result = $oM1qX(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4955503c9c2a41c0$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $4955503c9c2a41c0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$oM1qX) return false;
    if ($oM1qX.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($oM1qX(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ /**
 * Constructs a new Parse.Error object with the given code and message.
 *
 * @alias Parse.Error
 */ var $4955503c9c2a41c0$var$ParseError = /*#__PURE__*/ function(_Error) {
    (0, $4955503c9c2a41c0$var$_inherits2.default)(ParseError, _Error);
    var _super = $4955503c9c2a41c0$var$_createSuper(ParseError);
    /**
   * @param {number} code An error code constant from <code>Parse.Error</code>.
   * @param {string} message A detailed description of the error.
   */ function ParseError(code, message) {
        var _this;
        (0, $4955503c9c2a41c0$var$_classCallCheck2.default)(this, ParseError);
        _this = _super.call(this, message);
        _this.code = code;
        (0, $4955503c9c2a41c0$var$_defineProperty.default)((0, $4955503c9c2a41c0$var$_assertThisInitialized2.default)(_this), "message", {
            enumerable: true,
            value: message
        });
        return _this;
    }
    (0, $4955503c9c2a41c0$var$_createClass2.default)(ParseError, [
        {
            key: "toString",
            value: function() {
                return "ParseError: " + this.code + " " + this.message;
            }
        }
    ]);
    return ParseError;
}(/*#__PURE__*/ (0, $4955503c9c2a41c0$var$_wrapNativeSuper2.default)(Error));
/**
 * Error code indicating some error other than those enumerated here.
 *
 * @property {number} OTHER_CAUSE
 * @static
 */ $4955503c9c2a41c0$var$ParseError.OTHER_CAUSE = -1;
/**
 * Error code indicating that something has gone wrong with the server.
 *
 * @property {number} INTERNAL_SERVER_ERROR
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INTERNAL_SERVER_ERROR = 1;
/**
 * Error code indicating the connection to the Parse servers failed.
 *
 * @property {number} CONNECTION_FAILED
 * @static
 */ $4955503c9c2a41c0$var$ParseError.CONNECTION_FAILED = 100;
/**
 * Error code indicating the specified object doesn't exist.
 *
 * @property {number} OBJECT_NOT_FOUND
 * @static
 */ $4955503c9c2a41c0$var$ParseError.OBJECT_NOT_FOUND = 101;
/**
 * Error code indicating you tried to query with a datatype that doesn't
 * support it, like exact matching an array or object.
 *
 * @property {number} INVALID_QUERY
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_QUERY = 102;
/**
 * Error code indicating a missing or invalid classname. Classnames are
 * case-sensitive. They must start with a letter, and a-zA-Z0-9_ are the
 * only valid characters.
 *
 * @property {number} INVALID_CLASS_NAME
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_CLASS_NAME = 103;
/**
 * Error code indicating an unspecified object id.
 *
 * @property {number} MISSING_OBJECT_ID
 * @static
 */ $4955503c9c2a41c0$var$ParseError.MISSING_OBJECT_ID = 104;
/**
 * Error code indicating an invalid key name. Keys are case-sensitive. They
 * must start with a letter, and a-zA-Z0-9_ are the only valid characters.
 *
 * @property {number} INVALID_KEY_NAME
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_KEY_NAME = 105;
/**
 * Error code indicating a malformed pointer. You should not see this unless
 * you have been mucking about changing internal Parse code.
 *
 * @property {number} INVALID_POINTER
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_POINTER = 106;
/**
 * Error code indicating that badly formed JSON was received upstream. This
 * either indicates you have done something unusual with modifying how
 * things encode to JSON, or the network is failing badly.
 *
 * @property {number} INVALID_JSON
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_JSON = 107;
/**
 * Error code indicating that the feature you tried to access is only
 * available internally for testing purposes.
 *
 * @property {number} COMMAND_UNAVAILABLE
 * @static
 */ $4955503c9c2a41c0$var$ParseError.COMMAND_UNAVAILABLE = 108;
/**
 * You must call Parse.initialize before using the Parse library.
 *
 * @property {number} NOT_INITIALIZED
 * @static
 */ $4955503c9c2a41c0$var$ParseError.NOT_INITIALIZED = 109;
/**
 * Error code indicating that a field was set to an inconsistent type.
 *
 * @property {number} INCORRECT_TYPE
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INCORRECT_TYPE = 111;
/**
 * Error code indicating an invalid channel name. A channel name is either
 * an empty string (the broadcast channel) or contains only a-zA-Z0-9_
 * characters and starts with a letter.
 *
 * @property {number} INVALID_CHANNEL_NAME
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_CHANNEL_NAME = 112;
/**
 * Error code indicating that push is misconfigured.
 *
 * @property {number} PUSH_MISCONFIGURED
 * @static
 */ $4955503c9c2a41c0$var$ParseError.PUSH_MISCONFIGURED = 115;
/**
 * Error code indicating that the object is too large.
 *
 * @property {number} OBJECT_TOO_LARGE
 * @static
 */ $4955503c9c2a41c0$var$ParseError.OBJECT_TOO_LARGE = 116;
/**
 * Error code indicating that the operation isn't allowed for clients.
 *
 * @property {number} OPERATION_FORBIDDEN
 * @static
 */ $4955503c9c2a41c0$var$ParseError.OPERATION_FORBIDDEN = 119;
/**
 * Error code indicating the result was not found in the cache.
 *
 * @property {number} CACHE_MISS
 * @static
 */ $4955503c9c2a41c0$var$ParseError.CACHE_MISS = 120;
/**
 * Error code indicating that an invalid key was used in a nested
 * JSONObject.
 *
 * @property {number} INVALID_NESTED_KEY
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_NESTED_KEY = 121;
/**
 * Error code indicating that an invalid filename was used for ParseFile.
 * A valid file name contains only a-zA-Z0-9_. characters and is between 1
 * and 128 characters.
 *
 * @property {number} INVALID_FILE_NAME
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_FILE_NAME = 122;
/**
 * Error code indicating an invalid ACL was provided.
 *
 * @property {number} INVALID_ACL
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_ACL = 123;
/**
 * Error code indicating that the request timed out on the server. Typically
 * this indicates that the request is too expensive to run.
 *
 * @property {number} TIMEOUT
 * @static
 */ $4955503c9c2a41c0$var$ParseError.TIMEOUT = 124;
/**
 * Error code indicating that the email address was invalid.
 *
 * @property {number} INVALID_EMAIL_ADDRESS
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_EMAIL_ADDRESS = 125;
/**
 * Error code indicating a missing content type.
 *
 * @property {number} MISSING_CONTENT_TYPE
 * @static
 */ $4955503c9c2a41c0$var$ParseError.MISSING_CONTENT_TYPE = 126;
/**
 * Error code indicating a missing content length.
 *
 * @property {number} MISSING_CONTENT_LENGTH
 * @static
 */ $4955503c9c2a41c0$var$ParseError.MISSING_CONTENT_LENGTH = 127;
/**
 * Error code indicating an invalid content length.
 *
 * @property {number} INVALID_CONTENT_LENGTH
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_CONTENT_LENGTH = 128;
/**
 * Error code indicating a file that was too large.
 *
 * @property {number} FILE_TOO_LARGE
 * @static
 */ $4955503c9c2a41c0$var$ParseError.FILE_TOO_LARGE = 129;
/**
 * Error code indicating an error saving a file.
 *
 * @property {number} FILE_SAVE_ERROR
 * @static
 */ $4955503c9c2a41c0$var$ParseError.FILE_SAVE_ERROR = 130;
/**
 * Error code indicating that a unique field was given a value that is
 * already taken.
 *
 * @property {number} DUPLICATE_VALUE
 * @static
 */ $4955503c9c2a41c0$var$ParseError.DUPLICATE_VALUE = 137;
/**
 * Error code indicating that a role's name is invalid.
 *
 * @property {number} INVALID_ROLE_NAME
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_ROLE_NAME = 139;
/**
 * Error code indicating that an application quota was exceeded.  Upgrade to
 * resolve.
 *
 * @property {number} EXCEEDED_QUOTA
 * @static
 */ $4955503c9c2a41c0$var$ParseError.EXCEEDED_QUOTA = 140;
/**
 * Error code indicating that a Cloud Code script failed.
 *
 * @property {number} SCRIPT_FAILED
 * @static
 */ $4955503c9c2a41c0$var$ParseError.SCRIPT_FAILED = 141;
/**
 * Error code indicating that a Cloud Code validation failed.
 *
 * @property {number} VALIDATION_ERROR
 * @static
 */ $4955503c9c2a41c0$var$ParseError.VALIDATION_ERROR = 142;
/**
 * Error code indicating that invalid image data was provided.
 *
 * @property {number} INVALID_IMAGE_DATA
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_IMAGE_DATA = 143;
/**
 * Error code indicating an unsaved file.
 *
 * @property {number} UNSAVED_FILE_ERROR
 * @static
 */ $4955503c9c2a41c0$var$ParseError.UNSAVED_FILE_ERROR = 151;
/**
 * Error code indicating an invalid push time.
 *
 * @property {number} INVALID_PUSH_TIME_ERROR
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_PUSH_TIME_ERROR = 152;
/**
 * Error code indicating an error deleting a file.
 *
 * @property {number} FILE_DELETE_ERROR
 * @static
 */ $4955503c9c2a41c0$var$ParseError.FILE_DELETE_ERROR = 153;
/**
 * Error code indicating an error deleting an unnamed file.
 *
 * @property {number} FILE_DELETE_UNNAMED_ERROR
 * @static
 */ $4955503c9c2a41c0$var$ParseError.FILE_DELETE_UNNAMED_ERROR = 161;
/**
 * Error code indicating that the application has exceeded its request
 * limit.
 *
 * @property {number} REQUEST_LIMIT_EXCEEDED
 * @static
 */ $4955503c9c2a41c0$var$ParseError.REQUEST_LIMIT_EXCEEDED = 155;
/**
 * Error code indicating that the request was a duplicate and has been discarded due to
 * idempotency rules.
 *
 * @property {number} DUPLICATE_REQUEST
 * @static
 */ $4955503c9c2a41c0$var$ParseError.DUPLICATE_REQUEST = 159;
/**
 * Error code indicating an invalid event name.
 *
 * @property {number} INVALID_EVENT_NAME
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_EVENT_NAME = 160;
/**
 * Error code indicating that a field had an invalid value.
 *
 * @property {number} INVALID_VALUE
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_VALUE = 162;
/**
 * Error code indicating that the username is missing or empty.
 *
 * @property {number} USERNAME_MISSING
 * @static
 */ $4955503c9c2a41c0$var$ParseError.USERNAME_MISSING = 200;
/**
 * Error code indicating that the password is missing or empty.
 *
 * @property {number} PASSWORD_MISSING
 * @static
 */ $4955503c9c2a41c0$var$ParseError.PASSWORD_MISSING = 201;
/**
 * Error code indicating that the username has already been taken.
 *
 * @property {number} USERNAME_TAKEN
 * @static
 */ $4955503c9c2a41c0$var$ParseError.USERNAME_TAKEN = 202;
/**
 * Error code indicating that the email has already been taken.
 *
 * @property {number} EMAIL_TAKEN
 * @static
 */ $4955503c9c2a41c0$var$ParseError.EMAIL_TAKEN = 203;
/**
 * Error code indicating that the email is missing, but must be specified.
 *
 * @property {number} EMAIL_MISSING
 * @static
 */ $4955503c9c2a41c0$var$ParseError.EMAIL_MISSING = 204;
/**
 * Error code indicating that a user with the specified email was not found.
 *
 * @property {number} EMAIL_NOT_FOUND
 * @static
 */ $4955503c9c2a41c0$var$ParseError.EMAIL_NOT_FOUND = 205;
/**
 * Error code indicating that a user object without a valid session could
 * not be altered.
 *
 * @property {number} SESSION_MISSING
 * @static
 */ $4955503c9c2a41c0$var$ParseError.SESSION_MISSING = 206;
/**
 * Error code indicating that a user can only be created through signup.
 *
 * @property {number} MUST_CREATE_USER_THROUGH_SIGNUP
 * @static
 */ $4955503c9c2a41c0$var$ParseError.MUST_CREATE_USER_THROUGH_SIGNUP = 207;
/**
 * Error code indicating that an an account being linked is already linked
 * to another user.
 *
 * @property {number} ACCOUNT_ALREADY_LINKED
 * @static
 */ $4955503c9c2a41c0$var$ParseError.ACCOUNT_ALREADY_LINKED = 208;
/**
 * Error code indicating that the current session token is invalid.
 *
 * @property {number} INVALID_SESSION_TOKEN
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_SESSION_TOKEN = 209;
/**
 * Error code indicating an error enabling or verifying MFA
 *
 * @property {number} MFA_ERROR
 * @static
 */ $4955503c9c2a41c0$var$ParseError.MFA_ERROR = 210;
/**
 * Error code indicating that a valid MFA token must be provided
 *
 * @property {number} MFA_TOKEN_REQUIRED
 * @static
 */ $4955503c9c2a41c0$var$ParseError.MFA_TOKEN_REQUIRED = 211;
/**
 * Error code indicating that a user cannot be linked to an account because
 * that account's id could not be found.
 *
 * @property {number} LINKED_ID_MISSING
 * @static
 */ $4955503c9c2a41c0$var$ParseError.LINKED_ID_MISSING = 250;
/**
 * Error code indicating that a user with a linked (e.g. Facebook) account
 * has an invalid session.
 *
 * @property {number} INVALID_LINKED_SESSION
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_LINKED_SESSION = 251;
/**
 * Error code indicating that a service being linked (e.g. Facebook or
 * Twitter) is unsupported.
 *
 * @property {number} UNSUPPORTED_SERVICE
 * @static
 */ $4955503c9c2a41c0$var$ParseError.UNSUPPORTED_SERVICE = 252;
/**
 * Error code indicating an invalid operation occured on schema
 *
 * @property {number} INVALID_SCHEMA_OPERATION
 * @static
 */ $4955503c9c2a41c0$var$ParseError.INVALID_SCHEMA_OPERATION = 255;
/**
 * Error code indicating that there were multiple errors. Aggregate errors
 * have an "errors" property, which is an array of error objects with more
 * detail about each error that occurred.
 *
 * @property {number} AGGREGATE_ERROR
 * @static
 */ $4955503c9c2a41c0$var$ParseError.AGGREGATE_ERROR = 600;
/**
 * Error code indicating the client was unable to read an input file.
 *
 * @property {number} FILE_READ_ERROR
 * @static
 */ $4955503c9c2a41c0$var$ParseError.FILE_READ_ERROR = 601;
/**
 * Error code indicating a real error code is unavailable because
 * we had to use an XDomainRequest object to allow CORS requests in
 * Internet Explorer, which strips the body from HTTP responses that have
 * a non-2XX status code.
 *
 * @property {number} X_DOMAIN_REQUEST
 * @static
 */ $4955503c9c2a41c0$var$ParseError.X_DOMAIN_REQUEST = 602;
var $4955503c9c2a41c0$var$_default = $4955503c9c2a41c0$var$ParseError;
module.exports.default = $4955503c9c2a41c0$var$_default;

});
parcelRequire.register("78RoH", function(module, exports) {

var $kJ7gl = parcelRequire("kJ7gl");

var $5JKxW = parcelRequire("5JKxW");

var $kptbe = parcelRequire("kptbe");

var $f3Brs = parcelRequire("f3Brs");

var $dCi2u = parcelRequire("dCi2u");

var $5fJCO = parcelRequire("5fJCO");
function $5332b3580547db20$var$_wrapNativeSuper(Class) {
    var _cache = typeof $kJ7gl === "function" ? new $kJ7gl() : undefined;
    module.exports = $5332b3580547db20$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$dCi2u(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $5fJCO(Class, arguments, $kptbe(this).constructor);
        }
        Wrapper.prototype = $5JKxW(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $f3Brs(Wrapper, Class);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $5332b3580547db20$var$_wrapNativeSuper(Class);
}
module.exports = $5332b3580547db20$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("kJ7gl", function(module, exports) {

module.exports = (parcelRequire("56xTc"));

});
parcelRequire.register("56xTc", function(module, exports) {

module.exports = (parcelRequire("fQazF"));

});
parcelRequire.register("fQazF", function(module, exports) {

var $2ol2p = parcelRequire("2ol2p");
parcelRequire("4zCjO");
parcelRequire("6HjGA");
parcelRequire("37LvH");
parcelRequire("d8wXV");
parcelRequire("5BMlR");
parcelRequire("8SkHK");
parcelRequire("7SSjB");
parcelRequire("ksITo");
parcelRequire("1yZwj");
parcelRequire("1Uj81");
parcelRequire("2oCpr");
parcelRequire("aqrAf");
parcelRequire("hHR8w");
parcelRequire("aWmWR");
parcelRequire("voGy6");
parcelRequire("7QU6C");
parcelRequire("4E0hS");
parcelRequire("j5hxn");
parcelRequire("jp01D");
parcelRequire("XkoE2");
module.exports = $2ol2p;

});
parcelRequire.register("2ol2p", function(module, exports) {

var $gXAPd = parcelRequire("gXAPd");
module.exports = $gXAPd;

});
parcelRequire.register("gXAPd", function(module, exports) {

var $4pVgE = parcelRequire("4pVgE");
parcelRequire("jXhxH");
module.exports = $4pVgE;

});
parcelRequire.register("4pVgE", function(module, exports) {
parcelRequire("5xrGR");
parcelRequire("5rfW8");
parcelRequire("iYyco");
parcelRequire("ja2zQ");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Map;

});
parcelRequire.register("5rfW8", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's replaced to module below
parcelRequire("hoPYl");

});
parcelRequire.register("hoPYl", function(module, exports) {
"use strict";

var $30YqS = parcelRequire("30YqS");

var $1q3vw = parcelRequire("1q3vw");
// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$30YqS("Map", function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $1q3vw);

});
parcelRequire.register("1q3vw", function(module, exports) {
"use strict";

var $fhVPP = parcelRequire("fhVPP");

var $7kUwJ = parcelRequire("7kUwJ");

var $gklY2 = parcelRequire("gklY2");

var $b5UsH = parcelRequire("b5UsH");

var $a95no = parcelRequire("a95no");

var $6exeg = parcelRequire("6exeg");

var $jUk8Y = parcelRequire("jUk8Y");

var $5KUYO = parcelRequire("5KUYO");

var $5IrwJ = parcelRequire("5IrwJ");

var $13iqA = parcelRequire("13iqA");

var $jeZ4p = parcelRequire("jeZ4p");

var $iZE4H = parcelRequire("iZE4H");
var $108af0a6911c2cfe$require$fastKey = $iZE4H.fastKey;

var $fmQ29 = parcelRequire("fmQ29");
var $108af0a6911c2cfe$var$setInternalState = $fmQ29.set;
var $108af0a6911c2cfe$var$internalStateGetterFor = $fmQ29.getterFor;
module.exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $a95no(that, Prototype);
            $108af0a6911c2cfe$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $fhVPP(null),
                first: undefined,
                last: undefined,
                size: 0
            });
            if (!$jeZ4p) that.size = 0;
            if (!$6exeg(iterable)) $jUk8Y(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $108af0a6911c2cfe$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $108af0a6911c2cfe$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: undefined,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($jeZ4p) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $108af0a6911c2cfe$require$fastKey(key);
            var entry;
            if (index !== "F") return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key == key) return entry;
            }
        };
        $gklY2(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                    delete data[entry.index];
                    entry = entry.next;
                }
                state.first = state.last = undefined;
                if ($jeZ4p) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            "delete": function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first == entry) state.first = next;
                    if (state.last == entry) state.last = prev;
                    if ($jeZ4p) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $b5UsH(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $gklY2(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($jeZ4p) $7kUwJ(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
        var getInternalCollectionState = $108af0a6911c2cfe$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $108af0a6911c2cfe$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $5KUYO(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $108af0a6911c2cfe$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: undefined
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return $5IrwJ(undefined, true);
            }
            // return step by kind
            if (kind == "keys") return $5IrwJ(entry.key, false);
            if (kind == "values") return $5IrwJ(entry.value, false);
            return $5IrwJ([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $13iqA(CONSTRUCTOR_NAME);
    }
};

});






parcelRequire.register("4zCjO", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $03YYL = parcelRequire("03YYL");
// `Map.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
$ggcsv({
    target: "Map",
    stat: true,
    forced: true
}, {
    from: $03YYL
});

});
parcelRequire.register("03YYL", function(module, exports) {
"use strict";

var $b5UsH = parcelRequire("b5UsH");

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $dGyrk = parcelRequire("dGyrk");

var $6exeg = parcelRequire("6exeg");

var $jUk8Y = parcelRequire("jUk8Y");
var $00bf9518eaf04d21$var$push = [].push;
module.exports = function from(source /* , mapFn, thisArg */ ) {
    var length = arguments.length;
    var mapFn = length > 1 ? arguments[1] : undefined;
    var mapping, array, n, boundFunction;
    $dGyrk(this);
    mapping = mapFn !== undefined;
    if (mapping) $8GsPx(mapFn);
    if ($6exeg(source)) return new this();
    array = [];
    if (mapping) {
        n = 0;
        boundFunction = $b5UsH(mapFn, length > 2 ? arguments[2] : undefined);
        $jUk8Y(source, function(nextItem) {
            $aELZY($00bf9518eaf04d21$var$push, array, boundFunction(nextItem, n++));
        });
    } else $jUk8Y(source, $00bf9518eaf04d21$var$push, {
        that: array
    });
    return new this(array);
};

});


parcelRequire.register("6HjGA", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $gQL8j = parcelRequire("gQL8j");
// `Map.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
$ggcsv({
    target: "Map",
    stat: true,
    forced: true
}, {
    of: $gQL8j
});

});
parcelRequire.register("gQL8j", function(module, exports) {
"use strict";

var $hF40G = parcelRequire("hF40G");
// https://tc39.github.io/proposal-setmap-offrom/
module.exports = function of() {
    return new this($hF40G(arguments));
};

});


parcelRequire.register("37LvH", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $d6D38 = parcelRequire("d6D38");

var $dfy73 = parcelRequire("dfy73");
var $2466e1131e496c3a$require$remove = $dfy73.remove;
// `Map.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $d6D38(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $2466e1131e496c3a$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});

});
parcelRequire.register("d6D38", function(module, exports) {

var $k9gzN = parcelRequire("k9gzN");
// Perform ? RequireInternalSlot(M, [[MapData]])
module.exports = function(it) {
    if (typeof it == "object" && "size" in it && "has" in it && "get" in it && "set" in it && "delete" in it && "entries" in it) return it;
    throw TypeError($k9gzN(it) + " is not a map");
};

});

parcelRequire.register("dfy73", function(module, exports) {

var $5Pobw = parcelRequire("5Pobw");

var $1Tqyy = parcelRequire("1Tqyy");
var $9a57232bf25135e7$var$Map = $5Pobw("Map");
module.exports = {
    Map: $9a57232bf25135e7$var$Map,
    set: $1Tqyy("set", 2),
    get: $1Tqyy("get", 1),
    has: $1Tqyy("has", 1),
    remove: $1Tqyy("delete", 1),
    proto: $9a57232bf25135e7$var$Map.prototype
};

});
parcelRequire.register("1Tqyy", function(module, exports) {
module.exports = function(methodName, numArgs) {
    return numArgs == 1 ? function(object, arg) {
        return object[methodName](arg);
    } : function(object, arg1, arg2) {
        return object[methodName](arg1, arg2);
    };
};

});



parcelRequire.register("d8wXV", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $d6D38 = parcelRequire("d6D38");

var $dfy73 = parcelRequire("dfy73");
var $99059801b4a4c334$var$get = $dfy73.get;
var $99059801b4a4c334$var$has = $dfy73.has;
var $99059801b4a4c334$var$set = $dfy73.set;
// `Map.prototype.emplace` method
// https://github.com/tc39/proposal-upsert
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    emplace: function emplace(key, handler) {
        var map = $d6D38(this);
        var value, inserted;
        if ($99059801b4a4c334$var$has(map, key)) {
            value = $99059801b4a4c334$var$get(map, key);
            if ("update" in handler) {
                value = handler.update(value, key, map);
                $99059801b4a4c334$var$set(map, key, value);
            }
            return value;
        }
        inserted = handler.insert(key, map);
        $99059801b4a4c334$var$set(map, key, inserted);
        return inserted;
    }
});

});

parcelRequire.register("5BMlR", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $b5UsH = parcelRequire("b5UsH");

var $d6D38 = parcelRequire("d6D38");

var $9LbVe = parcelRequire("9LbVe");
// `Map.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var map = $d6D38(this);
        var boundFunction = $b5UsH(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $9LbVe(map, function(value, key) {
            if (!boundFunction(value, key, map)) return false;
        }, true) !== false;
    }
});

});
parcelRequire.register("9LbVe", function(module, exports) {

var $9fqlz = parcelRequire("9fqlz");
module.exports = function(map, fn, interruptible) {
    return interruptible ? $9fqlz(map.entries(), function(entry) {
        return fn(entry[1], entry[0]);
    }) : map.forEach(fn);
};

});
parcelRequire.register("9fqlz", function(module, exports) {

var $aELZY = parcelRequire("aELZY");
module.exports = function(iterator, fn, $next) {
    var next = $next || iterator.next;
    var step, result;
    while(!(step = $aELZY(next, iterator)).done){
        result = fn(step.value);
        if (result !== undefined) return result;
    }
};

});



parcelRequire.register("8SkHK", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $b5UsH = parcelRequire("b5UsH");

var $d6D38 = parcelRequire("d6D38");

var $dfy73 = parcelRequire("dfy73");

var $9LbVe = parcelRequire("9LbVe");
var $67636d627d44e325$var$Map = $dfy73.Map;
var $67636d627d44e325$var$set = $dfy73.set;
// `Map.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var map = $d6D38(this);
        var boundFunction = $b5UsH(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $67636d627d44e325$var$Map();
        $9LbVe(map, function(value, key) {
            if (boundFunction(value, key, map)) $67636d627d44e325$var$set(newMap, key, value);
        });
        return newMap;
    }
});

});

parcelRequire.register("7SSjB", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $b5UsH = parcelRequire("b5UsH");

var $d6D38 = parcelRequire("d6D38");

var $9LbVe = parcelRequire("9LbVe");
// `Map.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var map = $d6D38(this);
        var boundFunction = $b5UsH(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $9LbVe(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                value: value
            };
        }, true);
        return result && result.value;
    }
});

});

parcelRequire.register("ksITo", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $b5UsH = parcelRequire("b5UsH");

var $d6D38 = parcelRequire("d6D38");

var $9LbVe = parcelRequire("9LbVe");
// `Map.prototype.findKey` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    findKey: function findKey(callbackfn /* , thisArg */ ) {
        var map = $d6D38(this);
        var boundFunction = $b5UsH(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $9LbVe(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});

});

parcelRequire.register("1yZwj", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $f518o = parcelRequire("f518o");

var $8GsPx = parcelRequire("8GsPx");

var $cBWnS = parcelRequire("cBWnS");

var $jUk8Y = parcelRequire("jUk8Y");

var $dfy73 = parcelRequire("dfy73");
var $1238b01084c5ae49$var$Map = $dfy73.Map;
var $1238b01084c5ae49$var$has = $dfy73.has;
var $1238b01084c5ae49$var$get = $dfy73.get;
var $1238b01084c5ae49$var$set = $dfy73.set;
var $1238b01084c5ae49$var$push = $f518o([].push);
// `Map.groupBy` method
// https://github.com/tc39/proposal-array-grouping
$ggcsv({
    target: "Map",
    stat: true,
    forced: true
}, {
    groupBy: function groupBy(items, callbackfn) {
        $cBWnS(items);
        $8GsPx(callbackfn);
        var map = new $1238b01084c5ae49$var$Map();
        var k = 0;
        $jUk8Y(items, function(value) {
            var key = callbackfn(value, k++);
            if (!$1238b01084c5ae49$var$has(map, key)) $1238b01084c5ae49$var$set(map, key, [
                value
            ]);
            else $1238b01084c5ae49$var$push($1238b01084c5ae49$var$get(map, key), value);
        });
        return map;
    }
});

});

parcelRequire.register("1Uj81", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $gdUnB = parcelRequire("gdUnB");

var $d6D38 = parcelRequire("d6D38");

var $9LbVe = parcelRequire("9LbVe");
// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    includes: function includes(searchElement) {
        return $9LbVe($d6D38(this), function(value) {
            if ($gdUnB(value, searchElement)) return true;
        }, true) === true;
    }
});

});
parcelRequire.register("gdUnB", function(module, exports) {
// `SameValueZero` abstract operation
// https://tc39.es/ecma262/#sec-samevaluezero
module.exports = function(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y || x != x && y != y;
};

});


parcelRequire.register("2oCpr", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $aELZY = parcelRequire("aELZY");

var $jUk8Y = parcelRequire("jUk8Y");

var $e6Rz5 = parcelRequire("e6Rz5");

var $8GsPx = parcelRequire("8GsPx");

var $dfy73 = parcelRequire("dfy73");
var $1beb9df3c0df5a1c$require$Map = $dfy73.Map;
// `Map.keyBy` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    stat: true,
    forced: true
}, {
    keyBy: function keyBy(iterable, keyDerivative) {
        var C = $e6Rz5(this) ? this : $1beb9df3c0df5a1c$require$Map;
        var newMap = new C();
        $8GsPx(keyDerivative);
        var setter = $8GsPx(newMap.set);
        $jUk8Y(iterable, function(element) {
            $aELZY(setter, newMap, keyDerivative(element), element);
        });
        return newMap;
    }
});

});

parcelRequire.register("aqrAf", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $d6D38 = parcelRequire("d6D38");

var $9LbVe = parcelRequire("9LbVe");
// `Map.prototype.keyOf` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    keyOf: function keyOf(searchElement) {
        var result = $9LbVe($d6D38(this), function(value, key) {
            if (value === searchElement) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});

});

parcelRequire.register("hHR8w", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $b5UsH = parcelRequire("b5UsH");

var $d6D38 = parcelRequire("d6D38");

var $dfy73 = parcelRequire("dfy73");

var $9LbVe = parcelRequire("9LbVe");
var $ce3faba15e5ebd56$var$Map = $dfy73.Map;
var $ce3faba15e5ebd56$var$set = $dfy73.set;
// `Map.prototype.mapKeys` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    mapKeys: function mapKeys(callbackfn /* , thisArg */ ) {
        var map = $d6D38(this);
        var boundFunction = $b5UsH(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $ce3faba15e5ebd56$var$Map();
        $9LbVe(map, function(value, key) {
            $ce3faba15e5ebd56$var$set(newMap, boundFunction(value, key, map), value);
        });
        return newMap;
    }
});

});

parcelRequire.register("aWmWR", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $b5UsH = parcelRequire("b5UsH");

var $d6D38 = parcelRequire("d6D38");

var $dfy73 = parcelRequire("dfy73");

var $9LbVe = parcelRequire("9LbVe");
var $7f711f3969e1ec52$var$Map = $dfy73.Map;
var $7f711f3969e1ec52$var$set = $dfy73.set;
// `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    mapValues: function mapValues(callbackfn /* , thisArg */ ) {
        var map = $d6D38(this);
        var boundFunction = $b5UsH(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $7f711f3969e1ec52$var$Map();
        $9LbVe(map, function(value, key) {
            $7f711f3969e1ec52$var$set(newMap, key, boundFunction(value, key, map));
        });
        return newMap;
    }
});

});

parcelRequire.register("voGy6", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $d6D38 = parcelRequire("d6D38");

var $jUk8Y = parcelRequire("jUk8Y");

var $dfy73 = parcelRequire("dfy73");
var $05e60b58c91463d7$require$set = $dfy73.set;
// `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    arity: 1,
    forced: true
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    merge: function merge(iterable /* ...iterables */ ) {
        var map = $d6D38(this);
        var argumentsLength = arguments.length;
        var i = 0;
        while(i < argumentsLength)$jUk8Y(arguments[i++], function(key, value) {
            $05e60b58c91463d7$require$set(map, key, value);
        }, {
            AS_ENTRIES: true
        });
        return map;
    }
});

});

parcelRequire.register("7QU6C", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $8GsPx = parcelRequire("8GsPx");

var $d6D38 = parcelRequire("d6D38");

var $9LbVe = parcelRequire("9LbVe");
var $5b78e9265362ec72$var$$TypeError = TypeError;
// `Map.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var map = $d6D38(this);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $8GsPx(callbackfn);
        $9LbVe(map, function(value, key) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, key, map);
        });
        if (noInitial) throw $5b78e9265362ec72$var$$TypeError("Reduce of empty map with no initial value");
        return accumulator;
    }
});

});

parcelRequire.register("4E0hS", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $b5UsH = parcelRequire("b5UsH");

var $d6D38 = parcelRequire("d6D38");

var $9LbVe = parcelRequire("9LbVe");
// `Map.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var map = $d6D38(this);
        var boundFunction = $b5UsH(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $9LbVe(map, function(value, key) {
            if (boundFunction(value, key, map)) return true;
        }, true) === true;
    }
});

});

parcelRequire.register("j5hxn", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $8GsPx = parcelRequire("8GsPx");

var $d6D38 = parcelRequire("d6D38");

var $dfy73 = parcelRequire("dfy73");
var $de4c16805620b3db$var$$TypeError = TypeError;
var $de4c16805620b3db$var$get = $dfy73.get;
var $de4c16805620b3db$var$has = $dfy73.has;
var $de4c16805620b3db$var$set = $dfy73.set;
// `Map.prototype.update` method
// https://github.com/tc39/proposal-collection-methods
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    update: function update(key, callback /* , thunk */ ) {
        var map = $d6D38(this);
        var length = arguments.length;
        $8GsPx(callback);
        var isPresentInMap = $de4c16805620b3db$var$has(map, key);
        if (!isPresentInMap && length < 3) throw $de4c16805620b3db$var$$TypeError("Updating absent value");
        var value = isPresentInMap ? $de4c16805620b3db$var$get(map, key) : $8GsPx(length > 2 ? arguments[2] : undefined)(key, map);
        $de4c16805620b3db$var$set(map, key, callback(value, key, map));
        return map;
    }
});

});

parcelRequire.register("jp01D", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $eekUm = parcelRequire("eekUm");
// `Map.prototype.upsert` method (replaced by `Map.prototype.emplace`)
// https://github.com/thumbsupep/proposal-upsert
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    forced: true
}, {
    upsert: $eekUm
});

});
parcelRequire.register("eekUm", function(module, exports) {
"use strict";

var $aELZY = parcelRequire("aELZY");

var $8GsPx = parcelRequire("8GsPx");

var $e6Rz5 = parcelRequire("e6Rz5");

var $l3LMJ = parcelRequire("l3LMJ");
var $a5c297619580f61f$var$$TypeError = TypeError;
// `Map.prototype.upsert` method
// https://github.com/tc39/proposal-upsert
module.exports = function upsert(key, updateFn /* , insertFn */ ) {
    var map = $l3LMJ(this);
    var get = $8GsPx(map.get);
    var has = $8GsPx(map.has);
    var set = $8GsPx(map.set);
    var insertFn = arguments.length > 2 ? arguments[2] : undefined;
    var value;
    if (!$e6Rz5(updateFn) && !$e6Rz5(insertFn)) throw $a5c297619580f61f$var$$TypeError("At least one callback required");
    if ($aELZY(has, map, key)) {
        value = $aELZY(get, map, key);
        if ($e6Rz5(updateFn)) {
            value = updateFn(value);
            $aELZY(set, map, key, value);
        }
    } else if ($e6Rz5(insertFn)) {
        value = insertFn();
        $aELZY(set, map, key, value);
    }
    return value;
};

});


parcelRequire.register("XkoE2", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $eekUm = parcelRequire("eekUm");
// `Map.prototype.updateOrInsert` method (replaced by `Map.prototype.emplace`)
// https://github.com/thumbsupep/proposal-upsert
$ggcsv({
    target: "Map",
    proto: true,
    real: true,
    name: "upsert",
    forced: true
}, {
    updateOrInsert: $eekUm
});

});




parcelRequire.register("dCi2u", function(module, exports) {

var $9mgAl = parcelRequire("9mgAl");
function $9e9cd1273dad0d5d$var$_isNativeFunction(fn) {
    var _context;
    return $9mgAl(_context = Function.toString.call(fn)).call(_context, "[native code]") !== -1;
}
module.exports = $9e9cd1273dad0d5d$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("9mgAl", function(module, exports) {

module.exports = (parcelRequire("9jcai"));

});
parcelRequire.register("9jcai", function(module, exports) {

module.exports = (parcelRequire("kFbbg"));

});
parcelRequire.register("kFbbg", function(module, exports) {

var $khQas = parcelRequire("khQas");
module.exports = $khQas;

});
parcelRequire.register("khQas", function(module, exports) {

var $hCfza = parcelRequire("hCfza");
module.exports = $hCfza;

});
parcelRequire.register("hCfza", function(module, exports) {

var $d7pYj = parcelRequire("d7pYj");
module.exports = $d7pYj;

});
parcelRequire.register("d7pYj", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $19Owo = parcelRequire("19Owo");
var $98d013491640d7ee$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.indexOf;
    return it === $98d013491640d7ee$var$ArrayPrototype || $8hsAO($98d013491640d7ee$var$ArrayPrototype, it) && own === $98d013491640d7ee$var$ArrayPrototype.indexOf ? $19Owo : own;
};

});
parcelRequire.register("19Owo", function(module, exports) {
parcelRequire("Qq8LU");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").indexOf;

});
parcelRequire.register("Qq8LU", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5FNR6 = parcelRequire("5FNR6");

var $3NUiQ = parcelRequire("3NUiQ");
var $09d92265e7517df8$require$$indexOf = $3NUiQ.indexOf;

var $kQPJO = parcelRequire("kQPJO");
var $09d92265e7517df8$var$nativeIndexOf = $5FNR6([].indexOf);
var $09d92265e7517df8$var$NEGATIVE_ZERO = !!$09d92265e7517df8$var$nativeIndexOf && 1 / $09d92265e7517df8$var$nativeIndexOf([
    1
], 1, -0) < 0;
var $09d92265e7517df8$var$FORCED = $09d92265e7517df8$var$NEGATIVE_ZERO || !$kQPJO("indexOf");
// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$ggcsv({
    target: "Array",
    proto: true,
    forced: $09d92265e7517df8$var$FORCED
}, {
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
        return $09d92265e7517df8$var$NEGATIVE_ZERO ? $09d92265e7517df8$var$nativeIndexOf(this, searchElement, fromIndex) || 0 : $09d92265e7517df8$require$$indexOf(this, searchElement, fromIndex);
    }
});

});









parcelRequire.register("5fJCO", function(module, exports) {

var $Rgxrs = parcelRequire("Rgxrs");

var $37K0E = parcelRequire("37K0E");

var $f3Brs = parcelRequire("f3Brs");

var $jhD9m = parcelRequire("jhD9m");
function $3d31bea9b00391f6$var$_construct(Parent, args, Class) {
    if ($jhD9m()) module.exports = $3d31bea9b00391f6$var$_construct = $Rgxrs, module.exports.__esModule = true, module.exports["default"] = module.exports;
    else module.exports = $3d31bea9b00391f6$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = $37K0E(Function).apply(Parent, a);
        var instance = new Constructor();
        if (Class) $f3Brs(instance, Class.prototype);
        return instance;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $3d31bea9b00391f6$var$_construct.apply(null, arguments);
}
module.exports = $3d31bea9b00391f6$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("Rgxrs", function(module, exports) {

module.exports = (parcelRequire("86bVD"));

});
parcelRequire.register("86bVD", function(module, exports) {

module.exports = (parcelRequire("c2fUc"));

});
parcelRequire.register("c2fUc", function(module, exports) {

var $2pKyY = parcelRequire("2pKyY");
module.exports = $2pKyY;

});
parcelRequire.register("2pKyY", function(module, exports) {

var $5xQII = parcelRequire("5xQII");
module.exports = $5xQII;

});




parcelRequire.register("37K0E", function(module, exports) {

module.exports = (parcelRequire("h4TMI"));

});
parcelRequire.register("h4TMI", function(module, exports) {

module.exports = (parcelRequire("6WUgI"));

});
parcelRequire.register("6WUgI", function(module, exports) {

var $cs97r = parcelRequire("cs97r");
module.exports = $cs97r;

});
parcelRequire.register("cs97r", function(module, exports) {

var $gn22P = parcelRequire("gn22P");
module.exports = $gn22P;

});
parcelRequire.register("gn22P", function(module, exports) {

var $dv3bg = parcelRequire("dv3bg");
module.exports = $dv3bg;

});
parcelRequire.register("dv3bg", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $jOysZ = parcelRequire("jOysZ");
var $9d40a340398128f8$var$FunctionPrototype = Function.prototype;
module.exports = function(it) {
    var own = it.bind;
    return it === $9d40a340398128f8$var$FunctionPrototype || $8hsAO($9d40a340398128f8$var$FunctionPrototype, it) && own === $9d40a340398128f8$var$FunctionPrototype.bind ? $jOysZ : own;
};

});
parcelRequire.register("jOysZ", function(module, exports) {
parcelRequire("83xNS");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Function").bind;

});
parcelRequire.register("83xNS", function(module, exports) {
// TODO: Remove from `core-js@4`

var $ggcsv = parcelRequire("ggcsv");

var $jWy7e = parcelRequire("jWy7e");
// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$ggcsv({
    target: "Function",
    proto: true,
    forced: Function.bind !== $jWy7e
}, {
    bind: $jWy7e
});

});








parcelRequire.register("jhD9m", function(module, exports) {

var $Rgxrs = parcelRequire("Rgxrs");
function $e09df93c56f790d6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$Rgxrs) return false;
    if ($Rgxrs.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($Rgxrs(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
module.exports = $e09df93c56f790d6$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRequire.register("fMBjE", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $1X85b = parcelRequire("1X85b");


var $iG2ur = parcelRequire("iG2ur");

var $35NIM = parcelRequire("35NIM");

var $a1TrC = parcelRequire("a1TrC");

var $4wehD = parcelRequire("4wehD");


var $dQJQf = parcelRequire("dQJQf");




var $iDZ3d = parcelRequire("iDZ3d");


var $dLJtR = parcelRequire("dLJtR");

var $fgRng = parcelRequire("fgRng");


var $dzKYE = parcelRequire("dzKYE");

var $i3o6i = parcelRequire("i3o6i");

var $3bLGW = parcelRequire("3bLGW");

(parcelRequire("4i3Tl"))(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02f719f3389c19af$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $02f719f3389c19af$var$_find = $iHLHC((parcelRequire("c61hX")));

var $02f719f3389c19af$var$_defineProperty2 = $iHLHC((parcelRequire("4i3Tl")));

var $02f719f3389c19af$var$_create = $iHLHC((parcelRequire("jQ6K5")));

var $02f719f3389c19af$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $02f719f3389c19af$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $02f719f3389c19af$var$_asyncToGenerator2 = $iHLHC((parcelRequire("kkHAR")));

var $02f719f3389c19af$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $02f719f3389c19af$var$_getPrototypeOf = $iHLHC((parcelRequire("kOp5W")));

var $02f719f3389c19af$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $02f719f3389c19af$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $02f719f3389c19af$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $02f719f3389c19af$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $02f719f3389c19af$var$_freeze = $iHLHC((parcelRequire("hNwyw")));

var $02f719f3389c19af$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $02f719f3389c19af$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $02f719f3389c19af$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $02f719f3389c19af$var$_defineProperty3 = $iHLHC((parcelRequire("4cByw")));

var $02f719f3389c19af$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $02f719f3389c19af$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $02f719f3389c19af$var$_canBeSerialized = $iHLHC((parcelRequire("gloAc")));

var $02f719f3389c19af$var$_decode = $iHLHC((parcelRequire("42E6z")));

var $02f719f3389c19af$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $02f719f3389c19af$var$_escape2 = $iHLHC((parcelRequire("1JxNp")));

var $02f719f3389c19af$var$_EventuallyQueue = $iHLHC((parcelRequire("cJKeG")));

var $02f719f3389c19af$var$_ParseACL = $iHLHC((parcelRequire("2xGBa")));

var $02f719f3389c19af$var$_parseDate = $iHLHC((parcelRequire("ktbIl")));

var $02f719f3389c19af$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $02f719f3389c19af$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $9FsFR = parcelRequire("9FsFR");

var $klpRA = parcelRequire("klpRA");

var $3l0Qd = parcelRequire("3l0Qd");

var $02f719f3389c19af$var$_ParseQuery = $iHLHC((parcelRequire("4FVCr")));

var $02f719f3389c19af$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));

var $02f719f3389c19af$var$SingleInstanceStateController = $02f719f3389c19af$var$_interopRequireWildcard((parcelRequire("8mp0p")));

var $02f719f3389c19af$var$_unique = $iHLHC((parcelRequire("aoRXv")));

var $02f719f3389c19af$var$UniqueInstanceStateController = $02f719f3389c19af$var$_interopRequireWildcard((parcelRequire("eyyNg")));

var $02f719f3389c19af$var$_unsavedChildren = $iHLHC((parcelRequire("zyRRD")));
function $02f719f3389c19af$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof $1X85b !== "function") return null;
    var cacheBabelInterop = new $1X85b();
    var cacheNodeInterop = new $1X85b();
    return ($02f719f3389c19af$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $02f719f3389c19af$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (parcelRequire("6iqUa"))(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $02f719f3389c19af$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = (parcelRequire("4i3Tl")) && $dzKYE ? $dzKYE(obj, key) : null;
        if (desc && (desc.get || desc.set)) (parcelRequire("4i3Tl"))(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $02f719f3389c19af$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $iDZ3d !== "undefined" && $iG2ur(o) || o["@@iterator"];
    if (!it) {
        if ((parcelRequire("euZIZ"))(o) || (it = $02f719f3389c19af$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $02f719f3389c19af$var$_unsupportedIterableToArray(o, minLen) {
    var _context20;
    if (!o) return;
    if (typeof o === "string") return $02f719f3389c19af$var$_arrayLikeToArray(o, minLen);
    var n = $a1TrC(_context20 = Object.prototype.toString.call(o)).call(_context20, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $35NIM(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $02f719f3389c19af$var$_arrayLikeToArray(o, minLen);
}
function $02f719f3389c19af$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $02f719f3389c19af$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $02f719f3389c19af$var$_regeneratorRuntime = function() {
        return exports1;
    };
    var exports1 = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $iDZ3d ? $iDZ3d : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return (parcelRequire("4i3Tl"))(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = (parcelRequire("jQ6K5"))(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports1.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = (parcelRequire("kOp5W")), NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = (parcelRequire("jQ6K5"))(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context18;
        (parcelRequire("gW71a"))(_context18 = [
            "next",
            "throw",
            "return"
        ]).call(_context18, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == (parcelRequire("6iqUa"))(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], (parcelRequire("gW71a"))(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports1.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports1.mark = function(genFun) {
        return $dQJQf ? $dQJQf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = (parcelRequire("jQ6K5"))(Gp), genFun;
    }, exports1.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports1.AsyncIterator = AsyncIterator, exports1.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("iH0WI")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports1.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports1.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $4wehD(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports1.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context19;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, (parcelRequire("gW71a"))(_context19 = this.tryEntries).call(_context19, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$a1TrC(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports1;
}
function $02f719f3389c19af$var$ownKeys(object, enumerableOnly) {
    var keys = (parcelRequire("2QmZN"))(object);
    if ($3bLGW) {
        var symbols = $3bLGW(object);
        enumerableOnly && (symbols = $i3o6i(symbols).call(symbols, function(sym) {
            return $dzKYE(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $02f719f3389c19af$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var _context16, _context17;
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? (parcelRequire("gW71a"))(_context16 = $02f719f3389c19af$var$ownKeys(Object(source), !0)).call(_context16, function(key) {
            (0, $02f719f3389c19af$var$_defineProperty3.default)(target, key, source[key]);
        }) : $fgRng ? $dLJtR(target, $fgRng(source)) : (parcelRequire("gW71a"))(_context17 = $02f719f3389c19af$var$ownKeys(Object(source))).call(_context17, function(key) {
            (parcelRequire("4i3Tl"))(target, key, $dzKYE(source, key));
        });
    }
    return target;
}

var $4q6en = parcelRequire("4q6en");
/*:: export type Pointer = {
  __type: string,
  className: string,
  objectId: string,
};*/ /*:: type SaveParams = {
  method: string,
  path: string,
  body: AttributeMap,
};*/ /*:: export type SaveOptions = FullOptions & {
  cascadeSave?: boolean,
  context?: AttributeMap,
};*/ // Mapping of class names to constructors, so we can populate objects from the
// server with appropriate subclasses of ParseObject
var $02f719f3389c19af$var$classMap = {}; // Global counter for generating unique Ids for non-single-instance objects
var $02f719f3389c19af$var$objectCount = 0; // On web clients, objects are single-instance: any two objects with the same Id
// will have the same attributes. However, this may be dangerous default
// behavior in a server scenario
var $02f719f3389c19af$var$singleInstance = !$02f719f3389c19af$var$_CoreManager.default.get("IS_NODE");
if ($02f719f3389c19af$var$singleInstance) $02f719f3389c19af$var$_CoreManager.default.setObjectStateController($02f719f3389c19af$var$SingleInstanceStateController);
else $02f719f3389c19af$var$_CoreManager.default.setObjectStateController($02f719f3389c19af$var$UniqueInstanceStateController);
function $02f719f3389c19af$var$getServerUrlPath() {
    var serverUrl = $02f719f3389c19af$var$_CoreManager.default.get("SERVER_URL");
    if (serverUrl[serverUrl.length - 1] !== "/") serverUrl += "/";
    var url = serverUrl.replace(/https?:\/\//, "");
    return url.substr((0, $02f719f3389c19af$var$_indexOf.default)(url).call(url, "/"));
}
/**
 * Creates a new model with defined attributes.
 *
 * <p>You won't normally call this method directly.  It is recommended that
 * you use a subclass of <code>Parse.Object</code> instead, created by calling
 * <code>extend</code>.</p>
 *
 * <p>However, if you don't want to use a subclass, or aren't sure which
 * subclass is appropriate, you can use this form:<pre>
 *     var object = new Parse.Object("ClassName");
 * </pre>
 * That is basically equivalent to:<pre>
 *     var MyClass = Parse.Object.extend("ClassName");
 *     var object = new MyClass();
 * </pre></p>
 *
 * @alias Parse.Object
 */ var $02f719f3389c19af$var$ParseObject = /*#__PURE__*/ function() {
    /**
   * @param {string} className The class name for the object
   * @param {object} attributes The initial set of data to store in the object.
   * @param {object} options The options for this object instance.
   */ function ParseObject(className, attributes, options) {
        (0, $02f719f3389c19af$var$_classCallCheck2.default)(this, ParseObject);
        (0, $02f719f3389c19af$var$_defineProperty3.default)(this, "id", void 0);
        (0, $02f719f3389c19af$var$_defineProperty3.default)(this, "_localId", void 0);
        (0, $02f719f3389c19af$var$_defineProperty3.default)(this, "_objCount", void 0);
        (0, $02f719f3389c19af$var$_defineProperty3.default)(this, "className", void 0); // Enable legacy initializers
        if (typeof this.initialize === "function") this.initialize.apply(this, arguments);
        var toSet = null;
        this._objCount = $02f719f3389c19af$var$objectCount++;
        if (typeof className === "string") {
            this.className = className;
            if (attributes && (0, $02f719f3389c19af$var$_typeof2.default)(attributes) === "object") toSet = attributes;
        } else if (className && (0, $02f719f3389c19af$var$_typeof2.default)(className) === "object") {
            this.className = className.className;
            toSet = {};
            for(var _attr in className)if (_attr !== "className") toSet[_attr] = className[_attr];
            if (attributes && (0, $02f719f3389c19af$var$_typeof2.default)(attributes) === "object") options = attributes;
        }
        if (toSet && !this.set(toSet, options)) throw new Error("Can't create an invalid Parse Object");
    }
    /**
   * The ID of this object, unique within its class.
   *
   * @property {string} id
   */ (0, $02f719f3389c19af$var$_createClass2.default)(ParseObject, [
        {
            key: "attributes",
            get: /** Prototype getters / setters **/ function() /*: AttributeMap*/ {
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                return (0, $02f719f3389c19af$var$_freeze.default)(stateController.estimateAttributes(this._getStateIdentifier()));
            }
        },
        {
            key: "createdAt",
            get: function() /*: ?Date*/ {
                return this._getServerData().createdAt;
            }
        },
        {
            key: "updatedAt",
            get: function() /*: ?Date*/ {
                return this._getServerData().updatedAt;
            }
        },
        {
            key: "_getId",
            value: function() /*: string*/ {
                if (typeof this.id === "string") return this.id;
                if (typeof this._localId === "string") return this._localId;
                var localId = "local" + $4q6en();
                this._localId = localId;
                return localId;
            }
        },
        {
            key: "_getStateIdentifier",
            value: function() /*: ParseObject | { id: string, className: string }*/ {
                if ($02f719f3389c19af$var$singleInstance) {
                    var id = this.id;
                    if (!id) id = this._getId();
                    return {
                        id: id,
                        className: this.className
                    };
                } else return this;
            }
        },
        {
            key: "_getServerData",
            value: function() /*: AttributeMap*/ {
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                return stateController.getServerData(this._getStateIdentifier());
            }
        },
        {
            key: "_clearServerData",
            value: function() {
                var serverData = this._getServerData();
                var unset = {};
                for(var _attr2 in serverData)unset[_attr2] = undefined;
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                stateController.setServerData(this._getStateIdentifier(), unset);
            }
        },
        {
            key: "_getPendingOps",
            value: function() /*: Array<OpsMap>*/ {
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                return stateController.getPendingOps(this._getStateIdentifier());
            }
        },
        {
            key: "_clearPendingOps",
            value: function(keysToClear) {
                var pending = this._getPendingOps();
                var latest = pending[pending.length - 1];
                var keys = keysToClear || (0, $02f719f3389c19af$var$_keys.default)(latest);
                (0, $02f719f3389c19af$var$_forEach.default)(keys).call(keys, function(key) {
                    delete latest[key];
                });
            }
        },
        {
            key: "_getDirtyObjectAttributes",
            value: function() /*: AttributeMap*/ {
                var attributes = this.attributes;
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                var objectCache = stateController.getObjectCache(this._getStateIdentifier());
                var dirty = {};
                for(var _attr3 in attributes){
                    var val = attributes[_attr3];
                    if (val && (0, $02f719f3389c19af$var$_typeof2.default)(val) === "object" && !(val instanceof ParseObject) && !(val instanceof $02f719f3389c19af$var$_ParseFile.default) && !(val instanceof $02f719f3389c19af$var$_ParseRelation.default)) // Due to the way browsers construct maps, the key order will not change
                    // unless the object is changed
                    try {
                        var json = (0, $02f719f3389c19af$var$_encode.default)(val, false, true);
                        var stringified = (0, $02f719f3389c19af$var$_stringify.default)(json);
                        if (objectCache[_attr3] !== stringified) dirty[_attr3] = val;
                    } catch (e) {
                        // Error occurred, possibly by a nested unsaved pointer in a mutable container
                        // No matter how it happened, it indicates a change in the attribute
                        dirty[_attr3] = val;
                    }
                }
                return dirty;
            }
        },
        {
            key: "_toFullJSON",
            value: function(seen, offline) /*: AttributeMap*/ {
                var json = this.toJSON(seen, offline);
                json.__type = "Object";
                json.className = this.className;
                return json;
            }
        },
        {
            key: "_getSaveJSON",
            value: function() /*: AttributeMap*/ {
                var pending = this._getPendingOps();
                var dirtyObjects = this._getDirtyObjectAttributes();
                var json = {};
                for(var attr in dirtyObjects){
                    var isDotNotation = false;
                    for(var i = 0; i < pending.length; i += 1){
                        for(var field in pending[i])// Dot notation operations are handled later
                        if ((0, $02f719f3389c19af$var$_includes.default)(field).call(field, ".")) {
                            var fieldName = field.split(".")[0];
                            if (fieldName === attr) {
                                isDotNotation = true;
                                break;
                            }
                        }
                    }
                    if (!isDotNotation) json[attr] = new $3l0Qd.SetOp(dirtyObjects[attr]).toJSON();
                }
                for(attr in pending[0])json[attr] = pending[0][attr].toJSON();
                return json;
            }
        },
        {
            key: "_getSaveParams",
            value: function() /*: SaveParams*/ {
                var method = this.id ? "PUT" : "POST";
                var body = this._getSaveJSON();
                var path = "classes/" + this.className;
                if ($02f719f3389c19af$var$_CoreManager.default.get("ALLOW_CUSTOM_OBJECT_ID")) {
                    if (!this.createdAt) {
                        method = "POST";
                        body.objectId = this.id;
                    } else {
                        method = "PUT";
                        path += "/" + this.id;
                    }
                } else if (this.id) path += "/" + this.id;
                else if (this.className === "_User") path = "users";
                return {
                    method: method,
                    body: body,
                    path: path
                };
            }
        },
        {
            key: "_finishFetch",
            value: function(serverData) {
                if (!this.id && serverData.objectId) this.id = serverData.objectId;
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                stateController.initializeState(this._getStateIdentifier());
                var decoded = {};
                for(var _attr4 in serverData){
                    if (_attr4 === "ACL") decoded[_attr4] = new $02f719f3389c19af$var$_ParseACL.default(serverData[_attr4]);
                    else if (_attr4 !== "objectId") {
                        decoded[_attr4] = (0, $02f719f3389c19af$var$_decode.default)(serverData[_attr4]);
                        if (decoded[_attr4] instanceof $02f719f3389c19af$var$_ParseRelation.default) decoded[_attr4]._ensureParentAndKey(this, _attr4);
                    }
                }
                if (decoded.createdAt && typeof decoded.createdAt === "string") decoded.createdAt = (0, $02f719f3389c19af$var$_parseDate.default)(decoded.createdAt);
                if (decoded.updatedAt && typeof decoded.updatedAt === "string") decoded.updatedAt = (0, $02f719f3389c19af$var$_parseDate.default)(decoded.updatedAt);
                if (!decoded.updatedAt && decoded.createdAt) decoded.updatedAt = decoded.createdAt;
                stateController.commitServerChanges(this._getStateIdentifier(), decoded);
            }
        },
        {
            key: "_setExisted",
            value: function(existed) {
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                var state = stateController.getState(this._getStateIdentifier());
                if (state) state.existed = existed;
            }
        },
        {
            key: "_migrateId",
            value: function(serverId) {
                if (this._localId && serverId) {
                    if ($02f719f3389c19af$var$singleInstance) {
                        var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                        var oldState = stateController.removeState(this._getStateIdentifier());
                        this.id = serverId;
                        delete this._localId;
                        if (oldState) stateController.initializeState(this._getStateIdentifier(), oldState);
                    } else {
                        this.id = serverId;
                        delete this._localId;
                    }
                }
            }
        },
        {
            key: "_handleSaveResponse",
            value: function(response, status) {
                var changes = {};
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                var pending = stateController.popPendingState(this._getStateIdentifier());
                for(var attr in pending){
                    if (pending[attr] instanceof $3l0Qd.RelationOp) changes[attr] = pending[attr].applyTo(undefined, this, attr);
                    else if (!(attr in response)) // Only SetOps and UnsetOps should not come back with results
                    changes[attr] = pending[attr].applyTo(undefined);
                }
                for(attr in response){
                    if ((attr === "createdAt" || attr === "updatedAt") && typeof response[attr] === "string") changes[attr] = (0, $02f719f3389c19af$var$_parseDate.default)(response[attr]);
                    else if (attr === "ACL") changes[attr] = new $02f719f3389c19af$var$_ParseACL.default(response[attr]);
                    else if (attr !== "objectId") {
                        var val = (0, $02f719f3389c19af$var$_decode.default)(response[attr]);
                        if (val && (0, $02f719f3389c19af$var$_getPrototypeOf.default)(val) === Object.prototype) changes[attr] = $02f719f3389c19af$var$_objectSpread($02f719f3389c19af$var$_objectSpread({}, this.attributes[attr]), val);
                        else changes[attr] = val;
                        if (changes[attr] instanceof $3l0Qd.UnsetOp) changes[attr] = undefined;
                    }
                }
                if (changes.createdAt && !changes.updatedAt) changes.updatedAt = changes.createdAt;
                this._migrateId(response.objectId);
                if (status !== 201) this._setExisted(true);
                stateController.commitServerChanges(this._getStateIdentifier(), changes);
            }
        },
        {
            key: "_handleSaveError",
            value: function() {
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                stateController.mergeFirstPendingState(this._getStateIdentifier());
            }
        },
        {
            key: "initialize",
            value: /** Public methods **/ function() {}
        },
        {
            key: "toJSON",
            value: function(seen, offline) /*: AttributeMap*/ {
                var seenEntry = this.id ? this.className + ":" + this.id : this;
                seen = seen || [
                    seenEntry
                ];
                var json = {};
                var attrs = this.attributes;
                for(var _attr5 in attrs)if ((_attr5 === "createdAt" || _attr5 === "updatedAt") && attrs[_attr5].toJSON) json[_attr5] = attrs[_attr5].toJSON();
                else json[_attr5] = (0, $02f719f3389c19af$var$_encode.default)(attrs[_attr5], false, false, seen, offline);
                var pending = this._getPendingOps();
                for(var _attr6 in pending[0])json[_attr6] = pending[0][_attr6].toJSON(offline);
                if (this.id) json.objectId = this.id;
                return json;
            }
        },
        {
            key: "equals",
            value: function(other) /*: boolean*/ {
                if (this === other) return true;
                return other instanceof ParseObject && this.className === other.className && this.id === other.id && typeof this.id !== "undefined";
            }
        },
        {
            key: "dirty",
            value: function(attr) /*: boolean*/ {
                if (!this.id) return true;
                var pendingOps = this._getPendingOps();
                var dirtyObjects = this._getDirtyObjectAttributes();
                if (attr) {
                    if (dirtyObjects.hasOwnProperty(attr)) return true;
                    for(var i = 0; i < pendingOps.length; i++){
                        if (pendingOps[i].hasOwnProperty(attr)) return true;
                    }
                    return false;
                }
                if ((0, $02f719f3389c19af$var$_keys.default)(pendingOps[0]).length !== 0) return true;
                if ((0, $02f719f3389c19af$var$_keys.default)(dirtyObjects).length !== 0) return true;
                return false;
            }
        },
        {
            key: "dirtyKeys",
            value: function() /*: Array<string>*/ {
                var pendingOps = this._getPendingOps();
                var keys = {};
                for(var i = 0; i < pendingOps.length; i++)for(var _attr7 in pendingOps[i])keys[_attr7] = true;
                var dirtyObjects = this._getDirtyObjectAttributes();
                for(var _attr8 in dirtyObjects)keys[_attr8] = true;
                return (0, $02f719f3389c19af$var$_keys.default)(keys);
            }
        },
        {
            key: "isDataAvailable",
            value: function() /*: boolean*/ {
                var serverData = this._getServerData();
                return !!(0, $02f719f3389c19af$var$_keys.default)(serverData).length;
            }
        },
        {
            key: "toPointer",
            value: function() /*: Pointer*/ {
                if (!this.id) throw new Error("Cannot create a pointer to an unsaved ParseObject");
                return {
                    __type: "Pointer",
                    className: this.className,
                    objectId: this.id
                };
            }
        },
        {
            key: "toOfflinePointer",
            value: function() /*: Pointer*/ {
                if (!this._localId) throw new Error("Cannot create a offline pointer to a saved ParseObject");
                return {
                    __type: "Object",
                    className: this.className,
                    _localId: this._localId
                };
            }
        },
        {
            key: "get",
            value: function(attr) /*: mixed*/ {
                return this.attributes[attr];
            }
        },
        {
            key: "relation",
            value: function(attr) /*: ParseRelation*/ {
                var value = this.get(attr);
                if (value) {
                    if (!(value instanceof $02f719f3389c19af$var$_ParseRelation.default)) throw new Error("Called relation() on non-relation field " + attr);
                    value._ensureParentAndKey(this, attr);
                    return value;
                }
                return new $02f719f3389c19af$var$_ParseRelation.default(this, attr);
            }
        },
        {
            key: "escape",
            value: function(attr) /*: string*/ {
                var val = this.attributes[attr];
                if (val == null) return "";
                if (typeof val !== "string") {
                    if (typeof val.toString !== "function") return "";
                    val = val.toString();
                }
                return (0, $02f719f3389c19af$var$_escape2.default)(val);
            }
        },
        {
            key: "has",
            value: function(attr) /*: boolean*/ {
                var attributes = this.attributes;
                if (attributes.hasOwnProperty(attr)) return attributes[attr] != null;
                return false;
            }
        },
        {
            key: "set",
            value: function(key, value, options) /*: ParseObject | boolean*/ {
                var changes = {};
                var newOps = {};
                if (key && (0, $02f719f3389c19af$var$_typeof2.default)(key) === "object") {
                    changes = key;
                    options = value;
                } else if (typeof key === "string") changes[key] = value;
                else return this;
                options = options || {};
                var readonly = [];
                if (typeof this.constructor.readOnlyAttributes === "function") readonly = (0, $02f719f3389c19af$var$_concat.default)(readonly).call(readonly, this.constructor.readOnlyAttributes());
                for(var k in changes){
                    if (k === "createdAt" || k === "updatedAt") continue;
                    if ((0, $02f719f3389c19af$var$_indexOf.default)(readonly).call(readonly, k) > -1) throw new Error("Cannot modify readonly attribute: " + k);
                    if (options.unset) newOps[k] = new $3l0Qd.UnsetOp();
                    else if (changes[k] instanceof $3l0Qd.Op) newOps[k] = changes[k];
                    else if (changes[k] && (0, $02f719f3389c19af$var$_typeof2.default)(changes[k]) === "object" && typeof changes[k].__op === "string") newOps[k] = (0, $3l0Qd.opFromJSON)(changes[k]);
                    else if (k === "objectId" || k === "id") {
                        if (typeof changes[k] === "string") this.id = changes[k];
                    } else if (k === "ACL" && (0, $02f719f3389c19af$var$_typeof2.default)(changes[k]) === "object" && !(changes[k] instanceof $02f719f3389c19af$var$_ParseACL.default)) newOps[k] = new $3l0Qd.SetOp(new $02f719f3389c19af$var$_ParseACL.default(changes[k]));
                    else if (changes[k] instanceof $02f719f3389c19af$var$_ParseRelation.default) {
                        var relation = new $02f719f3389c19af$var$_ParseRelation.default(this, k);
                        relation.targetClassName = changes[k].targetClassName;
                        newOps[k] = new $3l0Qd.SetOp(relation);
                    } else newOps[k] = new $3l0Qd.SetOp(changes[k]);
                }
                var currentAttributes = this.attributes; // Calculate new values
                var newValues = {};
                for(var _attr9 in newOps){
                    if (newOps[_attr9] instanceof $3l0Qd.RelationOp) newValues[_attr9] = newOps[_attr9].applyTo(currentAttributes[_attr9], this, _attr9);
                    else if (!(newOps[_attr9] instanceof $3l0Qd.UnsetOp)) newValues[_attr9] = newOps[_attr9].applyTo(currentAttributes[_attr9]);
                } // Validate changes
                if (!options.ignoreValidation) {
                    var validation = this.validate(newValues);
                    if (validation) {
                        if (typeof options.error === "function") options.error(this, validation);
                        return false;
                    }
                } // Consolidate Ops
                var pendingOps = this._getPendingOps();
                var last = pendingOps.length - 1;
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                for(var _attr10 in newOps){
                    var nextOp = newOps[_attr10].mergeWith(pendingOps[last][_attr10]);
                    stateController.setPendingOp(this._getStateIdentifier(), _attr10, nextOp);
                }
                return this;
            }
        },
        {
            key: "unset",
            value: function(attr, options) /*: ParseObject | boolean*/ {
                options = options || {};
                options.unset = true;
                return this.set(attr, null, options);
            }
        },
        {
            key: "increment",
            value: function(attr, amount) /*: ParseObject | boolean*/ {
                if (typeof amount === "undefined") amount = 1;
                if (typeof amount !== "number") throw new Error("Cannot increment by a non-numeric amount.");
                return this.set(attr, new $3l0Qd.IncrementOp(amount));
            }
        },
        {
            key: "decrement",
            value: function(attr, amount) /*: ParseObject | boolean*/ {
                if (typeof amount === "undefined") amount = 1;
                if (typeof amount !== "number") throw new Error("Cannot decrement by a non-numeric amount.");
                return this.set(attr, new $3l0Qd.IncrementOp(amount * -1));
            }
        },
        {
            key: "add",
            value: function(attr, item) /*: ParseObject | boolean*/ {
                return this.set(attr, new $3l0Qd.AddOp([
                    item
                ]));
            }
        },
        {
            key: "addAll",
            value: function(attr, items) /*: ParseObject | boolean*/ {
                return this.set(attr, new $3l0Qd.AddOp(items));
            }
        },
        {
            key: "addUnique",
            value: function(attr, item) /*: ParseObject | boolean*/ {
                return this.set(attr, new $3l0Qd.AddUniqueOp([
                    item
                ]));
            }
        },
        {
            key: "addAllUnique",
            value: function(attr, items) /*: ParseObject | boolean*/ {
                return this.set(attr, new $3l0Qd.AddUniqueOp(items));
            }
        },
        {
            key: "remove",
            value: function(attr, item) /*: ParseObject | boolean*/ {
                return this.set(attr, new $3l0Qd.RemoveOp([
                    item
                ]));
            }
        },
        {
            key: "removeAll",
            value: function(attr, items) /*: ParseObject | boolean*/ {
                return this.set(attr, new $3l0Qd.RemoveOp(items));
            }
        },
        {
            key: "op",
            value: function(attr) /*: ?Op*/ {
                var pending = this._getPendingOps();
                for(var i = pending.length; i--;){
                    if (pending[i][attr]) return pending[i][attr];
                }
            }
        },
        {
            key: "clone",
            value: function clone() /*: any*/ {
                var clone = new this.constructor(this.className);
                var attributes = this.attributes;
                if (typeof this.constructor.readOnlyAttributes === "function") {
                    var readonly = this.constructor.readOnlyAttributes() || []; // Attributes are frozen, so we have to rebuild an object,
                    // rather than delete readonly keys
                    var copy = {};
                    for(var a in attributes)if ((0, $02f719f3389c19af$var$_indexOf.default)(readonly).call(readonly, a) < 0) copy[a] = attributes[a];
                    attributes = copy;
                }
                if (clone.set) clone.set(attributes);
                return clone;
            }
        },
        {
            key: "newInstance",
            value: function() /*: any*/ {
                var clone = new this.constructor(this.className);
                clone.id = this.id;
                if ($02f719f3389c19af$var$singleInstance) // Just return an object with the right id
                return clone;
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                if (stateController) stateController.duplicateState(this._getStateIdentifier(), clone._getStateIdentifier());
                return clone;
            }
        },
        {
            key: "isNew",
            value: function() /*: boolean*/ {
                return !this.id;
            }
        },
        {
            key: "existed",
            value: function() /*: boolean*/ {
                if (!this.id) return false;
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                var state = stateController.getState(this._getStateIdentifier());
                if (state) return state.existed;
                return false;
            }
        },
        {
            key: "exists",
            value: function() {
                var _exists = (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee(options) {
                    var query;
                    return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (this.id) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 2:
                                _context.prev = 2;
                                query = new $02f719f3389c19af$var$_ParseQuery.default(this.className);
                                _context.next = 6;
                                return query.get(this.id, options);
                            case 6:
                                return _context.abrupt("return", true);
                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0.code === $02f719f3389c19af$var$_ParseError.default.OBJECT_NOT_FOUND)) {
                                    _context.next = 13;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 13:
                                throw _context.t0;
                            case 14:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            9
                        ]
                    ]);
                }));
                function exists(_x) {
                    return _exists.apply(this, arguments);
                }
                return exists;
            }()
        },
        {
            key: "isValid",
            value: function isValid() /*: boolean*/ {
                return !this.validate(this.attributes);
            }
        },
        {
            key: "validate",
            value: function validate(attrs) /*: ParseError | boolean*/ {
                if (attrs.hasOwnProperty("ACL") && !(attrs.ACL instanceof $02f719f3389c19af$var$_ParseACL.default)) return new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.OTHER_CAUSE, "ACL must be a Parse ACL.");
                for(var _key in attrs){
                    if (!/^[A-Za-z][0-9A-Za-z_.]*$/.test(_key)) return new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.INVALID_KEY_NAME);
                }
                return false;
            }
        },
        {
            key: "getACL",
            value: function getACL() /*: ?ParseACL*/ {
                var acl = this.get("ACL");
                if (acl instanceof $02f719f3389c19af$var$_ParseACL.default) return acl;
                return null;
            }
        },
        {
            key: "setACL",
            value: function setACL(acl, options) /*: ParseObject | boolean*/ {
                return this.set("ACL", acl, options);
            }
        },
        {
            key: "revert",
            value: function revert() /*: void*/ {
                var keysToRevert;
                for(var _len = arguments.length, keys = new Array(_len), _key2 = 0; _key2 < _len; _key2++)keys[_key2] = arguments[_key2];
                if (keys.length) {
                    keysToRevert = [];
                    var _iterator = $02f719f3389c19af$var$_createForOfIteratorHelper(keys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var _key3 = _step.value;
                            if (typeof _key3 === "string") keysToRevert.push(_key3);
                            else throw new Error("Parse.Object#revert expects either no, or a list of string, arguments.");
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this._clearPendingOps(keysToRevert);
            }
        },
        {
            key: "clear",
            value: function clear() /*: ParseObject | boolean*/ {
                var attributes = this.attributes;
                var erasable = {};
                var readonly = [
                    "createdAt",
                    "updatedAt"
                ];
                if (typeof this.constructor.readOnlyAttributes === "function") readonly = (0, $02f719f3389c19af$var$_concat.default)(readonly).call(readonly, this.constructor.readOnlyAttributes());
                for(var _attr11 in attributes)if ((0, $02f719f3389c19af$var$_indexOf.default)(readonly).call(readonly, _attr11) < 0) erasable[_attr11] = true;
                return this.set(erasable, {
                    unset: true
                });
            }
        },
        {
            key: "fetch",
            value: function fetch(options) /*: Promise*/ {
                options = options || {};
                var fetchOptions = {};
                if (options.hasOwnProperty("useMasterKey")) fetchOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) fetchOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("context") && (0, $02f719f3389c19af$var$_typeof2.default)(options.context) === "object") fetchOptions.context = options.context;
                if (options.hasOwnProperty("include")) {
                    fetchOptions.include = [];
                    if ((0, $02f719f3389c19af$var$_isArray.default)(options.include)) {
                        var _context2;
                        (0, $02f719f3389c19af$var$_forEach.default)(_context2 = options.include).call(_context2, function(key) {
                            if ((0, $02f719f3389c19af$var$_isArray.default)(key)) {
                                var _context3;
                                fetchOptions.include = (0, $02f719f3389c19af$var$_concat.default)(_context3 = fetchOptions.include).call(_context3, key);
                            } else fetchOptions.include.push(key);
                        });
                    } else fetchOptions.include.push(options.include);
                }
                var controller = $02f719f3389c19af$var$_CoreManager.default.getObjectController();
                return controller.fetch(this, true, fetchOptions);
            }
        },
        {
            key: "fetchWithInclude",
            value: function fetchWithInclude(keys, options) /*: Promise*/ {
                options = options || {};
                options.include = keys;
                return this.fetch(options);
            }
        },
        {
            key: "saveEventually",
            value: function() {
                var _saveEventually = (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee2(options) {
                    return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee2$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.prev = 0;
                                _context4.next = 3;
                                return this.save(null, options);
                            case 3:
                                _context4.next = 11;
                                break;
                            case 5:
                                _context4.prev = 5;
                                _context4.t0 = _context4["catch"](0);
                                if (!(_context4.t0.message === 'XMLHttpRequest failed: "Unable to connect to the Parse API"')) {
                                    _context4.next = 11;
                                    break;
                                }
                                _context4.next = 10;
                                return $02f719f3389c19af$var$_EventuallyQueue.default.save(this, options);
                            case 10:
                                $02f719f3389c19af$var$_EventuallyQueue.default.poll();
                            case 11:
                                return _context4.abrupt("return", this);
                            case 12:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee2, this, [
                        [
                            0,
                            5
                        ]
                    ]);
                }));
                function saveEventually(_x2) {
                    return _saveEventually.apply(this, arguments);
                }
                return saveEventually;
            }()
        },
        {
            key: "save",
            value: function save(arg1, arg2, arg3) /*: Promise*/ {
                var _this = this;
                var attrs;
                var options;
                if ((0, $02f719f3389c19af$var$_typeof2.default)(arg1) === "object" || typeof arg1 === "undefined") {
                    attrs = arg1;
                    if ((0, $02f719f3389c19af$var$_typeof2.default)(arg2) === "object") options = arg2;
                } else {
                    attrs = {};
                    attrs[arg1] = arg2;
                    options = arg3;
                }
                if (attrs) {
                    var validation = this.validate(attrs);
                    if (validation) return $02f719f3389c19af$var$_promise.default.reject(validation);
                    this.set(attrs, options);
                }
                options = options || {};
                var saveOptions = {};
                if (options.hasOwnProperty("useMasterKey")) saveOptions.useMasterKey = !!options.useMasterKey;
                if (options.hasOwnProperty("sessionToken") && typeof options.sessionToken === "string") saveOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("installationId") && typeof options.installationId === "string") saveOptions.installationId = options.installationId;
                if (options.hasOwnProperty("context") && (0, $02f719f3389c19af$var$_typeof2.default)(options.context) === "object") saveOptions.context = options.context;
                var controller = $02f719f3389c19af$var$_CoreManager.default.getObjectController();
                var unsaved = options.cascadeSave !== false ? (0, $02f719f3389c19af$var$_unsavedChildren.default)(this) : null;
                return controller.save(unsaved, saveOptions).then(function() {
                    return controller.save(_this, saveOptions);
                });
            }
        },
        {
            key: "destroyEventually",
            value: function() {
                var _destroyEventually = (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee3(options) {
                    return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee3$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _context5.prev = 0;
                                _context5.next = 3;
                                return this.destroy(options);
                            case 3:
                                _context5.next = 11;
                                break;
                            case 5:
                                _context5.prev = 5;
                                _context5.t0 = _context5["catch"](0);
                                if (!(_context5.t0.message === 'XMLHttpRequest failed: "Unable to connect to the Parse API"')) {
                                    _context5.next = 11;
                                    break;
                                }
                                _context5.next = 10;
                                return $02f719f3389c19af$var$_EventuallyQueue.default.destroy(this, options);
                            case 10:
                                $02f719f3389c19af$var$_EventuallyQueue.default.poll();
                            case 11:
                                return _context5.abrupt("return", this);
                            case 12:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee3, this, [
                        [
                            0,
                            5
                        ]
                    ]);
                }));
                function destroyEventually(_x3) {
                    return _destroyEventually.apply(this, arguments);
                }
                return destroyEventually;
            }()
        },
        {
            key: "destroy",
            value: function destroy(options) /*: Promise*/ {
                options = options || {};
                var destroyOptions = {};
                if (options.hasOwnProperty("useMasterKey")) destroyOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) destroyOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("context") && (0, $02f719f3389c19af$var$_typeof2.default)(options.context) === "object") destroyOptions.context = options.context;
                if (!this.id) return $02f719f3389c19af$var$_promise.default.resolve();
                return $02f719f3389c19af$var$_CoreManager.default.getObjectController().destroy(this, destroyOptions);
            }
        },
        {
            key: "pin",
            value: function pin() /*: Promise<void>*/ {
                return ParseObject.pinAllWithName($klpRA.DEFAULT_PIN, [
                    this
                ]);
            }
        },
        {
            key: "unPin",
            value: function unPin() /*: Promise<void>*/ {
                return ParseObject.unPinAllWithName($klpRA.DEFAULT_PIN, [
                    this
                ]);
            }
        },
        {
            key: "isPinned",
            value: function() {
                var _isPinned = (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee4() {
                    var localDatastore, objectKey, pin;
                    return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee4$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
                                if (localDatastore.isEnabled) {
                                    _context6.next = 3;
                                    break;
                                }
                                return _context6.abrupt("return", $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first"));
                            case 3:
                                objectKey = localDatastore.getKeyForObject(this);
                                _context6.next = 6;
                                return localDatastore.fromPinWithName(objectKey);
                            case 6:
                                pin = _context6.sent;
                                return _context6.abrupt("return", pin.length > 0);
                            case 8:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee4, this);
                }));
                function isPinned() {
                    return _isPinned.apply(this, arguments);
                }
                return isPinned;
            }()
        },
        {
            key: "pinWithName",
            value: function pinWithName(name) /*: Promise<void>*/ {
                return ParseObject.pinAllWithName(name, [
                    this
                ]);
            }
        },
        {
            key: "unPinWithName",
            value: function unPinWithName(name) /*: Promise<void>*/ {
                return ParseObject.unPinAllWithName(name, [
                    this
                ]);
            }
        },
        {
            key: "fetchFromLocalDatastore",
            value: function() {
                var _fetchFromLocalDatastore = (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee5() {
                    var localDatastore, objectKey, pinned, result;
                    return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee5$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
                                if (localDatastore.isEnabled) {
                                    _context7.next = 3;
                                    break;
                                }
                                throw new Error("Parse.enableLocalDatastore() must be called first");
                            case 3:
                                objectKey = localDatastore.getKeyForObject(this);
                                _context7.next = 6;
                                return localDatastore._serializeObject(objectKey);
                            case 6:
                                pinned = _context7.sent;
                                if (pinned) {
                                    _context7.next = 9;
                                    break;
                                }
                                throw new Error("Cannot fetch an unsaved ParseObject");
                            case 9:
                                result = ParseObject.fromJSON(pinned);
                                this._finishFetch(result.toJSON());
                                return _context7.abrupt("return", this);
                            case 12:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchFromLocalDatastore() {
                    return _fetchFromLocalDatastore.apply(this, arguments);
                }
                return fetchFromLocalDatastore;
            }()
        }
    ], [
        {
            key: "_getClassMap",
            value: function _getClassMap() {
                return $02f719f3389c19af$var$classMap;
            }
        },
        {
            key: "_clearAllState",
            value: function _clearAllState() {
                var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
                stateController.clearAllState();
            }
        },
        {
            key: "fetchAll",
            value: function fetchAll(list) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var queryOptions = {};
                if (options.hasOwnProperty("useMasterKey")) queryOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) queryOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("include")) queryOptions.include = ParseObject.handleIncludeOptions(options);
                return $02f719f3389c19af$var$_CoreManager.default.getObjectController().fetch(list, true, queryOptions);
            }
        },
        {
            key: "fetchAllWithInclude",
            value: function fetchAllWithInclude(list, keys, options) {
                options = options || {};
                options.include = keys;
                return ParseObject.fetchAll(list, options);
            }
        },
        {
            key: "fetchAllIfNeededWithInclude",
            value: function fetchAllIfNeededWithInclude(list, keys, options) {
                options = options || {};
                options.include = keys;
                return ParseObject.fetchAllIfNeeded(list, options);
            }
        },
        {
            key: "fetchAllIfNeeded",
            value: function fetchAllIfNeeded(list, options) {
                options = options || {};
                var queryOptions = {};
                if (options.hasOwnProperty("useMasterKey")) queryOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) queryOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("include")) queryOptions.include = ParseObject.handleIncludeOptions(options);
                return $02f719f3389c19af$var$_CoreManager.default.getObjectController().fetch(list, false, queryOptions);
            }
        },
        {
            key: "handleIncludeOptions",
            value: function handleIncludeOptions(options) {
                var include = [];
                if ((0, $02f719f3389c19af$var$_isArray.default)(options.include)) {
                    var _context8;
                    (0, $02f719f3389c19af$var$_forEach.default)(_context8 = options.include).call(_context8, function(key) {
                        if ((0, $02f719f3389c19af$var$_isArray.default)(key)) include = (0, $02f719f3389c19af$var$_concat.default)(include).call(include, key);
                        else include.push(key);
                    });
                } else include.push(options.include);
                return include;
            }
        },
        {
            key: "destroyAll",
            value: function destroyAll(list) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var destroyOptions = {};
                if (options.hasOwnProperty("useMasterKey")) destroyOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) destroyOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("batchSize") && typeof options.batchSize === "number") destroyOptions.batchSize = options.batchSize;
                if (options.hasOwnProperty("context") && (0, $02f719f3389c19af$var$_typeof2.default)(options.context) === "object") destroyOptions.context = options.context;
                return $02f719f3389c19af$var$_CoreManager.default.getObjectController().destroy(list, destroyOptions);
            }
        },
        {
            key: "saveAll",
            value: function saveAll(list) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var saveOptions = {};
                if (options.hasOwnProperty("useMasterKey")) saveOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) saveOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("batchSize") && typeof options.batchSize === "number") saveOptions.batchSize = options.batchSize;
                if (options.hasOwnProperty("context") && (0, $02f719f3389c19af$var$_typeof2.default)(options.context) === "object") saveOptions.context = options.context;
                return $02f719f3389c19af$var$_CoreManager.default.getObjectController().save(list, saveOptions);
            }
        },
        {
            key: "createWithoutData",
            value: function createWithoutData(id) {
                var obj = new this();
                obj.id = id;
                return obj;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json, override, dirty) {
                if (!json.className) throw new Error("Cannot create an object without a className");
                var constructor = $02f719f3389c19af$var$classMap[json.className];
                var o = constructor ? new constructor(json.className) : new ParseObject(json.className);
                var otherAttributes = {};
                for(var _attr12 in json)if (_attr12 !== "className" && _attr12 !== "__type") {
                    otherAttributes[_attr12] = json[_attr12];
                    if (dirty) o.set(_attr12, json[_attr12]);
                }
                if (override) {
                    // id needs to be set before clearServerData can work
                    if (otherAttributes.objectId) o.id = otherAttributes.objectId;
                    var preserved = null;
                    if (typeof o._preserveFieldsOnFetch === "function") preserved = o._preserveFieldsOnFetch();
                    o._clearServerData();
                    if (preserved) o._finishFetch(preserved);
                }
                o._finishFetch(otherAttributes);
                if (json.objectId) o._setExisted(true);
                return o;
            }
        },
        {
            key: "registerSubclass",
            value: function registerSubclass(className, constructor) {
                if (typeof className !== "string") throw new TypeError("The first argument must be a valid class name.");
                if (typeof constructor === "undefined") throw new TypeError("You must supply a subclass constructor.");
                if (typeof constructor !== "function") throw new TypeError("You must register the subclass constructor. Did you attempt to register an instance of the subclass?");
                $02f719f3389c19af$var$classMap[className] = constructor;
                if (!constructor.className) constructor.className = className;
            }
        },
        {
            key: "unregisterSubclass",
            value: function unregisterSubclass(className) {
                if (typeof className !== "string") throw new TypeError("The first argument must be a valid class name.");
                delete $02f719f3389c19af$var$classMap[className];
            }
        },
        {
            key: "extend",
            value: function extend(className, protoProps, classProps) {
                if (typeof className !== "string") {
                    if (className && typeof className.className === "string") return ParseObject.extend(className.className, className, protoProps);
                    else throw new Error("Parse.Object.extend's first argument should be the className.");
                }
                var adjustedClassName = className;
                if (adjustedClassName === "User" && $02f719f3389c19af$var$_CoreManager.default.get("PERFORM_USER_REWRITE")) adjustedClassName = "_User";
                var parentProto = ParseObject.prototype;
                if (this.hasOwnProperty("__super__") && this.__super__) parentProto = this.prototype;
                else if ($02f719f3389c19af$var$classMap[adjustedClassName]) parentProto = $02f719f3389c19af$var$classMap[adjustedClassName].prototype;
                var ParseObjectSubclass = function ParseObjectSubclass(attributes, options) {
                    this.className = adjustedClassName;
                    this._objCount = $02f719f3389c19af$var$objectCount++; // Enable legacy initializers
                    if (typeof this.initialize === "function") this.initialize.apply(this, arguments);
                    if (attributes && (0, $02f719f3389c19af$var$_typeof2.default)(attributes) === "object") {
                        if (!this.set(attributes || {}, options)) throw new Error("Can't create an invalid Parse Object");
                    }
                };
                ParseObjectSubclass.className = adjustedClassName;
                ParseObjectSubclass.__super__ = parentProto;
                ParseObjectSubclass.prototype = (0, $02f719f3389c19af$var$_create.default)(parentProto, {
                    constructor: {
                        value: ParseObjectSubclass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (protoProps) {
                    for(var prop in protoProps)if (prop !== "className") (0, $02f719f3389c19af$var$_defineProperty2.default)(ParseObjectSubclass.prototype, prop, {
                        value: protoProps[prop],
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                }
                if (classProps) {
                    for(var _prop in classProps)if (_prop !== "className") (0, $02f719f3389c19af$var$_defineProperty2.default)(ParseObjectSubclass, _prop, {
                        value: classProps[_prop],
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                }
                ParseObjectSubclass.extend = function(name, protoProps, classProps) {
                    if (typeof name === "string") return ParseObject.extend.call(ParseObjectSubclass, name, protoProps, classProps);
                    return ParseObject.extend.call(ParseObjectSubclass, adjustedClassName, name, protoProps);
                };
                ParseObjectSubclass.createWithoutData = ParseObject.createWithoutData;
                $02f719f3389c19af$var$classMap[adjustedClassName] = ParseObjectSubclass;
                return ParseObjectSubclass;
            }
        },
        {
            key: "enableSingleInstance",
            value: function enableSingleInstance() {
                $02f719f3389c19af$var$singleInstance = true;
                $02f719f3389c19af$var$_CoreManager.default.setObjectStateController($02f719f3389c19af$var$SingleInstanceStateController);
            }
        },
        {
            key: "disableSingleInstance",
            value: function disableSingleInstance() {
                $02f719f3389c19af$var$singleInstance = false;
                $02f719f3389c19af$var$_CoreManager.default.setObjectStateController($02f719f3389c19af$var$UniqueInstanceStateController);
            }
        },
        {
            key: "pinAll",
            value: function pinAll(objects) /*: Promise<void>*/ {
                var localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return ParseObject.pinAllWithName($klpRA.DEFAULT_PIN, objects);
            }
        },
        {
            key: "pinAllWithName",
            value: function pinAllWithName(name, objects) /*: Promise<void>*/ {
                var localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return localDatastore._handlePinAllWithName(name, objects);
            }
        },
        {
            key: "unPinAll",
            value: function unPinAll(objects) /*: Promise<void>*/ {
                var localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return ParseObject.unPinAllWithName($klpRA.DEFAULT_PIN, objects);
            }
        },
        {
            key: "unPinAllWithName",
            value: function unPinAllWithName(name, objects) /*: Promise<void>*/ {
                var localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return localDatastore._handleUnPinAllWithName(name, objects);
            }
        },
        {
            key: "unPinAllObjects",
            value: function unPinAllObjects() /*: Promise<void>*/ {
                var localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return localDatastore.unPinWithName($klpRA.DEFAULT_PIN);
            }
        },
        {
            key: "unPinAllObjectsWithName",
            value: function unPinAllObjectsWithName(name) /*: Promise<void>*/ {
                var localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
                if (!localDatastore.isEnabled) return $02f719f3389c19af$var$_promise.default.reject("Parse.enableLocalDatastore() must be called first");
                return localDatastore.unPinWithName($klpRA.PIN_PREFIX + name);
            }
        }
    ]);
    return ParseObject;
}();
var $02f719f3389c19af$var$DefaultController = {
    fetch: function fetch(target, forceFetch, options) /*: Promise<Array<void> | ParseObject>*/ {
        var localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        if ((0, $02f719f3389c19af$var$_isArray.default)(target)) {
            if (target.length < 1) return $02f719f3389c19af$var$_promise.default.resolve([]);
            var objs = [];
            var ids = [];
            var className = null;
            var results = [];
            var error = null;
            (0, $02f719f3389c19af$var$_forEach.default)(target).call(target, function(el) {
                if (error) return;
                if (!className) className = el.className;
                if (className !== el.className) error = new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.INVALID_CLASS_NAME, "All objects should be of the same class");
                if (!el.id) error = new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.MISSING_OBJECT_ID, "All objects must have an ID");
                if (forceFetch || !el.isDataAvailable()) {
                    ids.push(el.id);
                    objs.push(el);
                }
                results.push(el);
            });
            if (error) return $02f719f3389c19af$var$_promise.default.reject(error);
            var query = new $02f719f3389c19af$var$_ParseQuery.default(className);
            query.containedIn("objectId", ids);
            if (options && options.include) query.include(options.include);
            query._limit = ids.length;
            return (0, $02f719f3389c19af$var$_find.default)(query).call(query, options).then(/*#__PURE__*/ function() {
                var _ref = (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee6(objects) {
                    var idMap, i, obj, _i, _obj, id, _iterator2, _step2, object;
                    return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee6$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                idMap = {};
                                (0, $02f719f3389c19af$var$_forEach.default)(objects).call(objects, function(o) {
                                    idMap[o.id] = o;
                                });
                                i = 0;
                            case 3:
                                if (!(i < objs.length)) {
                                    _context9.next = 11;
                                    break;
                                }
                                obj = objs[i];
                                if (!(!obj || !obj.id || !idMap[obj.id])) {
                                    _context9.next = 8;
                                    break;
                                }
                                if (!forceFetch) {
                                    _context9.next = 8;
                                    break;
                                }
                                return _context9.abrupt("return", $02f719f3389c19af$var$_promise.default.reject(new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.OBJECT_NOT_FOUND, "All objects must exist on the server.")));
                            case 8:
                                i++;
                                _context9.next = 3;
                                break;
                            case 11:
                                if (!$02f719f3389c19af$var$singleInstance) // If single instance objects are disabled, we need to replace the
                                for(_i = 0; _i < results.length; _i++){
                                    _obj = results[_i];
                                    if (_obj && _obj.id && idMap[_obj.id]) {
                                        id = _obj.id;
                                        _obj._finishFetch(idMap[id].toJSON());
                                        results[_i] = idMap[id];
                                    }
                                }
                                _iterator2 = $02f719f3389c19af$var$_createForOfIteratorHelper(results);
                                _context9.prev = 13;
                                _iterator2.s();
                            case 15:
                                if ((_step2 = _iterator2.n()).done) {
                                    _context9.next = 21;
                                    break;
                                }
                                object = _step2.value;
                                _context9.next = 19;
                                return localDatastore._updateObjectIfPinned(object);
                            case 19:
                                _context9.next = 15;
                                break;
                            case 21:
                                _context9.next = 26;
                                break;
                            case 23:
                                _context9.prev = 23;
                                _context9.t0 = _context9["catch"](13);
                                _iterator2.e(_context9.t0);
                            case 26:
                                _context9.prev = 26;
                                _iterator2.f();
                                return _context9.finish(26);
                            case 29:
                                return _context9.abrupt("return", $02f719f3389c19af$var$_promise.default.resolve(results));
                            case 30:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee6, null, [
                        [
                            13,
                            23,
                            26,
                            29
                        ]
                    ]);
                }));
                return function(_x4) {
                    return _ref.apply(this, arguments);
                };
            }());
        } else if (target instanceof $02f719f3389c19af$var$ParseObject) {
            if (!target.id) return $02f719f3389c19af$var$_promise.default.reject(new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.MISSING_OBJECT_ID, "Object does not have an ID"));
            var RESTController = $02f719f3389c19af$var$_CoreManager.default.getRESTController();
            var params = {};
            if (options && options.include) params.include = options.include.join();
            return RESTController.request("GET", "classes/" + target.className + "/" + target._getId(), params, options).then(/*#__PURE__*/ function() {
                var _ref2 = (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee7(response) {
                    return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee7$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                target._clearPendingOps();
                                target._clearServerData();
                                target._finishFetch(response);
                                _context10.next = 5;
                                return localDatastore._updateObjectIfPinned(target);
                            case 5:
                                return _context10.abrupt("return", target);
                            case 6:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee7);
                }));
                return function(_x5) {
                    return _ref2.apply(this, arguments);
                };
            }());
        }
        return $02f719f3389c19af$var$_promise.default.resolve();
    },
    destroy: function destroy(target, options) /*: Promise<Array<void> | ParseObject>*/ {
        return (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee10() {
            var batchSize, localDatastore, RESTController, batches, deleteCompleted, errors;
            return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee10$(_context13) {
                while(true)switch(_context13.prev = _context13.next){
                    case 0:
                        batchSize = options && options.batchSize ? options.batchSize : $02f719f3389c19af$var$_CoreManager.default.get("REQUEST_BATCH_SIZE");
                        localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
                        RESTController = $02f719f3389c19af$var$_CoreManager.default.getRESTController();
                        if (!(0, $02f719f3389c19af$var$_isArray.default)(target)) {
                            _context13.next = 15;
                            break;
                        }
                        if (!(target.length < 1)) {
                            _context13.next = 6;
                            break;
                        }
                        return _context13.abrupt("return", $02f719f3389c19af$var$_promise.default.resolve([]));
                    case 6:
                        batches = [
                            []
                        ];
                        (0, $02f719f3389c19af$var$_forEach.default)(target).call(target, function(obj) {
                            if (!obj.id) return;
                            batches[batches.length - 1].push(obj);
                            if (batches[batches.length - 1].length >= batchSize) batches.push([]);
                        });
                        if (batches[batches.length - 1].length === 0) // If the last batch is empty, remove it
                        batches.pop();
                        deleteCompleted = $02f719f3389c19af$var$_promise.default.resolve();
                        errors = [];
                        (0, $02f719f3389c19af$var$_forEach.default)(batches).call(batches, function(batch) {
                            deleteCompleted = deleteCompleted.then(function() {
                                return RESTController.request("POST", "batch", {
                                    requests: (0, $02f719f3389c19af$var$_map.default)(batch).call(batch, function(obj) {
                                        return {
                                            method: "DELETE",
                                            path: $02f719f3389c19af$var$getServerUrlPath() + "classes/" + obj.className + "/" + obj._getId(),
                                            body: {}
                                        };
                                    })
                                }, options).then(function(results) {
                                    for(var i = 0; i < results.length; i++)if (results[i] && results[i].hasOwnProperty("error")) {
                                        var err = new $02f719f3389c19af$var$_ParseError.default(results[i].error.code, results[i].error.error);
                                        err.object = batch[i];
                                        errors.push(err);
                                    }
                                });
                            });
                        });
                        return _context13.abrupt("return", deleteCompleted.then(/*#__PURE__*/ (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee8() {
                            var aggregate, _iterator3, _step3, object;
                            return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee8$(_context11) {
                                while(true)switch(_context11.prev = _context11.next){
                                    case 0:
                                        if (!errors.length) {
                                            _context11.next = 4;
                                            break;
                                        }
                                        aggregate = new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.AGGREGATE_ERROR);
                                        aggregate.errors = errors;
                                        return _context11.abrupt("return", $02f719f3389c19af$var$_promise.default.reject(aggregate));
                                    case 4:
                                        _iterator3 = $02f719f3389c19af$var$_createForOfIteratorHelper(target);
                                        _context11.prev = 5;
                                        _iterator3.s();
                                    case 7:
                                        if ((_step3 = _iterator3.n()).done) {
                                            _context11.next = 13;
                                            break;
                                        }
                                        object = _step3.value;
                                        _context11.next = 11;
                                        return localDatastore._destroyObjectIfPinned(object);
                                    case 11:
                                        _context11.next = 7;
                                        break;
                                    case 13:
                                        _context11.next = 18;
                                        break;
                                    case 15:
                                        _context11.prev = 15;
                                        _context11.t0 = _context11["catch"](5);
                                        _iterator3.e(_context11.t0);
                                    case 18:
                                        _context11.prev = 18;
                                        _iterator3.f();
                                        return _context11.finish(18);
                                    case 21:
                                        return _context11.abrupt("return", $02f719f3389c19af$var$_promise.default.resolve(target));
                                    case 22:
                                    case "end":
                                        return _context11.stop();
                                }
                            }, _callee8, null, [
                                [
                                    5,
                                    15,
                                    18,
                                    21
                                ]
                            ]);
                        }))));
                    case 15:
                        if (!(target instanceof $02f719f3389c19af$var$ParseObject)) {
                            _context13.next = 17;
                            break;
                        }
                        return _context13.abrupt("return", RESTController.request("DELETE", "classes/" + target.className + "/" + target._getId(), {}, options).then(/*#__PURE__*/ (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee9() {
                            return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee9$(_context12) {
                                while(true)switch(_context12.prev = _context12.next){
                                    case 0:
                                        _context12.next = 2;
                                        return localDatastore._destroyObjectIfPinned(target);
                                    case 2:
                                        return _context12.abrupt("return", $02f719f3389c19af$var$_promise.default.resolve(target));
                                    case 3:
                                    case "end":
                                        return _context12.stop();
                                }
                            }, _callee9);
                        }))));
                    case 17:
                        return _context13.abrupt("return", $02f719f3389c19af$var$_promise.default.resolve(target));
                    case 18:
                    case "end":
                        return _context13.stop();
                }
            }, _callee10);
        }))();
    },
    save: function save(target, options) {
        var batchSize = options && options.batchSize ? options.batchSize : $02f719f3389c19af$var$_CoreManager.default.get("REQUEST_BATCH_SIZE");
        var localDatastore = $02f719f3389c19af$var$_CoreManager.default.getLocalDatastore();
        var mapIdForPin = {};
        var RESTController = $02f719f3389c19af$var$_CoreManager.default.getRESTController();
        var stateController = $02f719f3389c19af$var$_CoreManager.default.getObjectStateController();
        var allowCustomObjectId = $02f719f3389c19af$var$_CoreManager.default.get("ALLOW_CUSTOM_OBJECT_ID");
        options = options || {};
        options.returnStatus = options.returnStatus || true;
        if ((0, $02f719f3389c19af$var$_isArray.default)(target)) {
            if (target.length < 1) return $02f719f3389c19af$var$_promise.default.resolve([]);
            var unsaved = (0, $02f719f3389c19af$var$_concat.default)(target).call(target);
            for(var i = 0; i < target.length; i++)if (target[i] instanceof $02f719f3389c19af$var$ParseObject) unsaved = (0, $02f719f3389c19af$var$_concat.default)(unsaved).call(unsaved, (0, $02f719f3389c19af$var$_unsavedChildren.default)(target[i], true));
            unsaved = (0, $02f719f3389c19af$var$_unique.default)(unsaved);
            var filesSaved = [];
            var pending = [];
            (0, $02f719f3389c19af$var$_forEach.default)(unsaved).call(unsaved, function(el) {
                if (el instanceof $02f719f3389c19af$var$_ParseFile.default) filesSaved.push(el.save(options));
                else if (el instanceof $02f719f3389c19af$var$ParseObject) pending.push(el);
            });
            return $02f719f3389c19af$var$_promise.default.all(filesSaved).then(function() {
                var objectError = null;
                return (0, $9FsFR.continueWhile)(function() {
                    return pending.length > 0;
                }, function() {
                    var batch = [];
                    var nextPending = [];
                    (0, $02f719f3389c19af$var$_forEach.default)(pending).call(pending, function(el) {
                        if (allowCustomObjectId && Object.prototype.hasOwnProperty.call(el, "id") && !el.id) throw new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.MISSING_OBJECT_ID, "objectId must not be empty or null");
                        if (batch.length < batchSize && (0, $02f719f3389c19af$var$_canBeSerialized.default)(el)) batch.push(el);
                        else nextPending.push(el);
                    });
                    pending = nextPending;
                    if (batch.length < 1) return $02f719f3389c19af$var$_promise.default.reject(new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.OTHER_CAUSE, "Tried to save a batch with a cycle."));
                     // Queue up tasks for each object in the batch.
                    // When every task is ready, the API request will execute
                    var batchReturned = new $9FsFR.resolvingPromise();
                    var batchReady = [];
                    var batchTasks = [];
                    (0, $02f719f3389c19af$var$_forEach.default)(batch).call(batch, function(obj, index) {
                        var ready = new $9FsFR.resolvingPromise();
                        batchReady.push(ready);
                        var task = function task() {
                            ready.resolve();
                            return batchReturned.then(function(responses) {
                                if (responses[index].hasOwnProperty("success")) {
                                    var objectId = responses[index].success.objectId;
                                    var status = responses[index]._status;
                                    delete responses[index]._status;
                                    mapIdForPin[objectId] = obj._localId;
                                    obj._handleSaveResponse(responses[index].success, status);
                                } else {
                                    if (!objectError && responses[index].hasOwnProperty("error")) {
                                        var serverError = responses[index].error;
                                        objectError = new $02f719f3389c19af$var$_ParseError.default(serverError.code, serverError.error); // Cancel the rest of the save
                                        pending = [];
                                    }
                                    obj._handleSaveError();
                                }
                            });
                        };
                        stateController.pushPendingState(obj._getStateIdentifier());
                        batchTasks.push(stateController.enqueueTask(obj._getStateIdentifier(), task));
                    });
                    (0, $9FsFR.when)(batchReady).then(function() {
                        // Kick off the batch request
                        return RESTController.request("POST", "batch", {
                            requests: (0, $02f719f3389c19af$var$_map.default)(batch).call(batch, function(obj) {
                                var params = obj._getSaveParams();
                                params.path = $02f719f3389c19af$var$getServerUrlPath() + params.path;
                                return params;
                            })
                        }, options);
                    }).then(batchReturned.resolve, function(error) {
                        batchReturned.reject(new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.INCORRECT_TYPE, error.message));
                    });
                    return (0, $9FsFR.when)(batchTasks);
                }).then(/*#__PURE__*/ (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee11() {
                    var _iterator4, _step4, object;
                    return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee11$(_context14) {
                        while(true)switch(_context14.prev = _context14.next){
                            case 0:
                                if (!objectError) {
                                    _context14.next = 2;
                                    break;
                                }
                                return _context14.abrupt("return", $02f719f3389c19af$var$_promise.default.reject(objectError));
                            case 2:
                                _iterator4 = $02f719f3389c19af$var$_createForOfIteratorHelper(target);
                                _context14.prev = 3;
                                _iterator4.s();
                            case 5:
                                if ((_step4 = _iterator4.n()).done) {
                                    _context14.next = 13;
                                    break;
                                }
                                object = _step4.value;
                                _context14.next = 9;
                                return localDatastore._updateLocalIdForObject(mapIdForPin[object.id], object);
                            case 9:
                                _context14.next = 11;
                                return localDatastore._updateObjectIfPinned(object);
                            case 11:
                                _context14.next = 5;
                                break;
                            case 13:
                                _context14.next = 18;
                                break;
                            case 15:
                                _context14.prev = 15;
                                _context14.t0 = _context14["catch"](3);
                                _iterator4.e(_context14.t0);
                            case 18:
                                _context14.prev = 18;
                                _iterator4.f();
                                return _context14.finish(18);
                            case 21:
                                return _context14.abrupt("return", $02f719f3389c19af$var$_promise.default.resolve(target));
                            case 22:
                            case "end":
                                return _context14.stop();
                        }
                    }, _callee11, null, [
                        [
                            3,
                            15,
                            18,
                            21
                        ]
                    ]);
                })));
            });
        } else if (target instanceof $02f719f3389c19af$var$ParseObject) {
            if (allowCustomObjectId && Object.prototype.hasOwnProperty.call(target, "id") && !target.id) throw new $02f719f3389c19af$var$_ParseError.default($02f719f3389c19af$var$_ParseError.default.MISSING_OBJECT_ID, "objectId must not be empty or null");
             // generate _localId in case if cascadeSave=false
            target._getId();
            var localId = target._localId; // copying target lets Flow guarantee the pointer isn't modified elsewhere
            var targetCopy = target;
            var task = function task() {
                var params = targetCopy._getSaveParams();
                return RESTController.request(params.method, params.path, params.body, options).then(function(response) {
                    var status = response._status;
                    delete response._status;
                    targetCopy._handleSaveResponse(response, status);
                }, function(error) {
                    targetCopy._handleSaveError();
                    return $02f719f3389c19af$var$_promise.default.reject(error);
                });
            };
            stateController.pushPendingState(target._getStateIdentifier());
            return stateController.enqueueTask(target._getStateIdentifier(), task).then(/*#__PURE__*/ (0, $02f719f3389c19af$var$_asyncToGenerator2.default)(/*#__PURE__*/ $02f719f3389c19af$var$_regeneratorRuntime().mark(function _callee12() {
                return $02f719f3389c19af$var$_regeneratorRuntime().wrap(function _callee12$(_context15) {
                    while(true)switch(_context15.prev = _context15.next){
                        case 0:
                            _context15.next = 2;
                            return localDatastore._updateLocalIdForObject(localId, target);
                        case 2:
                            _context15.next = 4;
                            return localDatastore._updateObjectIfPinned(target);
                        case 4:
                            return _context15.abrupt("return", target);
                        case 5:
                        case "end":
                            return _context15.stop();
                    }
                }, _callee12);
            })), function(error) {
                return $02f719f3389c19af$var$_promise.default.reject(error);
            });
        }
        return $02f719f3389c19af$var$_promise.default.resolve();
    }
};
$02f719f3389c19af$var$_CoreManager.default.setObjectController($02f719f3389c19af$var$DefaultController);
var $02f719f3389c19af$var$_default = $02f719f3389c19af$var$ParseObject;
module.exports.default = $02f719f3389c19af$var$_default;

});
parcelRequire.register("iG2ur", function(module, exports) {

module.exports = (parcelRequire("emFTQ"));

});
parcelRequire.register("emFTQ", function(module, exports) {

module.exports = (parcelRequire("9Fgdi"));

});
parcelRequire.register("9Fgdi", function(module, exports) {

var $i9UYa = parcelRequire("i9UYa");
module.exports = $i9UYa;

});
parcelRequire.register("i9UYa", function(module, exports) {

var $cOiyi = parcelRequire("cOiyi");
module.exports = $cOiyi;

});
parcelRequire.register("cOiyi", function(module, exports) {

var $jTvpL = parcelRequire("jTvpL");
parcelRequire("jXhxH");
module.exports = $jTvpL;

});
parcelRequire.register("jTvpL", function(module, exports) {
parcelRequire("5xrGR");
parcelRequire("ja2zQ");

var $7qrIj = parcelRequire("7qrIj");
module.exports = $7qrIj;

});






parcelRequire.register("35NIM", function(module, exports) {

module.exports = (parcelRequire("9O8w2"));

});
parcelRequire.register("9O8w2", function(module, exports) {

var $bKchz = parcelRequire("bKchz");
module.exports = $bKchz;

});
parcelRequire.register("bKchz", function(module, exports) {
parcelRequire("ja2zQ");
parcelRequire("23sQl");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Array.from;

});
parcelRequire.register("23sQl", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $kNa4r = parcelRequire("kNa4r");

var $39DPZ = parcelRequire("39DPZ");
var $17f23c3e48682178$var$INCORRECT_ITERATION = !$39DPZ(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$ggcsv({
    target: "Array",
    stat: true,
    forced: $17f23c3e48682178$var$INCORRECT_ITERATION
}, {
    from: $kNa4r
});

});
parcelRequire.register("kNa4r", function(module, exports) {
"use strict";

var $b5UsH = parcelRequire("b5UsH");

var $aELZY = parcelRequire("aELZY");

var $iJNxK = parcelRequire("iJNxK");

var $kv5he = parcelRequire("kv5he");

var $b4lk6 = parcelRequire("b4lk6");

var $iQLrm = parcelRequire("iQLrm");

var $6ocdr = parcelRequire("6ocdr");

var $b1Dzg = parcelRequire("b1Dzg");

var $3Tvts = parcelRequire("3Tvts");

var $7qrIj = parcelRequire("7qrIj");
var $f2303212040ef78d$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $iJNxK(arrayLike);
    var IS_CONSTRUCTOR = $iQLrm(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $b5UsH(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $7qrIj(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $f2303212040ef78d$var$$Array && $b4lk6(iteratorMethod))) {
        iterator = $3Tvts(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = $aELZY(next, iterator)).done; index++){
            value = mapping ? $kv5he(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $b1Dzg(result, index, value);
        }
    } else {
        length = $6ocdr(O);
        result = IS_CONSTRUCTOR ? new this(length) : $f2303212040ef78d$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $b1Dzg(result, index, value);
        }
    }
    result.length = index;
    return result;
};

});
parcelRequire.register("kv5he", function(module, exports) {

var $l3LMJ = parcelRequire("l3LMJ");

var $2l0vW = parcelRequire("2l0vW");
// call something on iterator step with safe closing on error
module.exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($l3LMJ(value)[0], value[1]) : fn(value);
    } catch (error) {
        $2l0vW(iterator, "throw", error);
    }
};

});






parcelRequire.register("a1TrC", function(module, exports) {

module.exports = (parcelRequire("loUO6"));

});
parcelRequire.register("loUO6", function(module, exports) {

var $17yB6 = parcelRequire("17yB6");
module.exports = $17yB6;

});
parcelRequire.register("17yB6", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $fa9j5 = parcelRequire("fa9j5");
var $0d11483398c26308$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.slice;
    return it === $0d11483398c26308$var$ArrayPrototype || $8hsAO($0d11483398c26308$var$ArrayPrototype, it) && own === $0d11483398c26308$var$ArrayPrototype.slice ? $fa9j5 : own;
};

});
parcelRequire.register("fa9j5", function(module, exports) {
parcelRequire("hGTMp");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").slice;

});
parcelRequire.register("hGTMp", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5zZFa = parcelRequire("5zZFa");

var $iQLrm = parcelRequire("iQLrm");

var $1WYwK = parcelRequire("1WYwK");

var $2s0YW = parcelRequire("2s0YW");

var $6ocdr = parcelRequire("6ocdr");

var $bYkAs = parcelRequire("bYkAs");

var $b1Dzg = parcelRequire("b1Dzg");

var $fq7H3 = parcelRequire("fq7H3");

var $PdD5d = parcelRequire("PdD5d");

var $hF40G = parcelRequire("hF40G");
var $ce11a0a1d0d9691d$var$HAS_SPECIES_SUPPORT = $PdD5d("slice");
var $ce11a0a1d0d9691d$var$SPECIES = $fq7H3("species");
var $ce11a0a1d0d9691d$var$$Array = Array;
var $ce11a0a1d0d9691d$var$max = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$ggcsv({
    target: "Array",
    proto: true,
    forced: !$ce11a0a1d0d9691d$var$HAS_SPECIES_SUPPORT
}, {
    slice: function slice(start, end) {
        var O = $bYkAs(this);
        var length = $6ocdr(O);
        var k = $2s0YW(start, length);
        var fin = $2s0YW(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if ($5zZFa(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if ($iQLrm(Constructor) && (Constructor === $ce11a0a1d0d9691d$var$$Array || $5zZFa(Constructor.prototype))) Constructor = undefined;
            else if ($1WYwK(Constructor)) {
                Constructor = Constructor[$ce11a0a1d0d9691d$var$SPECIES];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $ce11a0a1d0d9691d$var$$Array || Constructor === undefined) return $hF40G(O, k, fin);
        }
        result = new (Constructor === undefined ? $ce11a0a1d0d9691d$var$$Array : Constructor)($ce11a0a1d0d9691d$var$max(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) $b1Dzg(result, n, O[k]);
        result.length = n;
        return result;
    }
});

});





parcelRequire.register("4wehD", function(module, exports) {

module.exports = (parcelRequire("ljEWM"));

});
parcelRequire.register("ljEWM", function(module, exports) {

var $1i410 = parcelRequire("1i410");
module.exports = $1i410;

});
parcelRequire.register("1i410", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $3xPCK = parcelRequire("3xPCK");
var $0f0a963ff40f6476$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.reverse;
    return it === $0f0a963ff40f6476$var$ArrayPrototype || $8hsAO($0f0a963ff40f6476$var$ArrayPrototype, it) && own === $0f0a963ff40f6476$var$ArrayPrototype.reverse ? $3xPCK : own;
};

});
parcelRequire.register("3xPCK", function(module, exports) {
parcelRequire("73eJg");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").reverse;

});
parcelRequire.register("73eJg", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $f518o = parcelRequire("f518o");

var $5zZFa = parcelRequire("5zZFa");
var $52243d15ad337188$var$nativeReverse = $f518o([].reverse);
var $52243d15ad337188$var$test = [
    1,
    2
];
// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$ggcsv({
    target: "Array",
    proto: true,
    forced: String($52243d15ad337188$var$test) === String($52243d15ad337188$var$test.reverse())
}, {
    reverse: function reverse() {
        // eslint-disable-next-line no-self-assign -- dirty hack
        if ($5zZFa(this)) this.length = this.length;
        return $52243d15ad337188$var$nativeReverse(this);
    }
});

});





parcelRequire.register("dQJQf", function(module, exports) {

module.exports = (parcelRequire("gm0j3"));

});

parcelRequire.register("kOp5W", function(module, exports) {

module.exports = (parcelRequire("6Llo9"));

});

parcelRequire.register("jQ6K5", function(module, exports) {

module.exports = (parcelRequire("c9ilJ"));

});

parcelRequire.register("iDZ3d", function(module, exports) {

module.exports = (parcelRequire("feUJs"));

});

parcelRequire.register("dLJtR", function(module, exports) {

module.exports = (parcelRequire("jEcfg"));

});
parcelRequire.register("jEcfg", function(module, exports) {

var $1rfWW = parcelRequire("1rfWW");
module.exports = $1rfWW;

});
parcelRequire.register("1rfWW", function(module, exports) {
parcelRequire("1dC5I");

var $ly30u = parcelRequire("ly30u");
var $10c4af555ab07755$var$Object = $ly30u.Object;
var $10c4af555ab07755$var$defineProperties = module.exports = function defineProperties(T, D) {
    return $10c4af555ab07755$var$Object.defineProperties(T, D);
};
if ($10c4af555ab07755$var$Object.defineProperties.sham) $10c4af555ab07755$var$defineProperties.sham = true;

});
parcelRequire.register("1dC5I", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $jeZ4p = parcelRequire("jeZ4p");

var $a965u = parcelRequire("a965u");
var $0e348d7b725a21fe$require$defineProperties = $a965u.f;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$ggcsv({
    target: "Object",
    stat: true,
    forced: Object.defineProperties !== $0e348d7b725a21fe$require$defineProperties,
    sham: !$jeZ4p
}, {
    defineProperties: $0e348d7b725a21fe$require$defineProperties
});

});




parcelRequire.register("fgRng", function(module, exports) {

module.exports = (parcelRequire("1gazd"));

});
parcelRequire.register("1gazd", function(module, exports) {

var $7gvry = parcelRequire("7gvry");
module.exports = $7gvry;

});
parcelRequire.register("7gvry", function(module, exports) {
parcelRequire("658ta");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.getOwnPropertyDescriptors;

});
parcelRequire.register("658ta", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $jeZ4p = parcelRequire("jeZ4p");

var $eNGig = parcelRequire("eNGig");

var $bYkAs = parcelRequire("bYkAs");

var $fTFId = parcelRequire("fTFId");

var $b1Dzg = parcelRequire("b1Dzg");
// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$ggcsv({
    target: "Object",
    stat: true,
    sham: !$jeZ4p
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $bYkAs(object);
        var getOwnPropertyDescriptor = $fTFId.f;
        var keys = $eNGig(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) $b1Dzg(result, key, descriptor);
        }
        return result;
    }
});

});




parcelRequire.register("i3o6i", function(module, exports) {

module.exports = (parcelRequire("84aiV"));

});
parcelRequire.register("84aiV", function(module, exports) {

var $2qJJl = parcelRequire("2qJJl");
module.exports = $2qJJl;

});
parcelRequire.register("2qJJl", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $hqow7 = parcelRequire("hqow7");
var $1c517b94a3f865cc$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.filter;
    return it === $1c517b94a3f865cc$var$ArrayPrototype || $8hsAO($1c517b94a3f865cc$var$ArrayPrototype, it) && own === $1c517b94a3f865cc$var$ArrayPrototype.filter ? $hqow7 : own;
};

});
parcelRequire.register("hqow7", function(module, exports) {
parcelRequire("jGn0H");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").filter;

});
parcelRequire.register("jGn0H", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $igsV9 = parcelRequire("igsV9");
var $e543c9ebeb55a59c$require$$filter = $igsV9.filter;

var $PdD5d = parcelRequire("PdD5d");
var $e543c9ebeb55a59c$var$HAS_SPECIES_SUPPORT = $PdD5d("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$ggcsv({
    target: "Array",
    proto: true,
    forced: !$e543c9ebeb55a59c$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $e543c9ebeb55a59c$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRequire.register("3bLGW", function(module, exports) {

module.exports = (parcelRequire("c9EK5"));

});
parcelRequire.register("c9EK5", function(module, exports) {

var $7qyP2 = parcelRequire("7qyP2");
module.exports = $7qyP2;

});
parcelRequire.register("7qyP2", function(module, exports) {
parcelRequire("ko4d9");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.getOwnPropertySymbols;

});



parcelRequire.register("2VoQi", function(module, exports) {

module.exports = (parcelRequire("hxV74"));

});
parcelRequire.register("hxV74", function(module, exports) {

var $c5uyW = parcelRequire("c5uyW");
module.exports = $c5uyW;

});
parcelRequire.register("c5uyW", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $3smyF = parcelRequire("3smyF");
var $8ccda8c3e7128aab$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.map;
    return it === $8ccda8c3e7128aab$var$ArrayPrototype || $8hsAO($8ccda8c3e7128aab$var$ArrayPrototype, it) && own === $8ccda8c3e7128aab$var$ArrayPrototype.map ? $3smyF : own;
};

});
parcelRequire.register("3smyF", function(module, exports) {
parcelRequire("bQEFd");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").map;

});
parcelRequire.register("bQEFd", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $igsV9 = parcelRequire("igsV9");
var $8a04180965f7f8c1$require$$map = $igsV9.map;

var $PdD5d = parcelRequire("PdD5d");
var $8a04180965f7f8c1$var$HAS_SPECIES_SUPPORT = $PdD5d("map");
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$ggcsv({
    target: "Array",
    proto: true,
    forced: !$8a04180965f7f8c1$var$HAS_SPECIES_SUPPORT
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $8a04180965f7f8c1$require$$map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRequire.register("c61hX", function(module, exports) {

module.exports = (parcelRequire("c7TcM"));

});
parcelRequire.register("c7TcM", function(module, exports) {

var $1gQ9y = parcelRequire("1gQ9y");
module.exports = $1gQ9y;

});
parcelRequire.register("1gQ9y", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $6G24z = parcelRequire("6G24z");
var $0ecfbd9b08790f64$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.find;
    return it === $0ecfbd9b08790f64$var$ArrayPrototype || $8hsAO($0ecfbd9b08790f64$var$ArrayPrototype, it) && own === $0ecfbd9b08790f64$var$ArrayPrototype.find ? $6G24z : own;
};

});
parcelRequire.register("6G24z", function(module, exports) {
parcelRequire("iz28m");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").find;

});
parcelRequire.register("iz28m", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $igsV9 = parcelRequire("igsV9");
var $d83d269faf2aac2e$require$$find = $igsV9.find;

var $ajzxw = parcelRequire("ajzxw");
var $d83d269faf2aac2e$var$FIND = "find";
var $d83d269faf2aac2e$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if ($d83d269faf2aac2e$var$FIND in []) Array(1)[$d83d269faf2aac2e$var$FIND](function() {
    $d83d269faf2aac2e$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$ggcsv({
    target: "Array",
    proto: true,
    forced: $d83d269faf2aac2e$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $d83d269faf2aac2e$require$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$ajzxw($d83d269faf2aac2e$var$FIND);

});





parcelRequire.register("kkHAR", function(module, exports) {

var $jWrzA = parcelRequire("jWrzA");
function $ecd77daa7def9a06$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else $jWrzA.resolve(value).then(_next, _throw);
}
function $ecd77daa7def9a06$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new $jWrzA(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $ecd77daa7def9a06$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $ecd77daa7def9a06$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $ecd77daa7def9a06$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("jWrzA", function(module, exports) {

module.exports = (parcelRequire("Zpch2"));

});
parcelRequire.register("Zpch2", function(module, exports) {

module.exports = (parcelRequire("gvfML"));

});
parcelRequire.register("gvfML", function(module, exports) {

var $1W69K = parcelRequire("1W69K");
parcelRequire("9vCOJ");
parcelRequire("dAged");
parcelRequire("jU3wP");
parcelRequire("d1CmP");
parcelRequire("fwEM0");
module.exports = $1W69K;

});
parcelRequire.register("1W69K", function(module, exports) {

var $5XWAD = parcelRequire("5XWAD");
module.exports = $5XWAD;

});

parcelRequire.register("9vCOJ", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $1HEKk = parcelRequire("1HEKk");
// `Promise.withResolvers` method
// https://github.com/tc39/proposal-promise-with-resolvers
$ggcsv({
    target: "Promise",
    stat: true,
    forced: true
}, {
    withResolvers: function withResolvers() {
        var promiseCapability = $1HEKk.f(this);
        return {
            promise: promiseCapability.promise,
            resolve: promiseCapability.resolve,
            reject: promiseCapability.reject
        };
    }
});

});

parcelRequire.register("dAged", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("l3Lsr");

});

parcelRequire.register("jU3wP", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("ettPZ");

});

parcelRequire.register("d1CmP", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $1HEKk = parcelRequire("1HEKk");

var $7aQOM = parcelRequire("7aQOM");
// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$ggcsv({
    target: "Promise",
    stat: true,
    forced: true
}, {
    "try": function(callbackfn) {
        var promiseCapability = $1HEKk.f(this);
        var result = $7aQOM(callbackfn);
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});

});

parcelRequire.register("fwEM0", function(module, exports) {
// TODO: Remove from `core-js@4`
parcelRequire("hakp0");

});





parcelRequire.register("oorJA", function(module, exports) {

module.exports = (parcelRequire("eOq4R"));

});
parcelRequire.register("eOq4R", function(module, exports) {

var $7SISV = parcelRequire("7SISV");
module.exports = $7SISV;

});
parcelRequire.register("7SISV", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $6qdGo = parcelRequire("6qdGo");
var $5bd064c4553bb24a$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.concat;
    return it === $5bd064c4553bb24a$var$ArrayPrototype || $8hsAO($5bd064c4553bb24a$var$ArrayPrototype, it) && own === $5bd064c4553bb24a$var$ArrayPrototype.concat ? $6qdGo : own;
};

});
parcelRequire.register("6qdGo", function(module, exports) {
parcelRequire("isTuv");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").concat;

});




parcelRequire.register("dNrmj", function(module, exports) {

module.exports = (parcelRequire("1ArLc"));

});
parcelRequire.register("1ArLc", function(module, exports) {

var $ysJEj = parcelRequire("ysJEj");
module.exports = $ysJEj;

});
parcelRequire.register("ysJEj", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $eDxhp = parcelRequire("eDxhp");

var $dNqHo = parcelRequire("dNqHo");
var $0679775168a8741b$var$ArrayPrototype = Array.prototype;
var $0679775168a8741b$var$StringPrototype = String.prototype;
module.exports = function(it) {
    var own = it.includes;
    if (it === $0679775168a8741b$var$ArrayPrototype || $8hsAO($0679775168a8741b$var$ArrayPrototype, it) && own === $0679775168a8741b$var$ArrayPrototype.includes) return $eDxhp;
    if (typeof it == "string" || it === $0679775168a8741b$var$StringPrototype || $8hsAO($0679775168a8741b$var$StringPrototype, it) && own === $0679775168a8741b$var$StringPrototype.includes) return $dNqHo;
    return own;
};

});
parcelRequire.register("eDxhp", function(module, exports) {
parcelRequire("aOny7");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").includes;

});
parcelRequire.register("aOny7", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $3NUiQ = parcelRequire("3NUiQ");
var $7df0d746f7e8703e$require$$includes = $3NUiQ.includes;

var $77TPA = parcelRequire("77TPA");

var $ajzxw = parcelRequire("ajzxw");
// FF99+ bug
var $7df0d746f7e8703e$var$BROKEN_ON_SPARSE = $77TPA(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$ggcsv({
    target: "Array",
    proto: true,
    forced: $7df0d746f7e8703e$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $7df0d746f7e8703e$require$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$ajzxw("includes");

});


parcelRequire.register("dNqHo", function(module, exports) {
parcelRequire("5KRrY");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("String").includes;

});
parcelRequire.register("5KRrY", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $f518o = parcelRequire("f518o");

var $4Te7f = parcelRequire("4Te7f");

var $cBWnS = parcelRequire("cBWnS");

var $l2Ut5 = parcelRequire("l2Ut5");

var $bmRml = parcelRequire("bmRml");
var $0114d161e47b718e$var$stringIndexOf = $f518o("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$ggcsv({
    target: "String",
    proto: true,
    forced: !$bmRml("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$0114d161e47b718e$var$stringIndexOf($l2Ut5($cBWnS(this)), $l2Ut5($4Te7f(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});

});
parcelRequire.register("4Te7f", function(module, exports) {

var $6oZqm = parcelRequire("6oZqm");
var $38f73f974d28d73c$var$$TypeError = TypeError;
module.exports = function(it) {
    if ($6oZqm(it)) throw $38f73f974d28d73c$var$$TypeError("The method doesn't accept regular expressions");
    return it;
};

});
parcelRequire.register("6oZqm", function(module, exports) {

var $1WYwK = parcelRequire("1WYwK");

var $bTsfg = parcelRequire("bTsfg");

var $fq7H3 = parcelRequire("fq7H3");
var $4a94a18cd9ae2bc7$var$MATCH = $fq7H3("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function(it) {
    var isRegExp;
    return $1WYwK(it) && ((isRegExp = it[$4a94a18cd9ae2bc7$var$MATCH]) !== undefined ? !!isRegExp : $bTsfg(it) == "RegExp");
};

});


parcelRequire.register("bmRml", function(module, exports) {

var $fq7H3 = parcelRequire("fq7H3");
var $846b23dc5ef8dd49$var$MATCH = $fq7H3("match");
module.exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$846b23dc5ef8dd49$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};

});






parcelRequire.register("4qY0x", function(module, exports) {

module.exports = (parcelRequire("jHJ1q"));

});
parcelRequire.register("jHJ1q", function(module, exports) {

var $6DDjT = parcelRequire("6DDjT");
module.exports = $6DDjT;

});
parcelRequire.register("6DDjT", function(module, exports) {
parcelRequire("kvPdS");

var $ly30u = parcelRequire("ly30u");

var $2JOsI = parcelRequire("2JOsI");
// eslint-disable-next-line es/no-json -- safe
if (!$ly30u.JSON) $ly30u.JSON = {
    stringify: JSON.stringify
};
// eslint-disable-next-line no-unused-vars -- required for `.length`
module.exports = function stringify(it, replacer, space) {
    return $2JOsI($ly30u.JSON.stringify, null, arguments);
};

});



parcelRequire.register("hNwyw", function(module, exports) {

module.exports = (parcelRequire("bek8o"));

});
parcelRequire.register("bek8o", function(module, exports) {

var $dPRNc = parcelRequire("dPRNc");
module.exports = $dPRNc;

});
parcelRequire.register("dPRNc", function(module, exports) {
parcelRequire("2Nn8K");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.freeze;

});
parcelRequire.register("2Nn8K", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $7DccQ = parcelRequire("7DccQ");

var $77TPA = parcelRequire("77TPA");

var $1WYwK = parcelRequire("1WYwK");

var $iZE4H = parcelRequire("iZE4H");
var $20921b834d47c4a5$require$onFreeze = $iZE4H.onFreeze;
// eslint-disable-next-line es/no-object-freeze -- safe
var $20921b834d47c4a5$var$$freeze = Object.freeze;
var $20921b834d47c4a5$var$FAILS_ON_PRIMITIVES = $77TPA(function() {
    $20921b834d47c4a5$var$$freeze(1);
});
// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$ggcsv({
    target: "Object",
    stat: true,
    forced: $20921b834d47c4a5$var$FAILS_ON_PRIMITIVES,
    sham: !$7DccQ
}, {
    freeze: function freeze(it) {
        return $20921b834d47c4a5$var$$freeze && $1WYwK(it) ? $20921b834d47c4a5$var$$freeze($20921b834d47c4a5$require$onFreeze(it)) : it;
    }
});

});




parcelRequire.register("9l1BE", function(module, exports) {

module.exports = (parcelRequire("hCfza"));

});

parcelRequire.register("73D0B", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $523712883a269370$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $523712883a269370$var$_forEach = $iHLHC((parcelRequire("gW71a")));
/*
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /*:: import type { AttributeMap, ObjectCache, OpsMap, State } from './ObjectStateMutations';*/ /*:: import type ParseFile from './ParseFile';*/ /*:: import type { FileSource } from './ParseFile';*/ /*:: import type { Op } from './ParseOp';*/ /*:: import type ParseObject from './ParseObject';*/ /*:: import type { QueryJSON } from './ParseQuery';*/ /*:: import type ParseUser from './ParseUser';*/ /*:: import type { AuthData } from './ParseUser';*/ /*:: import type { PushData } from './Push';*/ /*:: import type { RequestOptions, FullOptions } from './RESTController';*/ /*:: type AnalyticsController = {
  track: (name: string, dimensions: { [key: string]: string }) => Promise,
};*/ /*:: type CloudController = {
  run: (name: string, data: mixed, options: RequestOptions) => Promise,
  getJobsData: (options: RequestOptions) => Promise,
  startJob: (name: string, data: mixed, options: RequestOptions) => Promise,
};*/ /*:: type ConfigController = {
  current: () => Promise,
  get: () => Promise,
  save: (attrs: { [key: string]: any }) => Promise,
};*/ /*:: type CryptoController = {
  encrypt: (obj: any, secretKey: string) => string,
  decrypt: (encryptedText: string, secretKey: any) => string,
};*/ /*:: type FileController = {
  saveFile: (name: string, source: FileSource, options: FullOptions) => Promise,
  saveBase64: (name: string, source: FileSource, options: FullOptions) => Promise,
  download: (uri: string) => Promise,
};*/ /*:: type InstallationController = {
  currentInstallationId: () => Promise,
};*/ /*:: type ObjectController = {
  fetch: (
    object: ParseObject | Array<ParseObject>,
    forceFetch: boolean,
    options: RequestOptions
  ) => Promise,
  save: (object: ParseObject | Array<ParseObject | ParseFile>, options: RequestOptions) => Promise,
  destroy: (object: ParseObject | Array<ParseObject>, options: RequestOptions) => Promise,
};*/ /*:: type ObjectStateController = {
  getState: (obj: any) => ?State,
  initializeState: (obj: any, initial?: State) => State,
  removeState: (obj: any) => ?State,
  getServerData: (obj: any) => AttributeMap,
  setServerData: (obj: any, attributes: AttributeMap) => void,
  getPendingOps: (obj: any) => Array<OpsMap>,
  setPendingOp: (obj: any, attr: string, op: ?Op) => void,
  pushPendingState: (obj: any) => void,
  popPendingState: (obj: any) => OpsMap,
  mergeFirstPendingState: (obj: any) => void,
  getObjectCache: (obj: any) => ObjectCache,
  estimateAttribute: (obj: any, attr: string) => mixed,
  estimateAttributes: (obj: any) => AttributeMap,
  commitServerChanges: (obj: any, changes: AttributeMap) => void,
  enqueueTask: (obj: any, task: () => Promise) => Promise,
  clearAllState: () => void,
  duplicateState: (source: any, dest: any) => void,
};*/ /*:: type PushController = {
  send: (data: PushData) => Promise,
};*/ /*:: type QueryController = {
  find: (className: string, params: QueryJSON, options: RequestOptions) => Promise,
  aggregate: (className: string, params: any, options: RequestOptions) => Promise,
};*/ /*:: type RESTController = {
  request: (method: string, path: string, data: mixed, options: RequestOptions) => Promise,
  ajax: (method: string, url: string, data: any, headers?: any, options: FullOptions) => Promise,
};*/ /*:: type SchemaController = {
  purge: (className: string) => Promise,
  get: (className: string, options: RequestOptions) => Promise,
  delete: (className: string, options: RequestOptions) => Promise,
  create: (className: string, params: any, options: RequestOptions) => Promise,
  update: (className: string, params: any, options: RequestOptions) => Promise,
  send(className: string, method: string, params: any, options: RequestOptions): Promise,
};*/ /*:: type SessionController = {
  getSession: (token: RequestOptions) => Promise,
};*/ /*:: type StorageController =
  | {
      async: 0,
      getItem: (path: string) => ?string,
      setItem: (path: string, value: string) => void,
      removeItem: (path: string) => void,
      getItemAsync?: (path: string) => Promise,
      setItemAsync?: (path: string, value: string) => Promise,
      removeItemAsync?: (path: string) => Promise,
      clear: () => void,
    }
  | {
      async: 1,
      getItem?: (path: string) => ?string,
      setItem?: (path: string, value: string) => void,
      removeItem?: (path: string) => void,
      getItemAsync: (path: string) => Promise,
      setItemAsync: (path: string, value: string) => Promise,
      removeItemAsync: (path: string) => Promise,
      clear: () => void,
    };*/ /*:: type LocalDatastoreController = {
  fromPinWithName: (name: string) => ?any,
  pinWithName: (name: string, objects: any) => void,
  unPinWithName: (name: string) => void,
  getAllContents: () => ?any,
  clear: () => void,
};*/ /*:: type UserController = {
  setCurrentUser: (user: ParseUser) => Promise,
  currentUser: () => ?ParseUser,
  currentUserAsync: () => Promise,
  signUp: (user: ParseUser, attrs: AttributeMap, options: RequestOptions) => Promise,
  logIn: (user: ParseUser, options: RequestOptions) => Promise,
  become: (options: RequestOptions) => Promise,
  hydrate: (userJSON: AttributeMap) => Promise,
  logOut: (options: RequestOptions) => Promise,
  me: (options: RequestOptions) => Promise,
  requestPasswordReset: (email: string, options: RequestOptions) => Promise,
  updateUserOnDisk: (user: ParseUser) => Promise,
  upgradeToRevocableSession: (user: ParseUser, options: RequestOptions) => Promise,
  linkWith: (user: ParseUser, authData: AuthData) => Promise,
  removeUserFromDisk: () => Promise,
  verifyPassword: (username: string, password: string, options: RequestOptions) => Promise,
  requestEmailVerification: (email: string, options: RequestOptions) => Promise,
};*/ /*:: type HooksController = {
  get: (type: string, functionName?: string, triggerName?: string) => Promise,
  create: (hook: mixed) => Promise,
  delete: (hook: mixed) => Promise,
  update: (hook: mixed) => Promise,
  send: (method: string, path: string, body?: mixed) => Promise,
};*/ /*:: type WebSocketController = {
  onopen: () => void,
  onmessage: (message: any) => void,
  onclose: () => void,
  onerror: (error: any) => void,
  send: (data: any) => void,
  close: () => void,
};*/ /*:: type Config = {
  AnalyticsController?: AnalyticsController,
  CloudController?: CloudController,
  ConfigController?: ConfigController,
  FileController?: FileController,
  InstallationController?: InstallationController,
  ObjectController?: ObjectController,
  ObjectStateController?: ObjectStateController,
  PushController?: PushController,
  QueryController?: QueryController,
  RESTController?: RESTController,
  SchemaController?: SchemaController,
  SessionController?: SessionController,
  StorageController?: StorageController,
  LocalDatastoreController?: LocalDatastoreController,
  UserController?: UserController,
  HooksController?: HooksController,
  WebSocketController?: WebSocketController,
};*/ var $523712883a269370$var$config = {
    // Defaults
    IS_NODE: typeof $4TNnu !== "undefined" && !!$4TNnu.versions && !!$4TNnu.versions.node && !$4TNnu.versions.electron,
    REQUEST_ATTEMPT_LIMIT: 5,
    REQUEST_BATCH_SIZE: 20,
    REQUEST_HEADERS: {},
    SERVER_URL: "https://api.parse.com/1",
    SERVER_AUTH_TYPE: null,
    SERVER_AUTH_TOKEN: null,
    LIVEQUERY_SERVER_URL: null,
    ENCRYPTED_KEY: null,
    VERSION: "js3.5.1",
    APPLICATION_ID: null,
    JAVASCRIPT_KEY: null,
    MASTER_KEY: null,
    USE_MASTER_KEY: false,
    PERFORM_USER_REWRITE: true,
    FORCE_REVOCABLE_SESSION: false,
    ENCRYPTED_USER: false,
    IDEMPOTENCY: false,
    ALLOW_CUSTOM_OBJECT_ID: false
};
function $523712883a269370$var$requireMethods(name, methods, controller) {
    (0, $523712883a269370$var$_forEach.default)(methods).call(methods, function(func) {
        if (typeof controller[func] !== "function") {
            var _context;
            throw new Error((0, $523712883a269370$var$_concat.default)(_context = "".concat(name, " must implement ")).call(_context, func, "()"));
        }
    });
}
module.exports = {
    get: function(key) /*: any*/ {
        if ($523712883a269370$var$config.hasOwnProperty(key)) return $523712883a269370$var$config[key];
        throw new Error("Configuration key not found: " + key);
    },
    set: function(key, value) /*: void*/ {
        $523712883a269370$var$config[key] = value;
    },
    /* Specialized Controller Setters/Getters */ setAnalyticsController: function(controller) {
        $523712883a269370$var$requireMethods("AnalyticsController", [
            "track"
        ], controller);
        $523712883a269370$var$config["AnalyticsController"] = controller;
    },
    getAnalyticsController: function() /*: AnalyticsController*/ {
        return $523712883a269370$var$config["AnalyticsController"];
    },
    setCloudController: function(controller) {
        $523712883a269370$var$requireMethods("CloudController", [
            "run",
            "getJobsData",
            "startJob"
        ], controller);
        $523712883a269370$var$config["CloudController"] = controller;
    },
    getCloudController: function() /*: CloudController*/ {
        return $523712883a269370$var$config["CloudController"];
    },
    setConfigController: function(controller) {
        $523712883a269370$var$requireMethods("ConfigController", [
            "current",
            "get",
            "save"
        ], controller);
        $523712883a269370$var$config["ConfigController"] = controller;
    },
    getConfigController: function() /*: ConfigController*/ {
        return $523712883a269370$var$config["ConfigController"];
    },
    setCryptoController: function(controller) {
        $523712883a269370$var$requireMethods("CryptoController", [
            "encrypt",
            "decrypt"
        ], controller);
        $523712883a269370$var$config["CryptoController"] = controller;
    },
    getCryptoController: function() /*: CryptoController*/ {
        return $523712883a269370$var$config["CryptoController"];
    },
    setFileController: function(controller) {
        $523712883a269370$var$requireMethods("FileController", [
            "saveFile",
            "saveBase64"
        ], controller);
        $523712883a269370$var$config["FileController"] = controller;
    },
    getFileController: function() /*: FileController*/ {
        return $523712883a269370$var$config["FileController"];
    },
    setInstallationController: function(controller) {
        $523712883a269370$var$requireMethods("InstallationController", [
            "currentInstallationId"
        ], controller);
        $523712883a269370$var$config["InstallationController"] = controller;
    },
    getInstallationController: function() /*: InstallationController*/ {
        return $523712883a269370$var$config["InstallationController"];
    },
    setObjectController: function(controller) {
        $523712883a269370$var$requireMethods("ObjectController", [
            "save",
            "fetch",
            "destroy"
        ], controller);
        $523712883a269370$var$config["ObjectController"] = controller;
    },
    getObjectController: function() /*: ObjectController*/ {
        return $523712883a269370$var$config["ObjectController"];
    },
    setObjectStateController: function(controller) {
        $523712883a269370$var$requireMethods("ObjectStateController", [
            "getState",
            "initializeState",
            "removeState",
            "getServerData",
            "setServerData",
            "getPendingOps",
            "setPendingOp",
            "pushPendingState",
            "popPendingState",
            "mergeFirstPendingState",
            "getObjectCache",
            "estimateAttribute",
            "estimateAttributes",
            "commitServerChanges",
            "enqueueTask",
            "clearAllState"
        ], controller);
        $523712883a269370$var$config["ObjectStateController"] = controller;
    },
    getObjectStateController: function() /*: ObjectStateController*/ {
        return $523712883a269370$var$config["ObjectStateController"];
    },
    setPushController: function(controller) {
        $523712883a269370$var$requireMethods("PushController", [
            "send"
        ], controller);
        $523712883a269370$var$config["PushController"] = controller;
    },
    getPushController: function() /*: PushController*/ {
        return $523712883a269370$var$config["PushController"];
    },
    setQueryController: function(controller) {
        $523712883a269370$var$requireMethods("QueryController", [
            "find",
            "aggregate"
        ], controller);
        $523712883a269370$var$config["QueryController"] = controller;
    },
    getQueryController: function() /*: QueryController*/ {
        return $523712883a269370$var$config["QueryController"];
    },
    setRESTController: function(controller) {
        $523712883a269370$var$requireMethods("RESTController", [
            "request",
            "ajax"
        ], controller);
        $523712883a269370$var$config["RESTController"] = controller;
    },
    getRESTController: function() /*: RESTController*/ {
        return $523712883a269370$var$config["RESTController"];
    },
    setSchemaController: function(controller) {
        $523712883a269370$var$requireMethods("SchemaController", [
            "get",
            "create",
            "update",
            "delete",
            "send",
            "purge"
        ], controller);
        $523712883a269370$var$config["SchemaController"] = controller;
    },
    getSchemaController: function() /*: SchemaController*/ {
        return $523712883a269370$var$config["SchemaController"];
    },
    setSessionController: function(controller) {
        $523712883a269370$var$requireMethods("SessionController", [
            "getSession"
        ], controller);
        $523712883a269370$var$config["SessionController"] = controller;
    },
    getSessionController: function() /*: SessionController*/ {
        return $523712883a269370$var$config["SessionController"];
    },
    setStorageController: function(controller) {
        if (controller.async) $523712883a269370$var$requireMethods("An async StorageController", [
            "getItemAsync",
            "setItemAsync",
            "removeItemAsync",
            "getAllKeysAsync"
        ], controller);
        else $523712883a269370$var$requireMethods("A synchronous StorageController", [
            "getItem",
            "setItem",
            "removeItem",
            "getAllKeys"
        ], controller);
        $523712883a269370$var$config["StorageController"] = controller;
    },
    setLocalDatastoreController: function(controller) {
        $523712883a269370$var$requireMethods("LocalDatastoreController", [
            "pinWithName",
            "fromPinWithName",
            "unPinWithName",
            "getAllContents",
            "clear"
        ], controller);
        $523712883a269370$var$config["LocalDatastoreController"] = controller;
    },
    getLocalDatastoreController: function() /*: LocalDatastoreController*/ {
        return $523712883a269370$var$config["LocalDatastoreController"];
    },
    setLocalDatastore: function(store) {
        $523712883a269370$var$config["LocalDatastore"] = store;
    },
    getLocalDatastore: function() {
        return $523712883a269370$var$config["LocalDatastore"];
    },
    getStorageController: function() /*: StorageController*/ {
        return $523712883a269370$var$config["StorageController"];
    },
    setAsyncStorage: function(storage) {
        $523712883a269370$var$config["AsyncStorage"] = storage;
    },
    getAsyncStorage: function() {
        return $523712883a269370$var$config["AsyncStorage"];
    },
    setWebSocketController: function(controller) {
        $523712883a269370$var$config["WebSocketController"] = controller;
    },
    getWebSocketController: function() /*: WebSocketController*/ {
        return $523712883a269370$var$config["WebSocketController"];
    },
    setUserController: function(controller) {
        $523712883a269370$var$requireMethods("UserController", [
            "setCurrentUser",
            "currentUser",
            "currentUserAsync",
            "signUp",
            "logIn",
            "become",
            "logOut",
            "me",
            "requestPasswordReset",
            "upgradeToRevocableSession",
            "requestEmailVerification",
            "verifyPassword",
            "linkWith"
        ], controller);
        $523712883a269370$var$config["UserController"] = controller;
    },
    getUserController: function() /*: UserController*/ {
        return $523712883a269370$var$config["UserController"];
    },
    setLiveQueryController: function(controller) {
        $523712883a269370$var$requireMethods("LiveQueryController", [
            "setDefaultLiveQueryClient",
            "getDefaultLiveQueryClient",
            "_clearCachedDefaultClient"
        ], controller);
        $523712883a269370$var$config["LiveQueryController"] = controller;
    },
    getLiveQueryController: function() /*: any*/ {
        return $523712883a269370$var$config["LiveQueryController"];
    },
    setHooksController: function(controller) {
        $523712883a269370$var$requireMethods("HooksController", [
            "create",
            "get",
            "update",
            "remove"
        ], controller);
        $523712883a269370$var$config["HooksController"] = controller;
    },
    getHooksController: function() /*: HooksController*/ {
        return $523712883a269370$var$config["HooksController"];
    }
};

});

parcelRequire.register("gloAc", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be61ad28250c80b9$var$canBeSerialized;

var $be61ad28250c80b9$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $be61ad28250c80b9$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $be61ad28250c80b9$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $be61ad28250c80b9$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $be61ad28250c80b9$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $be61ad28250c80b9$var$canBeSerialized(obj) /*: boolean*/ {
    if (!(obj instanceof $be61ad28250c80b9$var$_ParseObject.default)) return true;
    var attributes = obj.attributes;
    for(var attr in attributes){
        var val = attributes[attr];
        if (!$be61ad28250c80b9$var$canBeSerializedHelper(val)) return false;
    }
    return true;
}
function $be61ad28250c80b9$var$canBeSerializedHelper(value) /*: boolean*/ {
    if ((0, $be61ad28250c80b9$var$_typeof2.default)(value) !== "object") return true;
    if (value instanceof $be61ad28250c80b9$var$_ParseRelation.default) return true;
    if (value instanceof $be61ad28250c80b9$var$_ParseObject.default) return !!value.id;
    if (value instanceof $be61ad28250c80b9$var$_ParseFile.default) {
        if (value.url()) return true;
        return false;
    }
    if ((0, $be61ad28250c80b9$var$_isArray.default)(value)) {
        for(var i = 0; i < value.length; i++){
            if (!$be61ad28250c80b9$var$canBeSerializedHelper(value[i])) return false;
        }
        return true;
    }
    for(var k in value){
        if (!$be61ad28250c80b9$var$canBeSerializedHelper(value[k])) return false;
    }
    return true;
}

});
parcelRequire.register("59JWU", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $dLJtR = parcelRequire("dLJtR");

var $fgRng = parcelRequire("fgRng");

var $dzKYE = parcelRequire("dzKYE");

var $i3o6i = parcelRequire("i3o6i");

var $3bLGW = parcelRequire("3bLGW");



var $4wehD = parcelRequire("4wehD");


var $dQJQf = parcelRequire("dQJQf");



var $kOp5W = parcelRequire("kOp5W");

var $jQ6K5 = parcelRequire("jQ6K5");

var $4i3Tl = parcelRequire("4i3Tl");

var $iDZ3d = parcelRequire("iDZ3d");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c116f8917d53f2a$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $3c116f8917d53f2a$var$_slicedToArray2 = $iHLHC((parcelRequire("ccwCe")));

var $3c116f8917d53f2a$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $3c116f8917d53f2a$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $3c116f8917d53f2a$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $3c116f8917d53f2a$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $3c116f8917d53f2a$var$_asyncToGenerator2 = $iHLHC((parcelRequire("kkHAR")));

var $3c116f8917d53f2a$var$_slice = $iHLHC((parcelRequire("a1TrC")));

var $3c116f8917d53f2a$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $3c116f8917d53f2a$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $3c116f8917d53f2a$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $3c116f8917d53f2a$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $3c116f8917d53f2a$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
function $3c116f8917d53f2a$var$ownKeys(object, enumerableOnly) {
    var keys = (parcelRequire("2QmZN"))(object);
    if ($3bLGW) {
        var symbols = $3bLGW(object);
        enumerableOnly && (symbols = $i3o6i(symbols).call(symbols, function(sym) {
            return $dzKYE(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3c116f8917d53f2a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var _context10, _context11;
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? (parcelRequire("gW71a"))(_context10 = $3c116f8917d53f2a$var$ownKeys(Object(source), !0)).call(_context10, function(key) {
            (0, $3c116f8917d53f2a$var$_defineProperty2.default)(target, key, source[key]);
        }) : $fgRng ? $dLJtR(target, $fgRng(source)) : (parcelRequire("gW71a"))(_context11 = $3c116f8917d53f2a$var$ownKeys(Object(source))).call(_context11, function(key) {
            $4i3Tl(target, key, $dzKYE(source, key));
        });
    }
    return target;
}
function $3c116f8917d53f2a$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $3c116f8917d53f2a$var$_regeneratorRuntime = function() {
        return exports1;
    };
    var exports1 = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $iDZ3d ? $iDZ3d : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $4i3Tl(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $jQ6K5(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports1.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $kOp5W, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $jQ6K5(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context8;
        (parcelRequire("gW71a"))(_context8 = [
            "next",
            "throw",
            "return"
        ]).call(_context8, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == (parcelRequire("6iqUa"))(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], (parcelRequire("gW71a"))(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports1.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports1.mark = function(genFun) {
        return $dQJQf ? $dQJQf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $jQ6K5(Gp), genFun;
    }, exports1.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports1.AsyncIterator = AsyncIterator, exports1.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("iH0WI")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports1.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports1.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $4wehD(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports1.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context9;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, (parcelRequire("gW71a"))(_context9 = this.tryEntries).call(_context9, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+(parcelRequire("a1TrC"))(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports1;
}

var $6ilM0 = parcelRequire("6ilM0");
var $3c116f8917d53f2a$require$ParseError = $6ilM0.default;
var $3c116f8917d53f2a$var$XHR = null;
if (typeof XMLHttpRequest !== "undefined") $3c116f8917d53f2a$var$XHR = XMLHttpRequest;
/*:: type Base64 = { base64: string };*/ /*:: type Uri = { uri: string };*/ /*:: type FileData = Array<number> | Base64 | Blob | Uri;*/ /*:: export type FileSource =
  | {
      format: 'file',
      file: Blob,
      type: string,
    }
  | {
      format: 'base64',
      base64: string,
      type: string,
    }
  | {
      format: 'uri',
      uri: string,
      type: string,
    };*/ function $3c116f8917d53f2a$var$b64Digit(number) /*: string*/ {
    if (number < 26) return String.fromCharCode(65 + number);
    if (number < 52) return String.fromCharCode(97 + (number - 26));
    if (number < 62) return String.fromCharCode(48 + (number - 52));
    if (number === 62) return "+";
    if (number === 63) return "/";
    throw new TypeError("Tried to encode large digit " + number + " in base64.");
}
/**
 * A Parse.File is a local representation of a file that is saved to the Parse
 * cloud.
 *
 * @alias Parse.File
 */ var $3c116f8917d53f2a$var$ParseFile = /*#__PURE__*/ function() {
    /**
   * @param name {String} The file's name. This will be prefixed by a unique
   *     value once the file has finished saving. The file name must begin with
   *     an alphanumeric character, and consist of alphanumeric characters,
   *     periods, spaces, underscores, or dashes.
   * @param data {Array} The data for the file, as either:
   *     1. an Array of byte value Numbers, or
   *     2. an Object like { base64: "..." } with a base64-encoded String.
   *     3. an Object like { uri: "..." } with a uri String.
   *     4. a File object selected with a file upload control. (3) only works
   *        in Firefox 3.6+, Safari 6.0.2+, Chrome 7+, and IE 10+.
   *        For example:
   * <pre>
   * var fileUploadControl = $("#profilePhotoFileUpload")[0];
   * if (fileUploadControl.files.length > 0) {
   *   var file = fileUploadControl.files[0];
   *   var name = "photo.jpg";
   *   var parseFile = new Parse.File(name, file);
   *   parseFile.save().then(function() {
   *     // The file has been saved to Parse.
   *   }, function(error) {
   *     // The file either could not be read, or could not be saved to Parse.
   *   });
   * }</pre>
   * @param type {String} Optional Content-Type header to use for the file. If
   *     this is omitted, the content type will be inferred from the name's
   *     extension.
   * @param metadata {Object} Optional key value pairs to be stored with file object
   * @param tags {Object} Optional key value pairs to be stored with file object
   */ function ParseFile(name, data, type, metadata, tags) {
        (0, $3c116f8917d53f2a$var$_classCallCheck2.default)(this, ParseFile);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_name", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_url", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_source", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_previousSave", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_data", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_requestTask", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_metadata", void 0);
        (0, $3c116f8917d53f2a$var$_defineProperty2.default)(this, "_tags", void 0);
        var specifiedType = type || "";
        this._name = name;
        this._metadata = metadata || {};
        this._tags = tags || {};
        if (data !== undefined) {
            if ((0, $3c116f8917d53f2a$var$_isArray.default)(data)) {
                this._data = ParseFile.encodeBase64(data);
                this._source = {
                    format: "base64",
                    base64: this._data,
                    type: specifiedType
                };
            } else if (typeof Blob !== "undefined" && data instanceof Blob) this._source = {
                format: "file",
                file: data,
                type: specifiedType
            };
            else if (data && typeof data.uri === "string" && data.uri !== undefined) this._source = {
                format: "uri",
                uri: data.uri,
                type: specifiedType
            };
            else if (data && typeof data.base64 === "string") {
                var _context, _context2, _context3;
                var base64 = (0, $3c116f8917d53f2a$var$_slice.default)(_context = data.base64.split(",")).call(_context, -1)[0];
                var dataType = specifiedType || (0, $3c116f8917d53f2a$var$_slice.default)(_context2 = (0, $3c116f8917d53f2a$var$_slice.default)(_context3 = data.base64.split(";")).call(_context3, 0, 1)[0].split(":")).call(_context2, 1, 2)[0] || "text/plain";
                this._data = base64;
                this._source = {
                    format: "base64",
                    base64: base64,
                    type: dataType
                };
            } else throw new TypeError("Cannot create a Parse.File with that data.");
        }
    }
    /**
   * Return the data for the file, downloading it if not already present.
   * Data is present if initialized with Byte Array, Base64 or Saved with Uri.
   * Data is cleared if saved with File object selected with a file upload control
   *
   * @returns {Promise} Promise that is resolve with base64 data
   */ (0, $3c116f8917d53f2a$var$_createClass2.default)(ParseFile, [
        {
            key: "getData",
            value: function() {
                var _getData = (0, $3c116f8917d53f2a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3c116f8917d53f2a$var$_regeneratorRuntime().mark(function _callee() {
                    var _this = this;
                    var options, controller, result;
                    return $3c116f8917d53f2a$var$_regeneratorRuntime().wrap(function(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (!this._data) {
                                    _context4.next = 2;
                                    break;
                                }
                                return _context4.abrupt("return", this._data);
                            case 2:
                                if (this._url) {
                                    _context4.next = 4;
                                    break;
                                }
                                throw new Error("Cannot retrieve data for unsaved ParseFile.");
                            case 4:
                                options = {
                                    requestTask: function(task) {
                                        return _this._requestTask = task;
                                    }
                                };
                                controller = $3c116f8917d53f2a$var$_CoreManager.default.getFileController();
                                _context4.next = 8;
                                return controller.download(this._url, options);
                            case 8:
                                result = _context4.sent;
                                this._data = result.base64;
                                return _context4.abrupt("return", this._data);
                            case 11:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee, this);
                }));
                function getData() {
                    return _getData.apply(this, arguments);
                }
                return getData;
            }()
        },
        {
            key: "name",
            value: function() /*: string*/ {
                return this._name;
            }
        },
        {
            key: "url",
            value: function(options) /*: ?string*/ {
                options = options || {};
                if (!this._url) return;
                if (options.forceSecure) return this._url.replace(/^http:\/\//i, "https://");
                else return this._url;
            }
        },
        {
            key: "metadata",
            value: function() /*: Object*/ {
                return this._metadata;
            }
        },
        {
            key: "tags",
            value: function() /*: Object*/ {
                return this._tags;
            }
        },
        {
            key: "save",
            value: function(options) {
                var _this2 = this;
                options = options || {};
                options.requestTask = function(task) {
                    return _this2._requestTask = task;
                };
                options.metadata = this._metadata;
                options.tags = this._tags;
                var controller = $3c116f8917d53f2a$var$_CoreManager.default.getFileController();
                if (!this._previousSave) {
                    if (this._source.format === "file") this._previousSave = controller.saveFile(this._name, this._source, options).then(function(res) {
                        _this2._name = res.name;
                        _this2._url = res.url;
                        _this2._data = null;
                        _this2._requestTask = null;
                        return _this2;
                    });
                    else if (this._source.format === "uri") this._previousSave = controller.download(this._source.uri, options).then(function(result) {
                        if (!(result && result.base64)) return {};
                        var newSource = {
                            format: "base64",
                            base64: result.base64,
                            type: result.contentType
                        };
                        _this2._data = result.base64;
                        _this2._requestTask = null;
                        return controller.saveBase64(_this2._name, newSource, options);
                    }).then(function(res) {
                        _this2._name = res.name;
                        _this2._url = res.url;
                        _this2._requestTask = null;
                        return _this2;
                    });
                    else this._previousSave = controller.saveBase64(this._name, this._source, options).then(function(res) {
                        _this2._name = res.name;
                        _this2._url = res.url;
                        _this2._requestTask = null;
                        return _this2;
                    });
                }
                if (this._previousSave) return this._previousSave;
            }
        },
        {
            key: "cancel",
            value: function() {
                if (this._requestTask && typeof this._requestTask.abort === "function") this._requestTask.abort();
                this._requestTask = null;
            }
        },
        {
            key: "destroy",
            value: function() {
                var _this3 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this._name) throw new $3c116f8917d53f2a$require$ParseError($3c116f8917d53f2a$require$ParseError.FILE_DELETE_UNNAMED_ERROR, "Cannot delete an unnamed file.");
                var destroyOptions = {
                    useMasterKey: true
                };
                if (options.hasOwnProperty("useMasterKey")) destroyOptions.useMasterKey = options.useMasterKey;
                var controller = $3c116f8917d53f2a$var$_CoreManager.default.getFileController();
                return controller.deleteFile(this._name, destroyOptions).then(function() {
                    _this3._data = null;
                    _this3._requestTask = null;
                    return _this3;
                });
            }
        },
        {
            key: "toJSON",
            value: function() /*: { name: ?string, url: ?string }*/ {
                return {
                    __type: "File",
                    name: this._name,
                    url: this._url
                };
            }
        },
        {
            key: "equals",
            value: function(other) /*: boolean*/ {
                if (this === other) return true;
                 // Unsaved Files are never equal, since they will be saved to different URLs
                return other instanceof ParseFile && this.name() === other.name() && this.url() === other.url() && typeof this.url() !== "undefined";
            }
        },
        {
            key: "setMetadata",
            value: function(metadata) {
                var _this4 = this;
                if (metadata && (0, $3c116f8917d53f2a$var$_typeof2.default)(metadata) === "object") {
                    var _context5;
                    (0, $3c116f8917d53f2a$var$_forEach.default)(_context5 = (0, $3c116f8917d53f2a$var$_keys.default)(metadata)).call(_context5, function(key) {
                        _this4.addMetadata(key, metadata[key]);
                    });
                }
            }
        },
        {
            key: "addMetadata",
            value: function(key, value) {
                if (typeof key === "string") this._metadata[key] = value;
            }
        },
        {
            key: "setTags",
            value: function(tags) {
                var _this5 = this;
                if (tags && (0, $3c116f8917d53f2a$var$_typeof2.default)(tags) === "object") {
                    var _context6;
                    (0, $3c116f8917d53f2a$var$_forEach.default)(_context6 = (0, $3c116f8917d53f2a$var$_keys.default)(tags)).call(_context6, function(key) {
                        _this5.addTag(key, tags[key]);
                    });
                }
            }
        },
        {
            key: "addTag",
            value: function(key, value) {
                if (typeof key === "string") this._tags[key] = value;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function(obj) /*: ParseFile*/ {
                if (obj.__type !== "File") throw new TypeError("JSON object does not represent a ParseFile");
                var file = new ParseFile(obj.name);
                file._url = obj.url;
                return file;
            }
        },
        {
            key: "encodeBase64",
            value: function(bytes) /*: string*/ {
                var chunks = [];
                chunks.length = Math.ceil(bytes.length / 3);
                for(var i = 0; i < chunks.length; i++){
                    var b1 = bytes[i * 3];
                    var b2 = bytes[i * 3 + 1] || 0;
                    var b3 = bytes[i * 3 + 2] || 0;
                    var has2 = i * 3 + 1 < bytes.length;
                    var has3 = i * 3 + 2 < bytes.length;
                    chunks[i] = [
                        $3c116f8917d53f2a$var$b64Digit(b1 >> 2 & 0x3f),
                        $3c116f8917d53f2a$var$b64Digit(b1 << 4 & 0x30 | b2 >> 4 & 0x0f),
                        has2 ? $3c116f8917d53f2a$var$b64Digit(b2 << 2 & 0x3c | b3 >> 6 & 0x03) : "=",
                        has3 ? $3c116f8917d53f2a$var$b64Digit(b3 & 0x3f) : "="
                    ].join("");
                }
                return chunks.join("");
            }
        }
    ]);
    return ParseFile;
}();
var $3c116f8917d53f2a$var$DefaultController = {
    saveFile: function() {
        var _saveFile = (0, $3c116f8917d53f2a$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3c116f8917d53f2a$var$_regeneratorRuntime().mark(function _callee2(name, source, options) {
            var base64Data, _base64Data$split, _base64Data$split2, first, second, data, newSource;
            return $3c116f8917d53f2a$var$_regeneratorRuntime().wrap(function _callee2$(_context7) {
                while(true)switch(_context7.prev = _context7.next){
                    case 0:
                        if (!(source.format !== "file")) {
                            _context7.next = 2;
                            break;
                        }
                        throw new Error("saveFile can only be used with File-type sources.");
                    case 2:
                        _context7.next = 4;
                        return new $3c116f8917d53f2a$var$_promise.default(function(res, rej) {
                            // eslint-disable-next-line no-undef
                            var reader = new FileReader();
                            reader.onload = function() {
                                return res(reader.result);
                            };
                            reader.onerror = function(error) {
                                return rej(error);
                            };
                            reader.readAsDataURL(source.file);
                        });
                    case 4:
                        base64Data = _context7.sent; // we only want the data after the comma
                        // For example: "data:application/pdf;base64,JVBERi0xLjQKJ..." we would only want "JVBERi0xLjQKJ..."
                        _base64Data$split = base64Data.split(","), _base64Data$split2 = (0, $3c116f8917d53f2a$var$_slicedToArray2.default)(_base64Data$split, 2), first = _base64Data$split2[0], second = _base64Data$split2[1]; // in the event there is no 'data:application/pdf;base64,' at the beginning of the base64 string
                        // use the entire string instead
                        data = second ? second : first;
                        newSource = {
                            format: "base64",
                            base64: data,
                            type: source.type || (source.file ? source.file.type : null)
                        };
                        _context7.next = 10;
                        return $3c116f8917d53f2a$var$DefaultController.saveBase64(name, newSource, options);
                    case 10:
                        return _context7.abrupt("return", _context7.sent);
                    case 11:
                    case "end":
                        return _context7.stop();
                }
            }, _callee2);
        }));
        function saveFile(_x, _x2, _x3) {
            return _saveFile.apply(this, arguments);
        }
        return saveFile;
    }(),
    saveBase64: function saveBase64(name, source, options) {
        if (source.format !== "base64") throw new Error("saveBase64 can only be used with Base64-type sources.");
        var data = {
            base64: source.base64,
            fileData: {
                metadata: $3c116f8917d53f2a$var$_objectSpread({}, options.metadata),
                tags: $3c116f8917d53f2a$var$_objectSpread({}, options.tags)
            }
        };
        delete options.metadata;
        delete options.tags;
        if (source.type) data._ContentType = source.type;
        var path = "files/" + name;
        return $3c116f8917d53f2a$var$_CoreManager.default.getRESTController().request("POST", path, data, options);
    },
    download: function download(uri, options) {
        if ($3c116f8917d53f2a$var$XHR) return this.downloadAjax(uri, options);
        else return $3c116f8917d53f2a$var$_promise.default.reject("Cannot make a request: No definition of XMLHttpRequest was found.");
    },
    downloadAjax: function downloadAjax(uri, options) {
        return new $3c116f8917d53f2a$var$_promise.default(function(resolve, reject) {
            var xhr = new $3c116f8917d53f2a$var$XHR();
            xhr.open("GET", uri, true);
            xhr.responseType = "arraybuffer";
            xhr.onerror = function(e) {
                reject(e);
            };
            xhr.onreadystatechange = function() {
                if (xhr.readyState !== xhr.DONE) return;
                if (!this.response) return resolve({});
                var bytes = new Uint8Array(this.response);
                resolve({
                    base64: $3c116f8917d53f2a$var$ParseFile.encodeBase64(bytes),
                    contentType: xhr.getResponseHeader("content-type")
                });
            };
            options.requestTask(xhr);
            xhr.send();
        });
    },
    deleteFile: function deleteFile(name, options) {
        var headers = {
            "X-Parse-Application-ID": $3c116f8917d53f2a$var$_CoreManager.default.get("APPLICATION_ID")
        };
        if (options.useMasterKey) headers["X-Parse-Master-Key"] = $3c116f8917d53f2a$var$_CoreManager.default.get("MASTER_KEY");
        var url = $3c116f8917d53f2a$var$_CoreManager.default.get("SERVER_URL");
        if (url[url.length - 1] !== "/") url += "/";
        url += "files/" + name;
        return $3c116f8917d53f2a$var$_CoreManager.default.getRESTController().ajax("DELETE", url, "", headers).catch(function(response) {
            // TODO: return JSON object in server
            if (!response || response === "SyntaxError: Unexpected end of JSON input") return $3c116f8917d53f2a$var$_promise.default.resolve();
            else return $3c116f8917d53f2a$var$_CoreManager.default.getRESTController().handleError(response);
        });
    },
    _setXHR: function _setXHR(xhr) {
        $3c116f8917d53f2a$var$XHR = xhr;
    },
    _getXHR: function _getXHR() {
        return $3c116f8917d53f2a$var$XHR;
    }
};
$3c116f8917d53f2a$var$_CoreManager.default.setFileController($3c116f8917d53f2a$var$DefaultController);
var $3c116f8917d53f2a$var$_default = $3c116f8917d53f2a$var$ParseFile;
module.exports.default = $3c116f8917d53f2a$var$_default;
module.exports.b64Digit = $3c116f8917d53f2a$var$b64Digit;

});
parcelRequire.register("ccwCe", function(module, exports) {

var $5liP5 = parcelRequire("5liP5");

var $bJnpF = parcelRequire("bJnpF");

var $8qDrx = parcelRequire("8qDrx");

var $6agai = parcelRequire("6agai");
function $8e1fe7d3a4168a12$var$_slicedToArray(arr, i) {
    return $5liP5(arr) || $bJnpF(arr, i) || $8qDrx(arr, i) || $6agai();
}
module.exports = $8e1fe7d3a4168a12$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("5liP5", function(module, exports) {

var $6xtVb = parcelRequire("6xtVb");
function $3e3d83c4f4407275$var$_arrayWithHoles(arr) {
    if ($6xtVb(arr)) return arr;
}
module.exports = $3e3d83c4f4407275$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("6xtVb", function(module, exports) {

module.exports = (parcelRequire("3dzeb"));

});
parcelRequire.register("3dzeb", function(module, exports) {

module.exports = (parcelRequire("3VDop"));

});
parcelRequire.register("3VDop", function(module, exports) {

var $g0lAq = parcelRequire("g0lAq");
module.exports = $g0lAq;

});
parcelRequire.register("g0lAq", function(module, exports) {

var $4hHz8 = parcelRequire("4hHz8");
module.exports = $4hHz8;

});





parcelRequire.register("bJnpF", function(module, exports) {

var $3nM7d = parcelRequire("3nM7d");

var $iG2ur = parcelRequire("iG2ur");
function $88a60f03da8c3ee4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof $3nM7d !== "undefined" && $iG2ur(arr) || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
module.exports = $88a60f03da8c3ee4$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("8qDrx", function(module, exports) {

var $i0N08 = parcelRequire("i0N08");

var $7VEQP = parcelRequire("7VEQP");

var $bdV1f = parcelRequire("bdV1f");
function $622f590ba4eafd44$var$_unsupportedIterableToArray(o, minLen) {
    var _context;
    if (!o) return;
    if (typeof o === "string") return $bdV1f(o, minLen);
    var n = $i0N08(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $7VEQP(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bdV1f(o, minLen);
}
module.exports = $622f590ba4eafd44$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("i0N08", function(module, exports) {

module.exports = (parcelRequire("cVo77"));

});
parcelRequire.register("cVo77", function(module, exports) {

module.exports = (parcelRequire("eCBSO"));

});
parcelRequire.register("eCBSO", function(module, exports) {

var $c8NGO = parcelRequire("c8NGO");
module.exports = $c8NGO;

});
parcelRequire.register("c8NGO", function(module, exports) {

var $loUO6 = parcelRequire("loUO6");
module.exports = $loUO6;

});




parcelRequire.register("7VEQP", function(module, exports) {

module.exports = (parcelRequire("lXxcQ"));

});
parcelRequire.register("lXxcQ", function(module, exports) {

module.exports = (parcelRequire("fegOw"));

});
parcelRequire.register("fegOw", function(module, exports) {

var $9zhiu = parcelRequire("9zhiu");
module.exports = $9zhiu;

});
parcelRequire.register("9zhiu", function(module, exports) {

var $9O8w2 = parcelRequire("9O8w2");
module.exports = $9O8w2;

});




parcelRequire.register("bdV1f", function(module, exports) {
function $82bd236b0b4ddf60$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $82bd236b0b4ddf60$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("6agai", function(module, exports) {
function $47d03746bc20dd2d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $47d03746bc20dd2d$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("967gW", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69fa50bab9964798$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $69fa50bab9964798$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $69fa50bab9964798$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $69fa50bab9964798$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $3l0Qd = parcelRequire("3l0Qd");

var $69fa50bab9964798$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $69fa50bab9964798$var$_ParseQuery = $iHLHC((parcelRequire("4FVCr")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Creates a new Relation for the given parent object and key. This
 * constructor should rarely be used directly, but rather created by
 * Parse.Object.relation.
 *
 * <p>
 * A class that is used to access all of the children of a many-to-many
 * relationship.  Each instance of Parse.Relation is associated with a
 * particular parent object and key.
 * </p>
 *
 * @alias Parse.Relation
 */ var $69fa50bab9964798$var$ParseRelation = /*#__PURE__*/ function() {
    /**
   * @param {Parse.Object} parent The parent of this relation.
   * @param {string} key The key for this relation on the parent.
   */ function ParseRelation(parent, key) {
        (0, $69fa50bab9964798$var$_classCallCheck2.default)(this, ParseRelation);
        (0, $69fa50bab9964798$var$_defineProperty2.default)(this, "parent", void 0);
        (0, $69fa50bab9964798$var$_defineProperty2.default)(this, "key", void 0);
        (0, $69fa50bab9964798$var$_defineProperty2.default)(this, "targetClassName", void 0);
        this.parent = parent;
        this.key = key;
        this.targetClassName = null;
    }
    /*
   * Makes sure that this relation has the right parent and key.
   */ (0, $69fa50bab9964798$var$_createClass2.default)(ParseRelation, [
        {
            key: "_ensureParentAndKey",
            value: function(parent, key) {
                this.key = this.key || key;
                if (this.key !== key) throw new Error("Internal Error. Relation retrieved from two different keys.");
                if (this.parent) {
                    if (this.parent.className !== parent.className) throw new Error("Internal Error. Relation retrieved from two different Objects.");
                    if (this.parent.id) {
                        if (this.parent.id !== parent.id) throw new Error("Internal Error. Relation retrieved from two different Objects.");
                    } else if (parent.id) this.parent = parent;
                } else this.parent = parent;
            }
        },
        {
            key: "add",
            value: function(objects) /*: ParseObject*/ {
                if (!(0, $69fa50bab9964798$var$_isArray.default)(objects)) objects = [
                    objects
                ];
                var change = new $3l0Qd.RelationOp(objects, []);
                var parent = this.parent;
                if (!parent) throw new Error("Cannot add to a Relation without a parent");
                if (objects.length === 0) return parent;
                parent.set(this.key, change);
                this.targetClassName = change._targetClassName;
                return parent;
            }
        },
        {
            key: "remove",
            value: function(objects) {
                if (!(0, $69fa50bab9964798$var$_isArray.default)(objects)) objects = [
                    objects
                ];
                var change = new $3l0Qd.RelationOp([], objects);
                if (!this.parent) throw new Error("Cannot remove from a Relation without a parent");
                if (objects.length === 0) return;
                this.parent.set(this.key, change);
                this.targetClassName = change._targetClassName;
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __type: 'Relation', className: ?string }*/ {
                return {
                    __type: "Relation",
                    className: this.targetClassName
                };
            }
        },
        {
            key: "query",
            value: function query() /*: ParseQuery*/ {
                var query;
                var parent = this.parent;
                if (!parent) throw new Error("Cannot construct a query for a Relation without a parent");
                if (!this.targetClassName) {
                    query = new $69fa50bab9964798$var$_ParseQuery.default(parent.className);
                    query._extraOptions.redirectClassNameForKey = this.key;
                } else query = new $69fa50bab9964798$var$_ParseQuery.default(this.targetClassName);
                query._addCondition("$relatedTo", "object", {
                    __type: "Pointer",
                    className: parent.className,
                    objectId: parent.id
                });
                query._addCondition("$relatedTo", "key", this.key);
                return query;
            }
        }
    ]);
    return ParseRelation;
}();
var $69fa50bab9964798$var$_default = $69fa50bab9964798$var$ParseRelation;
module.exports.default = $69fa50bab9964798$var$_default;

});
parcelRequire.register("3l0Qd", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");

var $oM1qX = parcelRequire("oM1qX");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.UnsetOp = module.exports.SetOp = module.exports.RemoveOp = module.exports.RelationOp = module.exports.Op = module.exports.IncrementOp = module.exports.AddUniqueOp = module.exports.AddOp = void 0;
module.exports.opFromJSON = $26e3fc4ccd45c3d4$var$opFromJSON;

var $26e3fc4ccd45c3d4$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $26e3fc4ccd45c3d4$var$_splice = $iHLHC((parcelRequire("aFg1C")));

var $26e3fc4ccd45c3d4$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $26e3fc4ccd45c3d4$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $26e3fc4ccd45c3d4$var$_assertThisInitialized2 = $iHLHC((parcelRequire("ePpfW")));

var $26e3fc4ccd45c3d4$var$_inherits2 = $iHLHC((parcelRequire("cNDsY")));

var $26e3fc4ccd45c3d4$var$_possibleConstructorReturn2 = $iHLHC((parcelRequire("1C8Dw")));

var $26e3fc4ccd45c3d4$var$_getPrototypeOf2 = $iHLHC((parcelRequire("kptbe")));

var $26e3fc4ccd45c3d4$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $26e3fc4ccd45c3d4$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $26e3fc4ccd45c3d4$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $26e3fc4ccd45c3d4$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $26e3fc4ccd45c3d4$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $26e3fc4ccd45c3d4$var$_arrayContainsObject = $iHLHC((parcelRequire("koRMr")));

var $26e3fc4ccd45c3d4$var$_decode = $iHLHC((parcelRequire("42E6z")));

var $26e3fc4ccd45c3d4$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $26e3fc4ccd45c3d4$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $26e3fc4ccd45c3d4$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));

var $26e3fc4ccd45c3d4$var$_unique = $iHLHC((parcelRequire("aoRXv")));
function $26e3fc4ccd45c3d4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $26e3fc4ccd45c3d4$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $26e3fc4ccd45c3d4$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $26e3fc4ccd45c3d4$var$_getPrototypeOf2.default)(this).constructor;
            result = $oM1qX(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $26e3fc4ccd45c3d4$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $26e3fc4ccd45c3d4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$oM1qX) return false;
    if ($oM1qX.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($oM1qX(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $26e3fc4ccd45c3d4$var$opFromJSON(json) /*: ?Op*/ {
    if (!json || !json.__op) return null;
    switch(json.__op){
        case "Delete":
            return new $26e3fc4ccd45c3d4$var$UnsetOp();
        case "Increment":
            return new $26e3fc4ccd45c3d4$var$IncrementOp(json.amount);
        case "Add":
            return new $26e3fc4ccd45c3d4$var$AddOp((0, $26e3fc4ccd45c3d4$var$_decode.default)(json.objects));
        case "AddUnique":
            return new $26e3fc4ccd45c3d4$var$AddUniqueOp((0, $26e3fc4ccd45c3d4$var$_decode.default)(json.objects));
        case "Remove":
            return new $26e3fc4ccd45c3d4$var$RemoveOp((0, $26e3fc4ccd45c3d4$var$_decode.default)(json.objects));
        case "AddRelation":
            var toAdd = (0, $26e3fc4ccd45c3d4$var$_decode.default)(json.objects);
            if (!(0, $26e3fc4ccd45c3d4$var$_isArray.default)(toAdd)) return new $26e3fc4ccd45c3d4$var$RelationOp([], []);
            return new $26e3fc4ccd45c3d4$var$RelationOp(toAdd, []);
        case "RemoveRelation":
            var toRemove = (0, $26e3fc4ccd45c3d4$var$_decode.default)(json.objects);
            if (!(0, $26e3fc4ccd45c3d4$var$_isArray.default)(toRemove)) return new $26e3fc4ccd45c3d4$var$RelationOp([], []);
            return new $26e3fc4ccd45c3d4$var$RelationOp([], toRemove);
        case "Batch":
            var _toAdd = [];
            var _toRemove = [];
            for(var i = 0; i < json.ops.length; i++){
                if (json.ops[i].__op === "AddRelation") _toAdd = (0, $26e3fc4ccd45c3d4$var$_concat.default)(_toAdd).call(_toAdd, (0, $26e3fc4ccd45c3d4$var$_decode.default)(json.ops[i].objects));
                else if (json.ops[i].__op === "RemoveRelation") _toRemove = (0, $26e3fc4ccd45c3d4$var$_concat.default)(_toRemove).call(_toRemove, (0, $26e3fc4ccd45c3d4$var$_decode.default)(json.ops[i].objects));
            }
            return new $26e3fc4ccd45c3d4$var$RelationOp(_toAdd, _toRemove);
    }
    return null;
}
var $26e3fc4ccd45c3d4$var$Op = /*#__PURE__*/ function() {
    function Op() {
        (0, $26e3fc4ccd45c3d4$var$_classCallCheck2.default)(this, Op);
    }
    (0, $26e3fc4ccd45c3d4$var$_createClass2.default)(Op, [
        {
            key: "applyTo",
            value: function() /*: mixed*/ {}
        },
        {
            key: "mergeWith",
            value: function() /*: ?Op*/ {}
        },
        {
            key: "toJSON",
            value: function() /*: mixed*/ {}
        }
    ]);
    return Op;
}();
module.exports.Op = $26e3fc4ccd45c3d4$var$Op;
var $26e3fc4ccd45c3d4$var$SetOp = /*#__PURE__*/ function(_Op) {
    (0, $26e3fc4ccd45c3d4$var$_inherits2.default)(SetOp, _Op);
    var _super = $26e3fc4ccd45c3d4$var$_createSuper(SetOp);
    function SetOp(value) {
        var _this;
        (0, $26e3fc4ccd45c3d4$var$_classCallCheck2.default)(this, SetOp);
        _this = _super.call(this);
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)((0, $26e3fc4ccd45c3d4$var$_assertThisInitialized2.default)(_this), "_value", void 0);
        _this._value = value;
        return _this;
    }
    (0, $26e3fc4ccd45c3d4$var$_createClass2.default)(SetOp, [
        {
            key: "applyTo",
            value: function() /*: mixed*/ {
                return this._value;
            }
        },
        {
            key: "mergeWith",
            value: function() /*: SetOp*/ {
                return new SetOp(this._value);
            }
        },
        {
            key: "toJSON",
            value: function(offline) {
                return (0, $26e3fc4ccd45c3d4$var$_encode.default)(this._value, false, true, undefined, offline);
            }
        }
    ]);
    return SetOp;
}($26e3fc4ccd45c3d4$var$Op);
module.exports.SetOp = $26e3fc4ccd45c3d4$var$SetOp;
var $26e3fc4ccd45c3d4$var$UnsetOp = /*#__PURE__*/ function(_Op2) {
    (0, $26e3fc4ccd45c3d4$var$_inherits2.default)(UnsetOp, _Op2);
    var _super2 = $26e3fc4ccd45c3d4$var$_createSuper(UnsetOp);
    function UnsetOp() {
        (0, $26e3fc4ccd45c3d4$var$_classCallCheck2.default)(this, UnsetOp);
        return _super2.apply(this, arguments);
    }
    (0, $26e3fc4ccd45c3d4$var$_createClass2.default)(UnsetOp, [
        {
            key: "applyTo",
            value: function() {
                return undefined;
            }
        },
        {
            key: "mergeWith",
            value: function() /*: UnsetOp*/ {
                return new UnsetOp();
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op: string }*/ {
                return {
                    __op: "Delete"
                };
            }
        }
    ]);
    return UnsetOp;
}($26e3fc4ccd45c3d4$var$Op);
module.exports.UnsetOp = $26e3fc4ccd45c3d4$var$UnsetOp;
var $26e3fc4ccd45c3d4$var$IncrementOp = /*#__PURE__*/ function(_Op3) {
    (0, $26e3fc4ccd45c3d4$var$_inherits2.default)(IncrementOp, _Op3);
    var _super3 = $26e3fc4ccd45c3d4$var$_createSuper(IncrementOp);
    function IncrementOp(amount) {
        var _this2;
        (0, $26e3fc4ccd45c3d4$var$_classCallCheck2.default)(this, IncrementOp);
        _this2 = _super3.call(this);
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)((0, $26e3fc4ccd45c3d4$var$_assertThisInitialized2.default)(_this2), "_amount", void 0);
        if (typeof amount !== "number") throw new TypeError("Increment Op must be initialized with a numeric amount.");
        _this2._amount = amount;
        return _this2;
    }
    (0, $26e3fc4ccd45c3d4$var$_createClass2.default)(IncrementOp, [
        {
            key: "applyTo",
            value: function(value) /*: number*/ {
                if (typeof value === "undefined") return this._amount;
                if (typeof value !== "number") throw new TypeError("Cannot increment a non-numeric value.");
                return this._amount + value;
            }
        },
        {
            key: "mergeWith",
            value: function(previous) /*: Op*/ {
                if (!previous) return this;
                if (previous instanceof $26e3fc4ccd45c3d4$var$SetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this.applyTo(previous._value));
                if (previous instanceof $26e3fc4ccd45c3d4$var$UnsetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this._amount);
                if (previous instanceof IncrementOp) return new IncrementOp(this.applyTo(previous._amount));
                throw new Error("Cannot merge Increment Op with the previous Op");
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op: string, amount: number }*/ {
                return {
                    __op: "Increment",
                    amount: this._amount
                };
            }
        }
    ]);
    return IncrementOp;
}($26e3fc4ccd45c3d4$var$Op);
module.exports.IncrementOp = $26e3fc4ccd45c3d4$var$IncrementOp;
var $26e3fc4ccd45c3d4$var$AddOp = /*#__PURE__*/ function(_Op4) {
    (0, $26e3fc4ccd45c3d4$var$_inherits2.default)(AddOp, _Op4);
    var _super4 = $26e3fc4ccd45c3d4$var$_createSuper(AddOp);
    function AddOp(value) {
        var _this3;
        (0, $26e3fc4ccd45c3d4$var$_classCallCheck2.default)(this, AddOp);
        _this3 = _super4.call(this);
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)((0, $26e3fc4ccd45c3d4$var$_assertThisInitialized2.default)(_this3), "_value", void 0);
        _this3._value = (0, $26e3fc4ccd45c3d4$var$_isArray.default)(value) ? value : [
            value
        ];
        return _this3;
    }
    (0, $26e3fc4ccd45c3d4$var$_createClass2.default)(AddOp, [
        {
            key: "applyTo",
            value: function(value) /*: Array<mixed>*/ {
                if (value == null) return this._value;
                if ((0, $26e3fc4ccd45c3d4$var$_isArray.default)(value)) return (0, $26e3fc4ccd45c3d4$var$_concat.default)(value).call(value, this._value);
                throw new Error("Cannot add elements to a non-array value");
            }
        },
        {
            key: "mergeWith",
            value: function(previous) /*: Op*/ {
                if (!previous) return this;
                if (previous instanceof $26e3fc4ccd45c3d4$var$SetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this.applyTo(previous._value));
                if (previous instanceof $26e3fc4ccd45c3d4$var$UnsetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this._value);
                if (previous instanceof AddOp) return new AddOp(this.applyTo(previous._value));
                throw new Error("Cannot merge Add Op with the previous Op");
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op: string, objects: mixed }*/ {
                return {
                    __op: "Add",
                    objects: (0, $26e3fc4ccd45c3d4$var$_encode.default)(this._value, false, true)
                };
            }
        }
    ]);
    return AddOp;
}($26e3fc4ccd45c3d4$var$Op);
module.exports.AddOp = $26e3fc4ccd45c3d4$var$AddOp;
var $26e3fc4ccd45c3d4$var$AddUniqueOp = /*#__PURE__*/ function(_Op5) {
    (0, $26e3fc4ccd45c3d4$var$_inherits2.default)(AddUniqueOp, _Op5);
    var _super5 = $26e3fc4ccd45c3d4$var$_createSuper(AddUniqueOp);
    function AddUniqueOp(value) {
        var _this4;
        (0, $26e3fc4ccd45c3d4$var$_classCallCheck2.default)(this, AddUniqueOp);
        _this4 = _super5.call(this);
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)((0, $26e3fc4ccd45c3d4$var$_assertThisInitialized2.default)(_this4), "_value", void 0);
        _this4._value = (0, $26e3fc4ccd45c3d4$var$_unique.default)((0, $26e3fc4ccd45c3d4$var$_isArray.default)(value) ? value : [
            value
        ]);
        return _this4;
    }
    (0, $26e3fc4ccd45c3d4$var$_createClass2.default)(AddUniqueOp, [
        {
            key: "applyTo",
            value: function(value) /*: Array<mixed>*/ {
                if (value == null) return this._value || [];
                if ((0, $26e3fc4ccd45c3d4$var$_isArray.default)(value)) {
                    var _context;
                    var toAdd = [];
                    (0, $26e3fc4ccd45c3d4$var$_forEach.default)(_context = this._value).call(_context, function(v) {
                        if (v instanceof $26e3fc4ccd45c3d4$var$_ParseObject.default) {
                            if (!(0, $26e3fc4ccd45c3d4$var$_arrayContainsObject.default)(value, v)) toAdd.push(v);
                        } else if ((0, $26e3fc4ccd45c3d4$var$_indexOf.default)(value).call(value, v) < 0) toAdd.push(v);
                    });
                    return (0, $26e3fc4ccd45c3d4$var$_concat.default)(value).call(value, toAdd);
                }
                throw new Error("Cannot add elements to a non-array value");
            }
        },
        {
            key: "mergeWith",
            value: function(previous) /*: Op*/ {
                if (!previous) return this;
                if (previous instanceof $26e3fc4ccd45c3d4$var$SetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this.applyTo(previous._value));
                if (previous instanceof $26e3fc4ccd45c3d4$var$UnsetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this._value);
                if (previous instanceof AddUniqueOp) return new AddUniqueOp(this.applyTo(previous._value));
                throw new Error("Cannot merge AddUnique Op with the previous Op");
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op: string, objects: mixed }*/ {
                return {
                    __op: "AddUnique",
                    objects: (0, $26e3fc4ccd45c3d4$var$_encode.default)(this._value, false, true)
                };
            }
        }
    ]);
    return AddUniqueOp;
}($26e3fc4ccd45c3d4$var$Op);
module.exports.AddUniqueOp = $26e3fc4ccd45c3d4$var$AddUniqueOp;
var $26e3fc4ccd45c3d4$var$RemoveOp = /*#__PURE__*/ function(_Op6) {
    (0, $26e3fc4ccd45c3d4$var$_inherits2.default)(RemoveOp, _Op6);
    var _super6 = $26e3fc4ccd45c3d4$var$_createSuper(RemoveOp);
    function RemoveOp(value) {
        var _this5;
        (0, $26e3fc4ccd45c3d4$var$_classCallCheck2.default)(this, RemoveOp);
        _this5 = _super6.call(this);
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)((0, $26e3fc4ccd45c3d4$var$_assertThisInitialized2.default)(_this5), "_value", void 0);
        _this5._value = (0, $26e3fc4ccd45c3d4$var$_unique.default)((0, $26e3fc4ccd45c3d4$var$_isArray.default)(value) ? value : [
            value
        ]);
        return _this5;
    }
    (0, $26e3fc4ccd45c3d4$var$_createClass2.default)(RemoveOp, [
        {
            key: "applyTo",
            value: function(value) /*: Array<mixed>*/ {
                if (value == null) return [];
                if ((0, $26e3fc4ccd45c3d4$var$_isArray.default)(value)) {
                    // var i = value.indexOf(this._value);
                    var removed = (0, $26e3fc4ccd45c3d4$var$_concat.default)(value).call(value, []);
                    for(var i = 0; i < this._value.length; i++){
                        var index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(removed).call(removed, this._value[i]);
                        while(index > -1){
                            (0, $26e3fc4ccd45c3d4$var$_splice.default)(removed).call(removed, index, 1);
                            index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(removed).call(removed, this._value[i]);
                        }
                        if (this._value[i] instanceof $26e3fc4ccd45c3d4$var$_ParseObject.default && this._value[i].id) {
                            for(var j = 0; j < removed.length; j++)if (removed[j] instanceof $26e3fc4ccd45c3d4$var$_ParseObject.default && this._value[i].id === removed[j].id) {
                                (0, $26e3fc4ccd45c3d4$var$_splice.default)(removed).call(removed, j, 1);
                                j--;
                            }
                        }
                    }
                    return removed;
                }
                throw new Error("Cannot remove elements from a non-array value");
            }
        },
        {
            key: "mergeWith",
            value: function(previous) /*: Op*/ {
                if (!previous) return this;
                if (previous instanceof $26e3fc4ccd45c3d4$var$SetOp) return new $26e3fc4ccd45c3d4$var$SetOp(this.applyTo(previous._value));
                if (previous instanceof $26e3fc4ccd45c3d4$var$UnsetOp) return new $26e3fc4ccd45c3d4$var$UnsetOp();
                if (previous instanceof RemoveOp) {
                    var _context2;
                    var uniques = (0, $26e3fc4ccd45c3d4$var$_concat.default)(_context2 = previous._value).call(_context2, []);
                    for(var i = 0; i < this._value.length; i++){
                        if (this._value[i] instanceof $26e3fc4ccd45c3d4$var$_ParseObject.default) {
                            if (!(0, $26e3fc4ccd45c3d4$var$_arrayContainsObject.default)(uniques, this._value[i])) uniques.push(this._value[i]);
                        } else if ((0, $26e3fc4ccd45c3d4$var$_indexOf.default)(uniques).call(uniques, this._value[i]) < 0) uniques.push(this._value[i]);
                    }
                    return new RemoveOp(uniques);
                }
                throw new Error("Cannot merge Remove Op with the previous Op");
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op: string, objects: mixed }*/ {
                return {
                    __op: "Remove",
                    objects: (0, $26e3fc4ccd45c3d4$var$_encode.default)(this._value, false, true)
                };
            }
        }
    ]);
    return RemoveOp;
}($26e3fc4ccd45c3d4$var$Op);
module.exports.RemoveOp = $26e3fc4ccd45c3d4$var$RemoveOp;
var $26e3fc4ccd45c3d4$var$RelationOp = /*#__PURE__*/ function(_Op7) {
    (0, $26e3fc4ccd45c3d4$var$_inherits2.default)(RelationOp, _Op7);
    var _super7 = $26e3fc4ccd45c3d4$var$_createSuper(RelationOp);
    function RelationOp(adds, removes) {
        var _this6;
        (0, $26e3fc4ccd45c3d4$var$_classCallCheck2.default)(this, RelationOp);
        _this6 = _super7.call(this);
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)((0, $26e3fc4ccd45c3d4$var$_assertThisInitialized2.default)(_this6), "_targetClassName", void 0);
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)((0, $26e3fc4ccd45c3d4$var$_assertThisInitialized2.default)(_this6), "relationsToAdd", void 0);
        (0, $26e3fc4ccd45c3d4$var$_defineProperty2.default)((0, $26e3fc4ccd45c3d4$var$_assertThisInitialized2.default)(_this6), "relationsToRemove", void 0);
        _this6._targetClassName = null;
        if ((0, $26e3fc4ccd45c3d4$var$_isArray.default)(adds)) _this6.relationsToAdd = (0, $26e3fc4ccd45c3d4$var$_unique.default)((0, $26e3fc4ccd45c3d4$var$_map.default)(adds).call(adds, _this6._extractId, (0, $26e3fc4ccd45c3d4$var$_assertThisInitialized2.default)(_this6)));
        if ((0, $26e3fc4ccd45c3d4$var$_isArray.default)(removes)) _this6.relationsToRemove = (0, $26e3fc4ccd45c3d4$var$_unique.default)((0, $26e3fc4ccd45c3d4$var$_map.default)(removes).call(removes, _this6._extractId, (0, $26e3fc4ccd45c3d4$var$_assertThisInitialized2.default)(_this6)));
        return _this6;
    }
    (0, $26e3fc4ccd45c3d4$var$_createClass2.default)(RelationOp, [
        {
            key: "_extractId",
            value: function(obj) /*: string*/ {
                if (typeof obj === "string") return obj;
                if (!obj.id) throw new Error("You cannot add or remove an unsaved Parse Object from a relation");
                if (!this._targetClassName) this._targetClassName = obj.className;
                if (this._targetClassName !== obj.className) throw new Error("Tried to create a Relation with 2 different object types: " + this._targetClassName + " and " + obj.className + ".");
                return obj.id;
            }
        },
        {
            key: "applyTo",
            value: function(value, object, key) /*: ?ParseRelation*/ {
                if (!value) {
                    var _context3;
                    if (!object || !key) throw new Error("Cannot apply a RelationOp without either a previous value, or an object and a key");
                    var parent = new $26e3fc4ccd45c3d4$var$_ParseObject.default(object.className);
                    if (object.id && (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(_context3 = object.id).call(_context3, "local") === 0) parent._localId = object.id;
                    else if (object.id) parent.id = object.id;
                    var relation = new $26e3fc4ccd45c3d4$var$_ParseRelation.default(parent, key);
                    relation.targetClassName = this._targetClassName;
                    return relation;
                }
                if (value instanceof $26e3fc4ccd45c3d4$var$_ParseRelation.default) {
                    if (this._targetClassName) {
                        if (value.targetClassName) {
                            if (this._targetClassName !== value.targetClassName) throw new Error("Related object must be a " + value.targetClassName + ", but a " + this._targetClassName + " was passed in.");
                        } else value.targetClassName = this._targetClassName;
                    }
                    return value;
                } else throw new Error("Relation cannot be applied to a non-relation field");
            }
        },
        {
            key: "mergeWith",
            value: function(previous) /*: Op*/ {
                if (!previous) return this;
                else if (previous instanceof $26e3fc4ccd45c3d4$var$UnsetOp) throw new Error("You cannot modify a relation after deleting it.");
                else if (previous instanceof $26e3fc4ccd45c3d4$var$SetOp && previous._value instanceof $26e3fc4ccd45c3d4$var$_ParseRelation.default) return this;
                else if (previous instanceof RelationOp) {
                    var _context4, _context5, _context6, _context7, _context8, _context9;
                    if (previous._targetClassName && previous._targetClassName !== this._targetClassName) throw new Error("Related object must be of class " + previous._targetClassName + ", but " + (this._targetClassName || "null") + " was passed in.");
                    var newAdd = (0, $26e3fc4ccd45c3d4$var$_concat.default)(_context4 = previous.relationsToAdd).call(_context4, []);
                    (0, $26e3fc4ccd45c3d4$var$_forEach.default)(_context5 = this.relationsToRemove).call(_context5, function(r) {
                        var index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(newAdd).call(newAdd, r);
                        if (index > -1) (0, $26e3fc4ccd45c3d4$var$_splice.default)(newAdd).call(newAdd, index, 1);
                    });
                    (0, $26e3fc4ccd45c3d4$var$_forEach.default)(_context6 = this.relationsToAdd).call(_context6, function(r) {
                        var index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(newAdd).call(newAdd, r);
                        if (index < 0) newAdd.push(r);
                    });
                    var newRemove = (0, $26e3fc4ccd45c3d4$var$_concat.default)(_context7 = previous.relationsToRemove).call(_context7, []);
                    (0, $26e3fc4ccd45c3d4$var$_forEach.default)(_context8 = this.relationsToAdd).call(_context8, function(r) {
                        var index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(newRemove).call(newRemove, r);
                        if (index > -1) (0, $26e3fc4ccd45c3d4$var$_splice.default)(newRemove).call(newRemove, index, 1);
                    });
                    (0, $26e3fc4ccd45c3d4$var$_forEach.default)(_context9 = this.relationsToRemove).call(_context9, function(r) {
                        var index = (0, $26e3fc4ccd45c3d4$var$_indexOf.default)(newRemove).call(newRemove, r);
                        if (index < 0) newRemove.push(r);
                    });
                    var newRelation = new RelationOp(newAdd, newRemove);
                    newRelation._targetClassName = this._targetClassName;
                    return newRelation;
                }
                throw new Error("Cannot merge Relation Op with the previous Op");
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __op?: string, objects?: mixed, ops?: mixed }*/ {
                var _this7 = this;
                var idToPointer = function(id) {
                    return {
                        __type: "Pointer",
                        className: _this7._targetClassName,
                        objectId: id
                    };
                };
                var adds = null;
                var removes = null;
                var pointers = null;
                if (this.relationsToAdd.length > 0) {
                    var _context10;
                    pointers = (0, $26e3fc4ccd45c3d4$var$_map.default)(_context10 = this.relationsToAdd).call(_context10, idToPointer);
                    adds = {
                        __op: "AddRelation",
                        objects: pointers
                    };
                }
                if (this.relationsToRemove.length > 0) {
                    var _context11;
                    pointers = (0, $26e3fc4ccd45c3d4$var$_map.default)(_context11 = this.relationsToRemove).call(_context11, idToPointer);
                    removes = {
                        __op: "RemoveRelation",
                        objects: pointers
                    };
                }
                if (adds && removes) return {
                    __op: "Batch",
                    ops: [
                        adds,
                        removes
                    ]
                };
                return adds || removes || {};
            }
        }
    ]);
    return RelationOp;
}($26e3fc4ccd45c3d4$var$Op);
module.exports.RelationOp = $26e3fc4ccd45c3d4$var$RelationOp;

});
parcelRequire.register("aFg1C", function(module, exports) {

module.exports = (parcelRequire("1G8gP"));

});
parcelRequire.register("1G8gP", function(module, exports) {

var $lvdTQ = parcelRequire("lvdTQ");
module.exports = $lvdTQ;

});
parcelRequire.register("lvdTQ", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $dG9aM = parcelRequire("dG9aM");
var $fa77466ff259f814$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.splice;
    return it === $fa77466ff259f814$var$ArrayPrototype || $8hsAO($fa77466ff259f814$var$ArrayPrototype, it) && own === $fa77466ff259f814$var$ArrayPrototype.splice ? $dG9aM : own;
};

});
parcelRequire.register("dG9aM", function(module, exports) {
parcelRequire("6Dlvu");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").splice;

});
parcelRequire.register("6Dlvu", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $iJNxK = parcelRequire("iJNxK");

var $2s0YW = parcelRequire("2s0YW");

var $3ZmxQ = parcelRequire("3ZmxQ");

var $6ocdr = parcelRequire("6ocdr");

var $6lmzv = parcelRequire("6lmzv");

var $c8xJJ = parcelRequire("c8xJJ");

var $cU9IX = parcelRequire("cU9IX");

var $b1Dzg = parcelRequire("b1Dzg");

var $adIjL = parcelRequire("adIjL");

var $PdD5d = parcelRequire("PdD5d");
var $4d471167f3dade99$var$HAS_SPECIES_SUPPORT = $PdD5d("splice");
var $4d471167f3dade99$var$max = Math.max;
var $4d471167f3dade99$var$min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$ggcsv({
    target: "Array",
    proto: true,
    forced: !$4d471167f3dade99$var$HAS_SPECIES_SUPPORT
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = $iJNxK(this);
        var len = $6ocdr(O);
        var actualStart = $2s0YW(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = $4d471167f3dade99$var$min($4d471167f3dade99$var$max($3ZmxQ(deleteCount), 0), len - actualStart);
        }
        $c8xJJ(len + insertCount - actualDeleteCount);
        A = $cU9IX(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) $b1Dzg(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else $adIjL(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)$adIjL(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else $adIjL(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        $6lmzv(O, len - actualDeleteCount + insertCount);
        return A;
    }
});

});
parcelRequire.register("6lmzv", function(module, exports) {
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $5zZFa = parcelRequire("5zZFa");
var $49e6368470390ed9$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $49e6368470390ed9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $49e6368470390ed9$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $jeZ4p && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], "length", {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
module.exports = $49e6368470390ed9$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if ($5zZFa(O) && !$49e6368470390ed9$var$getOwnPropertyDescriptor(O, "length").writable) throw $49e6368470390ed9$var$$TypeError("Cannot set read only .length");
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};

});

parcelRequire.register("adIjL", function(module, exports) {
"use strict";

var $k9gzN = parcelRequire("k9gzN");
var $770d7ee0fff0d93d$var$$TypeError = TypeError;
module.exports = function(O, P) {
    if (!delete O[P]) throw $770d7ee0fff0d93d$var$$TypeError("Cannot delete property " + $k9gzN(P) + " of " + $k9gzN(O));
};

});






parcelRequire.register("koRMr", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ed9fc43353980608$var$arrayContainsObject;

var $ed9fc43353980608$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $ed9fc43353980608$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $ed9fc43353980608$var$arrayContainsObject(array, object) /*: boolean*/ {
    if ((0, $ed9fc43353980608$var$_indexOf.default)(array).call(array, object) > -1) return true;
    for(var i = 0; i < array.length; i++){
        if (array[i] instanceof $ed9fc43353980608$var$_ParseObject.default && array[i].className === object.className && array[i]._getId() === object._getId()) return true;
    }
    return false;
}

});

parcelRequire.register("1rsTn", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $10ceb975b6ee7f2c$var$_default;

var $10ceb975b6ee7f2c$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $10ceb975b6ee7f2c$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $10ceb975b6ee7f2c$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $10ceb975b6ee7f2c$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $10ceb975b6ee7f2c$var$_startsWith = $iHLHC((parcelRequire("hNmgD")));

var $10ceb975b6ee7f2c$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $10ceb975b6ee7f2c$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $10ceb975b6ee7f2c$var$_ParseACL = $iHLHC((parcelRequire("2xGBa")));

var $10ceb975b6ee7f2c$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $10ceb975b6ee7f2c$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));

var $10ceb975b6ee7f2c$var$_ParsePolygon = $iHLHC((parcelRequire("i8AKq")));

var $10ceb975b6ee7f2c$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $3l0Qd = parcelRequire("3l0Qd");

var $10ceb975b6ee7f2c$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $10ceb975b6ee7f2c$var$encode(value, disallowObjects, forcePointers, seen, offline) /*: any*/ {
    if (value instanceof $10ceb975b6ee7f2c$var$_ParseObject.default) {
        if (disallowObjects) throw new Error("Parse Objects not allowed here");
        var seenEntry = value.id ? value.className + ":" + value.id : value;
        if (forcePointers || !seen || (0, $10ceb975b6ee7f2c$var$_indexOf.default)(seen).call(seen, seenEntry) > -1 || value.dirty() || (0, $10ceb975b6ee7f2c$var$_keys.default)(value._getServerData()).length < 1) {
            var _context;
            if (offline && (0, $10ceb975b6ee7f2c$var$_startsWith.default)(_context = value._getId()).call(_context, "local")) return value.toOfflinePointer();
            return value.toPointer();
        }
        seen = (0, $10ceb975b6ee7f2c$var$_concat.default)(seen).call(seen, seenEntry);
        return value._toFullJSON(seen, offline);
    }
    if (value instanceof $3l0Qd.Op || value instanceof $10ceb975b6ee7f2c$var$_ParseACL.default || value instanceof $10ceb975b6ee7f2c$var$_ParseGeoPoint.default || value instanceof $10ceb975b6ee7f2c$var$_ParsePolygon.default || value instanceof $10ceb975b6ee7f2c$var$_ParseRelation.default) return value.toJSON();
    if (value instanceof $10ceb975b6ee7f2c$var$_ParseFile.default) {
        if (!value.url()) throw new Error("Tried to encode an unsaved file.");
        return value.toJSON();
    }
    if (Object.prototype.toString.call(value) === "[object Date]") {
        if (isNaN(value)) throw new Error("Tried to encode an invalid date.");
        return {
            __type: "Date",
            iso: value/*: any*/ .toJSON()
        };
    }
    if (Object.prototype.toString.call(value) === "[object RegExp]" && typeof value.source === "string") return value.source;
    if ((0, $10ceb975b6ee7f2c$var$_isArray.default)(value)) return (0, $10ceb975b6ee7f2c$var$_map.default)(value).call(value, function(v) {
        return $10ceb975b6ee7f2c$var$encode(v, disallowObjects, forcePointers, seen, offline);
    });
    if (value && (0, $10ceb975b6ee7f2c$var$_typeof2.default)(value) === "object") {
        var output = {};
        for(var k in value)output[k] = $10ceb975b6ee7f2c$var$encode(value[k], disallowObjects, forcePointers, seen, offline);
        return output;
    }
    return value;
}
function $10ceb975b6ee7f2c$var$_default(value, disallowObjects, forcePointers, seen, offline) /*: any*/ {
    return $10ceb975b6ee7f2c$var$encode(value, !!disallowObjects, !!forcePointers, seen || [], offline);
}

});
parcelRequire.register("hNmgD", function(module, exports) {

module.exports = (parcelRequire("kQxgJ"));

});
parcelRequire.register("kQxgJ", function(module, exports) {

var $dOs42 = parcelRequire("dOs42");
module.exports = $dOs42;

});
parcelRequire.register("dOs42", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $iQF3Q = parcelRequire("iQF3Q");
var $a0e5b6cd70b8df3f$var$StringPrototype = String.prototype;
module.exports = function(it) {
    var own = it.startsWith;
    return typeof it == "string" || it === $a0e5b6cd70b8df3f$var$StringPrototype || $8hsAO($a0e5b6cd70b8df3f$var$StringPrototype, it) && own === $a0e5b6cd70b8df3f$var$StringPrototype.startsWith ? $iQF3Q : own;
};

});
parcelRequire.register("iQF3Q", function(module, exports) {
parcelRequire("fPtxe");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("String").startsWith;

});
parcelRequire.register("fPtxe", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $5FNR6 = parcelRequire("5FNR6");

var $fTFId = parcelRequire("fTFId");
var $b862877cc9dad1a1$require$getOwnPropertyDescriptor = $fTFId.f;

var $8xt01 = parcelRequire("8xt01");

var $l2Ut5 = parcelRequire("l2Ut5");

var $4Te7f = parcelRequire("4Te7f");

var $cBWnS = parcelRequire("cBWnS");

var $bmRml = parcelRequire("bmRml");

var $7phdw = parcelRequire("7phdw");
// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var $b862877cc9dad1a1$var$nativeStartsWith = $5FNR6("".startsWith);
var $b862877cc9dad1a1$var$stringSlice = $5FNR6("".slice);
var $b862877cc9dad1a1$var$min = Math.min;
var $b862877cc9dad1a1$var$CORRECT_IS_REGEXP_LOGIC = $bmRml("startsWith");
// https://github.com/zloirock/core-js/pull/702
var $b862877cc9dad1a1$var$MDN_POLYFILL_BUG = !$7phdw && !$b862877cc9dad1a1$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $b862877cc9dad1a1$require$getOwnPropertyDescriptor(String.prototype, "startsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$ggcsv({
    target: "String",
    proto: true,
    forced: !$b862877cc9dad1a1$var$MDN_POLYFILL_BUG && !$b862877cc9dad1a1$var$CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $l2Ut5($cBWnS(this));
        $4Te7f(searchString);
        var index = $8xt01($b862877cc9dad1a1$var$min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = $l2Ut5(searchString);
        return $b862877cc9dad1a1$var$nativeStartsWith ? $b862877cc9dad1a1$var$nativeStartsWith(that, search, index) : $b862877cc9dad1a1$var$stringSlice(that, index, index + search.length) === search;
    }
});

});





parcelRequire.register("jtZTC", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2f0bd05739f27ec$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $e2f0bd05739f27ec$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $e2f0bd05739f27ec$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $e2f0bd05739f27ec$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $e2f0bd05739f27ec$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Creates a new GeoPoint with any of the following forms:<br>
 *   <pre>
 *   new GeoPoint(otherGeoPoint)
 *   new GeoPoint(30, 30)
 *   new GeoPoint([30, 30])
 *   new GeoPoint({latitude: 30, longitude: 30})
 *   new GeoPoint()  // defaults to (0, 0)
 *   </pre>
 * <p>Represents a latitude / longitude point that may be associated
 * with a key in a ParseObject or used as a reference point for geo queries.
 * This allows proximity-based queries on the key.</p>
 *
 * <p>Only one key in a class may contain a GeoPoint.</p>
 *
 * <p>Example:<pre>
 *   var point = new Parse.GeoPoint(30.0, -20.0);
 *   var object = new Parse.Object("PlaceObject");
 *   object.set("location", point);
 *   object.save();</pre></p>
 *
 * @alias Parse.GeoPoint
 */ /* global navigator */ var $e2f0bd05739f27ec$var$ParseGeoPoint = /*#__PURE__*/ function() {
    /**
   * @param {(number[] | object | number)} arg1 Either a list of coordinate pairs, an object with `latitude`, `longitude`, or the latitude or the point.
   * @param {number} arg2 The longitude of the GeoPoint
   */ function ParseGeoPoint(arg1, arg2) {
        (0, $e2f0bd05739f27ec$var$_classCallCheck2.default)(this, ParseGeoPoint);
        (0, $e2f0bd05739f27ec$var$_defineProperty2.default)(this, "_latitude", void 0);
        (0, $e2f0bd05739f27ec$var$_defineProperty2.default)(this, "_longitude", void 0);
        if ((0, $e2f0bd05739f27ec$var$_isArray.default)(arg1)) {
            ParseGeoPoint._validate(arg1[0], arg1[1]);
            this._latitude = arg1[0];
            this._longitude = arg1[1];
        } else if ((0, $e2f0bd05739f27ec$var$_typeof2.default)(arg1) === "object") {
            ParseGeoPoint._validate(arg1.latitude, arg1.longitude);
            this._latitude = arg1.latitude;
            this._longitude = arg1.longitude;
        } else if (arg1 !== undefined && arg2 !== undefined) {
            ParseGeoPoint._validate(arg1, arg2);
            this._latitude = arg1;
            this._longitude = arg2;
        } else {
            this._latitude = 0;
            this._longitude = 0;
        }
    }
    /**
   * North-south portion of the coordinate, in range [-90, 90].
   * Throws an exception if set out of range in a modern browser.
   *
   * @property {number} latitude
   * @returns {number}
   */ (0, $e2f0bd05739f27ec$var$_createClass2.default)(ParseGeoPoint, [
        {
            key: "latitude",
            get: function() /*: number*/ {
                return this._latitude;
            },
            set: function(val) {
                ParseGeoPoint._validate(val, this.longitude);
                this._latitude = val;
            }
        },
        {
            key: "longitude",
            get: function() /*: number*/ {
                return this._longitude;
            },
            set: function(val) {
                ParseGeoPoint._validate(this.latitude, val);
                this._longitude = val;
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __type: string, latitude: number, longitude: number }*/ {
                ParseGeoPoint._validate(this._latitude, this._longitude);
                return {
                    __type: "GeoPoint",
                    latitude: this._latitude,
                    longitude: this._longitude
                };
            }
        },
        {
            key: "equals",
            value: function(other) /*: boolean*/ {
                return other instanceof ParseGeoPoint && this.latitude === other.latitude && this.longitude === other.longitude;
            }
        },
        {
            key: "radiansTo",
            value: function(point) /*: number*/ {
                var d2r = Math.PI / 180.0;
                var lat1rad = this.latitude * d2r;
                var long1rad = this.longitude * d2r;
                var lat2rad = point.latitude * d2r;
                var long2rad = point.longitude * d2r;
                var sinDeltaLatDiv2 = Math.sin((lat1rad - lat2rad) / 2);
                var sinDeltaLongDiv2 = Math.sin((long1rad - long2rad) / 2); // Square of half the straight line chord distance between both points.
                var a = sinDeltaLatDiv2 * sinDeltaLatDiv2 + Math.cos(lat1rad) * Math.cos(lat2rad) * sinDeltaLongDiv2 * sinDeltaLongDiv2;
                a = Math.min(1.0, a);
                return 2 * Math.asin(Math.sqrt(a));
            }
        },
        {
            key: "kilometersTo",
            value: function(point) /*: number*/ {
                return this.radiansTo(point) * 6371.0;
            }
        },
        {
            key: "milesTo",
            value: function(point) /*: number*/ {
                return this.radiansTo(point) * 3958.8;
            }
        }
    ], [
        {
            key: "_validate",
            value: function(latitude, longitude) {
                if (isNaN(latitude) || isNaN(longitude) || typeof latitude !== "number" || typeof longitude !== "number") throw new TypeError("GeoPoint latitude and longitude must be valid numbers");
                if (latitude < -90) throw new TypeError("GeoPoint latitude out of bounds: " + latitude + " < -90.0.");
                if (latitude > 90.0) throw new TypeError("GeoPoint latitude out of bounds: " + latitude + " > 90.0.");
                if (longitude < -180) throw new TypeError("GeoPoint longitude out of bounds: " + longitude + " < -180.0.");
                if (longitude > 180.0) throw new TypeError("GeoPoint longitude out of bounds: " + longitude + " > 180.0.");
            }
        },
        {
            key: "current",
            value: function() {
                return navigator.geolocation.getCurrentPosition(function(location) {
                    return new ParseGeoPoint(location.coords.latitude, location.coords.longitude);
                });
            }
        }
    ]);
    return ParseGeoPoint;
}();
var $e2f0bd05739f27ec$var$_default = $e2f0bd05739f27ec$var$ParseGeoPoint;
module.exports.default = $e2f0bd05739f27ec$var$_default;

});

parcelRequire.register("i8AKq", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3457aac5b5626dc$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $d3457aac5b5626dc$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $d3457aac5b5626dc$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $d3457aac5b5626dc$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $d3457aac5b5626dc$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Creates a new Polygon with any of the following forms:<br>
 *   <pre>
 *   new Polygon([[0,0],[0,1],[1,1],[1,0]])
 *   new Polygon([GeoPoint, GeoPoint, GeoPoint])
 *   </pre>
 *
 * <p>Represents a coordinates that may be associated
 * with a key in a ParseObject or used as a reference point for geo queries.
 * This allows proximity-based queries on the key.</p>
 *
 * <p>Example:<pre>
 *   var polygon = new Parse.Polygon([[0,0],[0,1],[1,1],[1,0]]);
 *   var object = new Parse.Object("PlaceObject");
 *   object.set("area", polygon);
 *   object.save();</pre></p>
 *
 * @alias Parse.Polygon
 */ var $d3457aac5b5626dc$var$ParsePolygon = /*#__PURE__*/ function() {
    /**
   * @param {(number[][] | Parse.GeoPoint[])} coordinates An Array of coordinate pairs
   */ function ParsePolygon(coordinates) {
        (0, $d3457aac5b5626dc$var$_classCallCheck2.default)(this, ParsePolygon);
        (0, $d3457aac5b5626dc$var$_defineProperty2.default)(this, "_coordinates", void 0);
        this._coordinates = ParsePolygon._validate(coordinates);
    }
    /**
   * Coordinates value for this Polygon.
   * Throws an exception if not valid type.
   *
   * @property {(number[][] | Parse.GeoPoint[])} coordinates list of coordinates
   * @returns {number[][]}
   */ (0, $d3457aac5b5626dc$var$_createClass2.default)(ParsePolygon, [
        {
            key: "coordinates",
            get: function() /*: Array<Array<number>>*/ {
                return this._coordinates;
            },
            set: function(coords) {
                this._coordinates = ParsePolygon._validate(coords);
            }
        },
        {
            key: "toJSON",
            value: function() /*: { __type: string, coordinates: Array<Array<number>> }*/ {
                ParsePolygon._validate(this._coordinates);
                return {
                    __type: "Polygon",
                    coordinates: this._coordinates
                };
            }
        },
        {
            key: "equals",
            value: function(other) /*: boolean*/ {
                if (!(other instanceof ParsePolygon) || this.coordinates.length !== other.coordinates.length) return false;
                var isEqual = true;
                for(var i = 1; i < this._coordinates.length; i += 1)if (this._coordinates[i][0] != other.coordinates[i][0] || this._coordinates[i][1] != other.coordinates[i][1]) {
                    isEqual = false;
                    break;
                }
                return isEqual;
            }
        },
        {
            key: "containsPoint",
            value: function(point) /*: boolean*/ {
                var minX = this._coordinates[0][0];
                var maxX = this._coordinates[0][0];
                var minY = this._coordinates[0][1];
                var maxY = this._coordinates[0][1];
                for(var i = 1; i < this._coordinates.length; i += 1){
                    var p = this._coordinates[i];
                    minX = Math.min(p[0], minX);
                    maxX = Math.max(p[0], maxX);
                    minY = Math.min(p[1], minY);
                    maxY = Math.max(p[1], maxY);
                }
                var outside = point.latitude < minX || point.latitude > maxX || point.longitude < minY || point.longitude > maxY;
                if (outside) return false;
                var inside = false;
                for(var _i = 0, j = this._coordinates.length - 1; _i < this._coordinates.length; j = _i++){
                    var startX = this._coordinates[_i][0];
                    var startY = this._coordinates[_i][1];
                    var endX = this._coordinates[j][0];
                    var endY = this._coordinates[j][1];
                    var intersect = startY > point.longitude != endY > point.longitude && point.latitude < (endX - startX) * (point.longitude - startY) / (endY - startY) + startX;
                    if (intersect) inside = !inside;
                }
                return inside;
            }
        }
    ], [
        {
            key: "_validate",
            value: function(coords) /*: Array<Array<number>>*/ {
                if (!(0, $d3457aac5b5626dc$var$_isArray.default)(coords)) throw new TypeError("Coordinates must be an Array");
                if (coords.length < 3) throw new TypeError("Polygon must have at least 3 GeoPoints or Points");
                var points = [];
                for(var i = 0; i < coords.length; i += 1){
                    var coord = coords[i];
                    var geoPoint = void 0;
                    if (coord instanceof $d3457aac5b5626dc$var$_ParseGeoPoint.default) geoPoint = coord;
                    else if ((0, $d3457aac5b5626dc$var$_isArray.default)(coord) && coord.length === 2) geoPoint = new $d3457aac5b5626dc$var$_ParseGeoPoint.default(coord[0], coord[1]);
                    else throw new TypeError("Coordinates must be an Array of GeoPoints or Points");
                    points.push([
                        geoPoint.latitude,
                        geoPoint.longitude
                    ]);
                }
                return points;
            }
        }
    ]);
    return ParsePolygon;
}();
var $d3457aac5b5626dc$var$_default = $d3457aac5b5626dc$var$ParsePolygon;
module.exports.default = $d3457aac5b5626dc$var$_default;

});


parcelRequire.register("aoRXv", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7926005fcd592cab$var$unique;

var $7926005fcd592cab$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $7926005fcd592cab$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $7926005fcd592cab$var$_arrayContainsObject = $iHLHC((parcelRequire("koRMr")));

var $7926005fcd592cab$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $7926005fcd592cab$var$unique(arr) /*: Array<T>*/ {
    var uniques = [];
    (0, $7926005fcd592cab$var$_forEach.default)(arr).call(arr, function(value) {
        if (value instanceof $7926005fcd592cab$var$_ParseObject.default) {
            if (!(0, $7926005fcd592cab$var$_arrayContainsObject.default)(uniques, value)) uniques.push(value);
        } else if ((0, $7926005fcd592cab$var$_indexOf.default)(uniques).call(uniques, value) < 0) uniques.push(value);
    });
    return uniques;
}

});


parcelRequire.register("4FVCr", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");


var $4wehD = parcelRequire("4wehD");


var $dQJQf = parcelRequire("dQJQf");



var $kOp5W = parcelRequire("kOp5W");

var $jQ6K5 = parcelRequire("jQ6K5");

var $4i3Tl = parcelRequire("4i3Tl");

var $iDZ3d = parcelRequire("iDZ3d");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3677afb657bcb4bc$var$_entries = $iHLHC((parcelRequire("hOvAP")));

var $3677afb657bcb4bc$var$_slicedToArray2 = $iHLHC((parcelRequire("ccwCe")));

var $3677afb657bcb4bc$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $3677afb657bcb4bc$var$_toConsumableArray2 = $iHLHC((parcelRequire("h3AFy")));

var $3677afb657bcb4bc$var$_find = $iHLHC((parcelRequire("c61hX")));

var $3677afb657bcb4bc$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $3677afb657bcb4bc$var$_splice = $iHLHC((parcelRequire("aFg1C")));

var $3677afb657bcb4bc$var$_sort = $iHLHC((parcelRequire("8zvHt")));

var $3677afb657bcb4bc$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $3677afb657bcb4bc$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $3677afb657bcb4bc$var$_keys = $iHLHC((parcelRequire("e9nT0")));

var $3677afb657bcb4bc$var$_filter2 = $iHLHC((parcelRequire("i3o6i")));

var $3677afb657bcb4bc$var$_asyncToGenerator2 = $iHLHC((parcelRequire("kkHAR")));

var $3677afb657bcb4bc$var$_map2 = $iHLHC((parcelRequire("2VoQi")));

var $3677afb657bcb4bc$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $3677afb657bcb4bc$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $3677afb657bcb4bc$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $3677afb657bcb4bc$var$_slice = $iHLHC((parcelRequire("a1TrC")));

var $3677afb657bcb4bc$var$_keys2 = $iHLHC((parcelRequire("2QmZN")));

var $3677afb657bcb4bc$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $3677afb657bcb4bc$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $3677afb657bcb4bc$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $3677afb657bcb4bc$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $3677afb657bcb4bc$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $9FsFR = parcelRequire("9FsFR");

var $3677afb657bcb4bc$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $3677afb657bcb4bc$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));

var $3677afb657bcb4bc$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $3677afb657bcb4bc$var$_OfflineQuery = $iHLHC((parcelRequire("fKbuz")));

var $klpRA = parcelRequire("klpRA");
function $3677afb657bcb4bc$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $3677afb657bcb4bc$var$_regeneratorRuntime = function() {
        return exports1;
    };
    var exports1 = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $iDZ3d ? $iDZ3d : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $4i3Tl(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $jQ6K5(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports1.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $kOp5W, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $jQ6K5(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context23;
        (parcelRequire("gW71a"))(_context23 = [
            "next",
            "throw",
            "return"
        ]).call(_context23, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == (parcelRequire("6iqUa"))(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], (parcelRequire("gW71a"))(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports1.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports1.mark = function(genFun) {
        return $dQJQf ? $dQJQf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $jQ6K5(Gp), genFun;
    }, exports1.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports1.AsyncIterator = AsyncIterator, exports1.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("iH0WI")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports1.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports1.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $4wehD(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports1.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context24;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, (parcelRequire("gW71a"))(_context24 = this.tryEntries).call(_context24, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+(parcelRequire("a1TrC"))(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports1;
}
/**
 * Converts a string into a regex that matches it.
 * Surrounding with \Q .. \E does this, we just need to escape any \E's in
 * the text separately.
 *
 * @param s
 * @private
 * @returns {string}
 */ function $3677afb657bcb4bc$var$quote(s) /*: string*/ {
    return "\\Q" + s.replace("\\E", "\\E\\\\E\\Q") + "\\E";
}
/**
 * Extracts the class name from queries. If not all queries have the same
 * class name an error will be thrown.
 *
 * @param queries
 * @private
 * @returns {string}
 */ function $3677afb657bcb4bc$var$_getClassNameFromQueries(queries) /*: ?string*/ {
    var className = null;
    (0, $3677afb657bcb4bc$var$_forEach.default)(queries).call(queries, function(q) {
        if (!className) className = q.className;
        if (className !== q.className) throw new Error("All queries must be for the same class.");
    });
    return className;
}
/*
 * Handles pre-populating the result data of a query with select fields,
 * making sure that the data object contains keys for all objects that have
 * been requested with a select, so that our cached state updates correctly.
 */ function $3677afb657bcb4bc$var$handleSelectResult(data, select) {
    var serverDataMask = {};
    (0, $3677afb657bcb4bc$var$_forEach.default)(select).call(select, function(field) {
        var hasSubObjectSelect = (0, $3677afb657bcb4bc$var$_indexOf.default)(field).call(field, ".") !== -1;
        if (!hasSubObjectSelect && !data.hasOwnProperty(field)) // this field was selected, but is missing from the retrieved data
        data[field] = undefined;
        else if (hasSubObjectSelect) {
            // this field references a sub-object,
            // so we need to walk down the path components
            var pathComponents = field.split(".");
            var _obj = data;
            var serverMask = serverDataMask;
            (0, $3677afb657bcb4bc$var$_forEach.default)(pathComponents).call(pathComponents, function(component, index, arr) {
                // add keys if the expected data is missing
                if (_obj && !_obj.hasOwnProperty(component)) _obj[component] = undefined;
                if (_obj && (0, $3677afb657bcb4bc$var$_typeof2.default)(_obj) === "object") _obj = _obj[component];
                 //add this path component to the server mask so we can fill it in later if needed
                if (index < arr.length - 1) {
                    if (!serverMask[component]) serverMask[component] = {};
                    serverMask = serverMask[component];
                }
            });
        }
    });
    if ((0, $3677afb657bcb4bc$var$_keys2.default)(serverDataMask).length > 0) {
        // When selecting from sub-objects, we don't want to blow away the missing
        // information that we may have retrieved before. We've already added any
        // missing selected keys to sub-objects, but we still need to add in the
        // data for any previously retrieved sub-objects that were not selected.
        var serverData = $3677afb657bcb4bc$var$_CoreManager.default.getObjectStateController().getServerData({
            id: data.objectId,
            className: data.className
        });
        $3677afb657bcb4bc$var$copyMissingDataWithMask(serverData, data, serverDataMask, false);
    }
}
function $3677afb657bcb4bc$var$copyMissingDataWithMask(src, dest, mask, copyThisLevel) {
    //copy missing elements at this level
    if (copyThisLevel) {
        for(var _key in src)if (src.hasOwnProperty(_key) && !dest.hasOwnProperty(_key)) dest[_key] = src[_key];
    }
    for(var _key2 in mask)if (dest[_key2] !== undefined && dest[_key2] !== null && src !== undefined && src !== null) //traverse into objects as needed
    $3677afb657bcb4bc$var$copyMissingDataWithMask(src[_key2], dest[_key2], mask[_key2], true);
}
function $3677afb657bcb4bc$var$handleOfflineSort(a, b, sorts) {
    var order = sorts[0];
    var operator = (0, $3677afb657bcb4bc$var$_slice.default)(order).call(order, 0, 1);
    var isDescending = operator === "-";
    if (isDescending) order = order.substring(1);
    if (order === "_created_at") order = "createdAt";
    if (order === "_updated_at") order = "updatedAt";
    if (!/^[A-Za-z][0-9A-Za-z_]*$/.test(order) || order === "password") throw new $3677afb657bcb4bc$var$_ParseError.default($3677afb657bcb4bc$var$_ParseError.default.INVALID_KEY_NAME, "Invalid Key: ".concat(order));
    var field1 = a.get(order);
    var field2 = b.get(order);
    if (field1 < field2) return isDescending ? 1 : -1;
    if (field1 > field2) return isDescending ? -1 : 1;
    if (sorts.length > 1) {
        var remainingSorts = (0, $3677afb657bcb4bc$var$_slice.default)(sorts).call(sorts, 1);
        return $3677afb657bcb4bc$var$handleOfflineSort(a, b, remainingSorts);
    }
    return 0;
}
/**
 * Creates a new parse Parse.Query for the given Parse.Object subclass.
 *
 * <p>Parse.Query defines a query that is used to fetch Parse.Objects. The
 * most common use case is finding all objects that match a query through the
 * <code>find</code> method. for example, this sample code fetches all objects
 * of class <code>myclass</code>. it calls a different function depending on
 * whether the fetch succeeded or not.
 *
 * <pre>
 * var query = new Parse.Query(myclass);
 * query.find().then((results) => {
 *   // results is an array of parse.object.
 * }).catch((error) =>  {
 *  // error is an instance of parse.error.
 * });</pre></p>
 *
 * <p>a Parse.Query can also be used to retrieve a single object whose id is
 * known, through the get method. for example, this sample code fetches an
 * object of class <code>myclass</code> and id <code>myid</code>. it calls a
 * different function depending on whether the fetch succeeded or not.
 *
 * <pre>
 * var query = new Parse.Query(myclass);
 * query.get(myid).then((object) => {
 *     // object is an instance of parse.object.
 * }).catch((error) =>  {
 *  // error is an instance of parse.error.
 * });</pre></p>
 *
 * <p>a Parse.Query can also be used to count the number of objects that match
 * the query without retrieving all of those objects. for example, this
 * sample code counts the number of objects of the class <code>myclass</code>
 * <pre>
 * var query = new Parse.Query(myclass);
 * query.count().then((number) => {
 *     // there are number instances of myclass.
 * }).catch((error) => {
 *     // error is an instance of Parse.Error.
 * });</pre></p>
 *
 * @alias Parse.Query
 */ var $3677afb657bcb4bc$var$ParseQuery = /*#__PURE__*/ function() {
    /**
   * @property {string} className
   */ /**
   * @param {(string | Parse.Object)} objectClass An instance of a subclass of Parse.Object, or a Parse className string.
   */ function ParseQuery(objectClass) {
        (0, $3677afb657bcb4bc$var$_classCallCheck2.default)(this, ParseQuery);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "className", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_where", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_include", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_exclude", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_select", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_limit", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_skip", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_count", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_order", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_readPreference", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_includeReadPreference", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_subqueryReadPreference", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_queriesLocalDatastore", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_localDatastorePinName", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_extraOptions", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_hint", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_explain", void 0);
        (0, $3677afb657bcb4bc$var$_defineProperty2.default)(this, "_xhrRequest", void 0);
        if (typeof objectClass === "string") {
            if (objectClass === "User" && $3677afb657bcb4bc$var$_CoreManager.default.get("PERFORM_USER_REWRITE")) this.className = "_User";
            else this.className = objectClass;
        } else if (objectClass instanceof $3677afb657bcb4bc$var$_ParseObject.default) this.className = objectClass.className;
        else if (typeof objectClass === "function") {
            if (typeof objectClass.className === "string") this.className = objectClass.className;
            else {
                var _obj2 = new objectClass();
                this.className = _obj2.className;
            }
        } else throw new TypeError("A ParseQuery must be constructed with a ParseObject or class name.");
        this._where = {};
        this._include = [];
        this._exclude = [];
        this._count = false;
        this._limit = -1; // negative limit is not sent in the server request
        this._skip = 0;
        this._readPreference = null;
        this._includeReadPreference = null;
        this._subqueryReadPreference = null;
        this._queriesLocalDatastore = false;
        this._localDatastorePinName = null;
        this._extraOptions = {};
        this._xhrRequest = {
            task: null,
            onchange: function() {}
        };
    }
    /**
   * Adds constraint that at least one of the passed in queries matches.
   *
   * @param {Array} queries
   * @returns {Parse.Query} Returns the query, so you can chain this call.
   */ (0, $3677afb657bcb4bc$var$_createClass2.default)(ParseQuery, [
        {
            key: "_orQuery",
            value: function(queries) /*: ParseQuery*/ {
                var queryJSON = (0, $3677afb657bcb4bc$var$_map2.default)(queries).call(queries, function(q) {
                    return q.toJSON().where;
                });
                this._where.$or = queryJSON;
                return this;
            }
        },
        {
            key: "_andQuery",
            value: function(queries) /*: ParseQuery*/ {
                var queryJSON = (0, $3677afb657bcb4bc$var$_map2.default)(queries).call(queries, function(q) {
                    return q.toJSON().where;
                });
                this._where.$and = queryJSON;
                return this;
            }
        },
        {
            key: "_norQuery",
            value: function(queries) /*: ParseQuery*/ {
                var queryJSON = (0, $3677afb657bcb4bc$var$_map2.default)(queries).call(queries, function(q) {
                    return q.toJSON().where;
                });
                this._where.$nor = queryJSON;
                return this;
            }
        },
        {
            key: "_addCondition",
            value: function(key, condition, value) /*: ParseQuery*/ {
                if (!this._where[key] || typeof this._where[key] === "string") this._where[key] = {};
                this._where[key][condition] = (0, $3677afb657bcb4bc$var$_encode.default)(value, false, true);
                return this;
            }
        },
        {
            key: "_regexStartWith",
            value: function(string) /*: string*/ {
                return "^" + $3677afb657bcb4bc$var$quote(string);
            }
        },
        {
            key: "_handleOfflineQuery",
            value: function() {
                var _handleOfflineQuery2 = (0, $3677afb657bcb4bc$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3677afb657bcb4bc$var$_regeneratorRuntime().mark(function _callee(params) {
                    var _context, _this2 = this;
                    var localDatastore, objects, results, keys, alwaysSelectedKeys, sorts, count, limit;
                    return $3677afb657bcb4bc$var$_regeneratorRuntime().wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                $3677afb657bcb4bc$var$_OfflineQuery.default.validateQuery(this);
                                localDatastore = $3677afb657bcb4bc$var$_CoreManager.default.getLocalDatastore();
                                _context3.next = 4;
                                return localDatastore._serializeObjectsFromPinName(this._localDatastorePinName);
                            case 4:
                                objects = _context3.sent;
                                results = (0, $3677afb657bcb4bc$var$_filter2.default)(_context = (0, $3677afb657bcb4bc$var$_map2.default)(objects).call(objects, function(json, index, arr) {
                                    var object = $3677afb657bcb4bc$var$_ParseObject.default.fromJSON(json, false);
                                    if (json._localId && !json.objectId) object._localId = json._localId;
                                    if (!$3677afb657bcb4bc$var$_OfflineQuery.default.matchesQuery(_this2.className, object, arr, _this2)) return null;
                                    return object;
                                })).call(_context, function(object) {
                                    return object !== null;
                                });
                                if ((0, $3677afb657bcb4bc$var$_keys.default)(params)) {
                                    keys = (0, $3677afb657bcb4bc$var$_keys.default)(params).split(",");
                                    alwaysSelectedKeys = [
                                        "className",
                                        "objectId",
                                        "createdAt",
                                        "updatedAt",
                                        "ACL"
                                    ];
                                    keys = (0, $3677afb657bcb4bc$var$_concat.default)(keys).call(keys, alwaysSelectedKeys);
                                    results = (0, $3677afb657bcb4bc$var$_map2.default)(results).call(results, function(object) {
                                        var _context2;
                                        var json = object._toFullJSON();
                                        (0, $3677afb657bcb4bc$var$_forEach.default)(_context2 = (0, $3677afb657bcb4bc$var$_keys2.default)(json)).call(_context2, function(key) {
                                            if (!(0, $3677afb657bcb4bc$var$_includes.default)(keys).call(keys, key)) delete json[key];
                                        });
                                        return $3677afb657bcb4bc$var$_ParseObject.default.fromJSON(json, false);
                                    });
                                }
                                if (params.order) {
                                    sorts = params.order.split(",");
                                    (0, $3677afb657bcb4bc$var$_sort.default)(results).call(results, function(a, b) {
                                        return $3677afb657bcb4bc$var$handleOfflineSort(a, b, sorts);
                                    });
                                } // count total before applying limit/skip
                                if (params.count) count = results.length; // total count from response
                                if (params.skip) {
                                    if (params.skip >= results.length) results = [];
                                    else results = (0, $3677afb657bcb4bc$var$_splice.default)(results).call(results, params.skip, results.length);
                                }
                                limit = results.length;
                                if (params.limit !== 0 && params.limit < results.length) limit = params.limit;
                                results = (0, $3677afb657bcb4bc$var$_splice.default)(results).call(results, 0, limit);
                                if (!(typeof count === "number")) {
                                    _context3.next = 15;
                                    break;
                                }
                                return _context3.abrupt("return", {
                                    results: results,
                                    count: count
                                });
                            case 15:
                                return _context3.abrupt("return", results);
                            case 16:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee, this);
                }));
                function _handleOfflineQuery() {
                    return _handleOfflineQuery2.apply(this, arguments);
                }
                return _handleOfflineQuery;
            }()
        },
        {
            key: "toJSON",
            value: function() /*: QueryJSON*/ {
                var params = {
                    where: this._where
                };
                if (this._include.length) params.include = this._include.join(",");
                if (this._exclude.length) params.excludeKeys = this._exclude.join(",");
                if (this._select) params.keys = this._select.join(",");
                if (this._count) params.count = 1;
                if (this._limit >= 0) params.limit = this._limit;
                if (this._skip > 0) params.skip = this._skip;
                if (this._order) params.order = this._order.join(",");
                if (this._readPreference) params.readPreference = this._readPreference;
                if (this._includeReadPreference) params.includeReadPreference = this._includeReadPreference;
                if (this._subqueryReadPreference) params.subqueryReadPreference = this._subqueryReadPreference;
                if (this._hint) params.hint = this._hint;
                if (this._explain) params.explain = true;
                for(var _key3 in this._extraOptions)params[_key3] = this._extraOptions[_key3];
                return params;
            }
        },
        {
            key: "withJSON",
            value: function(json) /*: ParseQuery*/ {
                if (json.where) this._where = json.where;
                if (json.include) this._include = json.include.split(",");
                if ((0, $3677afb657bcb4bc$var$_keys.default)(json)) this._select = (0, $3677afb657bcb4bc$var$_keys.default)(json).split(",");
                if (json.excludeKeys) this._exclude = json.excludeKeys.split(",");
                if (json.count) this._count = json.count === 1;
                if (json.limit) this._limit = json.limit;
                if (json.skip) this._skip = json.skip;
                if (json.order) this._order = json.order.split(",");
                if (json.readPreference) this._readPreference = json.readPreference;
                if (json.includeReadPreference) this._includeReadPreference = json.includeReadPreference;
                if (json.subqueryReadPreference) this._subqueryReadPreference = json.subqueryReadPreference;
                if (json.hint) this._hint = json.hint;
                if (json.explain) this._explain = !!json.explain;
                for(var _key4 in json)if (json.hasOwnProperty(_key4)) {
                    var _context4;
                    if ((0, $3677afb657bcb4bc$var$_indexOf.default)(_context4 = [
                        "where",
                        "include",
                        "keys",
                        "count",
                        "limit",
                        "skip",
                        "order",
                        "readPreference",
                        "includeReadPreference",
                        "subqueryReadPreference",
                        "hint",
                        "explain"
                    ]).call(_context4, _key4) === -1) this._extraOptions[_key4] = json[_key4];
                }
                return this;
            }
        },
        {
            key: "get",
            value: /**
     * Constructs a Parse.Object whose id is already known by fetching data from
     * the server. Unlike the <code>first</code> method, it never returns undefined.
     *
     * @param {string} objectId The id of the object to be fetched.
     * @param {object} options
     * Valid options are:<ul>
     *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
     *     be used for this request.
     *   <li>sessionToken: A valid session token, used for making a request on
     *       behalf of a specific user.
     *   <li>context: A dictionary that is accessible in Cloud Code `beforeFind` trigger.
     *   <li>json: Return raw json without converting to Parse.Object
     * </ul>
     *
     * @returns {Promise} A promise that is resolved with the result when
     * the query completes.
     */ function(objectId, options) /*: Promise<ParseObject>*/ {
                this.equalTo("objectId", objectId);
                var firstOptions = {};
                if (options && options.hasOwnProperty("useMasterKey")) firstOptions.useMasterKey = options.useMasterKey;
                if (options && options.hasOwnProperty("sessionToken")) firstOptions.sessionToken = options.sessionToken;
                if (options && options.hasOwnProperty("context") && (0, $3677afb657bcb4bc$var$_typeof2.default)(options.context) === "object") firstOptions.context = options.context;
                if (options && options.hasOwnProperty("json")) firstOptions.json = options.json;
                return this.first(firstOptions).then(function(response) {
                    if (response) return response;
                    var errorObject = new $3677afb657bcb4bc$var$_ParseError.default($3677afb657bcb4bc$var$_ParseError.default.OBJECT_NOT_FOUND, "Object not found.");
                    return $3677afb657bcb4bc$var$_promise.default.reject(errorObject);
                });
            }
        },
        {
            key: "find",
            value: function(options) /*: Promise<Array<ParseObject>>*/ {
                var _this3 = this;
                options = options || {};
                var findOptions = {};
                if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("context") && (0, $3677afb657bcb4bc$var$_typeof2.default)(options.context) === "object") findOptions.context = options.context;
                this._setRequestTask(findOptions);
                var controller = $3677afb657bcb4bc$var$_CoreManager.default.getQueryController();
                var select = this._select;
                if (this._queriesLocalDatastore) return this._handleOfflineQuery(this.toJSON());
                return (0, $3677afb657bcb4bc$var$_find.default)(controller).call(controller, this.className, this.toJSON(), findOptions).then(function(response) {
                    var _context5; // Return generic object when explain is used
                    if (_this3._explain) return response.results;
                    var results = (0, $3677afb657bcb4bc$var$_map2.default)(_context5 = response.results).call(_context5, function(data) {
                        // In cases of relations, the server may send back a className
                        // on the top level of the payload
                        var override = response.className || _this3.className;
                        if (!data.className) data.className = override;
                         // Make sure the data object contains keys for all objects that
                        // have been requested with a select, so that our cached state
                        // updates correctly.
                        if (select) $3677afb657bcb4bc$var$handleSelectResult(data, select);
                        if (options.json) return data;
                        else return $3677afb657bcb4bc$var$_ParseObject.default.fromJSON(data, !select);
                    });
                    var count = response.count;
                    if (typeof count === "number") return {
                        results: results,
                        count: count
                    };
                    else return results;
                });
            }
        },
        {
            key: "findAll",
            value: function() {
                var _findAll = (0, $3677afb657bcb4bc$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3677afb657bcb4bc$var$_regeneratorRuntime().mark(function _callee2(options) {
                    var result;
                    return $3677afb657bcb4bc$var$_regeneratorRuntime().wrap(function _callee2$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                result = [];
                                _context7.next = 3;
                                return this.eachBatch(function(objects) {
                                    var _context6;
                                    result = (0, $3677afb657bcb4bc$var$_concat.default)(_context6 = []).call(_context6, (0, $3677afb657bcb4bc$var$_toConsumableArray2.default)(result), (0, $3677afb657bcb4bc$var$_toConsumableArray2.default)(objects));
                                }, options);
                            case 3:
                                return _context7.abrupt("return", result);
                            case 4:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee2, this);
                }));
                function findAll(_x2) {
                    return _findAll.apply(this, arguments);
                }
                return findAll;
            }()
        },
        {
            key: "count",
            value: function count(options) /*: Promise<number>*/ {
                options = options || {};
                var findOptions = {};
                if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
                this._setRequestTask(findOptions);
                var controller = $3677afb657bcb4bc$var$_CoreManager.default.getQueryController();
                var params = this.toJSON();
                params.limit = 0;
                params.count = 1;
                return (0, $3677afb657bcb4bc$var$_find.default)(controller).call(controller, this.className, params, findOptions).then(function(result) {
                    return result.count;
                });
            }
        },
        {
            key: "distinct",
            value: function distinct(key, options) /*: Promise<Array<mixed>>*/ {
                options = options || {};
                var distinctOptions = {};
                distinctOptions.useMasterKey = true;
                if (options.hasOwnProperty("sessionToken")) distinctOptions.sessionToken = options.sessionToken;
                this._setRequestTask(distinctOptions);
                var controller = $3677afb657bcb4bc$var$_CoreManager.default.getQueryController();
                var params = {
                    distinct: key,
                    where: this._where,
                    hint: this._hint
                };
                return controller.aggregate(this.className, params, distinctOptions).then(function(results) {
                    return results.results;
                });
            }
        },
        {
            key: "aggregate",
            value: function aggregate(pipeline, options) /*: Promise<Array<mixed>>*/ {
                options = options || {};
                var aggregateOptions = {};
                aggregateOptions.useMasterKey = true;
                if (options.hasOwnProperty("sessionToken")) aggregateOptions.sessionToken = options.sessionToken;
                this._setRequestTask(aggregateOptions);
                var controller = $3677afb657bcb4bc$var$_CoreManager.default.getQueryController();
                if (!(0, $3677afb657bcb4bc$var$_isArray.default)(pipeline) && (0, $3677afb657bcb4bc$var$_typeof2.default)(pipeline) !== "object") throw new Error("Invalid pipeline must be Array or Object");
                if ((0, $3677afb657bcb4bc$var$_keys2.default)(this._where || {}).length) {
                    if (!(0, $3677afb657bcb4bc$var$_isArray.default)(pipeline)) pipeline = [
                        pipeline
                    ];
                    pipeline.unshift({
                        match: this._where
                    });
                }
                var params = {
                    pipeline: pipeline,
                    hint: this._hint,
                    explain: this._explain,
                    readPreference: this._readPreference
                };
                return controller.aggregate(this.className, params, aggregateOptions).then(function(results) {
                    return results.results;
                });
            }
        },
        {
            key: "first",
            value: function first(options) /*: Promise<ParseObject | void>*/ {
                var _this4 = this;
                options = options || {};
                var findOptions = {};
                if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("context") && (0, $3677afb657bcb4bc$var$_typeof2.default)(options.context) === "object") findOptions.context = options.context;
                this._setRequestTask(findOptions);
                var controller = $3677afb657bcb4bc$var$_CoreManager.default.getQueryController();
                var params = this.toJSON();
                params.limit = 1;
                var select = this._select;
                if (this._queriesLocalDatastore) return this._handleOfflineQuery(params).then(function(objects) {
                    if (!objects[0]) return undefined;
                    return objects[0];
                });
                return (0, $3677afb657bcb4bc$var$_find.default)(controller).call(controller, this.className, params, findOptions).then(function(response) {
                    var objects = response.results;
                    if (!objects[0]) return undefined;
                    if (!objects[0].className) objects[0].className = _this4.className;
                     // Make sure the data object contains keys for all objects that
                    // have been requested with a select, so that our cached state
                    // updates correctly.
                    if (select) $3677afb657bcb4bc$var$handleSelectResult(objects[0], select);
                    if (options.json) return objects[0];
                    else return $3677afb657bcb4bc$var$_ParseObject.default.fromJSON(objects[0], !select);
                });
            }
        },
        {
            key: "eachBatch",
            value: function eachBatch(callback, options) /*: Promise<void>*/ {
                var _context8;
                options = options || {};
                if (this._order || this._skip || this._limit >= 0) {
                    var error = "Cannot iterate on a query with sort, skip, or limit.";
                    return $3677afb657bcb4bc$var$_promise.default.reject(error);
                }
                var query = new ParseQuery(this.className);
                query._limit = options.batchSize || 100;
                query._include = (0, $3677afb657bcb4bc$var$_map2.default)(_context8 = this._include).call(_context8, function(i) {
                    return i;
                });
                if (this._select) {
                    var _context9;
                    query._select = (0, $3677afb657bcb4bc$var$_map2.default)(_context9 = this._select).call(_context9, function(s) {
                        return s;
                    });
                }
                query._hint = this._hint;
                query._where = {};
                for(var _attr in this._where){
                    var val = this._where[_attr];
                    if ((0, $3677afb657bcb4bc$var$_isArray.default)(val)) query._where[_attr] = (0, $3677afb657bcb4bc$var$_map2.default)(val).call(val, function(v) {
                        return v;
                    });
                    else if (val && (0, $3677afb657bcb4bc$var$_typeof2.default)(val) === "object") {
                        var conditionMap = {};
                        query._where[_attr] = conditionMap;
                        for(var cond in val)conditionMap[cond] = val[cond];
                    } else query._where[_attr] = val;
                }
                query.ascending("objectId");
                var findOptions = {};
                if (options.hasOwnProperty("useMasterKey")) findOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("sessionToken")) findOptions.sessionToken = options.sessionToken;
                if (options.hasOwnProperty("context") && (0, $3677afb657bcb4bc$var$_typeof2.default)(options.context) === "object") findOptions.context = options.context;
                if (options.hasOwnProperty("json")) findOptions.json = options.json;
                var finished = false;
                var previousResults = [];
                return (0, $9FsFR.continueWhile)(function() {
                    return !finished;
                }, /*#__PURE__*/ (0, $3677afb657bcb4bc$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3677afb657bcb4bc$var$_regeneratorRuntime().mark(function _callee3() {
                    var _yield$Promise$all, _yield$Promise$all2, results;
                    return $3677afb657bcb4bc$var$_regeneratorRuntime().wrap(function _callee3$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                _context10.next = 2;
                                return $3677afb657bcb4bc$var$_promise.default.all([
                                    (0, $3677afb657bcb4bc$var$_find.default)(query).call(query, findOptions),
                                    $3677afb657bcb4bc$var$_promise.default.resolve(previousResults.length > 0 && callback(previousResults))
                                ]);
                            case 2:
                                _yield$Promise$all = _context10.sent;
                                _yield$Promise$all2 = (0, $3677afb657bcb4bc$var$_slicedToArray2.default)(_yield$Promise$all, 1);
                                results = _yield$Promise$all2[0];
                                if (!(results.length >= query._limit)) {
                                    _context10.next = 10;
                                    break;
                                }
                                query.greaterThan("objectId", results[results.length - 1].id);
                                previousResults = results;
                                _context10.next = 17;
                                break;
                            case 10:
                                if (!(results.length > 0)) {
                                    _context10.next = 16;
                                    break;
                                }
                                _context10.next = 13;
                                return $3677afb657bcb4bc$var$_promise.default.resolve(callback(results));
                            case 13:
                                finished = true;
                                _context10.next = 17;
                                break;
                            case 16:
                                finished = true;
                            case 17:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee3);
                })));
            }
        },
        {
            key: "each",
            value: function each(callback, options) /*: Promise<void>*/ {
                return this.eachBatch(function(results) {
                    var callbacksDone = $3677afb657bcb4bc$var$_promise.default.resolve();
                    (0, $3677afb657bcb4bc$var$_forEach.default)(results).call(results, function(result) {
                        callbacksDone = callbacksDone.then(function() {
                            return callback(result);
                        });
                    });
                    return callbacksDone;
                }, options);
            }
        },
        {
            key: "hint",
            value: function hint(value) /*: ParseQuery*/ {
                if (typeof value === "undefined") delete this._hint;
                this._hint = value;
                return this;
            }
        },
        {
            key: "explain",
            value: function explain() /*: ParseQuery*/ {
                var _explain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (typeof _explain !== "boolean") throw new Error("You can only set explain to a boolean value");
                this._explain = _explain;
                return this;
            }
        },
        {
            key: "map",
            value: function() {
                var _map = (0, $3677afb657bcb4bc$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3677afb657bcb4bc$var$_regeneratorRuntime().mark(function _callee4(callback, options) {
                    var _this5 = this;
                    var array, index;
                    return $3677afb657bcb4bc$var$_regeneratorRuntime().wrap(function _callee4$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                array = [];
                                index = 0;
                                _context11.next = 4;
                                return this.each(function(object) {
                                    return $3677afb657bcb4bc$var$_promise.default.resolve(callback(object, index, _this5)).then(function(result) {
                                        array.push(result);
                                        index += 1;
                                    });
                                }, options);
                            case 4:
                                return _context11.abrupt("return", array);
                            case 5:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee4, this);
                }));
                function map(_x3, _x4) {
                    return _map.apply(this, arguments);
                }
                return map;
            }()
        },
        {
            key: "reduce",
            value: function() {
                var _reduce = (0, $3677afb657bcb4bc$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3677afb657bcb4bc$var$_regeneratorRuntime().mark(function _callee5(callback, initialValue, options) {
                    var accumulator, index;
                    return $3677afb657bcb4bc$var$_regeneratorRuntime().wrap(function _callee5$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                accumulator = initialValue;
                                index = 0;
                                _context12.next = 4;
                                return this.each(function(object) {
                                    // If no initial value was given, we take the first object from the query
                                    // as the initial value and don't call the callback with it.
                                    if (index === 0 && initialValue === undefined) {
                                        accumulator = object;
                                        index += 1;
                                        return;
                                    }
                                    return $3677afb657bcb4bc$var$_promise.default.resolve(callback(accumulator, object, index)).then(function(result) {
                                        accumulator = result;
                                        index += 1;
                                    });
                                }, options);
                            case 4:
                                if (!(index === 0 && initialValue === undefined)) {
                                    _context12.next = 6;
                                    break;
                                }
                                throw new TypeError("Reducing empty query result set with no initial value");
                            case 6:
                                return _context12.abrupt("return", accumulator);
                            case 7:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee5, this);
                }));
                function reduce(_x5, _x6, _x7) {
                    return _reduce.apply(this, arguments);
                }
                return reduce;
            }()
        },
        {
            key: "filter",
            value: function() {
                var _filter = (0, $3677afb657bcb4bc$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3677afb657bcb4bc$var$_regeneratorRuntime().mark(function _callee6(callback, options) {
                    var _this6 = this;
                    var array, index;
                    return $3677afb657bcb4bc$var$_regeneratorRuntime().wrap(function _callee6$(_context13) {
                        while(true)switch(_context13.prev = _context13.next){
                            case 0:
                                array = [];
                                index = 0;
                                _context13.next = 4;
                                return this.each(function(object) {
                                    return $3677afb657bcb4bc$var$_promise.default.resolve(callback(object, index, _this6)).then(function(flag) {
                                        if (flag) array.push(object);
                                        index += 1;
                                    });
                                }, options);
                            case 4:
                                return _context13.abrupt("return", array);
                            case 5:
                            case "end":
                                return _context13.stop();
                        }
                    }, _callee6, this);
                }));
                function filter(_x8, _x9) {
                    return _filter.apply(this, arguments);
                }
                return filter;
            }()
        },
        {
            key: "equalTo",
            value: function equalTo(key, value) /*: ParseQuery*/ {
                var _this7 = this;
                if (key && (0, $3677afb657bcb4bc$var$_typeof2.default)(key) === "object") {
                    var _context14;
                    (0, $3677afb657bcb4bc$var$_forEach.default)(_context14 = (0, $3677afb657bcb4bc$var$_entries.default)(key)).call(_context14, function(_ref2) {
                        var _ref3 = (0, $3677afb657bcb4bc$var$_slicedToArray2.default)(_ref2, 2), k = _ref3[0], val = _ref3[1];
                        return _this7.equalTo(k, val);
                    });
                    return this;
                }
                if (typeof value === "undefined") return this.doesNotExist(key);
                this._where[key] = (0, $3677afb657bcb4bc$var$_encode.default)(value, false, true);
                return this;
            }
        },
        {
            key: "notEqualTo",
            value: function notEqualTo(key, value) /*: ParseQuery*/ {
                var _this8 = this;
                if (key && (0, $3677afb657bcb4bc$var$_typeof2.default)(key) === "object") {
                    var _context15;
                    (0, $3677afb657bcb4bc$var$_forEach.default)(_context15 = (0, $3677afb657bcb4bc$var$_entries.default)(key)).call(_context15, function(_ref4) {
                        var _ref5 = (0, $3677afb657bcb4bc$var$_slicedToArray2.default)(_ref4, 2), k = _ref5[0], val = _ref5[1];
                        return _this8.notEqualTo(k, val);
                    });
                    return this;
                }
                return this._addCondition(key, "$ne", value);
            }
        },
        {
            key: "lessThan",
            value: function lessThan(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$lt", value);
            }
        },
        {
            key: "greaterThan",
            value: function greaterThan(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$gt", value);
            }
        },
        {
            key: "lessThanOrEqualTo",
            value: function lessThanOrEqualTo(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$lte", value);
            }
        },
        {
            key: "greaterThanOrEqualTo",
            value: function greaterThanOrEqualTo(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$gte", value);
            }
        },
        {
            key: "containedIn",
            value: function containedIn(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$in", value);
            }
        },
        {
            key: "notContainedIn",
            value: function notContainedIn(key, value) /*: ParseQuery*/ {
                return this._addCondition(key, "$nin", value);
            }
        },
        {
            key: "containedBy",
            value: function containedBy(key, values) /*: ParseQuery*/ {
                return this._addCondition(key, "$containedBy", values);
            }
        },
        {
            key: "containsAll",
            value: function containsAll(key, values) /*: ParseQuery*/ {
                return this._addCondition(key, "$all", values);
            }
        },
        {
            key: "containsAllStartingWith",
            value: function containsAllStartingWith(key, values) /*: ParseQuery*/ {
                var _this = this;
                if (!(0, $3677afb657bcb4bc$var$_isArray.default)(values)) values = [
                    values
                ];
                var regexObject = (0, $3677afb657bcb4bc$var$_map2.default)(values).call(values, function(value) {
                    return {
                        $regex: _this._regexStartWith(value)
                    };
                });
                return this.containsAll(key, regexObject);
            }
        },
        {
            key: "exists",
            value: function exists(key) /*: ParseQuery*/ {
                return this._addCondition(key, "$exists", true);
            }
        },
        {
            key: "doesNotExist",
            value: function doesNotExist(key) /*: ParseQuery*/ {
                return this._addCondition(key, "$exists", false);
            }
        },
        {
            key: "matches",
            value: function matches(key, regex, modifiers) /*: ParseQuery*/ {
                this._addCondition(key, "$regex", regex);
                if (!modifiers) modifiers = "";
                if (regex.ignoreCase) modifiers += "i";
                if (regex.multiline) modifiers += "m";
                if (modifiers.length) this._addCondition(key, "$options", modifiers);
                return this;
            }
        },
        {
            key: "matchesQuery",
            value: function matchesQuery(key, query) /*: ParseQuery*/ {
                var queryJSON = query.toJSON();
                queryJSON.className = query.className;
                return this._addCondition(key, "$inQuery", queryJSON);
            }
        },
        {
            key: "doesNotMatchQuery",
            value: function doesNotMatchQuery(key, query) /*: ParseQuery*/ {
                var queryJSON = query.toJSON();
                queryJSON.className = query.className;
                return this._addCondition(key, "$notInQuery", queryJSON);
            }
        },
        {
            key: "matchesKeyInQuery",
            value: function matchesKeyInQuery(key, queryKey, query) /*: ParseQuery*/ {
                var queryJSON = query.toJSON();
                queryJSON.className = query.className;
                return this._addCondition(key, "$select", {
                    key: queryKey,
                    query: queryJSON
                });
            }
        },
        {
            key: "doesNotMatchKeyInQuery",
            value: function doesNotMatchKeyInQuery(key, queryKey, query) /*: ParseQuery*/ {
                var queryJSON = query.toJSON();
                queryJSON.className = query.className;
                return this._addCondition(key, "$dontSelect", {
                    key: queryKey,
                    query: queryJSON
                });
            }
        },
        {
            key: "contains",
            value: function contains(key, substring) /*: ParseQuery*/ {
                if (typeof substring !== "string") throw new Error("The value being searched for must be a string.");
                return this._addCondition(key, "$regex", $3677afb657bcb4bc$var$quote(substring));
            }
        },
        {
            key: "fullText",
            value: function fullText(key, value, options) /*: ParseQuery*/ {
                options = options || {};
                if (!key) throw new Error("A key is required.");
                if (!value) throw new Error("A search term is required");
                if (typeof value !== "string") throw new Error("The value being searched for must be a string.");
                var fullOptions = {};
                fullOptions.$term = value;
                for(var option in options)switch(option){
                    case "language":
                        fullOptions.$language = options[option];
                        break;
                    case "caseSensitive":
                        fullOptions.$caseSensitive = options[option];
                        break;
                    case "diacriticSensitive":
                        fullOptions.$diacriticSensitive = options[option];
                        break;
                    default:
                        throw new Error("Unknown option: ".concat(option));
                }
                return this._addCondition(key, "$text", {
                    $search: fullOptions
                });
            }
        },
        {
            key: "sortByTextScore",
            value: function sortByTextScore() {
                this.ascending("$score");
                this.select([
                    "$score"
                ]);
                return this;
            }
        },
        {
            key: "startsWith",
            value: function startsWith(key, prefix, modifiers) /*: ParseQuery*/ {
                if (typeof prefix !== "string") throw new Error("The value being searched for must be a string.");
                return this.matches(key, this._regexStartWith(prefix), modifiers);
            }
        },
        {
            key: "endsWith",
            value: function endsWith(key, suffix, modifiers) /*: ParseQuery*/ {
                if (typeof suffix !== "string") throw new Error("The value being searched for must be a string.");
                return this.matches(key, $3677afb657bcb4bc$var$quote(suffix) + "$", modifiers);
            }
        },
        {
            key: "near",
            value: function near(key, point) /*: ParseQuery*/ {
                if (!(point instanceof $3677afb657bcb4bc$var$_ParseGeoPoint.default)) // Try to cast it as a GeoPoint
                point = new $3677afb657bcb4bc$var$_ParseGeoPoint.default(point);
                return this._addCondition(key, "$nearSphere", point);
            }
        },
        {
            key: "withinRadians",
            value: function withinRadians(key, point, maxDistance, sorted) /*: ParseQuery*/ {
                if (sorted || sorted === undefined) {
                    this.near(key, point);
                    return this._addCondition(key, "$maxDistance", maxDistance);
                } else return this._addCondition(key, "$geoWithin", {
                    $centerSphere: [
                        [
                            point.longitude,
                            point.latitude
                        ],
                        maxDistance
                    ]
                });
            }
        },
        {
            key: "withinMiles",
            value: function withinMiles(key, point, maxDistance, sorted) /*: ParseQuery*/ {
                return this.withinRadians(key, point, maxDistance / 3958.8, sorted);
            }
        },
        {
            key: "withinKilometers",
            value: function withinKilometers(key, point, maxDistance, sorted) /*: ParseQuery*/ {
                return this.withinRadians(key, point, maxDistance / 6371.0, sorted);
            }
        },
        {
            key: "withinGeoBox",
            value: function withinGeoBox(key, southwest, northeast) /*: ParseQuery*/ {
                if (!(southwest instanceof $3677afb657bcb4bc$var$_ParseGeoPoint.default)) southwest = new $3677afb657bcb4bc$var$_ParseGeoPoint.default(southwest);
                if (!(northeast instanceof $3677afb657bcb4bc$var$_ParseGeoPoint.default)) northeast = new $3677afb657bcb4bc$var$_ParseGeoPoint.default(northeast);
                this._addCondition(key, "$within", {
                    $box: [
                        southwest,
                        northeast
                    ]
                });
                return this;
            }
        },
        {
            key: "withinPolygon",
            value: function withinPolygon(key, points) /*: ParseQuery*/ {
                return this._addCondition(key, "$geoWithin", {
                    $polygon: points
                });
            }
        },
        {
            key: "polygonContains",
            value: function polygonContains(key, point) /*: ParseQuery*/ {
                return this._addCondition(key, "$geoIntersects", {
                    $point: point
                });
            }
        },
        {
            key: "ascending",
            value: function ascending() /*: ParseQuery*/ {
                this._order = [];
                for(var _len = arguments.length, keys = new Array(_len), _key5 = 0; _key5 < _len; _key5++)keys[_key5] = arguments[_key5];
                return this.addAscending.apply(this, keys);
            }
        },
        {
            key: "addAscending",
            value: function addAscending() /*: ParseQuery*/ {
                var _this9 = this;
                if (!this._order) this._order = [];
                for(var _len2 = arguments.length, keys = new Array(_len2), _key6 = 0; _key6 < _len2; _key6++)keys[_key6] = arguments[_key6];
                (0, $3677afb657bcb4bc$var$_forEach.default)(keys).call(keys, function(key) {
                    var _context16;
                    if ((0, $3677afb657bcb4bc$var$_isArray.default)(key)) key = key.join();
                    _this9._order = (0, $3677afb657bcb4bc$var$_concat.default)(_context16 = _this9._order).call(_context16, key.replace(/\s/g, "").split(","));
                });
                return this;
            }
        },
        {
            key: "descending",
            value: function descending() /*: ParseQuery*/ {
                this._order = [];
                for(var _len3 = arguments.length, keys = new Array(_len3), _key7 = 0; _key7 < _len3; _key7++)keys[_key7] = arguments[_key7];
                return this.addDescending.apply(this, keys);
            }
        },
        {
            key: "addDescending",
            value: function addDescending() /*: ParseQuery*/ {
                var _this10 = this;
                if (!this._order) this._order = [];
                for(var _len4 = arguments.length, keys = new Array(_len4), _key8 = 0; _key8 < _len4; _key8++)keys[_key8] = arguments[_key8];
                (0, $3677afb657bcb4bc$var$_forEach.default)(keys).call(keys, function(key) {
                    var _context17, _context18;
                    if ((0, $3677afb657bcb4bc$var$_isArray.default)(key)) key = key.join();
                    _this10._order = (0, $3677afb657bcb4bc$var$_concat.default)(_context17 = _this10._order).call(_context17, (0, $3677afb657bcb4bc$var$_map2.default)(_context18 = key.replace(/\s/g, "").split(",")).call(_context18, function(k) {
                        return "-" + k;
                    }));
                });
                return this;
            }
        },
        {
            key: "skip",
            value: function skip(n) /*: ParseQuery*/ {
                if (typeof n !== "number" || n < 0) throw new Error("You can only skip by a positive number");
                this._skip = n;
                return this;
            }
        },
        {
            key: "limit",
            value: function limit(n) /*: ParseQuery*/ {
                if (typeof n !== "number") throw new Error("You can only set the limit to a numeric value");
                this._limit = n;
                return this;
            }
        },
        {
            key: "withCount",
            value: function withCount() /*: ParseQuery*/ {
                var includeCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (typeof includeCount !== "boolean") throw new Error("You can only set withCount to a boolean value");
                this._count = includeCount;
                return this;
            }
        },
        {
            key: "include",
            value: function include() /*: ParseQuery*/ {
                var _this11 = this;
                for(var _len5 = arguments.length, keys = new Array(_len5), _key9 = 0; _key9 < _len5; _key9++)keys[_key9] = arguments[_key9];
                (0, $3677afb657bcb4bc$var$_forEach.default)(keys).call(keys, function(key) {
                    if ((0, $3677afb657bcb4bc$var$_isArray.default)(key)) {
                        var _context19;
                        _this11._include = (0, $3677afb657bcb4bc$var$_concat.default)(_context19 = _this11._include).call(_context19, key);
                    } else _this11._include.push(key);
                });
                return this;
            }
        },
        {
            key: "includeAll",
            value: function includeAll() /*: ParseQuery*/ {
                return this.include("*");
            }
        },
        {
            key: "select",
            value: function select() /*: ParseQuery*/ {
                var _this12 = this;
                if (!this._select) this._select = [];
                for(var _len6 = arguments.length, keys = new Array(_len6), _key10 = 0; _key10 < _len6; _key10++)keys[_key10] = arguments[_key10];
                (0, $3677afb657bcb4bc$var$_forEach.default)(keys).call(keys, function(key) {
                    if ((0, $3677afb657bcb4bc$var$_isArray.default)(key)) {
                        var _context20;
                        _this12._select = (0, $3677afb657bcb4bc$var$_concat.default)(_context20 = _this12._select).call(_context20, key);
                    } else _this12._select.push(key);
                });
                return this;
            }
        },
        {
            key: "exclude",
            value: function exclude() /*: ParseQuery*/ {
                var _this13 = this;
                for(var _len7 = arguments.length, keys = new Array(_len7), _key11 = 0; _key11 < _len7; _key11++)keys[_key11] = arguments[_key11];
                (0, $3677afb657bcb4bc$var$_forEach.default)(keys).call(keys, function(key) {
                    if ((0, $3677afb657bcb4bc$var$_isArray.default)(key)) {
                        var _context21;
                        _this13._exclude = (0, $3677afb657bcb4bc$var$_concat.default)(_context21 = _this13._exclude).call(_context21, key);
                    } else _this13._exclude.push(key);
                });
                return this;
            }
        },
        {
            key: "readPreference",
            value: function readPreference(_readPreference, includeReadPreference, subqueryReadPreference) /*: ParseQuery*/ {
                this._readPreference = _readPreference;
                this._includeReadPreference = includeReadPreference;
                this._subqueryReadPreference = subqueryReadPreference;
                return this;
            }
        },
        {
            key: "subscribe",
            value: function() {
                var _subscribe = (0, $3677afb657bcb4bc$var$_asyncToGenerator2.default)(/*#__PURE__*/ $3677afb657bcb4bc$var$_regeneratorRuntime().mark(function _callee7(sessionToken) {
                    var currentUser, liveQueryClient, subscription;
                    return $3677afb657bcb4bc$var$_regeneratorRuntime().wrap(function _callee7$(_context22) {
                        while(true)switch(_context22.prev = _context22.next){
                            case 0:
                                _context22.next = 2;
                                return $3677afb657bcb4bc$var$_CoreManager.default.getUserController().currentUserAsync();
                            case 2:
                                currentUser = _context22.sent;
                                if (!sessionToken) sessionToken = currentUser ? currentUser.getSessionToken() : undefined;
                                _context22.next = 6;
                                return $3677afb657bcb4bc$var$_CoreManager.default.getLiveQueryController().getDefaultLiveQueryClient();
                            case 6:
                                liveQueryClient = _context22.sent;
                                if (liveQueryClient.shouldOpen()) liveQueryClient.open();
                                subscription = liveQueryClient.subscribe(this, sessionToken);
                                return _context22.abrupt("return", subscription.subscribePromise.then(function() {
                                    return subscription;
                                }));
                            case 10:
                            case "end":
                                return _context22.stop();
                        }
                    }, _callee7, this);
                }));
                function subscribe(_x10) {
                    return _subscribe.apply(this, arguments);
                }
                return subscribe;
            }()
        },
        {
            key: "fromNetwork",
            value: /**
     * Change the source of this query to the server.
     *
     * @returns {Parse.Query} Returns the query, so you can chain this call.
     */ function fromNetwork() /*: ParseQuery*/ {
                this._queriesLocalDatastore = false;
                this._localDatastorePinName = null;
                return this;
            }
        },
        {
            key: "fromLocalDatastore",
            value: function fromLocalDatastore() /*: ParseQuery*/ {
                return this.fromPinWithName(null);
            }
        },
        {
            key: "fromPin",
            value: function fromPin() /*: ParseQuery*/ {
                return this.fromPinWithName($klpRA.DEFAULT_PIN);
            }
        },
        {
            key: "fromPinWithName",
            value: function fromPinWithName(name) /*: ParseQuery*/ {
                var localDatastore = $3677afb657bcb4bc$var$_CoreManager.default.getLocalDatastore();
                if (localDatastore.checkIfEnabled()) {
                    this._queriesLocalDatastore = true;
                    this._localDatastorePinName = name;
                }
                return this;
            }
        },
        {
            key: "cancel",
            value: function cancel() /*: ParseQuery*/ {
                var _this14 = this;
                if (this._xhrRequest.task && typeof this._xhrRequest.task.abort === "function") {
                    this._xhrRequest.task._aborted = true;
                    this._xhrRequest.task.abort();
                    this._xhrRequest.task = null;
                    this._xhrRequest.onchange = function() {};
                    return this;
                }
                return this._xhrRequest.onchange = function() {
                    return _this14.cancel();
                };
            }
        },
        {
            key: "_setRequestTask",
            value: function _setRequestTask(options) {
                var _this15 = this;
                options.requestTask = function(task) {
                    _this15._xhrRequest.task = task;
                    _this15._xhrRequest.onchange();
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(className, json) /*: ParseQuery*/ {
                var query = new ParseQuery(className);
                return query.withJSON(json);
            }
        },
        {
            key: "or",
            value: function or() /*: ParseQuery*/ {
                for(var _len8 = arguments.length, queries = new Array(_len8), _key12 = 0; _key12 < _len8; _key12++)queries[_key12] = arguments[_key12];
                var className = $3677afb657bcb4bc$var$_getClassNameFromQueries(queries);
                var query = new ParseQuery(className);
                query._orQuery(queries);
                return query;
            }
        },
        {
            key: "and",
            value: function and() /*: ParseQuery*/ {
                for(var _len9 = arguments.length, queries = new Array(_len9), _key13 = 0; _key13 < _len9; _key13++)queries[_key13] = arguments[_key13];
                var className = $3677afb657bcb4bc$var$_getClassNameFromQueries(queries);
                var query = new ParseQuery(className);
                query._andQuery(queries);
                return query;
            }
        },
        {
            key: "nor",
            value: function nor() /*: ParseQuery*/ {
                for(var _len10 = arguments.length, queries = new Array(_len10), _key14 = 0; _key14 < _len10; _key14++)queries[_key14] = arguments[_key14];
                var className = $3677afb657bcb4bc$var$_getClassNameFromQueries(queries);
                var query = new ParseQuery(className);
                query._norQuery(queries);
                return query;
            }
        }
    ]);
    return ParseQuery;
}();
var $3677afb657bcb4bc$var$DefaultController = {
    find: function find(className, params, options) /*: Promise<Array<ParseObject>>*/ {
        var RESTController = $3677afb657bcb4bc$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "classes/" + className, params, options);
    },
    aggregate: function aggregate(className, params, options) /*: Promise<Array<mixed>>*/ {
        var RESTController = $3677afb657bcb4bc$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "aggregate/" + className, params, options);
    }
};
$3677afb657bcb4bc$var$_CoreManager.default.setQueryController($3677afb657bcb4bc$var$DefaultController);
var $3677afb657bcb4bc$var$_default = $3677afb657bcb4bc$var$ParseQuery;
module.exports.default = $3677afb657bcb4bc$var$_default;

});
parcelRequire.register("hOvAP", function(module, exports) {

module.exports = (parcelRequire("guHiv"));

});
parcelRequire.register("guHiv", function(module, exports) {

var $g8ncX = parcelRequire("g8ncX");
module.exports = $g8ncX;

});
parcelRequire.register("g8ncX", function(module, exports) {
parcelRequire("52i1a");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.entries;

});
parcelRequire.register("52i1a", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $78Urq = parcelRequire("78Urq");
var $3aab1d9fdd92967c$require$$entries = $78Urq.entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$ggcsv({
    target: "Object",
    stat: true
}, {
    entries: function entries(O) {
        return $3aab1d9fdd92967c$require$$entries(O);
    }
});

});
parcelRequire.register("78Urq", function(module, exports) {

var $jeZ4p = parcelRequire("jeZ4p");

var $77TPA = parcelRequire("77TPA");

var $f518o = parcelRequire("f518o");

var $2pQL6 = parcelRequire("2pQL6");

var $3Ut0t = parcelRequire("3Ut0t");

var $bYkAs = parcelRequire("bYkAs");

var $d5uYy = parcelRequire("d5uYy");
var $53350fd4f9c1fc1e$require$$propertyIsEnumerable = $d5uYy.f;
var $53350fd4f9c1fc1e$var$propertyIsEnumerable = $f518o($53350fd4f9c1fc1e$require$$propertyIsEnumerable);
var $53350fd4f9c1fc1e$var$push = $f518o([].push);
// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var $53350fd4f9c1fc1e$var$IE_BUG = $jeZ4p && $77TPA(function() {
    // eslint-disable-next-line es/no-object-create -- safe
    var O = Object.create(null);
    O[2] = 2;
    return !$53350fd4f9c1fc1e$var$propertyIsEnumerable(O, 2);
});
// `Object.{ entries, values }` methods implementation
var $53350fd4f9c1fc1e$var$createMethod = function(TO_ENTRIES) {
    return function(it) {
        var O = $bYkAs(it);
        var keys = $3Ut0t(O);
        var IE_WORKAROUND = $53350fd4f9c1fc1e$var$IE_BUG && $2pQL6(O) === null;
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$jeZ4p || (IE_WORKAROUND ? key in O : $53350fd4f9c1fc1e$var$propertyIsEnumerable(O, key))) $53350fd4f9c1fc1e$var$push(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
module.exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: $53350fd4f9c1fc1e$var$createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: $53350fd4f9c1fc1e$var$createMethod(false)
};

});





parcelRequire.register("h3AFy", function(module, exports) {

var $5rMh0 = parcelRequire("5rMh0");

var $hIR13 = parcelRequire("hIR13");

var $8qDrx = parcelRequire("8qDrx");

var $dU7eN = parcelRequire("dU7eN");
function $c6af293cde80aa0c$var$_toConsumableArray(arr) {
    return $5rMh0(arr) || $hIR13(arr) || $8qDrx(arr) || $dU7eN();
}
module.exports = $c6af293cde80aa0c$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("5rMh0", function(module, exports) {

var $6xtVb = parcelRequire("6xtVb");

var $bdV1f = parcelRequire("bdV1f");
function $3f74eb7396383e1a$var$_arrayWithoutHoles(arr) {
    if ($6xtVb(arr)) return $bdV1f(arr);
}
module.exports = $3f74eb7396383e1a$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("hIR13", function(module, exports) {

var $3nM7d = parcelRequire("3nM7d");

var $iG2ur = parcelRequire("iG2ur");

var $7VEQP = parcelRequire("7VEQP");
function $ce6fab9f5ab91ee5$var$_iterableToArray(iter) {
    if (typeof $3nM7d !== "undefined" && $iG2ur(iter) != null || iter["@@iterator"] != null) return $7VEQP(iter);
}
module.exports = $ce6fab9f5ab91ee5$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("dU7eN", function(module, exports) {
function $a1f61e937f9b8289$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $a1f61e937f9b8289$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("8zvHt", function(module, exports) {

module.exports = (parcelRequire("400TD"));

});
parcelRequire.register("400TD", function(module, exports) {

var $iQtta = parcelRequire("iQtta");
module.exports = $iQtta;

});
parcelRequire.register("iQtta", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $4J1NL = parcelRequire("4J1NL");
var $db83f1561354fe44$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.sort;
    return it === $db83f1561354fe44$var$ArrayPrototype || $8hsAO($db83f1561354fe44$var$ArrayPrototype, it) && own === $db83f1561354fe44$var$ArrayPrototype.sort ? $4J1NL : own;
};

});
parcelRequire.register("4J1NL", function(module, exports) {
parcelRequire("5MdsH");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").sort;

});
parcelRequire.register("5MdsH", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $f518o = parcelRequire("f518o");

var $8GsPx = parcelRequire("8GsPx");

var $iJNxK = parcelRequire("iJNxK");

var $6ocdr = parcelRequire("6ocdr");

var $adIjL = parcelRequire("adIjL");

var $l2Ut5 = parcelRequire("l2Ut5");

var $77TPA = parcelRequire("77TPA");

var $fkYhf = parcelRequire("fkYhf");

var $kQPJO = parcelRequire("kQPJO");

var $QGv4E = parcelRequire("QGv4E");

var $3vdye = parcelRequire("3vdye");

var $1MzR6 = parcelRequire("1MzR6");

var $2TmTf = parcelRequire("2TmTf");
var $434be0b4f2b23d14$var$test = [];
var $434be0b4f2b23d14$var$nativeSort = $f518o($434be0b4f2b23d14$var$test.sort);
var $434be0b4f2b23d14$var$push = $f518o($434be0b4f2b23d14$var$test.push);
// IE8-
var $434be0b4f2b23d14$var$FAILS_ON_UNDEFINED = $77TPA(function() {
    $434be0b4f2b23d14$var$test.sort(undefined);
});
// V8 bug
var $434be0b4f2b23d14$var$FAILS_ON_NULL = $77TPA(function() {
    $434be0b4f2b23d14$var$test.sort(null);
});
// Old WebKit
var $434be0b4f2b23d14$var$STRICT_METHOD = $kQPJO("sort");
var $434be0b4f2b23d14$var$STABLE_SORT = !$77TPA(function() {
    // feature detection can be too slow, so check engines versions
    if ($1MzR6) return $1MzR6 < 70;
    if ($QGv4E && $QGv4E > 3) return;
    if ($3vdye) return true;
    if ($2TmTf) return $2TmTf < 603;
    var result = "";
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$434be0b4f2b23d14$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $434be0b4f2b23d14$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $434be0b4f2b23d14$var$test.length; index++){
        chr = $434be0b4f2b23d14$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== "DGBEFHACIJK";
});
var $434be0b4f2b23d14$var$FORCED = $434be0b4f2b23d14$var$FAILS_ON_UNDEFINED || !$434be0b4f2b23d14$var$FAILS_ON_NULL || !$434be0b4f2b23d14$var$STRICT_METHOD || !$434be0b4f2b23d14$var$STABLE_SORT;
var $434be0b4f2b23d14$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $l2Ut5(x) > $l2Ut5(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$ggcsv({
    target: "Array",
    proto: true,
    forced: $434be0b4f2b23d14$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $8GsPx(comparefn);
        var array = $iJNxK(this);
        if ($434be0b4f2b23d14$var$STABLE_SORT) return comparefn === undefined ? $434be0b4f2b23d14$var$nativeSort(array) : $434be0b4f2b23d14$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $6ocdr(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $434be0b4f2b23d14$var$push(items, array[index]);
        $fkYhf(items, $434be0b4f2b23d14$var$getSortCompare(comparefn));
        itemsLength = $6ocdr(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$adIjL(array, index++);
        return array;
    }
});

});
parcelRequire.register("fkYhf", function(module, exports) {

var $9SxVM = parcelRequire("9SxVM");
var $b2a77b1793b3a8f1$var$floor = Math.floor;
var $b2a77b1793b3a8f1$var$mergeSort = function(array, comparefn) {
    var length = array.length;
    var middle = $b2a77b1793b3a8f1$var$floor(length / 2);
    return length < 8 ? $b2a77b1793b3a8f1$var$insertionSort(array, comparefn) : $b2a77b1793b3a8f1$var$merge(array, $b2a77b1793b3a8f1$var$mergeSort($9SxVM(array, 0, middle), comparefn), $b2a77b1793b3a8f1$var$mergeSort($9SxVM(array, middle), comparefn), comparefn);
};
var $b2a77b1793b3a8f1$var$insertionSort = function(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $b2a77b1793b3a8f1$var$merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
module.exports = $b2a77b1793b3a8f1$var$mergeSort;

});

parcelRequire.register("QGv4E", function(module, exports) {

var $4Hrut = parcelRequire("4Hrut");
var $09e5d318d1f952a6$var$firefox = $4Hrut.match(/firefox\/(\d+)/i);
module.exports = !!$09e5d318d1f952a6$var$firefox && +$09e5d318d1f952a6$var$firefox[1];

});

parcelRequire.register("3vdye", function(module, exports) {

var $4Hrut = parcelRequire("4Hrut");
module.exports = /MSIE|Trident/.test($4Hrut);

});

parcelRequire.register("2TmTf", function(module, exports) {

var $4Hrut = parcelRequire("4Hrut");
var $21b279521b8a1129$var$webkit = $4Hrut.match(/AppleWebKit\/(\d+)\./);
module.exports = !!$21b279521b8a1129$var$webkit && +$21b279521b8a1129$var$webkit[1];

});






parcelRequire.register("e9nT0", function(module, exports) {

module.exports = (parcelRequire("hFJ9D"));

});
parcelRequire.register("hFJ9D", function(module, exports) {
parcelRequire("jXhxH");

var $aHxiP = parcelRequire("aHxiP");

var $heVlo = parcelRequire("heVlo");

var $8hsAO = parcelRequire("8hsAO");

var $4dz8S = parcelRequire("4dz8S");
var $cdd94abe6deac196$var$ArrayPrototype = Array.prototype;
var $cdd94abe6deac196$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.keys;
    return it === $cdd94abe6deac196$var$ArrayPrototype || $8hsAO($cdd94abe6deac196$var$ArrayPrototype, it) && own === $cdd94abe6deac196$var$ArrayPrototype.keys || $heVlo($cdd94abe6deac196$var$DOMIterables, $aHxiP(it)) ? $4dz8S : own;
};

});
parcelRequire.register("4dz8S", function(module, exports) {

var $1ZkcD = parcelRequire("1ZkcD");
module.exports = $1ZkcD;

});
parcelRequire.register("1ZkcD", function(module, exports) {
parcelRequire("5xrGR");
parcelRequire("iYyco");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").keys;

});




parcelRequire.register("9FsFR", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.continueWhile = $709e2f78d55925d6$var$continueWhile;
module.exports.resolvingPromise = $709e2f78d55925d6$var$resolvingPromise;
module.exports.when = $709e2f78d55925d6$var$when;

var $709e2f78d55925d6$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $709e2f78d55925d6$var$_promise = $iHLHC((parcelRequire("iH0WI"))); // Create Deferred Promise
function $709e2f78d55925d6$var$resolvingPromise() {
    var res;
    var rej;
    var promise = new $709e2f78d55925d6$var$_promise.default(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $709e2f78d55925d6$var$when(promises) {
    var objects;
    var arrayArgument = (0, $709e2f78d55925d6$var$_isArray.default)(promises);
    if (arrayArgument) objects = promises;
    else objects = arguments;
    var total = objects.length;
    var hadError = false;
    var results = [];
    var returnValue = arrayArgument ? [
        results
    ] : results;
    var errors = [];
    results.length = objects.length;
    errors.length = objects.length;
    if (total === 0) return $709e2f78d55925d6$var$_promise.default.resolve(returnValue);
    var promise = new $709e2f78d55925d6$var$resolvingPromise();
    var resolveOne = function() {
        total--;
        if (total <= 0) {
            if (hadError) promise.reject(errors);
            else promise.resolve(returnValue);
        }
    };
    var chain = function(object, index) {
        if (object && typeof object.then === "function") object.then(function(result) {
            results[index] = result;
            resolveOne();
        }, function(error) {
            errors[index] = error;
            hadError = true;
            resolveOne();
        });
        else {
            results[index] = object;
            resolveOne();
        }
    };
    for(var i = 0; i < objects.length; i++)chain(objects[i], i);
    return promise;
}
function $709e2f78d55925d6$var$continueWhile(test, emitter) {
    if (test()) return emitter().then(function() {
        return $709e2f78d55925d6$var$continueWhile(test, emitter);
    });
    return $709e2f78d55925d6$var$_promise.default.resolve();
}

});

parcelRequire.register("fKbuz", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");


var $iG2ur = parcelRequire("iG2ur");

var $iDZ3d = parcelRequire("iDZ3d");

var $35NIM = parcelRequire("35NIM");


var $b76410fe68354a08$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $b76410fe68354a08$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $b76410fe68354a08$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $b76410fe68354a08$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $b76410fe68354a08$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $b76410fe68354a08$var$_isInteger = $iHLHC((parcelRequire("b4POi")));

var $b76410fe68354a08$var$_slicedToArray2 = $iHLHC((parcelRequire("ccwCe")));

var $b76410fe68354a08$var$_slice = $iHLHC((parcelRequire("a1TrC")));

var $b76410fe68354a08$var$_filter = $iHLHC((parcelRequire("i3o6i")));

var $b76410fe68354a08$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $b76410fe68354a08$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));
function $b76410fe68354a08$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $iDZ3d !== "undefined" && $iG2ur(o) || o["@@iterator"];
    if (!it) {
        if ((parcelRequire("euZIZ"))(o) || (it = $b76410fe68354a08$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $b76410fe68354a08$var$_unsupportedIterableToArray(o, minLen) {
    var _context6;
    if (!o) return;
    if (typeof o === "string") return $b76410fe68354a08$var$_arrayLikeToArray(o, minLen);
    var n = (parcelRequire("a1TrC"))(_context6 = Object.prototype.toString.call(o)).call(_context6, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $35NIM(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b76410fe68354a08$var$_arrayLikeToArray(o, minLen);
}
function $b76410fe68354a08$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

var $bkMQj = parcelRequire("bkMQj");
var $b76410fe68354a08$require$equalObjects = $bkMQj.default;

var $42E6z = parcelRequire("42E6z");
var $b76410fe68354a08$require$decode = $42E6z.default;

var $6ilM0 = parcelRequire("6ilM0");
var $b76410fe68354a08$require$ParseError = $6ilM0.default;

var $i8AKq = parcelRequire("i8AKq");
var $b76410fe68354a08$require$ParsePolygon = $i8AKq.default;

var $jtZTC = parcelRequire("jtZTC");
var $b76410fe68354a08$require$ParseGeoPoint = $jtZTC.default;
/**
 * contains -- Determines if an object is contained in a list with special handling for Parse pointers.
 *
 * @param haystack
 * @param needle
 * @private
 * @returns {boolean}
 */ function $b76410fe68354a08$var$contains(haystack, needle) {
    if (needle && needle.__type && (needle.__type === "Pointer" || needle.__type === "Object")) {
        for(var i in haystack){
            var ptr = haystack[i];
            if (typeof ptr === "string" && ptr === needle.objectId) return true;
            if (ptr.className === needle.className && ptr.objectId === needle.objectId) return true;
        }
        return false;
    }
    return (0, $b76410fe68354a08$var$_indexOf.default)(haystack).call(haystack, needle) > -1;
}
function $b76410fe68354a08$var$transformObject(object) {
    if (object._toFullJSON) return object._toFullJSON();
    return object;
}
/**
 * matchesQuery -- Determines if an object would be returned by a Parse Query
 * It's a lightweight, where-clause only implementation of a full query engine.
 * Since we find queries that match objects, rather than objects that match
 * queries, we can avoid building a full-blown query tool.
 *
 * @param className
 * @param object
 * @param objects
 * @param query
 * @private
 * @returns {boolean}
 */ function $b76410fe68354a08$var$matchesQuery(className, object, objects, query) {
    if (object.className !== className) return false;
    var obj = object;
    var q = query;
    if (object.toJSON) obj = object.toJSON();
    if (query.toJSON) q = query.toJSON().where;
    obj.className = className;
    for(var field in q){
        if (!$b76410fe68354a08$var$matchesKeyConstraints(className, obj, objects, field, q[field])) return false;
    }
    return true;
}
function $b76410fe68354a08$var$equalObjectsGeneric(obj, compareTo, eqlFn) {
    if ((0, $b76410fe68354a08$var$_isArray.default)(obj)) {
        for(var i = 0; i < obj.length; i++){
            if (eqlFn(obj[i], compareTo)) return true;
        }
        return false;
    }
    return eqlFn(obj, compareTo);
}
/**
 * @typedef RelativeTimeToDateResult
 * @property {string} status The conversion status, `error` if conversion failed or
 * `success` if conversion succeeded.
 * @property {string} info The error message if conversion failed, or the relative
 * time indication (`past`, `present`, `future`) if conversion succeeded.
 * @property {Date|undefined} result The converted date, or `undefined` if conversion
 * failed.
 */ /**
 * Converts human readable relative date string, for example, 'in 10 days' to a date
 * relative to now.
 *
 * @param {string} text The text to convert.
 * @param {Date} [now=new Date()] The date from which add or subtract. Default is now.
 * @returns {RelativeTimeToDateResult}
 */ function $b76410fe68354a08$var$relativeTimeToDate(text) {
    var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
    text = text.toLowerCase();
    var parts = text.split(" "); // Filter out whitespace
    parts = (0, $b76410fe68354a08$var$_filter.default)(parts).call(parts, function(part) {
        return part !== "";
    });
    var future = parts[0] === "in";
    var past = parts[parts.length - 1] === "ago";
    if (!future && !past && text !== "now") return {
        status: "error",
        info: "Time should either start with 'in' or end with 'ago'"
    };
    if (future && past) return {
        status: "error",
        info: "Time cannot have both 'in' and 'ago'"
    };
     // strip the 'ago' or 'in'
    if (future) parts = (0, $b76410fe68354a08$var$_slice.default)(parts).call(parts, 1);
    else // past
    parts = (0, $b76410fe68354a08$var$_slice.default)(parts).call(parts, 0, parts.length - 1);
    if (parts.length % 2 !== 0 && text !== "now") return {
        status: "error",
        info: "Invalid time string. Dangling unit or number."
    };
    var pairs = [];
    while(parts.length)pairs.push([
        parts.shift(),
        parts.shift()
    ]);
    var seconds = 0;
    for(var _i = 0, _pairs = pairs; _i < _pairs.length; _i++){
        var _pairs$_i = (0, $b76410fe68354a08$var$_slicedToArray2.default)(_pairs[_i], 2), num = _pairs$_i[0], interval = _pairs$_i[1];
        var val = Number(num);
        if (!(0, $b76410fe68354a08$var$_isInteger.default)(val)) return {
            status: "error",
            info: "'".concat(num, "' is not an integer.")
        };
        switch(interval){
            case "yr":
            case "yrs":
            case "year":
            case "years":
                seconds += val * 31536000; // 365 * 24 * 60 * 60
                break;
            case "wk":
            case "wks":
            case "week":
            case "weeks":
                seconds += val * 604800; // 7 * 24 * 60 * 60
                break;
            case "d":
            case "day":
            case "days":
                seconds += val * 86400; // 24 * 60 * 60
                break;
            case "hr":
            case "hrs":
            case "hour":
            case "hours":
                seconds += val * 3600; // 60 * 60
                break;
            case "min":
            case "mins":
            case "minute":
            case "minutes":
                seconds += val * 60;
                break;
            case "sec":
            case "secs":
            case "second":
            case "seconds":
                seconds += val;
                break;
            default:
                return {
                    status: "error",
                    info: "Invalid interval: '".concat(interval, "'")
                };
        }
    }
    var milliseconds = seconds * 1000;
    if (future) return {
        status: "success",
        info: "future",
        result: new Date(now.valueOf() + milliseconds)
    };
    else if (past) return {
        status: "success",
        info: "past",
        result: new Date(now.valueOf() - milliseconds)
    };
    else return {
        status: "success",
        info: "present",
        result: new Date(now.valueOf())
    };
}
/**
 * Determines whether an object matches a single key's constraints
 *
 * @param className
 * @param object
 * @param objects
 * @param key
 * @param constraints
 * @private
 * @returns {boolean}
 */ function $b76410fe68354a08$var$matchesKeyConstraints(className, object, objects, key, constraints) {
    if (constraints === null) return false;
    if ((0, $b76410fe68354a08$var$_indexOf.default)(key).call(key, ".") >= 0) {
        // Key references a subobject
        var keyComponents = key.split(".");
        var subObjectKey = keyComponents[0];
        var keyRemainder = (0, $b76410fe68354a08$var$_slice.default)(keyComponents).call(keyComponents, 1).join(".");
        return $b76410fe68354a08$var$matchesKeyConstraints(className, object[subObjectKey] || {}, objects, keyRemainder, constraints);
    }
    var i;
    if (key === "$or") {
        for(i = 0; i < constraints.length; i++){
            if ($b76410fe68354a08$var$matchesQuery(className, object, objects, constraints[i])) return true;
        }
        return false;
    }
    if (key === "$and") {
        for(i = 0; i < constraints.length; i++){
            if (!$b76410fe68354a08$var$matchesQuery(className, object, objects, constraints[i])) return false;
        }
        return true;
    }
    if (key === "$nor") {
        for(i = 0; i < constraints.length; i++){
            if ($b76410fe68354a08$var$matchesQuery(className, object, objects, constraints[i])) return false;
        }
        return true;
    }
    if (key === "$relatedTo") // Bail! We can't handle relational queries locally
    return false;
    if (!/^[A-Za-z][0-9A-Za-z_]*$/.test(key)) throw new $b76410fe68354a08$require$ParseError($b76410fe68354a08$require$ParseError.INVALID_KEY_NAME, "Invalid Key: ".concat(key));
     // Equality (or Array contains) cases
    if ((0, $b76410fe68354a08$var$_typeof2.default)(constraints) !== "object") {
        if ((0, $b76410fe68354a08$var$_isArray.default)(object[key])) {
            var _context;
            return (0, $b76410fe68354a08$var$_indexOf.default)(_context = object[key]).call(_context, constraints) > -1;
        }
        return object[key] === constraints;
    }
    var compareTo;
    if (constraints.__type) {
        if (constraints.__type === "Pointer") return $b76410fe68354a08$var$equalObjectsGeneric(object[key], constraints, function(obj, ptr) {
            return typeof obj !== "undefined" && ptr.className === obj.className && ptr.objectId === obj.objectId;
        });
        return $b76410fe68354a08$var$equalObjectsGeneric($b76410fe68354a08$require$decode(object[key]), $b76410fe68354a08$require$decode(constraints), $b76410fe68354a08$require$equalObjects);
    } // More complex cases
    for(var condition in constraints){
        compareTo = constraints[condition];
        if (compareTo.__type) compareTo = $b76410fe68354a08$require$decode(compareTo);
         // is it a $relativeTime? convert to date
        if (compareTo["$relativeTime"]) {
            var parserResult = $b76410fe68354a08$var$relativeTimeToDate(compareTo["$relativeTime"]);
            if (parserResult.status !== "success") {
                var _context2;
                throw new $b76410fe68354a08$require$ParseError($b76410fe68354a08$require$ParseError.INVALID_JSON, (0, $b76410fe68354a08$var$_concat.default)(_context2 = "bad $relativeTime (".concat(key, ") value. ")).call(_context2, parserResult.info));
            }
            compareTo = parserResult.result;
        } // Compare Date Object or Date String
        if (toString.call(compareTo) === "[object Date]" || typeof compareTo === "string" && true && !isNaN(new Date(compareTo))) object[key] = new Date(object[key].iso ? object[key].iso : object[key]);
        switch(condition){
            case "$lt":
                if (object[key] >= compareTo) return false;
                break;
            case "$lte":
                if (object[key] > compareTo) return false;
                break;
            case "$gt":
                if (object[key] <= compareTo) return false;
                break;
            case "$gte":
                if (object[key] < compareTo) return false;
                break;
            case "$ne":
                if ($b76410fe68354a08$require$equalObjects(object[key], compareTo)) return false;
                break;
            case "$in":
                if (!$b76410fe68354a08$var$contains(compareTo, object[key])) return false;
                break;
            case "$nin":
                if ($b76410fe68354a08$var$contains(compareTo, object[key])) return false;
                break;
            case "$all":
                for(i = 0; i < compareTo.length; i++){
                    var _context3;
                    if ((0, $b76410fe68354a08$var$_indexOf.default)(_context3 = object[key]).call(_context3, compareTo[i]) < 0) return false;
                }
                break;
            case "$exists":
                var propertyExists = typeof object[key] !== "undefined";
                var existenceIsRequired = constraints["$exists"];
                if (typeof constraints["$exists"] !== "boolean") break;
                if (!propertyExists && existenceIsRequired || propertyExists && !existenceIsRequired) return false;
                break;
            case "$regex":
                if ((0, $b76410fe68354a08$var$_typeof2.default)(compareTo) === "object") return compareTo.test(object[key]);
                 // JS doesn't support perl-style escaping
                var expString = "";
                var escapeEnd = -2;
                var escapeStart = (0, $b76410fe68354a08$var$_indexOf.default)(compareTo).call(compareTo, "\\Q");
                while(escapeStart > -1){
                    // Add the unescaped portion
                    expString += compareTo.substring(escapeEnd + 2, escapeStart);
                    escapeEnd = (0, $b76410fe68354a08$var$_indexOf.default)(compareTo).call(compareTo, "\\E", escapeStart);
                    if (escapeEnd > -1) expString += compareTo.substring(escapeStart + 2, escapeEnd).replace(/\\\\\\\\E/g, "\\E").replace(/\W/g, "\\$&");
                    escapeStart = (0, $b76410fe68354a08$var$_indexOf.default)(compareTo).call(compareTo, "\\Q", escapeEnd);
                }
                expString += compareTo.substring(Math.max(escapeStart, escapeEnd + 2));
                var modifiers = constraints.$options || "";
                modifiers = modifiers.replace("x", "").replace("s", ""); // Parse Server / Mongo support x and s modifiers but JS RegExp doesn't
                var exp = new RegExp(expString, modifiers);
                if (!exp.test(object[key])) return false;
                break;
            case "$nearSphere":
                if (!compareTo || !object[key]) return false;
                var distance = compareTo.radiansTo(object[key]);
                var max = constraints.$maxDistance || Infinity;
                return distance <= max;
            case "$within":
                if (!compareTo || !object[key]) return false;
                var southWest = compareTo.$box[0];
                var northEast = compareTo.$box[1];
                if (southWest.latitude > northEast.latitude || southWest.longitude > northEast.longitude) // Invalid box, crosses the date line
                return false;
                return object[key].latitude > southWest.latitude && object[key].latitude < northEast.latitude && object[key].longitude > southWest.longitude && object[key].longitude < northEast.longitude;
            case "$options":
                break;
            case "$maxDistance":
                break;
            case "$select":
                var subQueryObjects = (0, $b76410fe68354a08$var$_filter.default)(objects).call(objects, function(obj, index, arr) {
                    return $b76410fe68354a08$var$matchesQuery(compareTo.query.className, obj, arr, compareTo.query.where);
                });
                for(var _i2 = 0; _i2 < subQueryObjects.length; _i2 += 1){
                    var subObject = $b76410fe68354a08$var$transformObject(subQueryObjects[_i2]);
                    return $b76410fe68354a08$require$equalObjects(object[key], subObject[compareTo.key]);
                }
                return false;
            case "$dontSelect":
                var _subQueryObjects = (0, $b76410fe68354a08$var$_filter.default)(objects).call(objects, function(obj, index, arr) {
                    return $b76410fe68354a08$var$matchesQuery(compareTo.query.className, obj, arr, compareTo.query.where);
                });
                for(var _i3 = 0; _i3 < _subQueryObjects.length; _i3 += 1){
                    var _subObject = $b76410fe68354a08$var$transformObject(_subQueryObjects[_i3]);
                    return !$b76410fe68354a08$require$equalObjects(object[key], _subObject[compareTo.key]);
                }
                return false;
            case "$inQuery":
                var _subQueryObjects2 = (0, $b76410fe68354a08$var$_filter.default)(objects).call(objects, function(obj, index, arr) {
                    return $b76410fe68354a08$var$matchesQuery(compareTo.className, obj, arr, compareTo.where);
                });
                for(var _i4 = 0; _i4 < _subQueryObjects2.length; _i4 += 1){
                    var _subObject2 = $b76410fe68354a08$var$transformObject(_subQueryObjects2[_i4]);
                    if (object[key].className === _subObject2.className && object[key].objectId === _subObject2.objectId) return true;
                }
                return false;
            case "$notInQuery":
                var _subQueryObjects3 = (0, $b76410fe68354a08$var$_filter.default)(objects).call(objects, function(obj, index, arr) {
                    return $b76410fe68354a08$var$matchesQuery(compareTo.className, obj, arr, compareTo.where);
                });
                for(var _i5 = 0; _i5 < _subQueryObjects3.length; _i5 += 1){
                    var _subObject3 = $b76410fe68354a08$var$transformObject(_subQueryObjects3[_i5]);
                    if (object[key].className === _subObject3.className && object[key].objectId === _subObject3.objectId) return false;
                }
                return true;
            case "$containedBy":
                var _iterator = $b76410fe68354a08$var$_createForOfIteratorHelper(object[key]), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var value = _step.value;
                        if (!$b76410fe68354a08$var$contains(compareTo, value)) return false;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return true;
            case "$geoWithin":
                if (compareTo.$polygon) {
                    var _context4;
                    var points = (0, $b76410fe68354a08$var$_map.default)(_context4 = compareTo.$polygon).call(_context4, function(geoPoint) {
                        return [
                            geoPoint.latitude,
                            geoPoint.longitude
                        ];
                    });
                    var polygon = new $b76410fe68354a08$require$ParsePolygon(points);
                    return polygon.containsPoint(object[key]);
                }
                if (compareTo.$centerSphere) {
                    var _compareTo$$centerSph = (0, $b76410fe68354a08$var$_slicedToArray2.default)(compareTo.$centerSphere, 2), WGS84Point = _compareTo$$centerSph[0], maxDistance = _compareTo$$centerSph[1];
                    var centerPoint = new $b76410fe68354a08$require$ParseGeoPoint({
                        latitude: WGS84Point[1],
                        longitude: WGS84Point[0]
                    });
                    var point = new $b76410fe68354a08$require$ParseGeoPoint(object[key]);
                    var _distance = point.radiansTo(centerPoint);
                    return _distance <= maxDistance;
                }
                break;
            case "$geoIntersects":
                var _polygon = new $b76410fe68354a08$require$ParsePolygon(object[key].coordinates);
                var _point = new $b76410fe68354a08$require$ParseGeoPoint(compareTo.$point);
                return _polygon.containsPoint(_point);
            default:
                return false;
        }
    }
    return true;
}
function $b76410fe68354a08$var$validateQuery(query) {
    var _context5;
    var q = query;
    if (query.toJSON) q = query.toJSON().where;
    var specialQuerykeys = [
        "$and",
        "$or",
        "$nor",
        "_rperm",
        "_wperm",
        "_perishable_token",
        "_email_verify_token",
        "_email_verify_token_expires_at",
        "_account_lockout_expires_at",
        "_failed_login_count"
    ];
    (0, $b76410fe68354a08$var$_forEach.default)(_context5 = (0, $b76410fe68354a08$var$_keys.default)(q)).call(_context5, function(key) {
        if (q && q[key] && q[key].$regex) {
            if (typeof q[key].$options === "string") {
                if (!q[key].$options.match(/^[imxs]+$/)) throw new $b76410fe68354a08$require$ParseError($b76410fe68354a08$require$ParseError.INVALID_QUERY, "Bad $options value for query: ".concat(q[key].$options));
            }
        }
        if ((0, $b76410fe68354a08$var$_indexOf.default)(specialQuerykeys).call(specialQuerykeys, key) < 0 && !key.match(/^[a-zA-Z][a-zA-Z0-9_\.]*$/)) throw new $b76410fe68354a08$require$ParseError($b76410fe68354a08$require$ParseError.INVALID_KEY_NAME, "Invalid key name: ".concat(key));
    });
}
var $b76410fe68354a08$var$OfflineQuery = {
    matchesQuery: $b76410fe68354a08$var$matchesQuery,
    validateQuery: $b76410fe68354a08$var$validateQuery
};
module.exports = $b76410fe68354a08$var$OfflineQuery;

});
parcelRequire.register("b4POi", function(module, exports) {

module.exports = (parcelRequire("dJlUQ"));

});
parcelRequire.register("dJlUQ", function(module, exports) {

var $jyHF1 = parcelRequire("jyHF1");
module.exports = $jyHF1;

});
parcelRequire.register("jyHF1", function(module, exports) {
parcelRequire("40n6Q");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Number.isInteger;

});
parcelRequire.register("40n6Q", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $90Pfa = parcelRequire("90Pfa");
// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$ggcsv({
    target: "Number",
    stat: true
}, {
    isInteger: $90Pfa
});

});
parcelRequire.register("90Pfa", function(module, exports) {

var $1WYwK = parcelRequire("1WYwK");
var $68fbdd0a2d491e4f$var$floor = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
    return !$1WYwK(it) && isFinite(it) && $68fbdd0a2d491e4f$var$floor(it) === it;
};

});





parcelRequire.register("bkMQj", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8407732367a624c0$var$equals;

var $8407732367a624c0$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $8407732367a624c0$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $8407732367a624c0$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $8407732367a624c0$var$_ParseACL = $iHLHC((parcelRequire("2xGBa")));

var $8407732367a624c0$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $8407732367a624c0$var$_ParseGeoPoint = $iHLHC((parcelRequire("jtZTC")));

var $8407732367a624c0$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ function $8407732367a624c0$var$equals(a, b) {
    var toString = Object.prototype.toString;
    if (toString.call(a) === "[object Date]" || toString.call(b) === "[object Date]") {
        var dateA = new Date(a);
        var dateB = new Date(b);
        return +dateA === +dateB;
    }
    if ((0, $8407732367a624c0$var$_typeof2.default)(a) !== (0, $8407732367a624c0$var$_typeof2.default)(b)) return false;
    if (!a || (0, $8407732367a624c0$var$_typeof2.default)(a) !== "object") // a is a primitive
    return a === b;
    if ((0, $8407732367a624c0$var$_isArray.default)(a) || (0, $8407732367a624c0$var$_isArray.default)(b)) {
        if (!(0, $8407732367a624c0$var$_isArray.default)(a) || !(0, $8407732367a624c0$var$_isArray.default)(b)) return false;
        if (a.length !== b.length) return false;
        for(var i = a.length; i--;){
            if (!$8407732367a624c0$var$equals(a[i], b[i])) return false;
        }
        return true;
    }
    if (a instanceof $8407732367a624c0$var$_ParseACL.default || a instanceof $8407732367a624c0$var$_ParseFile.default || a instanceof $8407732367a624c0$var$_ParseGeoPoint.default || a instanceof $8407732367a624c0$var$_ParseObject.default) return a.equals(b);
    if (b instanceof $8407732367a624c0$var$_ParseObject.default) {
        if (a.__type === "Object" || a.__type === "Pointer") return a.objectId === b.id && a.className === b.className;
    }
    if ((0, $8407732367a624c0$var$_keys.default)(a).length !== (0, $8407732367a624c0$var$_keys.default)(b).length) return false;
    for(var k in a){
        if (!$8407732367a624c0$var$equals(a[k], b[k])) return false;
    }
    return true;
}

});


parcelRequire.register("klpRA", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.PIN_PREFIX = module.exports.OBJECT_PREFIX = module.exports.DEFAULT_PIN = void 0;
module.exports.isLocalDatastoreKey = $ecf9d4b8c1b67708$var$isLocalDatastoreKey;

var $ecf9d4b8c1b67708$var$_startsWith = $iHLHC((parcelRequire("hNmgD")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 * @private
 */ var $ecf9d4b8c1b67708$var$DEFAULT_PIN = "_default";
module.exports.DEFAULT_PIN = $ecf9d4b8c1b67708$var$DEFAULT_PIN;
var $ecf9d4b8c1b67708$var$PIN_PREFIX = "parsePin_";
module.exports.PIN_PREFIX = $ecf9d4b8c1b67708$var$PIN_PREFIX;
var $ecf9d4b8c1b67708$var$OBJECT_PREFIX = "Parse_LDS_";
module.exports.OBJECT_PREFIX = $ecf9d4b8c1b67708$var$OBJECT_PREFIX;
function $ecf9d4b8c1b67708$var$isLocalDatastoreKey(key) /*: boolean*/ {
    return !!(key && (key === $ecf9d4b8c1b67708$var$DEFAULT_PIN || (0, $ecf9d4b8c1b67708$var$_startsWith.default)(key).call(key, $ecf9d4b8c1b67708$var$PIN_PREFIX) || (0, $ecf9d4b8c1b67708$var$_startsWith.default)(key).call(key, $ecf9d4b8c1b67708$var$OBJECT_PREFIX)));
}

});




parcelRequire.register("1JxNp", function(module, exports) {
"use strict";

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1434359b124c737a$var$escape;
/*
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $1434359b124c737a$var$encoded = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "/": "&#x2F;",
    "'": "&#x27;",
    '"': "&quot;"
};
function $1434359b124c737a$var$escape(str) /*: string*/ {
    return str.replace(/[&<>\/'"]/g, function(char) {
        return $1434359b124c737a$var$encoded[char];
    });
}

});

parcelRequire.register("cJKeG", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $a1TrC = parcelRequire("a1TrC");

var $4wehD = parcelRequire("4wehD");

var $iH0WI = parcelRequire("iH0WI");

var $dQJQf = parcelRequire("dQJQf");

var $6iqUa = parcelRequire("6iqUa");

var $gW71a = parcelRequire("gW71a");

var $kOp5W = parcelRequire("kOp5W");

var $jQ6K5 = parcelRequire("jQ6K5");

var $4i3Tl = parcelRequire("4i3Tl");

var $iDZ3d = parcelRequire("iDZ3d");

var $945d8d7b16514ba0$var$_find = $iHLHC((parcelRequire("c61hX")));

var $945d8d7b16514ba0$var$_setInterval2 = $iHLHC((parcelRequire("ds9Aj")));

var $945d8d7b16514ba0$var$_toConsumableArray2 = $iHLHC((parcelRequire("h3AFy")));

var $945d8d7b16514ba0$var$_findIndex = $iHLHC((parcelRequire("arN5C")));

var $945d8d7b16514ba0$var$_splice = $iHLHC((parcelRequire("aFg1C")));

var $945d8d7b16514ba0$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $945d8d7b16514ba0$var$_asyncToGenerator2 = $iHLHC((parcelRequire("kkHAR")));

var $945d8d7b16514ba0$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $945d8d7b16514ba0$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $945d8d7b16514ba0$var$_ParseQuery = $iHLHC((parcelRequire("4FVCr")));

var $945d8d7b16514ba0$var$_Storage = $iHLHC((parcelRequire("7GXKV")));
function $945d8d7b16514ba0$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $945d8d7b16514ba0$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $iDZ3d ? $iDZ3d : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $4i3Tl(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $jQ6K5(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $kOp5W, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $jQ6K5(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context9;
        $gW71a(_context9 = [
            "next",
            "throw",
            "return"
        ]).call(_context9, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $6iqUa(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], $gW71a(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return $dQJQf ? $dQJQf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $jQ6K5(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = $iH0WI);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $4wehD(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context10;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, $gW71a(_context10 = this.tryEntries).call(_context10, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$a1TrC(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
var $945d8d7b16514ba0$var$QUEUE_KEY = "Parse/Eventually/Queue";
var $945d8d7b16514ba0$var$queueCache = [];
var $945d8d7b16514ba0$var$dirtyCache = true;
var $945d8d7b16514ba0$var$polling = undefined;
/**
 * Provides utility functions to queue objects that will be
 * saved to the server at a later date.
 *
 * @class Parse.EventuallyQueue
 * @static
 */ var $945d8d7b16514ba0$var$EventuallyQueue = {
    /**
   * Add object to queue with save operation.
   *
   * @function save
   * @name Parse.EventuallyQueue.save
   * @param {ParseObject} object Parse.Object to be saved eventually
   * @param {object} [serverOptions] See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Object.html#save Parse.Object.save} options.
   * @returns {Promise} A promise that is fulfilled if object is added to queue.
   * @static
   * @see Parse.Object#saveEventually
   */ save: function(object) /*: Promise*/ {
        var serverOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.enqueue("save", object, serverOptions);
    },
    /**
   * Add object to queue with save operation.
   *
   * @function destroy
   * @name Parse.EventuallyQueue.destroy
   * @param {ParseObject} object Parse.Object to be destroyed eventually
   * @param {object} [serverOptions] See {@link https://parseplatform.org/Parse-SDK-JS/api/master/Parse.Object.html#destroy Parse.Object.destroy} options
   * @returns {Promise} A promise that is fulfilled if object is added to queue.
   * @static
   * @see Parse.Object#destroyEventually
   */ destroy: function(object) /*: Promise*/ {
        var serverOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.enqueue("destroy", object, serverOptions);
    },
    /**
   * Generate unique identifier to avoid duplicates and maintain previous state.
   *
   * @param {string} action save / destroy
   * @param {object} object Parse.Object to be queued
   * @returns {string}
   * @static
   * @ignore
   */ generateQueueId: function(action, object) /*: string*/ {
        object._getId();
        var className = object.className, id = object.id, _localId = object._localId;
        var uniqueId = object.get("hash") || _localId;
        return [
            action,
            className,
            id,
            uniqueId
        ].join("_");
    },
    /**
   * Build queue object and add to queue.
   *
   * @param {string} action save / destroy
   * @param {object} object Parse.Object to be queued
   * @param {object} [serverOptions]
   * @returns {Promise} A promise that is fulfilled if object is added to queue.
   * @static
   * @ignore
   */ enqueue: function(action, object, serverOptions) /*: Promise*/ {
        var _this = this;
        return (0, $945d8d7b16514ba0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $945d8d7b16514ba0$var$_regeneratorRuntime().mark(function _callee() {
            var queueData, queueId, index, prop;
            return $945d8d7b16514ba0$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return _this.getQueue();
                    case 2:
                        queueData = _context.sent;
                        queueId = _this.generateQueueId(action, object);
                        index = _this.queueItemExists(queueData, queueId);
                        if (index > -1) {
                            // Add cached values to new object if they don't exist
                            for(prop in queueData[index].object)if (typeof object.get(prop) === "undefined") object.set(prop, queueData[index].object[prop]);
                        } else index = queueData.length;
                        queueData[index] = {
                            queueId: queueId,
                            action: action,
                            object: object.toJSON(),
                            serverOptions: serverOptions,
                            id: object.id,
                            className: object.className,
                            hash: object.get("hash"),
                            createdAt: new Date()
                        };
                        return _context.abrupt("return", _this.setQueue(queueData));
                    case 8:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }))();
    },
    store: function store(data) {
        return $945d8d7b16514ba0$var$_Storage.default.setItemAsync($945d8d7b16514ba0$var$QUEUE_KEY, (0, $945d8d7b16514ba0$var$_stringify.default)(data));
    },
    load: function load() {
        return $945d8d7b16514ba0$var$_Storage.default.getItemAsync($945d8d7b16514ba0$var$QUEUE_KEY);
    },
    /**
   * Sets the in-memory queue from local storage and returns.
   *
   * @function getQueue
   * @name Parse.EventuallyQueue.getQueue
   * @returns {Promise<Array>}
   * @static
   */ getQueue: function getQueue() /*: Promise<Array>*/ {
        var _this2 = this;
        return (0, $945d8d7b16514ba0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $945d8d7b16514ba0$var$_regeneratorRuntime().mark(function _callee2() {
            return $945d8d7b16514ba0$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        if (!$945d8d7b16514ba0$var$dirtyCache) {
                            _context2.next = 10;
                            break;
                        }
                        _context2.t0 = JSON;
                        _context2.next = 4;
                        return _this2.load();
                    case 4:
                        _context2.t1 = _context2.sent;
                        if (_context2.t1) {
                            _context2.next = 7;
                            break;
                        }
                        _context2.t1 = "[]";
                    case 7:
                        _context2.t2 = _context2.t1;
                        $945d8d7b16514ba0$var$queueCache = _context2.t0.parse.call(_context2.t0, _context2.t2);
                        $945d8d7b16514ba0$var$dirtyCache = false;
                    case 10:
                        return _context2.abrupt("return", $945d8d7b16514ba0$var$queueCache);
                    case 11:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }))();
    },
    /**
   * Saves the queue to local storage
   *
   * @param {Queue} queue Queue containing Parse.Object data.
   * @returns {Promise} A promise that is fulfilled when queue is stored.
   * @static
   * @ignore
   */ setQueue: function setQueue(queue) /*: Promise<void>*/ {
        $945d8d7b16514ba0$var$queueCache = queue;
        return this.store($945d8d7b16514ba0$var$queueCache);
    },
    /**
   * Removes Parse.Object data from queue.
   *
   * @param {string} queueId Unique identifier for Parse.Object data.
   * @returns {Promise} A promise that is fulfilled when queue is stored.
   * @static
   * @ignore
   */ remove: function remove(queueId) /*: Promise<void>*/ {
        var _this3 = this;
        return (0, $945d8d7b16514ba0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $945d8d7b16514ba0$var$_regeneratorRuntime().mark(function _callee3() {
            var queueData, index;
            return $945d8d7b16514ba0$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _context3.next = 2;
                        return _this3.getQueue();
                    case 2:
                        queueData = _context3.sent;
                        index = _this3.queueItemExists(queueData, queueId);
                        if (!(index > -1)) {
                            _context3.next = 8;
                            break;
                        }
                        (0, $945d8d7b16514ba0$var$_splice.default)(queueData).call(queueData, index, 1);
                        _context3.next = 8;
                        return _this3.setQueue(queueData);
                    case 8:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }))();
    },
    /**
   * Removes all objects from queue.
   *
   * @function clear
   * @name Parse.EventuallyQueue.clear
   * @returns {Promise} A promise that is fulfilled when queue is cleared.
   * @static
   */ clear: function clear() /*: Promise*/ {
        $945d8d7b16514ba0$var$queueCache = [];
        return this.store([]);
    },
    /**
   * Return the index of a queueId in the queue. Returns -1 if not found.
   *
   * @param {Queue} queue Queue containing Parse.Object data.
   * @param {string} queueId Unique identifier for Parse.Object data.
   * @returns {number}
   * @static
   * @ignore
   */ queueItemExists: function queueItemExists(queue, queueId) /*: number*/ {
        return (0, $945d8d7b16514ba0$var$_findIndex.default)(queue).call(queue, function(data) {
            return data.queueId === queueId;
        });
    },
    /**
   * Return the number of objects in the queue.
   *
   * @function length
   * @name Parse.EventuallyQueue.length
   * @returns {number}
   * @static
   */ length: function length() /*: number*/ {
        var _this4 = this;
        return (0, $945d8d7b16514ba0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $945d8d7b16514ba0$var$_regeneratorRuntime().mark(function _callee4() {
            var queueData;
            return $945d8d7b16514ba0$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        _context4.next = 2;
                        return _this4.getQueue();
                    case 2:
                        queueData = _context4.sent;
                        return _context4.abrupt("return", queueData.length);
                    case 4:
                    case "end":
                        return _context4.stop();
                }
            }, _callee4);
        }))();
    },
    /**
   * Sends the queue to the server.
   *
   * @function sendQueue
   * @name Parse.EventuallyQueue.sendQueue
   * @returns {Promise<boolean>} Returns true if queue was sent successfully.
   * @static
   */ sendQueue: function sendQueue() /*: Promise<boolean>*/ {
        var _this5 = this;
        return (0, $945d8d7b16514ba0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $945d8d7b16514ba0$var$_regeneratorRuntime().mark(function _callee5() {
            var queue, queueData, i, queueObject, id, hash, className, ObjectType;
            return $945d8d7b16514ba0$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                while(true)switch(_context5.prev = _context5.next){
                    case 0:
                        _context5.next = 2;
                        return _this5.getQueue();
                    case 2:
                        queue = _context5.sent;
                        queueData = (0, $945d8d7b16514ba0$var$_toConsumableArray2.default)(queue);
                        if (!(queueData.length === 0)) {
                            _context5.next = 6;
                            break;
                        }
                        return _context5.abrupt("return", false);
                    case 6:
                        i = 0;
                    case 7:
                        if (!(i < queueData.length)) {
                            _context5.next = 26;
                            break;
                        }
                        queueObject = queueData[i];
                        id = queueObject.id, hash = queueObject.hash, className = queueObject.className;
                        ObjectType = $945d8d7b16514ba0$var$_ParseObject.default.extend(className);
                        if (!id) {
                            _context5.next = 16;
                            break;
                        }
                        _context5.next = 14;
                        return _this5.process.byId(ObjectType, queueObject);
                    case 14:
                        _context5.next = 23;
                        break;
                    case 16:
                        if (!hash) {
                            _context5.next = 21;
                            break;
                        }
                        _context5.next = 19;
                        return _this5.process.byHash(ObjectType, queueObject);
                    case 19:
                        _context5.next = 23;
                        break;
                    case 21:
                        _context5.next = 23;
                        return _this5.process.create(ObjectType, queueObject);
                    case 23:
                        i += 1;
                        _context5.next = 7;
                        break;
                    case 26:
                        return _context5.abrupt("return", true);
                    case 27:
                    case "end":
                        return _context5.stop();
                }
            }, _callee5);
        }))();
    },
    /**
   * Build queue object and add to queue.
   *
   * @param {ParseObject} object Parse.Object to be processed
   * @param {QueueObject} queueObject Parse.Object data from the queue
   * @returns {Promise} A promise that is fulfilled when operation is performed.
   * @static
   * @ignore
   */ sendQueueCallback: function sendQueueCallback(object, queueObject) /*: Promise<void>*/ {
        var _this6 = this;
        return (0, $945d8d7b16514ba0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $945d8d7b16514ba0$var$_regeneratorRuntime().mark(function _callee6() {
            return $945d8d7b16514ba0$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        if (object) {
                            _context6.next = 2;
                            break;
                        }
                        return _context6.abrupt("return", _this6.remove(queueObject.queueId));
                    case 2:
                        _context6.t0 = queueObject.action;
                        _context6.next = _context6.t0 === "save" ? 5 : _context6.t0 === "destroy" ? 20 : 33;
                        break;
                    case 5:
                        if (!(typeof object.updatedAt !== "undefined" && object.updatedAt > new Date(queueObject.object.createdAt))) {
                            _context6.next = 7;
                            break;
                        }
                        return _context6.abrupt("return", _this6.remove(queueObject.queueId));
                    case 7:
                        _context6.prev = 7;
                        _context6.next = 10;
                        return object.save(queueObject.object, queueObject.serverOptions);
                    case 10:
                        _context6.next = 12;
                        return _this6.remove(queueObject.queueId);
                    case 12:
                        _context6.next = 19;
                        break;
                    case 14:
                        _context6.prev = 14;
                        _context6.t1 = _context6["catch"](7);
                        if (!(_context6.t1.message !== 'XMLHttpRequest failed: "Unable to connect to the Parse API"')) {
                            _context6.next = 19;
                            break;
                        }
                        _context6.next = 19;
                        return _this6.remove(queueObject.queueId);
                    case 19:
                        return _context6.abrupt("break", 33);
                    case 20:
                        _context6.prev = 20;
                        _context6.next = 23;
                        return object.destroy(queueObject.serverOptions);
                    case 23:
                        _context6.next = 25;
                        return _this6.remove(queueObject.queueId);
                    case 25:
                        _context6.next = 32;
                        break;
                    case 27:
                        _context6.prev = 27;
                        _context6.t2 = _context6["catch"](20);
                        if (!(_context6.t2.message !== 'XMLHttpRequest failed: "Unable to connect to the Parse API"')) {
                            _context6.next = 32;
                            break;
                        }
                        _context6.next = 32;
                        return _this6.remove(queueObject.queueId);
                    case 32:
                        return _context6.abrupt("break", 33);
                    case 33:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6, null, [
                [
                    7,
                    14
                ],
                [
                    20,
                    27
                ]
            ]);
        }))();
    },
    /**
   * Start polling server for network connection.
   * Will send queue if connection is established.
   *
   * @function poll
   * @name Parse.EventuallyQueue.poll
   * @param [ms] Milliseconds to ping the server. Default 2000ms
   * @static
   */ poll: function poll() {
        var _this7 = this;
        var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2000;
        if ($945d8d7b16514ba0$var$polling) return;
        $945d8d7b16514ba0$var$polling = (0, $945d8d7b16514ba0$var$_setInterval2.default)(function() {
            var RESTController = $945d8d7b16514ba0$var$_CoreManager.default.getRESTController();
            RESTController.request("GET", "health").then(function(_ref) {
                var status = _ref.status;
                if (status === "ok") {
                    _this7.stopPoll();
                    return _this7.sendQueue();
                }
            }).catch(function(e) {
                return e;
            });
        }, ms);
    },
    /**
   * Turns off polling.
   *
   * @function stopPoll
   * @name Parse.EventuallyQueue.stopPoll
   * @static
   */ stopPoll: function stopPoll() {
        clearInterval($945d8d7b16514ba0$var$polling);
        $945d8d7b16514ba0$var$polling = undefined;
    },
    /**
   * Return true if pinging the server.
   *
   * @function isPolling
   * @name Parse.EventuallyQueue.isPolling
   * @returns {boolean}
   * @static
   */ isPolling: function isPolling() /*: boolean*/ {
        return !!$945d8d7b16514ba0$var$polling;
    },
    _setPolling: function _setPolling(flag) {
        $945d8d7b16514ba0$var$polling = flag;
    },
    process: {
        create: function create(ObjectType, queueObject) {
            var object = new ObjectType();
            return $945d8d7b16514ba0$var$EventuallyQueue.sendQueueCallback(object, queueObject);
        },
        byId: function byId(ObjectType, queueObject) {
            return (0, $945d8d7b16514ba0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $945d8d7b16514ba0$var$_regeneratorRuntime().mark(function _callee7() {
                var sessionToken, query, results;
                return $945d8d7b16514ba0$var$_regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while(true)switch(_context7.prev = _context7.next){
                        case 0:
                            sessionToken = queueObject.serverOptions.sessionToken;
                            query = new $945d8d7b16514ba0$var$_ParseQuery.default(ObjectType);
                            query.equalTo("objectId", queueObject.id);
                            _context7.next = 5;
                            return (0, $945d8d7b16514ba0$var$_find.default)(query).call(query, {
                                sessionToken: sessionToken
                            });
                        case 5:
                            results = _context7.sent;
                            return _context7.abrupt("return", $945d8d7b16514ba0$var$EventuallyQueue.sendQueueCallback(results[0], queueObject));
                        case 7:
                        case "end":
                            return _context7.stop();
                    }
                }, _callee7);
            }))();
        },
        byHash: function byHash(ObjectType, queueObject) {
            return (0, $945d8d7b16514ba0$var$_asyncToGenerator2.default)(/*#__PURE__*/ $945d8d7b16514ba0$var$_regeneratorRuntime().mark(function _callee8() {
                var sessionToken, query, results;
                return $945d8d7b16514ba0$var$_regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while(true)switch(_context8.prev = _context8.next){
                        case 0:
                            sessionToken = queueObject.serverOptions.sessionToken;
                            query = new $945d8d7b16514ba0$var$_ParseQuery.default(ObjectType);
                            query.equalTo("hash", queueObject.hash);
                            _context8.next = 5;
                            return (0, $945d8d7b16514ba0$var$_find.default)(query).call(query, {
                                sessionToken: sessionToken
                            });
                        case 5:
                            results = _context8.sent;
                            if (!(results.length > 0)) {
                                _context8.next = 8;
                                break;
                            }
                            return _context8.abrupt("return", $945d8d7b16514ba0$var$EventuallyQueue.sendQueueCallback(results[0], queueObject));
                        case 8:
                            return _context8.abrupt("return", $945d8d7b16514ba0$var$EventuallyQueue.process.create(ObjectType, queueObject));
                        case 9:
                        case "end":
                            return _context8.stop();
                    }
                }, _callee8);
            }))();
        }
    }
};
module.exports = $945d8d7b16514ba0$var$EventuallyQueue;

});
parcelRequire.register("ds9Aj", function(module, exports) {

module.exports = (parcelRequire("c97Mc"));

});
parcelRequire.register("c97Mc", function(module, exports) {
parcelRequire("dGoN0");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.setInterval;

});
parcelRequire.register("dGoN0", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
parcelRequire("kEQ2H");
parcelRequire("51F4q");

});
parcelRequire.register("kEQ2H", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $3pyVf = parcelRequire("3pyVf");

var $cDN8S = parcelRequire("cDN8S");
var $f09fe9a1ef40720b$var$setInterval = $cDN8S($3pyVf.setInterval, true);
// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$ggcsv({
    global: true,
    bind: true,
    forced: $3pyVf.setInterval !== $f09fe9a1ef40720b$var$setInterval
}, {
    setInterval: $f09fe9a1ef40720b$var$setInterval
});

});
parcelRequire.register("cDN8S", function(module, exports) {
"use strict";

var $3pyVf = parcelRequire("3pyVf");

var $2JOsI = parcelRequire("2JOsI");

var $e6Rz5 = parcelRequire("e6Rz5");

var $15ALP = parcelRequire("15ALP");

var $4Hrut = parcelRequire("4Hrut");

var $hF40G = parcelRequire("hF40G");

var $10H6z = parcelRequire("10H6z");
var $933f3f25a064aad4$var$Function = $3pyVf.Function;
// dirty IE9- and Bun 0.3.0- checks
var $933f3f25a064aad4$var$WRAP = /MSIE .\./.test($4Hrut) || $15ALP && function() {
    var version = $3pyVf.Bun.version.split(".");
    return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $933f3f25a064aad4$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $10H6z(arguments.length, 1) > firstParamIndex;
        var fn = $e6Rz5(handler) ? handler : $933f3f25a064aad4$var$Function(handler);
        var params = boundArgs ? $hF40G(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $2JOsI(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};

});
parcelRequire.register("15ALP", function(module, exports) {
/* global Bun -- Deno case */ module.exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";

});



parcelRequire.register("51F4q", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $3pyVf = parcelRequire("3pyVf");

var $cDN8S = parcelRequire("cDN8S");
var $3a8ce77b7590cf0f$var$setTimeout = $cDN8S($3pyVf.setTimeout, true);
// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$ggcsv({
    global: true,
    bind: true,
    forced: $3pyVf.setTimeout !== $3a8ce77b7590cf0f$var$setTimeout
}, {
    setTimeout: $3a8ce77b7590cf0f$var$setTimeout
});

});




parcelRequire.register("arN5C", function(module, exports) {

module.exports = (parcelRequire("lz2LW"));

});
parcelRequire.register("lz2LW", function(module, exports) {

var $2xWef = parcelRequire("2xWef");
module.exports = $2xWef;

});
parcelRequire.register("2xWef", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $2cpI0 = parcelRequire("2cpI0");
var $1dabd4db1b5fbde1$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.findIndex;
    return it === $1dabd4db1b5fbde1$var$ArrayPrototype || $8hsAO($1dabd4db1b5fbde1$var$ArrayPrototype, it) && own === $1dabd4db1b5fbde1$var$ArrayPrototype.findIndex ? $2cpI0 : own;
};

});
parcelRequire.register("2cpI0", function(module, exports) {
parcelRequire("kY0qH");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").findIndex;

});
parcelRequire.register("kY0qH", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $igsV9 = parcelRequire("igsV9");
var $f439be9223039380$require$$findIndex = $igsV9.findIndex;

var $ajzxw = parcelRequire("ajzxw");
var $f439be9223039380$var$FIND_INDEX = "findIndex";
var $f439be9223039380$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if ($f439be9223039380$var$FIND_INDEX in []) Array(1)[$f439be9223039380$var$FIND_INDEX](function() {
    $f439be9223039380$var$SKIPS_HOLES = false;
});
// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$ggcsv({
    target: "Array",
    proto: true,
    forced: $f439be9223039380$var$SKIPS_HOLES
}, {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $f439be9223039380$require$$findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$ajzxw($f439be9223039380$var$FIND_INDEX);

});





parcelRequire.register("7GXKV", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $599acee56bb5306d$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $599acee56bb5306d$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $599acee56bb5306d$var$Storage = {
    async: function() /*: boolean*/ {
        var controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        return !!controller.async;
    },
    getItem: function(path) /*: ?string*/ {
        var controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.getItem(path);
    },
    getItemAsync: function(path) /*: Promise<string>*/ {
        var controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.getItemAsync(path);
        return $599acee56bb5306d$var$_promise.default.resolve(controller.getItem(path));
    },
    setItem: function(path, value) /*: void*/ {
        var controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.setItem(path, value);
    },
    setItemAsync: function(path, value) /*: Promise<void>*/ {
        var controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.setItemAsync(path, value);
        return $599acee56bb5306d$var$_promise.default.resolve(controller.setItem(path, value));
    },
    removeItem: function(path) /*: void*/ {
        var controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.removeItem(path);
    },
    removeItemAsync: function(path) /*: Promise<void>*/ {
        var controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.removeItemAsync(path);
        return $599acee56bb5306d$var$_promise.default.resolve(controller.removeItem(path));
    },
    getAllKeys: function() /*: Array<string>*/ {
        var controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) throw new Error("Synchronous storage is not supported by the current storage controller");
        return controller.getAllKeys();
    },
    getAllKeysAsync: function() /*: Promise<Array<string>>*/ {
        var controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.async === 1) return controller.getAllKeysAsync();
        return $599acee56bb5306d$var$_promise.default.resolve(controller.getAllKeys());
    },
    generatePath: function(path) /*: string*/ {
        if (!$599acee56bb5306d$var$_CoreManager.default.get("APPLICATION_ID")) throw new Error("You need to call Parse.initialize before using Parse.");
        if (typeof path !== "string") throw new Error("Tried to get a Storage path that was not a String.");
        if (path[0] === "/") path = path.substr(1);
        return "Parse/" + $599acee56bb5306d$var$_CoreManager.default.get("APPLICATION_ID") + "/" + path;
    },
    _clear: function() {
        var controller = $599acee56bb5306d$var$_CoreManager.default.getStorageController();
        if (controller.hasOwnProperty("clear")) controller.clear();
    }
};
module.exports = $599acee56bb5306d$var$Storage;

$599acee56bb5306d$var$_CoreManager.default.setStorageController((parcelRequire("dwctU")));

});
parcelRequire.register("dwctU", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 * @private
 */ /* global localStorage */ var $9d77f210814a41e5$var$StorageController = {
    async: 0,
    getItem: function(path) /*: ?string*/ {
        return localStorage.getItem(path);
    },
    setItem: function(path, value) {
        try {
            localStorage.setItem(path, value);
        } catch (e) {
            // Quota exceeded, possibly due to Safari Private Browsing mode
            console.log(e.message);
        }
    },
    removeItem: function(path) {
        localStorage.removeItem(path);
    },
    getAllKeys: function() {
        var keys = [];
        for(var i = 0; i < localStorage.length; i += 1)keys.push(localStorage.key(i));
        return keys;
    },
    clear: function() {
        localStorage.clear();
    }
};
module.exports = $9d77f210814a41e5$var$StorageController;

});



parcelRequire.register("ktbIl", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee6f9a424f393766$var$parseDate;

var $ee6f9a424f393766$var$_parseInt2 = $iHLHC((parcelRequire("dJMBp")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $ee6f9a424f393766$var$parseDate(iso8601) /*: ?Date*/ {
    var regexp = new RegExp("^([0-9]{1,4})-([0-9]{1,2})-([0-9]{1,2})T([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})(.([0-9]+))?Z$");
    var match = regexp.exec(iso8601);
    if (!match) return null;
    var year = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[1]) || 0;
    var month = ((0, $ee6f9a424f393766$var$_parseInt2.default)(match[2]) || 1) - 1;
    var day = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[3]) || 0;
    var hour = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[4]) || 0;
    var minute = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[5]) || 0;
    var second = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[6]) || 0;
    var milli = (0, $ee6f9a424f393766$var$_parseInt2.default)(match[8]) || 0;
    return new Date(Date.UTC(year, month, day, hour, minute, second, milli));
}

});
parcelRequire.register("dJMBp", function(module, exports) {

module.exports = (parcelRequire("04sMR"));

});
parcelRequire.register("04sMR", function(module, exports) {

var $3PfNE = parcelRequire("3PfNE");
module.exports = $3PfNE;

});
parcelRequire.register("3PfNE", function(module, exports) {
parcelRequire("19lh2");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.parseInt;

});
parcelRequire.register("19lh2", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $iiMYx = parcelRequire("iiMYx");
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$ggcsv({
    global: true,
    forced: parseInt != $iiMYx
}, {
    parseInt: $iiMYx
});

});
parcelRequire.register("iiMYx", function(module, exports) {

var $3pyVf = parcelRequire("3pyVf");

var $77TPA = parcelRequire("77TPA");

var $f518o = parcelRequire("f518o");

var $l2Ut5 = parcelRequire("l2Ut5");

var $eLO92 = parcelRequire("eLO92");
var $d52fe5f5747e292a$require$trim = $eLO92.trim;

var $hxoJH = parcelRequire("hxoJH");
var $d52fe5f5747e292a$var$$parseInt = $3pyVf.parseInt;
var $d52fe5f5747e292a$var$Symbol = $3pyVf.Symbol;
var $d52fe5f5747e292a$var$ITERATOR = $d52fe5f5747e292a$var$Symbol && $d52fe5f5747e292a$var$Symbol.iterator;
var $d52fe5f5747e292a$var$hex = /^[+-]?0x/i;
var $d52fe5f5747e292a$var$exec = $f518o($d52fe5f5747e292a$var$hex.exec);
var $d52fe5f5747e292a$var$FORCED = $d52fe5f5747e292a$var$$parseInt($hxoJH + "08") !== 8 || $d52fe5f5747e292a$var$$parseInt($hxoJH + "0x16") !== 22 || $d52fe5f5747e292a$var$ITERATOR && !$77TPA(function() {
    $d52fe5f5747e292a$var$$parseInt(Object($d52fe5f5747e292a$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = $d52fe5f5747e292a$var$FORCED ? function parseInt(string, radix) {
    var S = $d52fe5f5747e292a$require$trim($l2Ut5(string));
    return $d52fe5f5747e292a$var$$parseInt(S, radix >>> 0 || ($d52fe5f5747e292a$var$exec($d52fe5f5747e292a$var$hex, S) ? 16 : 10));
} : $d52fe5f5747e292a$var$$parseInt;

});
parcelRequire.register("eLO92", function(module, exports) {

var $f518o = parcelRequire("f518o");

var $cBWnS = parcelRequire("cBWnS");

var $l2Ut5 = parcelRequire("l2Ut5");

var $hxoJH = parcelRequire("hxoJH");
var $ac0c5a32125b222c$var$replace = $f518o("".replace);
var $ac0c5a32125b222c$var$ltrim = RegExp("^[" + $hxoJH + "]+");
var $ac0c5a32125b222c$var$rtrim = RegExp("(^|[^" + $hxoJH + "])[" + $hxoJH + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $ac0c5a32125b222c$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $l2Ut5($cBWnS($this));
        if (TYPE & 1) string = $ac0c5a32125b222c$var$replace(string, $ac0c5a32125b222c$var$ltrim, "");
        if (TYPE & 2) string = $ac0c5a32125b222c$var$replace(string, $ac0c5a32125b222c$var$rtrim, "$1");
        return string;
    };
};
module.exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $ac0c5a32125b222c$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $ac0c5a32125b222c$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $ac0c5a32125b222c$var$createMethod(3)
};

});
parcelRequire.register("hxoJH", function(module, exports) {
// a string of all valid unicode whitespaces
module.exports = "	\n\v\f\r \xa0              　\u2028\u2029\uFEFF";

});








parcelRequire.register("8mp0p", function(module, exports) {
"use strict";

var $dzKYE = parcelRequire("dzKYE");

var $4i3Tl = parcelRequire("4i3Tl");

var $6iqUa = parcelRequire("6iqUa");

var $1X85b = parcelRequire("1X85b");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllState = $6163c669c0dd0a58$var$clearAllState;
module.exports.commitServerChanges = $6163c669c0dd0a58$var$commitServerChanges;
module.exports.duplicateState = $6163c669c0dd0a58$var$duplicateState;
module.exports.enqueueTask = $6163c669c0dd0a58$var$enqueueTask;
module.exports.estimateAttribute = $6163c669c0dd0a58$var$estimateAttribute;
module.exports.estimateAttributes = $6163c669c0dd0a58$var$estimateAttributes;
module.exports.getObjectCache = $6163c669c0dd0a58$var$getObjectCache;
module.exports.getPendingOps = $6163c669c0dd0a58$var$getPendingOps;
module.exports.getServerData = $6163c669c0dd0a58$var$getServerData;
module.exports.getState = $6163c669c0dd0a58$var$getState;
module.exports.initializeState = $6163c669c0dd0a58$var$initializeState;
module.exports.mergeFirstPendingState = $6163c669c0dd0a58$var$mergeFirstPendingState;
module.exports.popPendingState = $6163c669c0dd0a58$var$popPendingState;
module.exports.pushPendingState = $6163c669c0dd0a58$var$pushPendingState;
module.exports.removeState = $6163c669c0dd0a58$var$removeState;
module.exports.setPendingOp = $6163c669c0dd0a58$var$setPendingOp;
module.exports.setServerData = $6163c669c0dd0a58$var$setServerData;

var $6163c669c0dd0a58$var$ObjectStateMutations = $6163c669c0dd0a58$var$_interopRequireWildcard((parcelRequire("ad1OE")));
function $6163c669c0dd0a58$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof $1X85b !== "function") return null;
    var cacheBabelInterop = new $1X85b();
    var cacheNodeInterop = new $1X85b();
    return ($6163c669c0dd0a58$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6163c669c0dd0a58$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $6iqUa(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6163c669c0dd0a58$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = $4i3Tl && $dzKYE ? $dzKYE(obj, key) : null;
        if (desc && (desc.get || desc.set)) $4i3Tl(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $6163c669c0dd0a58$var$objectState = {};
function $6163c669c0dd0a58$var$getState(obj) /*: ?State*/ {
    var classData = $6163c669c0dd0a58$var$objectState[obj.className];
    if (classData) return classData[obj.id] || null;
    return null;
}
function $6163c669c0dd0a58$var$initializeState(obj, initial) /*: State*/ {
    var state = $6163c669c0dd0a58$var$getState(obj);
    if (state) return state;
    if (!$6163c669c0dd0a58$var$objectState[obj.className]) $6163c669c0dd0a58$var$objectState[obj.className] = {};
    if (!initial) initial = $6163c669c0dd0a58$var$ObjectStateMutations.defaultState();
    state = $6163c669c0dd0a58$var$objectState[obj.className][obj.id] = initial;
    return state;
}
function $6163c669c0dd0a58$var$removeState(obj) /*: ?State*/ {
    var state = $6163c669c0dd0a58$var$getState(obj);
    if (state === null) return null;
    delete $6163c669c0dd0a58$var$objectState[obj.className][obj.id];
    return state;
}
function $6163c669c0dd0a58$var$getServerData(obj) /*: AttributeMap*/ {
    var state = $6163c669c0dd0a58$var$getState(obj);
    if (state) return state.serverData;
    return {};
}
function $6163c669c0dd0a58$var$setServerData(obj, attributes) {
    var serverData = $6163c669c0dd0a58$var$initializeState(obj).serverData;
    $6163c669c0dd0a58$var$ObjectStateMutations.setServerData(serverData, attributes);
}
function $6163c669c0dd0a58$var$getPendingOps(obj) /*: Array<OpsMap>*/ {
    var state = $6163c669c0dd0a58$var$getState(obj);
    if (state) return state.pendingOps;
    return [
        {}
    ];
}
function $6163c669c0dd0a58$var$setPendingOp(obj, attr, op) {
    var pendingOps = $6163c669c0dd0a58$var$initializeState(obj).pendingOps;
    $6163c669c0dd0a58$var$ObjectStateMutations.setPendingOp(pendingOps, attr, op);
}
function $6163c669c0dd0a58$var$pushPendingState(obj) {
    var pendingOps = $6163c669c0dd0a58$var$initializeState(obj).pendingOps;
    $6163c669c0dd0a58$var$ObjectStateMutations.pushPendingState(pendingOps);
}
function $6163c669c0dd0a58$var$popPendingState(obj) /*: OpsMap*/ {
    var pendingOps = $6163c669c0dd0a58$var$initializeState(obj).pendingOps;
    return $6163c669c0dd0a58$var$ObjectStateMutations.popPendingState(pendingOps);
}
function $6163c669c0dd0a58$var$mergeFirstPendingState(obj) {
    var pendingOps = $6163c669c0dd0a58$var$getPendingOps(obj);
    $6163c669c0dd0a58$var$ObjectStateMutations.mergeFirstPendingState(pendingOps);
}
function $6163c669c0dd0a58$var$getObjectCache(obj) /*: ObjectCache*/ {
    var state = $6163c669c0dd0a58$var$getState(obj);
    if (state) return state.objectCache;
    return {};
}
function $6163c669c0dd0a58$var$estimateAttribute(obj, attr) /*: mixed*/ {
    var serverData = $6163c669c0dd0a58$var$getServerData(obj);
    var pendingOps = $6163c669c0dd0a58$var$getPendingOps(obj);
    return $6163c669c0dd0a58$var$ObjectStateMutations.estimateAttribute(serverData, pendingOps, obj.className, obj.id, attr);
}
function $6163c669c0dd0a58$var$estimateAttributes(obj) /*: AttributeMap*/ {
    var serverData = $6163c669c0dd0a58$var$getServerData(obj);
    var pendingOps = $6163c669c0dd0a58$var$getPendingOps(obj);
    return $6163c669c0dd0a58$var$ObjectStateMutations.estimateAttributes(serverData, pendingOps, obj.className, obj.id);
}
function $6163c669c0dd0a58$var$commitServerChanges(obj, changes) {
    var state = $6163c669c0dd0a58$var$initializeState(obj);
    $6163c669c0dd0a58$var$ObjectStateMutations.commitServerChanges(state.serverData, state.objectCache, changes);
}
function $6163c669c0dd0a58$var$enqueueTask(obj, task) /*: Promise*/ {
    var state = $6163c669c0dd0a58$var$initializeState(obj);
    return state.tasks.enqueue(task);
}
function $6163c669c0dd0a58$var$clearAllState() {
    $6163c669c0dd0a58$var$objectState = {};
}
function $6163c669c0dd0a58$var$duplicateState(source, dest) {
    dest.id = source.id;
}

});
parcelRequire.register("ad1OE", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");

var $dLJtR = parcelRequire("dLJtR");

var $fgRng = parcelRequire("fgRng");

var $gW71a = parcelRequire("gW71a");

var $dzKYE = parcelRequire("dzKYE");

var $i3o6i = parcelRequire("i3o6i");

var $3bLGW = parcelRequire("3bLGW");

var $2QmZN = parcelRequire("2QmZN");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.commitServerChanges = $76ec86e4064af147$var$commitServerChanges;
module.exports.defaultState = $76ec86e4064af147$var$defaultState;
module.exports.estimateAttribute = $76ec86e4064af147$var$estimateAttribute;
module.exports.estimateAttributes = $76ec86e4064af147$var$estimateAttributes;
module.exports.mergeFirstPendingState = $76ec86e4064af147$var$mergeFirstPendingState;
module.exports.popPendingState = $76ec86e4064af147$var$popPendingState;
module.exports.pushPendingState = $76ec86e4064af147$var$pushPendingState;
module.exports.setPendingOp = $76ec86e4064af147$var$setPendingOp;
module.exports.setServerData = $76ec86e4064af147$var$setServerData;

var $76ec86e4064af147$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $76ec86e4064af147$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $76ec86e4064af147$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $76ec86e4064af147$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $76ec86e4064af147$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $76ec86e4064af147$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $76ec86e4064af147$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $76ec86e4064af147$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));

var $76ec86e4064af147$var$_TaskQueue = $iHLHC((parcelRequire("6o8rx")));

var $3l0Qd = parcelRequire("3l0Qd");
function $76ec86e4064af147$var$ownKeys(object, enumerableOnly) {
    var keys = $2QmZN(object);
    if ($3bLGW) {
        var symbols = $3bLGW(object);
        enumerableOnly && (symbols = $i3o6i(symbols).call(symbols, function(sym) {
            return $dzKYE(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $76ec86e4064af147$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var _context, _context2;
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $gW71a(_context = $76ec86e4064af147$var$ownKeys(Object(source), !0)).call(_context, function(key) {
            (0, $76ec86e4064af147$var$_defineProperty2.default)(target, key, source[key]);
        }) : $fgRng ? $dLJtR(target, $fgRng(source)) : $gW71a(_context2 = $76ec86e4064af147$var$ownKeys(Object(source))).call(_context2, function(key) {
            $4i3Tl(target, key, $dzKYE(source, key));
        });
    }
    return target;
}
function $76ec86e4064af147$var$defaultState() /*: State*/ {
    return {
        serverData: {},
        pendingOps: [
            {}
        ],
        objectCache: {},
        tasks: new $76ec86e4064af147$var$_TaskQueue.default(),
        existed: false
    };
}
function $76ec86e4064af147$var$setServerData(serverData, attributes) {
    for(var _attr in attributes)if (typeof attributes[_attr] !== "undefined") serverData[_attr] = attributes[_attr];
    else delete serverData[_attr];
}
function $76ec86e4064af147$var$setPendingOp(pendingOps, attr, op) {
    var last = pendingOps.length - 1;
    if (op) pendingOps[last][attr] = op;
    else delete pendingOps[last][attr];
}
function $76ec86e4064af147$var$pushPendingState(pendingOps) {
    pendingOps.push({});
}
function $76ec86e4064af147$var$popPendingState(pendingOps) /*: OpsMap*/ {
    var first = pendingOps.shift();
    if (!pendingOps.length) pendingOps[0] = {};
    return first;
}
function $76ec86e4064af147$var$mergeFirstPendingState(pendingOps) {
    var first = $76ec86e4064af147$var$popPendingState(pendingOps);
    var next = pendingOps[0];
    for(var _attr2 in first)if (next[_attr2] && first[_attr2]) {
        var merged = next[_attr2].mergeWith(first[_attr2]);
        if (merged) next[_attr2] = merged;
    } else next[_attr2] = first[_attr2];
}
function $76ec86e4064af147$var$estimateAttribute(serverData, pendingOps, className, id, attr) /*: mixed*/ {
    var value = serverData[attr];
    for(var i = 0; i < pendingOps.length; i++)if (pendingOps[i][attr]) {
        if (pendingOps[i][attr] instanceof $3l0Qd.RelationOp) {
            if (id) value = pendingOps[i][attr].applyTo(value, {
                className: className,
                id: id
            }, attr);
        } else value = pendingOps[i][attr].applyTo(value);
    }
    return value;
}
function $76ec86e4064af147$var$estimateAttributes(serverData, pendingOps, className, id) /*: AttributeMap*/ {
    var data = {};
    for(var attr in serverData)data[attr] = serverData[attr];
    for(var i = 0; i < pendingOps.length; i++)for(attr in pendingOps[i]){
        if (pendingOps[i][attr] instanceof $3l0Qd.RelationOp) {
            if (id) data[attr] = pendingOps[i][attr].applyTo(data[attr], {
                className: className,
                id: id
            }, attr);
        } else if ((0, $76ec86e4064af147$var$_includes.default)(attr).call(attr, ".")) {
            // convert a.b.c into { a: { b: { c: value } } }
            var fields = attr.split(".");
            var first = fields[0];
            var last = fields[fields.length - 1];
            data[first] = $76ec86e4064af147$var$_objectSpread({}, serverData[first]);
            var object = $76ec86e4064af147$var$_objectSpread({}, data);
            for(var _i = 0; _i < fields.length - 1; _i++){
                var key = fields[_i];
                if (!(key in object)) object[key] = {};
                object = object[key];
            }
            object[last] = pendingOps[i][attr].applyTo(object[last]);
        } else data[attr] = pendingOps[i][attr].applyTo(data[attr]);
    }
    return data;
}
function $76ec86e4064af147$var$nestedSet(obj, key, value) {
    var path = key.split(".");
    for(var i = 0; i < path.length - 1; i++){
        if (!(path[i] in obj)) obj[path[i]] = {};
        obj = obj[path[i]];
    }
    if (typeof value === "undefined") delete obj[path[path.length - 1]];
    else obj[path[path.length - 1]] = value;
}
function $76ec86e4064af147$var$commitServerChanges(serverData, objectCache, changes) {
    for(var _attr3 in changes){
        var val = changes[_attr3];
        $76ec86e4064af147$var$nestedSet(serverData, _attr3, val);
        if (val && (0, $76ec86e4064af147$var$_typeof2.default)(val) === "object" && !(val instanceof $76ec86e4064af147$var$_ParseObject.default) && !(val instanceof $76ec86e4064af147$var$_ParseFile.default) && !(val instanceof $76ec86e4064af147$var$_ParseRelation.default)) {
            var json = (0, $76ec86e4064af147$var$_encode.default)(val, false, true);
            objectCache[_attr3] = (0, $76ec86e4064af147$var$_stringify.default)(json);
        }
    }
}

});
parcelRequire.register("6o8rx", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4a6b889f9dd6a2af$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $4a6b889f9dd6a2af$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $4a6b889f9dd6a2af$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $9FsFR = parcelRequire("9FsFR");
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $4a6b889f9dd6a2af$var$TaskQueue = /*#__PURE__*/ function() {
    function TaskQueue() {
        (0, $4a6b889f9dd6a2af$var$_classCallCheck2.default)(this, TaskQueue);
        (0, $4a6b889f9dd6a2af$var$_defineProperty2.default)(this, "queue", void 0);
        this.queue = [];
    }
    (0, $4a6b889f9dd6a2af$var$_createClass2.default)(TaskQueue, [
        {
            key: "enqueue",
            value: function(task) /*: Promise*/ {
                var _this = this;
                var taskComplete = new $9FsFR.resolvingPromise();
                this.queue.push({
                    task: task,
                    _completion: taskComplete
                });
                if (this.queue.length === 1) task().then(function() {
                    _this._dequeue();
                    taskComplete.resolve();
                }, function(error) {
                    _this._dequeue();
                    taskComplete.reject(error);
                });
                return taskComplete;
            }
        },
        {
            key: "_dequeue",
            value: function() {
                var _this2 = this;
                this.queue.shift();
                if (this.queue.length) {
                    var next = this.queue[0];
                    next.task().then(function() {
                        _this2._dequeue();
                        next._completion.resolve();
                    }, function(error) {
                        _this2._dequeue();
                        next._completion.reject(error);
                    });
                }
            }
        }
    ]);
    return TaskQueue;
}();
module.exports = $4a6b889f9dd6a2af$var$TaskQueue;

});



parcelRequire.register("eyyNg", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $dzKYE = parcelRequire("dzKYE");

var $4i3Tl = parcelRequire("4i3Tl");

var $6iqUa = parcelRequire("6iqUa");

$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllState = $a98f3af035ff8d06$var$clearAllState;
module.exports.commitServerChanges = $a98f3af035ff8d06$var$commitServerChanges;
module.exports.duplicateState = $a98f3af035ff8d06$var$duplicateState;
module.exports.enqueueTask = $a98f3af035ff8d06$var$enqueueTask;
module.exports.estimateAttribute = $a98f3af035ff8d06$var$estimateAttribute;
module.exports.estimateAttributes = $a98f3af035ff8d06$var$estimateAttributes;
module.exports.getObjectCache = $a98f3af035ff8d06$var$getObjectCache;
module.exports.getPendingOps = $a98f3af035ff8d06$var$getPendingOps;
module.exports.getServerData = $a98f3af035ff8d06$var$getServerData;
module.exports.getState = $a98f3af035ff8d06$var$getState;
module.exports.initializeState = $a98f3af035ff8d06$var$initializeState;
module.exports.mergeFirstPendingState = $a98f3af035ff8d06$var$mergeFirstPendingState;
module.exports.popPendingState = $a98f3af035ff8d06$var$popPendingState;
module.exports.pushPendingState = $a98f3af035ff8d06$var$pushPendingState;
module.exports.removeState = $a98f3af035ff8d06$var$removeState;
module.exports.setPendingOp = $a98f3af035ff8d06$var$setPendingOp;
module.exports.setServerData = $a98f3af035ff8d06$var$setServerData;

var $a98f3af035ff8d06$var$_weakMap = $iHLHC((parcelRequire("1X85b")));

var $a98f3af035ff8d06$var$ObjectStateMutations = $a98f3af035ff8d06$var$_interopRequireWildcard((parcelRequire("ad1OE")));

var $a98f3af035ff8d06$var$_TaskQueue = $iHLHC((parcelRequire("6o8rx")));
function $a98f3af035ff8d06$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof (parcelRequire("1X85b")) !== "function") return null;
    var cacheBabelInterop = new (parcelRequire("1X85b"))();
    var cacheNodeInterop = new (parcelRequire("1X85b"))();
    return ($a98f3af035ff8d06$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a98f3af035ff8d06$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $6iqUa(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a98f3af035ff8d06$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = $4i3Tl && $dzKYE ? $dzKYE(obj, key) : null;
        if (desc && (desc.get || desc.set)) $4i3Tl(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $a98f3af035ff8d06$var$objectState = new $a98f3af035ff8d06$var$_weakMap.default();
function $a98f3af035ff8d06$var$getState(obj) /*: ?State*/ {
    var classData = $a98f3af035ff8d06$var$objectState.get(obj);
    return classData || null;
}
function $a98f3af035ff8d06$var$initializeState(obj, initial) /*: State*/ {
    var state = $a98f3af035ff8d06$var$getState(obj);
    if (state) return state;
    if (!initial) initial = {
        serverData: {},
        pendingOps: [
            {}
        ],
        objectCache: {},
        tasks: new $a98f3af035ff8d06$var$_TaskQueue.default(),
        existed: false
    };
    state = initial;
    $a98f3af035ff8d06$var$objectState.set(obj, state);
    return state;
}
function $a98f3af035ff8d06$var$removeState(obj) /*: ?State*/ {
    var state = $a98f3af035ff8d06$var$getState(obj);
    if (state === null) return null;
    $a98f3af035ff8d06$var$objectState.delete(obj);
    return state;
}
function $a98f3af035ff8d06$var$getServerData(obj) /*: AttributeMap*/ {
    var state = $a98f3af035ff8d06$var$getState(obj);
    if (state) return state.serverData;
    return {};
}
function $a98f3af035ff8d06$var$setServerData(obj, attributes) {
    var serverData = $a98f3af035ff8d06$var$initializeState(obj).serverData;
    $a98f3af035ff8d06$var$ObjectStateMutations.setServerData(serverData, attributes);
}
function $a98f3af035ff8d06$var$getPendingOps(obj) /*: Array<OpsMap>*/ {
    var state = $a98f3af035ff8d06$var$getState(obj);
    if (state) return state.pendingOps;
    return [
        {}
    ];
}
function $a98f3af035ff8d06$var$setPendingOp(obj, attr, op) {
    var pendingOps = $a98f3af035ff8d06$var$initializeState(obj).pendingOps;
    $a98f3af035ff8d06$var$ObjectStateMutations.setPendingOp(pendingOps, attr, op);
}
function $a98f3af035ff8d06$var$pushPendingState(obj) {
    var pendingOps = $a98f3af035ff8d06$var$initializeState(obj).pendingOps;
    $a98f3af035ff8d06$var$ObjectStateMutations.pushPendingState(pendingOps);
}
function $a98f3af035ff8d06$var$popPendingState(obj) /*: OpsMap*/ {
    var pendingOps = $a98f3af035ff8d06$var$initializeState(obj).pendingOps;
    return $a98f3af035ff8d06$var$ObjectStateMutations.popPendingState(pendingOps);
}
function $a98f3af035ff8d06$var$mergeFirstPendingState(obj) {
    var pendingOps = $a98f3af035ff8d06$var$getPendingOps(obj);
    $a98f3af035ff8d06$var$ObjectStateMutations.mergeFirstPendingState(pendingOps);
}
function $a98f3af035ff8d06$var$getObjectCache(obj) /*: ObjectCache*/ {
    var state = $a98f3af035ff8d06$var$getState(obj);
    if (state) return state.objectCache;
    return {};
}
function $a98f3af035ff8d06$var$estimateAttribute(obj, attr) /*: mixed*/ {
    var serverData = $a98f3af035ff8d06$var$getServerData(obj);
    var pendingOps = $a98f3af035ff8d06$var$getPendingOps(obj);
    return $a98f3af035ff8d06$var$ObjectStateMutations.estimateAttribute(serverData, pendingOps, obj.className, obj.id, attr);
}
function $a98f3af035ff8d06$var$estimateAttributes(obj) /*: AttributeMap*/ {
    var serverData = $a98f3af035ff8d06$var$getServerData(obj);
    var pendingOps = $a98f3af035ff8d06$var$getPendingOps(obj);
    return $a98f3af035ff8d06$var$ObjectStateMutations.estimateAttributes(serverData, pendingOps, obj.className, obj.id);
}
function $a98f3af035ff8d06$var$commitServerChanges(obj, changes) {
    var state = $a98f3af035ff8d06$var$initializeState(obj);
    $a98f3af035ff8d06$var$ObjectStateMutations.commitServerChanges(state.serverData, state.objectCache, changes);
}
function $a98f3af035ff8d06$var$enqueueTask(obj, task) /*: Promise*/ {
    var state = $a98f3af035ff8d06$var$initializeState(obj);
    return state.tasks.enqueue(task);
}
function $a98f3af035ff8d06$var$duplicateState(source, dest) /*: void*/ {
    var oldState = $a98f3af035ff8d06$var$initializeState(source);
    var newState = $a98f3af035ff8d06$var$initializeState(dest);
    for(var key in oldState.serverData)newState.serverData[key] = oldState.serverData[key];
    for(var index = 0; index < oldState.pendingOps.length; index++)for(var _key in oldState.pendingOps[index])newState.pendingOps[index][_key] = oldState.pendingOps[index][_key];
    for(var _key2 in oldState.objectCache)newState.objectCache[_key2] = oldState.objectCache[_key2];
    newState.existed = oldState.existed;
}
function $a98f3af035ff8d06$var$clearAllState() {
    $a98f3af035ff8d06$var$objectState = new $a98f3af035ff8d06$var$_weakMap.default();
}

});

parcelRequire.register("zyRRD", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06ae5103554c9256$var$unsavedChildren;

var $06ae5103554c9256$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $06ae5103554c9256$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $06ae5103554c9256$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $06ae5103554c9256$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $06ae5103554c9256$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $06ae5103554c9256$var$_ParseFile = $iHLHC((parcelRequire("59JWU")));

var $06ae5103554c9256$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $06ae5103554c9256$var$_ParseRelation = $iHLHC((parcelRequire("967gW")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Return an array of unsaved children, which are either Parse Objects or Files.
 * If it encounters any dirty Objects without Ids, it will throw an exception.
 *
 * @param {Parse.Object} obj
 * @param {boolean} allowDeepUnsaved
 * @returns {Array}
 */ function $06ae5103554c9256$var$unsavedChildren(obj, allowDeepUnsaved) /*: Array<ParseFile | ParseObject>*/ {
    var encountered = {
        objects: {},
        files: []
    };
    var identifier = obj.className + ":" + obj._getId();
    encountered.objects[identifier] = obj.dirty() ? obj : true;
    var attributes = obj.attributes;
    for(var attr in attributes)if ((0, $06ae5103554c9256$var$_typeof2.default)(attributes[attr]) === "object") $06ae5103554c9256$var$traverse(attributes[attr], encountered, false, !!allowDeepUnsaved);
    var unsaved = [];
    for(var id in encountered.objects)if (id !== identifier && encountered.objects[id] !== true) unsaved.push(encountered.objects[id]);
    return (0, $06ae5103554c9256$var$_concat.default)(unsaved).call(unsaved, encountered.files);
}
function $06ae5103554c9256$var$traverse(obj, encountered, shouldThrow, allowDeepUnsaved) {
    if (obj instanceof $06ae5103554c9256$var$_ParseObject.default) {
        if (!obj.id && shouldThrow) throw new Error("Cannot create a pointer to an unsaved Object.");
        var _identifier = obj.className + ":" + obj._getId();
        if (!encountered.objects[_identifier]) {
            encountered.objects[_identifier] = obj.dirty() ? obj : true;
            var attributes = obj.attributes;
            for(var attr in attributes)if ((0, $06ae5103554c9256$var$_typeof2.default)(attributes[attr]) === "object") $06ae5103554c9256$var$traverse(attributes[attr], encountered, !allowDeepUnsaved, allowDeepUnsaved);
        }
        return;
    }
    if (obj instanceof $06ae5103554c9256$var$_ParseFile.default) {
        var _context;
        if (!obj.url() && (0, $06ae5103554c9256$var$_indexOf.default)(_context = encountered.files).call(_context, obj) < 0) encountered.files.push(obj);
        return;
    }
    if (obj instanceof $06ae5103554c9256$var$_ParseRelation.default) return;
    if ((0, $06ae5103554c9256$var$_isArray.default)(obj)) (0, $06ae5103554c9256$var$_forEach.default)(obj).call(obj, function(el) {
        if ((0, $06ae5103554c9256$var$_typeof2.default)(el) === "object") $06ae5103554c9256$var$traverse(el, encountered, shouldThrow, allowDeepUnsaved);
    });
    for(var k in obj)if ((0, $06ae5103554c9256$var$_typeof2.default)(obj[k]) === "object") $06ae5103554c9256$var$traverse(obj[k], encountered, shouldThrow, allowDeepUnsaved);
}

});

parcelRequire.register("4q6en", function(module, exports) {
"use strict";
var $337e6c754049e2ee$var$uuid = null;

$337e6c754049e2ee$var$uuid = (parcelRequire("hvDV4"));
module.exports = $337e6c754049e2ee$var$uuid;

});
parcelRequire.register("hvDV4", function(module, exports) {

var $bmesH = parcelRequire("bmesH");

var $6Cr4u = parcelRequire("6Cr4u");
function $cbf44c17b8a2e6af$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $bmesH)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $6Cr4u(rnds);
}
module.exports = $cbf44c17b8a2e6af$var$v4;

});
parcelRequire.register("bmesH", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $844cf7a0ea9afd9d$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($844cf7a0ea9afd9d$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $844cf7a0ea9afd9d$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $844cf7a0ea9afd9d$var$getRandomValues($844cf7a0ea9afd9d$var$rnds8);
        return $844cf7a0ea9afd9d$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $844cf7a0ea9afd9d$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $844cf7a0ea9afd9d$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $844cf7a0ea9afd9d$var$rnds;
    };
}

});

parcelRequire.register("6Cr4u", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $4d1b4a87451e6582$var$byteToHex = [];
for(var $4d1b4a87451e6582$var$i = 0; $4d1b4a87451e6582$var$i < 256; ++$4d1b4a87451e6582$var$i)$4d1b4a87451e6582$var$byteToHex[$4d1b4a87451e6582$var$i] = ($4d1b4a87451e6582$var$i + 0x100).toString(16).substr(1);
function $4d1b4a87451e6582$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $4d1b4a87451e6582$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $4d1b4a87451e6582$var$bytesToUuid;

});





parcelRequire.register("iQ4JH", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $a1TrC = parcelRequire("a1TrC");

var $4wehD = parcelRequire("4wehD");


var $dQJQf = parcelRequire("dQJQf");


var $gW71a = parcelRequire("gW71a");

var $kOp5W = parcelRequire("kOp5W");

var $jQ6K5 = parcelRequire("jQ6K5");


var $iDZ3d = parcelRequire("iDZ3d");

var $oM1qX = parcelRequire("oM1qX");
(parcelRequire("4i3Tl"))(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db70c1cf4bc707fd$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $db70c1cf4bc707fd$var$_defineProperty = $iHLHC((parcelRequire("4i3Tl")));

var $db70c1cf4bc707fd$var$_asyncToGenerator2 = $iHLHC((parcelRequire("kkHAR")));

var $db70c1cf4bc707fd$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $db70c1cf4bc707fd$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $db70c1cf4bc707fd$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $db70c1cf4bc707fd$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $db70c1cf4bc707fd$var$_get2 = $iHLHC((parcelRequire("a4mHi")));

var $db70c1cf4bc707fd$var$_inherits2 = $iHLHC((parcelRequire("cNDsY")));

var $db70c1cf4bc707fd$var$_possibleConstructorReturn2 = $iHLHC((parcelRequire("1C8Dw")));

var $db70c1cf4bc707fd$var$_getPrototypeOf2 = $iHLHC((parcelRequire("kptbe")));

var $db70c1cf4bc707fd$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $db70c1cf4bc707fd$var$_isRevocableSession = $iHLHC((parcelRequire("6Jk06")));

var $db70c1cf4bc707fd$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $db70c1cf4bc707fd$var$_ParseObject2 = $iHLHC((parcelRequire("fMBjE")));

var $db70c1cf4bc707fd$var$_ParseSession = $iHLHC((parcelRequire("b7rpJ")));

var $db70c1cf4bc707fd$var$_Storage = $iHLHC((parcelRequire("7GXKV")));
function $db70c1cf4bc707fd$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $db70c1cf4bc707fd$var$_regeneratorRuntime = function() {
        return exports1;
    };
    var exports1 = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $iDZ3d ? $iDZ3d : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return (parcelRequire("4i3Tl"))(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $jQ6K5(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports1.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $kOp5W, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $jQ6K5(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context7;
        $gW71a(_context7 = [
            "next",
            "throw",
            "return"
        ]).call(_context7, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == (parcelRequire("6iqUa"))(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], $gW71a(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports1.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports1.mark = function(genFun) {
        return $dQJQf ? $dQJQf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $jQ6K5(Gp), genFun;
    }, exports1.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports1.AsyncIterator = AsyncIterator, exports1.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("iH0WI")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports1.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports1.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $4wehD(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports1.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context8;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, $gW71a(_context8 = this.tryEntries).call(_context8, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$a1TrC(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports1;
}
function $db70c1cf4bc707fd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $db70c1cf4bc707fd$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $db70c1cf4bc707fd$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $db70c1cf4bc707fd$var$_getPrototypeOf2.default)(this).constructor;
            result = $oM1qX(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $db70c1cf4bc707fd$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $db70c1cf4bc707fd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$oM1qX) return false;
    if ($oM1qX.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($oM1qX(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $db70c1cf4bc707fd$var$CURRENT_USER_KEY = "currentUser";
var $db70c1cf4bc707fd$var$canUseCurrentUser = !$db70c1cf4bc707fd$var$_CoreManager.default.get("IS_NODE");
var $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = false;
var $db70c1cf4bc707fd$var$currentUserCache = null;
var $db70c1cf4bc707fd$var$authProviders = {};
/**
 * <p>A Parse.User object is a local representation of a user persisted to the
 * Parse cloud. This class is a subclass of a Parse.Object, and retains the
 * same functionality of a Parse.Object, but also extends it with various
 * user specific methods, like authentication, signing up, and validation of
 * uniqueness.</p>
 *
 * @alias Parse.User
 * @augments Parse.Object
 */ var $db70c1cf4bc707fd$var$ParseUser = /*#__PURE__*/ function(_ParseObject) {
    (0, $db70c1cf4bc707fd$var$_inherits2.default)(ParseUser, _ParseObject);
    var _super = $db70c1cf4bc707fd$var$_createSuper(ParseUser);
    /**
   * @param {object} attributes The initial set of data to store in the user.
   */ function ParseUser(attributes) {
        var _this;
        (0, $db70c1cf4bc707fd$var$_classCallCheck2.default)(this, ParseUser);
        _this = _super.call(this, "_User");
        if (attributes && (0, $db70c1cf4bc707fd$var$_typeof2.default)(attributes) === "object") {
            if (!_this.set(attributes || {})) throw new Error("Can't create an invalid Parse User");
        }
        return _this;
    }
    /**
   * Request a revocable session token to replace the older style of token.
   *
   * @param {object} options
   * @returns {Promise} A promise that is resolved when the replacement
   *   token has been fetched.
   */ (0, $db70c1cf4bc707fd$var$_createClass2.default)(ParseUser, [
        {
            key: "_upgradeToRevocableSession",
            value: function(options) /*: Promise<void>*/ {
                options = options || {};
                var upgradeOptions = {};
                if (options.hasOwnProperty("useMasterKey")) upgradeOptions.useMasterKey = options.useMasterKey;
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                return controller.upgradeToRevocableSession(this, upgradeOptions);
            }
        },
        {
            key: "linkWith",
            value: function(provider, options) /*: Promise<ParseUser>*/ {
                var _this2 = this;
                var saveOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                saveOpts.sessionToken = saveOpts.sessionToken || this.getSessionToken() || "";
                var authType;
                if (typeof provider === "string") {
                    authType = provider;
                    if ($db70c1cf4bc707fd$var$authProviders[provider]) provider = $db70c1cf4bc707fd$var$authProviders[provider];
                    else {
                        var authProvider = {
                            restoreAuthentication: function() {
                                return true;
                            },
                            getAuthType: function() {
                                return authType;
                            }
                        };
                        $db70c1cf4bc707fd$var$authProviders[authProvider.getAuthType()] = authProvider;
                        provider = authProvider;
                    }
                } else authType = provider.getAuthType();
                if (options && options.hasOwnProperty("authData")) {
                    var authData = this.get("authData") || {};
                    if ((0, $db70c1cf4bc707fd$var$_typeof2.default)(authData) !== "object") throw new Error("Invalid type: authData field should be an object");
                    authData[authType] = options.authData;
                    var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                    return controller.linkWith(this, authData, saveOpts);
                } else return new $db70c1cf4bc707fd$var$_promise.default(function(resolve, reject) {
                    provider.authenticate({
                        success: function(provider, result) {
                            var opts = {};
                            opts.authData = result;
                            _this2.linkWith(provider, opts, saveOpts).then(function() {
                                resolve(_this2);
                            }, function(error) {
                                reject(error);
                            });
                        },
                        error: function(provider, _error) {
                            reject(_error);
                        }
                    });
                });
            }
        },
        {
            key: "_linkWith",
            value: function(provider, options) /*: Promise<ParseUser>*/ {
                var saveOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.linkWith(provider, options, saveOpts);
            }
        },
        {
            key: "_synchronizeAuthData",
            value: function(provider) {
                if (!this.isCurrent() || !provider) return;
                var authType;
                if (typeof provider === "string") {
                    authType = provider;
                    provider = $db70c1cf4bc707fd$var$authProviders[authType];
                } else authType = provider.getAuthType();
                var authData = this.get("authData");
                if (!provider || !authData || (0, $db70c1cf4bc707fd$var$_typeof2.default)(authData) !== "object") return;
                var success = provider.restoreAuthentication(authData[authType]);
                if (!success) this._unlinkFrom(provider);
            }
        },
        {
            key: "_synchronizeAllAuthData",
            value: function() {
                var authData = this.get("authData");
                if ((0, $db70c1cf4bc707fd$var$_typeof2.default)(authData) !== "object") return;
                for(var _key in authData)this._synchronizeAuthData(_key);
            }
        },
        {
            key: "_cleanupAuthData",
            value: function() {
                if (!this.isCurrent()) return;
                var authData = this.get("authData");
                if ((0, $db70c1cf4bc707fd$var$_typeof2.default)(authData) !== "object") return;
                for(var _key2 in authData)if (!authData[_key2]) delete authData[_key2];
            }
        },
        {
            key: "_unlinkFrom",
            value: function(provider, options) /*: Promise<ParseUser>*/ {
                var _this3 = this;
                return this.linkWith(provider, {
                    authData: null
                }, options).then(function() {
                    _this3._synchronizeAuthData(provider);
                    return $db70c1cf4bc707fd$var$_promise.default.resolve(_this3);
                });
            }
        },
        {
            key: "_isLinked",
            value: function(provider) /*: boolean*/ {
                var authType;
                if (typeof provider === "string") authType = provider;
                else authType = provider.getAuthType();
                var authData = this.get("authData") || {};
                if ((0, $db70c1cf4bc707fd$var$_typeof2.default)(authData) !== "object") return false;
                return !!authData[authType];
            }
        },
        {
            key: "_logOutWithAll",
            value: function() {
                var authData = this.get("authData");
                if ((0, $db70c1cf4bc707fd$var$_typeof2.default)(authData) !== "object") return;
                for(var _key3 in authData)this._logOutWith(_key3);
            }
        },
        {
            key: "_logOutWith",
            value: function(provider) {
                if (!this.isCurrent()) return;
                if (typeof provider === "string") provider = $db70c1cf4bc707fd$var$authProviders[provider];
                if (provider && provider.deauthenticate) provider.deauthenticate();
            }
        },
        {
            key: "_preserveFieldsOnFetch",
            value: function() /*: AttributeMap*/ {
                return {
                    sessionToken: this.get("sessionToken")
                };
            }
        },
        {
            key: "isCurrent",
            value: function() /*: boolean*/ {
                var current = ParseUser.current();
                return !!current && current.id === this.id;
            }
        },
        {
            key: "isCurrentAsync",
            value: function() {
                var _isCurrentAsync = (0, $db70c1cf4bc707fd$var$_asyncToGenerator2.default)(/*#__PURE__*/ $db70c1cf4bc707fd$var$_regeneratorRuntime().mark(function _callee() {
                    var current;
                    return $db70c1cf4bc707fd$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return ParseUser.currentAsync();
                            case 2:
                                current = _context.sent;
                                return _context.abrupt("return", !!current && current.id === this.id);
                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function isCurrentAsync() {
                    return _isCurrentAsync.apply(this, arguments);
                }
                return isCurrentAsync;
            }()
        },
        {
            key: "getUsername",
            value: function getUsername() /*: ?string*/ {
                var username = this.get("username");
                if (username == null || typeof username === "string") return username;
                return "";
            }
        },
        {
            key: "setUsername",
            value: function setUsername(username) {
                // Strip anonymity
                var authData = this.get("authData");
                if (authData && (0, $db70c1cf4bc707fd$var$_typeof2.default)(authData) === "object" && authData.hasOwnProperty("anonymous")) // We need to set anonymous to null instead of deleting it in order to remove it from Parse.
                authData.anonymous = null;
                this.set("username", username);
            }
        },
        {
            key: "setPassword",
            value: function setPassword(password) {
                this.set("password", password);
            }
        },
        {
            key: "getEmail",
            value: function getEmail() /*: ?string*/ {
                var email = this.get("email");
                if (email == null || typeof email === "string") return email;
                return "";
            }
        },
        {
            key: "setEmail",
            value: function setEmail(email) {
                return this.set("email", email);
            }
        },
        {
            key: "getSessionToken",
            value: function getSessionToken() /*: ?string*/ {
                var token = this.get("sessionToken");
                if (token == null || typeof token === "string") return token;
                return "";
            }
        },
        {
            key: "authenticated",
            value: function authenticated() /*: boolean*/ {
                var current = ParseUser.current();
                return !!this.get("sessionToken") && !!current && current.id === this.id;
            }
        },
        {
            key: "signUp",
            value: function signUp(attrs, options) /*: Promise<ParseUser>*/ {
                options = options || {};
                var signupOptions = {};
                if (options.hasOwnProperty("useMasterKey")) signupOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("installationId")) signupOptions.installationId = options.installationId;
                if (options.hasOwnProperty("context") && Object.prototype.toString.call(options.context) === "[object Object]") signupOptions.context = options.context;
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                return controller.signUp(this, attrs, signupOptions);
            }
        },
        {
            key: "logIn",
            value: function logIn(options) /*: Promise<ParseUser>*/ {
                options = options || {};
                var loginOptions = {
                    usePost: true
                };
                if (options.hasOwnProperty("useMasterKey")) loginOptions.useMasterKey = options.useMasterKey;
                if (options.hasOwnProperty("installationId")) loginOptions.installationId = options.installationId;
                if (options.hasOwnProperty("usePost")) loginOptions.usePost = options.usePost;
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                return controller.logIn(this, loginOptions);
            }
        },
        {
            key: "save",
            value: function() {
                var _save = (0, $db70c1cf4bc707fd$var$_asyncToGenerator2.default)(/*#__PURE__*/ $db70c1cf4bc707fd$var$_regeneratorRuntime().mark(function _callee2() {
                    var _len, args, _key4, current, _args2 = arguments;
                    return $db70c1cf4bc707fd$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                for(_len = _args2.length, args = new Array(_len), _key4 = 0; _key4 < _len; _key4++)args[_key4] = _args2[_key4];
                                _context2.next = 3;
                                return (0, $db70c1cf4bc707fd$var$_get2.default)((0, $db70c1cf4bc707fd$var$_getPrototypeOf2.default)(ParseUser.prototype), "save", this).apply(this, args);
                            case 3:
                                _context2.next = 5;
                                return this.isCurrentAsync();
                            case 5:
                                current = _context2.sent;
                                if (!current) {
                                    _context2.next = 8;
                                    break;
                                }
                                return _context2.abrupt("return", $db70c1cf4bc707fd$var$_CoreManager.default.getUserController().updateUserOnDisk(this));
                            case 8:
                                return _context2.abrupt("return", this);
                            case 9:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function save() {
                    return _save.apply(this, arguments);
                }
                return save;
            }()
        },
        {
            key: "destroy",
            value: function() {
                var _destroy = (0, $db70c1cf4bc707fd$var$_asyncToGenerator2.default)(/*#__PURE__*/ $db70c1cf4bc707fd$var$_regeneratorRuntime().mark(function _callee3() {
                    var _len2, args, _key5, current, _args3 = arguments;
                    return $db70c1cf4bc707fd$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                for(_len2 = _args3.length, args = new Array(_len2), _key5 = 0; _key5 < _len2; _key5++)args[_key5] = _args3[_key5];
                                _context3.next = 3;
                                return (0, $db70c1cf4bc707fd$var$_get2.default)((0, $db70c1cf4bc707fd$var$_getPrototypeOf2.default)(ParseUser.prototype), "destroy", this).apply(this, args);
                            case 3:
                                _context3.next = 5;
                                return this.isCurrentAsync();
                            case 5:
                                current = _context3.sent;
                                if (!current) {
                                    _context3.next = 8;
                                    break;
                                }
                                return _context3.abrupt("return", $db70c1cf4bc707fd$var$_CoreManager.default.getUserController().removeUserFromDisk());
                            case 8:
                                return _context3.abrupt("return", this);
                            case 9:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function destroy() {
                    return _destroy.apply(this, arguments);
                }
                return destroy;
            }()
        },
        {
            key: "fetch",
            value: function() {
                var _fetch = (0, $db70c1cf4bc707fd$var$_asyncToGenerator2.default)(/*#__PURE__*/ $db70c1cf4bc707fd$var$_regeneratorRuntime().mark(function _callee4() {
                    var _len3, args, _key6, current, _args4 = arguments;
                    return $db70c1cf4bc707fd$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                for(_len3 = _args4.length, args = new Array(_len3), _key6 = 0; _key6 < _len3; _key6++)args[_key6] = _args4[_key6];
                                _context4.next = 3;
                                return (0, $db70c1cf4bc707fd$var$_get2.default)((0, $db70c1cf4bc707fd$var$_getPrototypeOf2.default)(ParseUser.prototype), "fetch", this).apply(this, args);
                            case 3:
                                _context4.next = 5;
                                return this.isCurrentAsync();
                            case 5:
                                current = _context4.sent;
                                if (!current) {
                                    _context4.next = 8;
                                    break;
                                }
                                return _context4.abrupt("return", $db70c1cf4bc707fd$var$_CoreManager.default.getUserController().updateUserOnDisk(this));
                            case 8:
                                return _context4.abrupt("return", this);
                            case 9:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function fetch() {
                    return _fetch.apply(this, arguments);
                }
                return fetch;
            }()
        },
        {
            key: "fetchWithInclude",
            value: function() {
                var _fetchWithInclude = (0, $db70c1cf4bc707fd$var$_asyncToGenerator2.default)(/*#__PURE__*/ $db70c1cf4bc707fd$var$_regeneratorRuntime().mark(function _callee5() {
                    var _len4, args, _key7, current, _args5 = arguments;
                    return $db70c1cf4bc707fd$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                for(_len4 = _args5.length, args = new Array(_len4), _key7 = 0; _key7 < _len4; _key7++)args[_key7] = _args5[_key7];
                                _context5.next = 3;
                                return (0, $db70c1cf4bc707fd$var$_get2.default)((0, $db70c1cf4bc707fd$var$_getPrototypeOf2.default)(ParseUser.prototype), "fetchWithInclude", this).apply(this, args);
                            case 3:
                                _context5.next = 5;
                                return this.isCurrentAsync();
                            case 5:
                                current = _context5.sent;
                                if (!current) {
                                    _context5.next = 8;
                                    break;
                                }
                                return _context5.abrupt("return", $db70c1cf4bc707fd$var$_CoreManager.default.getUserController().updateUserOnDisk(this));
                            case 8:
                                return _context5.abrupt("return", this);
                            case 9:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchWithInclude() {
                    return _fetchWithInclude.apply(this, arguments);
                }
                return fetchWithInclude;
            }()
        },
        {
            key: "verifyPassword",
            value: function verifyPassword(password, options) /*: Promise<ParseUser>*/ {
                var username = this.getUsername() || "";
                return ParseUser.verifyPassword(username, password, options);
            }
        }
    ], [
        {
            key: "readOnlyAttributes",
            value: function readOnlyAttributes() {
                return [
                    "sessionToken"
                ];
            }
        },
        {
            key: "extend",
            value: function extend(protoProps, classProps) {
                if (protoProps) {
                    for(var _prop in protoProps)if (_prop !== "className") (0, $db70c1cf4bc707fd$var$_defineProperty.default)(ParseUser.prototype, _prop, {
                        value: protoProps[_prop],
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                }
                if (classProps) {
                    for(var _prop2 in classProps)if (_prop2 !== "className") (0, $db70c1cf4bc707fd$var$_defineProperty.default)(ParseUser, _prop2, {
                        value: classProps[_prop2],
                        enumerable: false,
                        writable: true,
                        configurable: true
                    });
                }
                return ParseUser;
            }
        },
        {
            key: "current",
            value: function current() /*: ?ParseUser*/ {
                if (!$db70c1cf4bc707fd$var$canUseCurrentUser) return null;
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                return controller.currentUser();
            }
        },
        {
            key: "currentAsync",
            value: function currentAsync() /*: Promise<?ParseUser>*/ {
                if (!$db70c1cf4bc707fd$var$canUseCurrentUser) return $db70c1cf4bc707fd$var$_promise.default.resolve(null);
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                return controller.currentUserAsync();
            }
        },
        {
            key: "signUp",
            value: function signUp(username, password, attrs, options) {
                attrs = attrs || {};
                attrs.username = username;
                attrs.password = password;
                var user = new this(attrs);
                return user.signUp({}, options);
            }
        },
        {
            key: "logIn",
            value: function logIn(username, password, options) {
                if (typeof username !== "string") return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Username must be a string."));
                else if (typeof password !== "string") return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Password must be a string."));
                var user = new this();
                user._finishFetch({
                    username: username,
                    password: password
                });
                return user.logIn(options);
            }
        },
        {
            key: "become",
            value: function become(sessionToken, options) {
                if (!$db70c1cf4bc707fd$var$canUseCurrentUser) throw new Error("It is not memory-safe to become a user in a server environment");
                options = options || {};
                var becomeOptions = {
                    sessionToken: sessionToken
                };
                if (options.hasOwnProperty("useMasterKey")) becomeOptions.useMasterKey = options.useMasterKey;
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                var user = new this();
                return controller.become(user, becomeOptions);
            }
        },
        {
            key: "me",
            value: function me(sessionToken) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                var meOptions = {
                    sessionToken: sessionToken
                };
                if (options.useMasterKey) meOptions.useMasterKey = options.useMasterKey;
                var user = new this();
                return controller.me(user, meOptions);
            }
        },
        {
            key: "hydrate",
            value: function hydrate(userJSON) {
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                var user = new this();
                return controller.hydrate(user, userJSON);
            }
        },
        {
            key: "logInWith",
            value: function logInWith(provider, options, saveOpts) /*: Promise<ParseUser>*/ {
                var user = new this();
                return user.linkWith(provider, options, saveOpts);
            }
        },
        {
            key: "logOut",
            value: function logOut() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                return controller.logOut(options);
            }
        },
        {
            key: "requestPasswordReset",
            value: function requestPasswordReset(email, options) {
                options = options || {};
                var requestOptions = {};
                if (options.hasOwnProperty("useMasterKey")) requestOptions.useMasterKey = options.useMasterKey;
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                return controller.requestPasswordReset(email, requestOptions);
            }
        },
        {
            key: "requestEmailVerification",
            value: function requestEmailVerification(email, options) {
                options = options || {};
                var requestOptions = {};
                if (options.hasOwnProperty("useMasterKey")) requestOptions.useMasterKey = options.useMasterKey;
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                return controller.requestEmailVerification(email, requestOptions);
            }
        },
        {
            key: "verifyPassword",
            value: function verifyPassword(username, password, options) {
                if (typeof username !== "string") return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Username must be a string."));
                if (typeof password !== "string") return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Password must be a string."));
                options = options || {};
                var verificationOption = {};
                if (options.hasOwnProperty("useMasterKey")) verificationOption.useMasterKey = options.useMasterKey;
                var controller = $db70c1cf4bc707fd$var$_CoreManager.default.getUserController();
                return controller.verifyPassword(username, password, verificationOption);
            }
        },
        {
            key: "allowCustomUserClass",
            value: function allowCustomUserClass(isAllowed) {
                $db70c1cf4bc707fd$var$_CoreManager.default.set("PERFORM_USER_REWRITE", !isAllowed);
            }
        },
        {
            key: "enableRevocableSession",
            value: function enableRevocableSession(options) {
                options = options || {};
                $db70c1cf4bc707fd$var$_CoreManager.default.set("FORCE_REVOCABLE_SESSION", true);
                if ($db70c1cf4bc707fd$var$canUseCurrentUser) {
                    var current = ParseUser.current();
                    if (current) return current._upgradeToRevocableSession(options);
                }
                return $db70c1cf4bc707fd$var$_promise.default.resolve();
            }
        },
        {
            key: "enableUnsafeCurrentUser",
            value: function enableUnsafeCurrentUser() {
                $db70c1cf4bc707fd$var$canUseCurrentUser = true;
            }
        },
        {
            key: "disableUnsafeCurrentUser",
            value: function disableUnsafeCurrentUser() {
                $db70c1cf4bc707fd$var$canUseCurrentUser = false;
            }
        },
        {
            key: "_registerAuthenticationProvider",
            value: function _registerAuthenticationProvider(provider) {
                $db70c1cf4bc707fd$var$authProviders[provider.getAuthType()] = provider; // Synchronize the current user with the auth provider.
                ParseUser.currentAsync().then(function(current) {
                    if (current) current._synchronizeAuthData(provider.getAuthType());
                });
            }
        },
        {
            key: "_logInWith",
            value: function _logInWith(provider, options, saveOpts) {
                var user = new this();
                return user.linkWith(provider, options, saveOpts);
            }
        },
        {
            key: "_clearCache",
            value: function _clearCache() {
                $db70c1cf4bc707fd$var$currentUserCache = null;
                $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = false;
            }
        },
        {
            key: "_setCurrentUserCache",
            value: function _setCurrentUserCache(user) {
                $db70c1cf4bc707fd$var$currentUserCache = user;
            }
        }
    ]);
    return ParseUser;
}($db70c1cf4bc707fd$var$_ParseObject2.default);
$db70c1cf4bc707fd$var$_ParseObject2.default.registerSubclass("_User", $db70c1cf4bc707fd$var$ParseUser);
var $db70c1cf4bc707fd$var$DefaultController = {
    updateUserOnDisk: function updateUserOnDisk(user) {
        var path = $db70c1cf4bc707fd$var$_Storage.default.generatePath($db70c1cf4bc707fd$var$CURRENT_USER_KEY);
        var json = user.toJSON();
        delete json.password;
        json.className = "_User";
        var userData = (0, $db70c1cf4bc707fd$var$_stringify.default)(json);
        if ($db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_USER")) {
            var crypto = $db70c1cf4bc707fd$var$_CoreManager.default.getCryptoController();
            userData = crypto.encrypt(json, $db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_KEY"));
        }
        return $db70c1cf4bc707fd$var$_Storage.default.setItemAsync(path, userData).then(function() {
            return user;
        });
    },
    removeUserFromDisk: function removeUserFromDisk() {
        var path = $db70c1cf4bc707fd$var$_Storage.default.generatePath($db70c1cf4bc707fd$var$CURRENT_USER_KEY);
        $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = true;
        $db70c1cf4bc707fd$var$currentUserCache = null;
        return $db70c1cf4bc707fd$var$_Storage.default.removeItemAsync(path);
    },
    setCurrentUser: function setCurrentUser(user) {
        $db70c1cf4bc707fd$var$currentUserCache = user;
        user._cleanupAuthData();
        user._synchronizeAllAuthData();
        return $db70c1cf4bc707fd$var$DefaultController.updateUserOnDisk(user);
    },
    currentUser: function currentUser() /*: ?ParseUser*/ {
        if ($db70c1cf4bc707fd$var$currentUserCache) return $db70c1cf4bc707fd$var$currentUserCache;
        if ($db70c1cf4bc707fd$var$currentUserCacheMatchesDisk) return null;
        if ($db70c1cf4bc707fd$var$_Storage.default.async()) throw new Error("Cannot call currentUser() when using a platform with an async storage system. Call currentUserAsync() instead.");
        var path = $db70c1cf4bc707fd$var$_Storage.default.generatePath($db70c1cf4bc707fd$var$CURRENT_USER_KEY);
        var userData = $db70c1cf4bc707fd$var$_Storage.default.getItem(path);
        $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = true;
        if (!userData) {
            $db70c1cf4bc707fd$var$currentUserCache = null;
            return null;
        }
        if ($db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_USER")) {
            var crypto = $db70c1cf4bc707fd$var$_CoreManager.default.getCryptoController();
            userData = crypto.decrypt(userData, $db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_KEY"));
        }
        userData = JSON.parse(userData);
        if (!userData.className) userData.className = "_User";
        if (userData._id) {
            if (userData.objectId !== userData._id) userData.objectId = userData._id;
            delete userData._id;
        }
        if (userData._sessionToken) {
            userData.sessionToken = userData._sessionToken;
            delete userData._sessionToken;
        }
        var current = $db70c1cf4bc707fd$var$_ParseObject2.default.fromJSON(userData);
        $db70c1cf4bc707fd$var$currentUserCache = current;
        current._synchronizeAllAuthData();
        return current;
    },
    currentUserAsync: function currentUserAsync() /*: Promise<?ParseUser>*/ {
        if ($db70c1cf4bc707fd$var$currentUserCache) return $db70c1cf4bc707fd$var$_promise.default.resolve($db70c1cf4bc707fd$var$currentUserCache);
        if ($db70c1cf4bc707fd$var$currentUserCacheMatchesDisk) return $db70c1cf4bc707fd$var$_promise.default.resolve(null);
        var path = $db70c1cf4bc707fd$var$_Storage.default.generatePath($db70c1cf4bc707fd$var$CURRENT_USER_KEY);
        return $db70c1cf4bc707fd$var$_Storage.default.getItemAsync(path).then(function(userData) {
            $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = true;
            if (!userData) {
                $db70c1cf4bc707fd$var$currentUserCache = null;
                return $db70c1cf4bc707fd$var$_promise.default.resolve(null);
            }
            if ($db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_USER")) {
                var crypto = $db70c1cf4bc707fd$var$_CoreManager.default.getCryptoController();
                userData = crypto.decrypt(userData.toString(), $db70c1cf4bc707fd$var$_CoreManager.default.get("ENCRYPTED_KEY"));
            }
            userData = JSON.parse(userData);
            if (!userData.className) userData.className = "_User";
            if (userData._id) {
                if (userData.objectId !== userData._id) userData.objectId = userData._id;
                delete userData._id;
            }
            if (userData._sessionToken) {
                userData.sessionToken = userData._sessionToken;
                delete userData._sessionToken;
            }
            var current = $db70c1cf4bc707fd$var$_ParseObject2.default.fromJSON(userData);
            $db70c1cf4bc707fd$var$currentUserCache = current;
            current._synchronizeAllAuthData();
            return $db70c1cf4bc707fd$var$_promise.default.resolve(current);
        });
    },
    signUp: function signUp(user, attrs, options) /*: Promise<ParseUser>*/ {
        var username = attrs && attrs.username || user.get("username");
        var password = attrs && attrs.password || user.get("password");
        if (!username || !username.length) return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Cannot sign up user with an empty username."));
        if (!password || !password.length) return $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.OTHER_CAUSE, "Cannot sign up user with an empty password."));
        return user.save(attrs, options).then(function() {
            // Clear the password field
            user._finishFetch({
                password: undefined
            });
            if ($db70c1cf4bc707fd$var$canUseCurrentUser) return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
            return user;
        });
    },
    logIn: function logIn(user, options) /*: Promise<ParseUser>*/ {
        var RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        var stateController = $db70c1cf4bc707fd$var$_CoreManager.default.getObjectStateController();
        var auth = {
            username: user.get("username"),
            password: user.get("password")
        };
        return RESTController.request(options.usePost ? "POST" : "GET", "login", auth, options).then(function(response) {
            user._migrateId(response.objectId);
            user._setExisted(true);
            stateController.setPendingOp(user._getStateIdentifier(), "username", undefined);
            stateController.setPendingOp(user._getStateIdentifier(), "password", undefined);
            response.password = undefined;
            user._finishFetch(response);
            if (!$db70c1cf4bc707fd$var$canUseCurrentUser) // We can't set the current user, so just return the one we logged in
            return $db70c1cf4bc707fd$var$_promise.default.resolve(user);
            return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
        });
    },
    become: function become(user, options) /*: Promise<ParseUser>*/ {
        var RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "users/me", {}, options).then(function(response) {
            user._finishFetch(response);
            user._setExisted(true);
            return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
        });
    },
    hydrate: function hydrate(user, userJSON) /*: Promise<ParseUser>*/ {
        user._finishFetch(userJSON);
        user._setExisted(true);
        if (userJSON.sessionToken && $db70c1cf4bc707fd$var$canUseCurrentUser) return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
        else return $db70c1cf4bc707fd$var$_promise.default.resolve(user);
    },
    me: function me(user, options) /*: Promise<ParseUser>*/ {
        var RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "users/me", {}, options).then(function(response) {
            user._finishFetch(response);
            user._setExisted(true);
            return user;
        });
    },
    logOut: function logOut(options) /*: Promise<ParseUser>*/ {
        var RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        if (options.sessionToken) return RESTController.request("POST", "logout", {}, options);
        return $db70c1cf4bc707fd$var$DefaultController.currentUserAsync().then(function(currentUser) {
            var path = $db70c1cf4bc707fd$var$_Storage.default.generatePath($db70c1cf4bc707fd$var$CURRENT_USER_KEY);
            var promise = $db70c1cf4bc707fd$var$_Storage.default.removeItemAsync(path);
            if (currentUser !== null) {
                var currentSession = currentUser.getSessionToken();
                if (currentSession && (0, $db70c1cf4bc707fd$var$_isRevocableSession.default)(currentSession)) promise = promise.then(function() {
                    return RESTController.request("POST", "logout", {}, {
                        sessionToken: currentSession
                    });
                });
                currentUser._logOutWithAll();
                currentUser._finishFetch({
                    sessionToken: undefined
                });
            }
            $db70c1cf4bc707fd$var$currentUserCacheMatchesDisk = true;
            $db70c1cf4bc707fd$var$currentUserCache = null;
            return promise;
        });
    },
    requestPasswordReset: function requestPasswordReset(email, options) {
        var RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        return RESTController.request("POST", "requestPasswordReset", {
            email: email
        }, options);
    },
    upgradeToRevocableSession: function upgradeToRevocableSession(user, options) {
        return (0, $db70c1cf4bc707fd$var$_asyncToGenerator2.default)(/*#__PURE__*/ $db70c1cf4bc707fd$var$_regeneratorRuntime().mark(function _callee6() {
            var token, RESTController, result, session, current;
            return $db70c1cf4bc707fd$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        token = user.getSessionToken();
                        if (token) {
                            _context6.next = 3;
                            break;
                        }
                        return _context6.abrupt("return", $db70c1cf4bc707fd$var$_promise.default.reject(new $db70c1cf4bc707fd$var$_ParseError.default($db70c1cf4bc707fd$var$_ParseError.default.SESSION_MISSING, "Cannot upgrade a user with no session token")));
                    case 3:
                        options.sessionToken = token;
                        RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
                        _context6.next = 7;
                        return RESTController.request("POST", "upgradeToRevocableSession", {}, options);
                    case 7:
                        result = _context6.sent;
                        session = new $db70c1cf4bc707fd$var$_ParseSession.default();
                        session._finishFetch(result);
                        user._finishFetch({
                            sessionToken: session.getSessionToken()
                        });
                        _context6.next = 13;
                        return user.isCurrentAsync();
                    case 13:
                        current = _context6.sent;
                        if (!current) {
                            _context6.next = 16;
                            break;
                        }
                        return _context6.abrupt("return", $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user));
                    case 16:
                        return _context6.abrupt("return", $db70c1cf4bc707fd$var$_promise.default.resolve(user));
                    case 17:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6);
        }))();
    },
    linkWith: function linkWith(user, authData, options) {
        return user.save({
            authData: authData
        }, options).then(function() {
            if ($db70c1cf4bc707fd$var$canUseCurrentUser) return $db70c1cf4bc707fd$var$DefaultController.setCurrentUser(user);
            return user;
        });
    },
    verifyPassword: function verifyPassword(username, password, options) {
        var RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "verifyPassword", {
            username: username,
            password: password
        }, options);
    },
    requestEmailVerification: function requestEmailVerification(email, options) {
        var RESTController = $db70c1cf4bc707fd$var$_CoreManager.default.getRESTController();
        return RESTController.request("POST", "verificationEmailRequest", {
            email: email
        }, options);
    }
};
$db70c1cf4bc707fd$var$_CoreManager.default.setUserController($db70c1cf4bc707fd$var$DefaultController);
var $db70c1cf4bc707fd$var$_default = $db70c1cf4bc707fd$var$ParseUser;
module.exports.default = $db70c1cf4bc707fd$var$_default;

});
parcelRequire.register("6Jk06", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4e6675c71402065a$var$isRevocableSession;

var $4e6675c71402065a$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ function $4e6675c71402065a$var$isRevocableSession(token) /*: boolean*/ {
    return (0, $4e6675c71402065a$var$_indexOf.default)(token).call(token, "r:") > -1;
}

});

parcelRequire.register("b7rpJ", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");

var $oM1qX = parcelRequire("oM1qX");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81859cfc4fe78f14$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $81859cfc4fe78f14$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $81859cfc4fe78f14$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $81859cfc4fe78f14$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $81859cfc4fe78f14$var$_inherits2 = $iHLHC((parcelRequire("cNDsY")));

var $81859cfc4fe78f14$var$_possibleConstructorReturn2 = $iHLHC((parcelRequire("1C8Dw")));

var $81859cfc4fe78f14$var$_getPrototypeOf2 = $iHLHC((parcelRequire("kptbe")));

var $81859cfc4fe78f14$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $81859cfc4fe78f14$var$_isRevocableSession = $iHLHC((parcelRequire("6Jk06")));

var $81859cfc4fe78f14$var$_ParseObject2 = $iHLHC((parcelRequire("fMBjE")));

var $81859cfc4fe78f14$var$_ParseUser = $iHLHC((parcelRequire("iQ4JH")));
function $81859cfc4fe78f14$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $81859cfc4fe78f14$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $81859cfc4fe78f14$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $81859cfc4fe78f14$var$_getPrototypeOf2.default)(this).constructor;
            result = $oM1qX(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $81859cfc4fe78f14$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $81859cfc4fe78f14$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$oM1qX) return false;
    if ($oM1qX.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($oM1qX(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * <p>A Parse.Session object is a local representation of a revocable session.
 * This class is a subclass of a Parse.Object, and retains the same
 * functionality of a Parse.Object.</p>
 *
 * @alias Parse.Session
 * @augments Parse.Object
 */ var $81859cfc4fe78f14$var$ParseSession = /*#__PURE__*/ function(_ParseObject) {
    (0, $81859cfc4fe78f14$var$_inherits2.default)(ParseSession, _ParseObject);
    var _super = $81859cfc4fe78f14$var$_createSuper(ParseSession);
    /**
   * @param {object} attributes The initial set of data to store in the user.
   */ function ParseSession(attributes) {
        var _this;
        (0, $81859cfc4fe78f14$var$_classCallCheck2.default)(this, ParseSession);
        _this = _super.call(this, "_Session");
        if (attributes && (0, $81859cfc4fe78f14$var$_typeof2.default)(attributes) === "object") {
            if (!_this.set(attributes || {})) throw new Error("Can't create an invalid Session");
        }
        return _this;
    }
    /**
   * Returns the session token string.
   *
   * @returns {string}
   */ (0, $81859cfc4fe78f14$var$_createClass2.default)(ParseSession, [
        {
            key: "getSessionToken",
            value: function() /*: string*/ {
                var token = this.get("sessionToken");
                if (typeof token === "string") return token;
                return "";
            }
        }
    ], [
        {
            key: "readOnlyAttributes",
            value: function() {
                return [
                    "createdWith",
                    "expiresAt",
                    "installationId",
                    "restricted",
                    "sessionToken",
                    "user"
                ];
            }
        },
        {
            key: "current",
            value: function(options) {
                options = options || {};
                var controller = $81859cfc4fe78f14$var$_CoreManager.default.getSessionController();
                var sessionOptions = {};
                if (options.hasOwnProperty("useMasterKey")) sessionOptions.useMasterKey = options.useMasterKey;
                return $81859cfc4fe78f14$var$_ParseUser.default.currentAsync().then(function(user) {
                    if (!user) return $81859cfc4fe78f14$var$_promise.default.reject("There is no current user.");
                    sessionOptions.sessionToken = user.getSessionToken();
                    return controller.getSession(sessionOptions);
                });
            }
        },
        {
            key: "isCurrentSessionRevocable",
            value: function() /*: boolean*/ {
                var currentUser = $81859cfc4fe78f14$var$_ParseUser.default.current();
                if (currentUser) return (0, $81859cfc4fe78f14$var$_isRevocableSession.default)(currentUser.getSessionToken() || "");
                return false;
            }
        }
    ]);
    return ParseSession;
}($81859cfc4fe78f14$var$_ParseObject2.default);
$81859cfc4fe78f14$var$_ParseObject2.default.registerSubclass("_Session", $81859cfc4fe78f14$var$ParseSession);
var $81859cfc4fe78f14$var$DefaultController = {
    getSession: function(options) /*: Promise<ParseSession>*/ {
        var RESTController = $81859cfc4fe78f14$var$_CoreManager.default.getRESTController();
        var session = new $81859cfc4fe78f14$var$ParseSession();
        return RESTController.request("GET", "sessions/me", {}, options).then(function(sessionData) {
            session._finishFetch(sessionData);
            session._setExisted(true);
            return session;
        });
    }
};
$81859cfc4fe78f14$var$_CoreManager.default.setSessionController($81859cfc4fe78f14$var$DefaultController);
var $81859cfc4fe78f14$var$_default = $81859cfc4fe78f14$var$ParseSession;
module.exports.default = $81859cfc4fe78f14$var$_default;

});




parcelRequire.register("hf5sb", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $c8d8115ecbe7cbf1$var$_stringify = $iHLHC((parcelRequire("4qY0x")));
var $c8d8115ecbe7cbf1$var$AES;
var $c8d8115ecbe7cbf1$var$ENC;

$c8d8115ecbe7cbf1$var$AES = (parcelRequire("3H9rt"));

$c8d8115ecbe7cbf1$var$ENC = (parcelRequire("1gKAu"));
var $c8d8115ecbe7cbf1$var$CryptoJS;
var $c8d8115ecbe7cbf1$var$CryptoController = {
    encrypt: function(obj, secretKey) /*: ?string*/ {
        var encrypted = $c8d8115ecbe7cbf1$var$AES.encrypt((0, $c8d8115ecbe7cbf1$var$_stringify.default)(obj), secretKey);
        return encrypted.toString();
    },
    decrypt: function(encryptedText, secretKey) /*: ?string*/ {
        var decryptedStr = $c8d8115ecbe7cbf1$var$AES.decrypt(encryptedText, secretKey).toString($c8d8115ecbe7cbf1$var$ENC);
        return decryptedStr;
    }
};
module.exports = $c8d8115ecbe7cbf1$var$CryptoController;

});
parcelRequire.register("3H9rt", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});
parcelRequire.register("cfaDk", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("5Io6y"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRequire.register("5Io6y", function(module, exports) {
"use strict";

});


parcelRequire.register("500SS", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRequire.register("6oXxt", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working varialbes
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRequire.register("ioEPr", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("lqaMD")), (parcelRequire("7ft6W")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});
parcelRequire.register("lqaMD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRequire.register("7ft6W", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRequire.register("fctwD", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("ioEPr")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});


parcelRequire.register("1gKAu", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    return CryptoJS.enc.Utf8;
});

});


parcelRequire.register("i5Nxa", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $d2bf1e0b8e81e213$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $d2bf1e0b8e81e213$var$_Storage = $iHLHC((parcelRequire("7GXKV")));

var $4q6en = parcelRequire("4q6en");
var $d2bf1e0b8e81e213$var$iidCache = null;
var $d2bf1e0b8e81e213$var$InstallationController = {
    currentInstallationId: function() /*: Promise<string>*/ {
        if (typeof $d2bf1e0b8e81e213$var$iidCache === "string") return $d2bf1e0b8e81e213$var$_promise.default.resolve($d2bf1e0b8e81e213$var$iidCache);
        var path = $d2bf1e0b8e81e213$var$_Storage.default.generatePath("installationId");
        return $d2bf1e0b8e81e213$var$_Storage.default.getItemAsync(path).then(function(iid) {
            if (!iid) {
                iid = $4q6en();
                return $d2bf1e0b8e81e213$var$_Storage.default.setItemAsync(path, iid).then(function() {
                    $d2bf1e0b8e81e213$var$iidCache = iid;
                    return iid;
                });
            }
            $d2bf1e0b8e81e213$var$iidCache = iid;
            return iid;
        });
    },
    _clearCache: function() {
        $d2bf1e0b8e81e213$var$iidCache = null;
    },
    _setInstallationIdCache: function(iid) {
        $d2bf1e0b8e81e213$var$iidCache = iid;
    }
};
module.exports = $d2bf1e0b8e81e213$var$InstallationController;

});

parcelRequire.register("dcLeF", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");

var $dLJtR = parcelRequire("dLJtR");

var $fgRng = parcelRequire("fgRng");

var $gW71a = parcelRequire("gW71a");

var $dzKYE = parcelRequire("dzKYE");

var $i3o6i = parcelRequire("i3o6i");

var $3bLGW = parcelRequire("3bLGW");

var $2QmZN = parcelRequire("2QmZN");

var $99d109557c64e215$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $99d109557c64e215$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $99d109557c64e215$var$_setTimeout2 = $iHLHC((parcelRequire("3Poce")));

var $99d109557c64e215$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $99d109557c64e215$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $99d109557c64e215$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $99d109557c64e215$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $99d109557c64e215$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $9FsFR = parcelRequire("9FsFR");
function $99d109557c64e215$var$ownKeys(object, enumerableOnly) {
    var keys = $2QmZN(object);
    if ($3bLGW) {
        var symbols = $3bLGW(object);
        enumerableOnly && (symbols = $i3o6i(symbols).call(symbols, function(sym) {
            return $dzKYE(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $99d109557c64e215$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var _context4, _context5;
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $gW71a(_context4 = $99d109557c64e215$var$ownKeys(Object(source), !0)).call(_context4, function(key) {
            (0, $99d109557c64e215$var$_defineProperty2.default)(target, key, source[key]);
        }) : $fgRng ? $dLJtR(target, $fgRng(source)) : $gW71a(_context5 = $99d109557c64e215$var$ownKeys(Object(source))).call(_context5, function(key) {
            $4i3Tl(target, key, $dzKYE(source, key));
        });
    }
    return target;
}

var $4q6en = parcelRequire("4q6en");
var $99d109557c64e215$var$XHR = null;
if (typeof XMLHttpRequest !== "undefined") $99d109557c64e215$var$XHR = XMLHttpRequest;
var $99d109557c64e215$var$useXDomainRequest = false;
if (typeof XDomainRequest !== "undefined" && !("withCredentials" in new XMLHttpRequest())) $99d109557c64e215$var$useXDomainRequest = true;
function $99d109557c64e215$var$ajaxIE9(method, url, data, headers, options) {
    return new $99d109557c64e215$var$_promise.default(function(resolve, reject) {
        var xdr = new XDomainRequest();
        xdr.onload = function() {
            var response;
            try {
                response = JSON.parse(xdr.responseText);
            } catch (e) {
                reject(e);
            }
            if (response) resolve({
                response: response
            });
        };
        xdr.onerror = xdr.ontimeout = function() {
            // Let's fake a real error message.
            var fakeResponse = {
                responseText: (0, $99d109557c64e215$var$_stringify.default)({
                    code: $99d109557c64e215$var$_ParseError.default.X_DOMAIN_REQUEST,
                    error: "IE's XDomainRequest does not supply error info."
                })
            };
            reject(fakeResponse);
        };
        xdr.onprogress = function() {
            if (options && typeof options.progress === "function") options.progress(xdr.responseText);
        };
        xdr.open(method, url);
        xdr.send(data);
        if (options && typeof options.requestTask === "function") options.requestTask(xdr);
    });
}
var $99d109557c64e215$var$RESTController = {
    ajax: function(method, url, data, headers, options) {
        var _context;
        if ($99d109557c64e215$var$useXDomainRequest) return $99d109557c64e215$var$ajaxIE9(method, url, data, headers, options);
        var promise = (0, $9FsFR.resolvingPromise)();
        var isIdempotent = $99d109557c64e215$var$_CoreManager.default.get("IDEMPOTENCY") && (0, $99d109557c64e215$var$_includes.default)(_context = [
            "POST",
            "PUT"
        ]).call(_context, method);
        var requestId = isIdempotent ? $4q6en() : "";
        var attempts = 0;
        (function dispatch() {
            if ($99d109557c64e215$var$XHR == null) throw new Error("Cannot make a request: No definition of XMLHttpRequest was found.");
            var handled = false;
            var xhr = new $99d109557c64e215$var$XHR();
            xhr.onreadystatechange = function() {
                if (xhr.readyState !== 4 || handled || xhr._aborted) return;
                handled = true;
                if (xhr.status >= 200 && xhr.status < 300) {
                    var response;
                    try {
                        response = JSON.parse(xhr.responseText);
                        if (typeof xhr.getResponseHeader === "function") {
                            var _context2, _context3;
                            if ((0, $99d109557c64e215$var$_includes.default)(_context2 = xhr.getAllResponseHeaders() || "").call(_context2, "x-parse-job-status-id: ")) response = xhr.getResponseHeader("x-parse-job-status-id");
                            if ((0, $99d109557c64e215$var$_includes.default)(_context3 = xhr.getAllResponseHeaders() || "").call(_context3, "x-parse-push-status-id: ")) response = xhr.getResponseHeader("x-parse-push-status-id");
                        }
                    } catch (e) {
                        promise.reject(e.toString());
                    }
                    if (response) promise.resolve({
                        response: response,
                        status: xhr.status,
                        xhr: xhr
                    });
                } else if (xhr.status >= 500 || xhr.status === 0) {
                    // retry on 5XX or node-xmlhttprequest error
                    if (++attempts < $99d109557c64e215$var$_CoreManager.default.get("REQUEST_ATTEMPT_LIMIT")) {
                        // Exponentially-growing random delay
                        var delay = Math.round(Math.random() * 125 * Math.pow(2, attempts));
                        (0, $99d109557c64e215$var$_setTimeout2.default)(dispatch, delay);
                    } else if (xhr.status === 0) promise.reject("Unable to connect to the Parse API");
                    else // After the retry limit is reached, fail
                    promise.reject(xhr);
                } else promise.reject(xhr);
            };
            headers = headers || {};
            if (typeof headers["Content-Type"] !== "string") headers["Content-Type"] = "text/plain"; // Avoid pre-flight
            if ($99d109557c64e215$var$_CoreManager.default.get("IS_NODE")) headers["User-Agent"] = "Parse/" + $99d109557c64e215$var$_CoreManager.default.get("VERSION") + " (NodeJS " + $4TNnu.versions.node + ")";
            if (isIdempotent) headers["X-Parse-Request-Id"] = requestId;
            if ($99d109557c64e215$var$_CoreManager.default.get("SERVER_AUTH_TYPE") && $99d109557c64e215$var$_CoreManager.default.get("SERVER_AUTH_TOKEN")) headers["Authorization"] = $99d109557c64e215$var$_CoreManager.default.get("SERVER_AUTH_TYPE") + " " + $99d109557c64e215$var$_CoreManager.default.get("SERVER_AUTH_TOKEN");
            var customHeaders = $99d109557c64e215$var$_CoreManager.default.get("REQUEST_HEADERS");
            for(var key in customHeaders)headers[key] = customHeaders[key];
            function handleProgress(type, event) {
                if (options && typeof options.progress === "function") {
                    if (event.lengthComputable) options.progress(event.loaded / event.total, event.loaded, event.total, {
                        type: type
                    });
                    else options.progress(null, null, null, {
                        type: type
                    });
                }
            }
            xhr.onprogress = function(event) {
                handleProgress("download", event);
            };
            if (xhr.upload) xhr.upload.onprogress = function(event) {
                handleProgress("upload", event);
            };
            xhr.open(method, url, true);
            for(var h in headers)xhr.setRequestHeader(h, headers[h]);
            xhr.onabort = function() {
                promise.resolve({
                    response: {
                        results: []
                    },
                    status: 0,
                    xhr: xhr
                });
            };
            xhr.send(data);
            if (options && typeof options.requestTask === "function") options.requestTask(xhr);
        })();
        return promise;
    },
    request: function request(method, path, data, options) {
        options = options || {};
        var url = $99d109557c64e215$var$_CoreManager.default.get("SERVER_URL");
        if (url[url.length - 1] !== "/") url += "/";
        url += path;
        var payload = {};
        if (data && (0, $99d109557c64e215$var$_typeof2.default)(data) === "object") for(var k in data)payload[k] = data[k];
         // Add context
        var context = options.context;
        if (context !== undefined) payload._context = context;
        if (method !== "POST") {
            payload._method = method;
            method = "POST";
        }
        payload._ApplicationId = $99d109557c64e215$var$_CoreManager.default.get("APPLICATION_ID");
        var jsKey = $99d109557c64e215$var$_CoreManager.default.get("JAVASCRIPT_KEY");
        if (jsKey) payload._JavaScriptKey = jsKey;
        payload._ClientVersion = $99d109557c64e215$var$_CoreManager.default.get("VERSION");
        var useMasterKey = options.useMasterKey;
        if (typeof useMasterKey === "undefined") useMasterKey = $99d109557c64e215$var$_CoreManager.default.get("USE_MASTER_KEY");
        if (useMasterKey) {
            if ($99d109557c64e215$var$_CoreManager.default.get("MASTER_KEY")) {
                delete payload._JavaScriptKey;
                payload._MasterKey = $99d109557c64e215$var$_CoreManager.default.get("MASTER_KEY");
            } else throw new Error("Cannot use the Master Key, it has not been provided.");
        }
        if ($99d109557c64e215$var$_CoreManager.default.get("FORCE_REVOCABLE_SESSION")) payload._RevocableSession = "1";
        var installationId = options.installationId;
        var installationIdPromise;
        if (installationId && typeof installationId === "string") installationIdPromise = $99d109557c64e215$var$_promise.default.resolve(installationId);
        else {
            var installationController = $99d109557c64e215$var$_CoreManager.default.getInstallationController();
            installationIdPromise = installationController.currentInstallationId();
        }
        return installationIdPromise.then(function(iid) {
            payload._InstallationId = iid;
            var userController = $99d109557c64e215$var$_CoreManager.default.getUserController();
            if (options && typeof options.sessionToken === "string") return $99d109557c64e215$var$_promise.default.resolve(options.sessionToken);
            else if (userController) return userController.currentUserAsync().then(function(user) {
                if (user) return $99d109557c64e215$var$_promise.default.resolve(user.getSessionToken());
                return $99d109557c64e215$var$_promise.default.resolve(null);
            });
            return $99d109557c64e215$var$_promise.default.resolve(null);
        }).then(function(token) {
            if (token) payload._SessionToken = token;
            var payloadString = (0, $99d109557c64e215$var$_stringify.default)(payload);
            return $99d109557c64e215$var$RESTController.ajax(method, url, payloadString, {}, options).then(function(_ref) {
                var response = _ref.response, status = _ref.status;
                if (options.returnStatus) return $99d109557c64e215$var$_objectSpread($99d109557c64e215$var$_objectSpread({}, response), {}, {
                    _status: status
                });
                else return response;
            });
        }).catch($99d109557c64e215$var$RESTController.handleError);
    },
    handleError: function handleError(response) {
        // Transform the error into an instance of ParseError by trying to parse
        // the error string as JSON
        var error;
        if (response && response.responseText) try {
            var errorJSON = JSON.parse(response.responseText);
            error = new $99d109557c64e215$var$_ParseError.default(errorJSON.code, errorJSON.error);
        } catch (e) {
            // If we fail to parse the error text, that's okay.
            error = new $99d109557c64e215$var$_ParseError.default($99d109557c64e215$var$_ParseError.default.INVALID_JSON, "Received an error with invalid JSON from Parse: " + response.responseText);
        }
        else {
            var message = response.message ? response.message : response;
            error = new $99d109557c64e215$var$_ParseError.default($99d109557c64e215$var$_ParseError.default.CONNECTION_FAILED, "XMLHttpRequest failed: " + (0, $99d109557c64e215$var$_stringify.default)(message));
        }
        return $99d109557c64e215$var$_promise.default.reject(error);
    },
    _setXHR: function _setXHR(xhr) {
        $99d109557c64e215$var$XHR = xhr;
    },
    _getXHR: function _getXHR() {
        return $99d109557c64e215$var$XHR;
    }
};
module.exports = $99d109557c64e215$var$RESTController;

});
parcelRequire.register("3Poce", function(module, exports) {

module.exports = (parcelRequire("4SOhh"));

});
parcelRequire.register("4SOhh", function(module, exports) {
parcelRequire("dGoN0");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.setTimeout;

});



parcelRequire.register("54Znm", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.track = $3b2cef6ef61accae$var$track;

var $3b2cef6ef61accae$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Parse.Analytics provides an interface to Parse's logging and analytics
 * backend.
 *
 * @class Parse.Analytics
 * @static
 * @hideconstructor
 */ /**
 * Tracks the occurrence of a custom event with additional dimensions.
 * Parse will store a data point at the time of invocation with the given
 * event name.
 *
 * Dimensions will allow segmentation of the occurrences of this custom
 * event. Keys and values should be {@code String}s, and will throw
 * otherwise.
 *
 * To track a user signup along with additional metadata, consider the
 * following:
 * <pre>
 * var dimensions = {
 *  gender: 'm',
 *  source: 'web',
 *  dayType: 'weekend'
 * };
 * Parse.Analytics.track('signup', dimensions);
 * </pre>
 *
 * There is a default limit of 8 dimensions per event tracked.
 *
 * @function track
 * @name Parse.Analytics.track
 * @param {string} name The name of the custom event to report to Parse as
 * having happened.
 * @param {object} dimensions The dictionary of information by which to
 * segment this event.
 * @returns {Promise} A promise that is resolved when the round-trip
 * to the server completes.
 */ function $3b2cef6ef61accae$var$track(name, dimensions) /*: Promise*/ {
    name = name || "";
    name = name.replace(/^\s*/, "");
    name = name.replace(/\s*$/, "");
    if (name.length === 0) throw new TypeError("A name for the custom event must be provided");
    for(var _key in dimensions){
        if (typeof _key !== "string" || typeof dimensions[_key] !== "string") throw new TypeError('track() dimensions expects keys and values of type "string".');
    }
    return $3b2cef6ef61accae$var$_CoreManager.default.getAnalyticsController().track(name, dimensions);
}
var $3b2cef6ef61accae$var$DefaultController = {
    track: function(name, dimensions) {
        var RESTController = $3b2cef6ef61accae$var$_CoreManager.default.getRESTController();
        return RESTController.request("POST", "events/" + name, {
            dimensions: dimensions
        });
    }
};
$3b2cef6ef61accae$var$_CoreManager.default.setAnalyticsController($3b2cef6ef61accae$var$DefaultController);

});

parcelRequire.register("ffqks", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b19cae1cd6b40d1a$var$_ParseUser = $iHLHC((parcelRequire("iQ4JH")));

var $4q6en = parcelRequire("4q6en");
var $b19cae1cd6b40d1a$var$registered = false;
/**
 * Provides utility functions for working with Anonymously logged-in users. <br />
 * Anonymous users have some unique characteristics:
 * <ul>
 *  <li>Anonymous users don't need a user name or password.</li>
 *  <ul>
 *    <li>Once logged out, an anonymous user cannot be recovered.</li>
 *  </ul>
 *  <li>signUp converts an anonymous user to a standard user with the given username and password.</li>
 *  <ul>
 *    <li>Data associated with the anonymous user is retained.</li>
 *  </ul>
 *  <li>logIn switches users without converting the anonymous user.</li>
 *  <ul>
 *    <li>Data associated with the anonymous user will be lost.</li>
 *  </ul>
 *  <li>Service logIn (e.g. Facebook, Twitter) will attempt to convert
 *  the anonymous user into a standard user by linking it to the service.</li>
 *  <ul>
 *    <li>If a user already exists that is linked to the service, it will instead switch to the existing user.</li>
 *  </ul>
 *  <li>Service linking (e.g. Facebook, Twitter) will convert the anonymous user
 *  into a standard user by linking it to the service.</li>
 * </ul>
 *
 * @class Parse.AnonymousUtils
 * @static
 */ var $b19cae1cd6b40d1a$var$AnonymousUtils = {
    /**
   * Gets whether the user has their account linked to anonymous user.
   *
   * @function isLinked
   * @name Parse.AnonymousUtils.isLinked
   * @param {Parse.User} user User to check for.
   *     The user must be logged in on this device.
   * @returns {boolean} <code>true</code> if the user has their account
   *     linked to an anonymous user.
   * @static
   */ isLinked: function(user) {
        var provider = this._getAuthProvider();
        return user._isLinked(provider.getAuthType());
    },
    /**
   * Logs in a user Anonymously.
   *
   * @function logIn
   * @name Parse.AnonymousUtils.logIn
   * @param {object} options MasterKey / SessionToken.
   * @returns {Promise} Logged in user
   * @static
   */ logIn: function(options) /*: Promise<ParseUser>*/ {
        var provider = this._getAuthProvider();
        return $b19cae1cd6b40d1a$var$_ParseUser.default.logInWith(provider.getAuthType(), provider.getAuthData(), options);
    },
    /**
   * Links Anonymous User to an existing PFUser.
   *
   * @function link
   * @name Parse.AnonymousUtils.link
   * @param {Parse.User} user User to link. This must be the current user.
   * @param {object} options MasterKey / SessionToken.
   * @returns {Promise} Linked with User
   * @static
   */ link: function(user, options) /*: Promise<ParseUser>*/ {
        var provider = this._getAuthProvider();
        return user.linkWith(provider.getAuthType(), provider.getAuthData(), options);
    },
    /**
   * Returns true if Authentication Provider has been registered for use.
   *
   * @function isRegistered
   * @name Parse.AnonymousUtils.isRegistered
   * @returns {boolean}
   * @static
   */ isRegistered: function() /*: boolean*/ {
        return $b19cae1cd6b40d1a$var$registered;
    },
    _getAuthProvider: function() {
        var provider = {
            restoreAuthentication: function() {
                return true;
            },
            getAuthType: function() {
                return "anonymous";
            },
            getAuthData: function() {
                return {
                    authData: {
                        id: $4q6en()
                    }
                };
            }
        };
        if (!$b19cae1cd6b40d1a$var$registered) {
            $b19cae1cd6b40d1a$var$_ParseUser.default._registerAuthenticationProvider(provider);
            $b19cae1cd6b40d1a$var$registered = true;
        }
        return provider;
    }
};
var $b19cae1cd6b40d1a$var$_default = $b19cae1cd6b40d1a$var$AnonymousUtils;
module.exports.default = $b19cae1cd6b40d1a$var$_default;

});

parcelRequire.register("2YVFi", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.getJobStatus = $22bdea717d82f556$var$getJobStatus;
module.exports.getJobsData = $22bdea717d82f556$var$getJobsData;
module.exports.run = $22bdea717d82f556$var$run;
module.exports.startJob = $22bdea717d82f556$var$startJob;

var $22bdea717d82f556$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $22bdea717d82f556$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $22bdea717d82f556$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $22bdea717d82f556$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $22bdea717d82f556$var$_decode = $iHLHC((parcelRequire("42E6z")));

var $22bdea717d82f556$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $22bdea717d82f556$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $22bdea717d82f556$var$_ParseQuery = $iHLHC((parcelRequire("4FVCr")));

var $22bdea717d82f556$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Contains functions for calling and declaring
 * <a href="/docs/cloud_code_guide#functions">cloud functions</a>.
 * <p><strong><em>
 *   Some functions are only available from Cloud Code.
 * </em></strong></p>
 *
 * @class Parse.Cloud
 * @static
 * @hideconstructor
 */ /**
 * Makes a call to a cloud function.
 *
 * @function run
 * @name Parse.Cloud.run
 * @param {string} name The function name.
 * @param {object} data The parameters to send to the cloud function.
 * @param {object} options
 * @returns {Promise} A promise that will be resolved with the result
 * of the function.
 */ function $22bdea717d82f556$var$run(name, data, options) /*: Promise<mixed>*/ {
    options = options || {};
    if (typeof name !== "string" || name.length === 0) throw new TypeError("Cloud function name must be a string.");
    var requestOptions = {};
    if (options.useMasterKey) requestOptions.useMasterKey = options.useMasterKey;
    if (options.sessionToken) requestOptions.sessionToken = options.sessionToken;
    if (options.context && (0, $22bdea717d82f556$var$_typeof2.default)(options.context) === "object") requestOptions.context = options.context;
    return $22bdea717d82f556$var$_CoreManager.default.getCloudController().run(name, data, requestOptions);
}
/**
 * Gets data for the current set of cloud jobs.
 *
 * @function getJobsData
 * @name Parse.Cloud.getJobsData
 * @returns {Promise} A promise that will be resolved with the result
 * of the function.
 */ function $22bdea717d82f556$var$getJobsData() /*: Promise<Object>*/ {
    return $22bdea717d82f556$var$_CoreManager.default.getCloudController().getJobsData({
        useMasterKey: true
    });
}
/**
 * Starts a given cloud job, which will process asynchronously.
 *
 * @function startJob
 * @name Parse.Cloud.startJob
 * @param {string} name The function name.
 * @param {object} data The parameters to send to the cloud function.
 * @returns {Promise} A promise that will be resolved with the jobStatusId
 * of the job.
 */ function $22bdea717d82f556$var$startJob(name, data) /*: Promise<string>*/ {
    if (typeof name !== "string" || name.length === 0) throw new TypeError("Cloud job name must be a string.");
    return $22bdea717d82f556$var$_CoreManager.default.getCloudController().startJob(name, data, {
        useMasterKey: true
    });
}
/**
 * Gets job status by Id
 *
 * @function getJobStatus
 * @name Parse.Cloud.getJobStatus
 * @param {string} jobStatusId The Id of Job Status.
 * @returns {Parse.Object} Status of Job.
 */ function $22bdea717d82f556$var$getJobStatus(jobStatusId) /*: Promise<ParseObject>*/ {
    var query = new $22bdea717d82f556$var$_ParseQuery.default("_JobStatus");
    return query.get(jobStatusId, {
        useMasterKey: true
    });
}
var $22bdea717d82f556$var$DefaultController = {
    run: function(name, data, options) {
        var RESTController = $22bdea717d82f556$var$_CoreManager.default.getRESTController();
        var payload = (0, $22bdea717d82f556$var$_encode.default)(data, true);
        var request = RESTController.request("POST", "functions/" + name, payload, options);
        return request.then(function(res) {
            if ((0, $22bdea717d82f556$var$_typeof2.default)(res) === "object" && (0, $22bdea717d82f556$var$_keys.default)(res).length > 0 && !res.hasOwnProperty("result")) throw new $22bdea717d82f556$var$_ParseError.default($22bdea717d82f556$var$_ParseError.default.INVALID_JSON, "The server returned an invalid response.");
            var decoded = (0, $22bdea717d82f556$var$_decode.default)(res);
            if (decoded && decoded.hasOwnProperty("result")) return $22bdea717d82f556$var$_promise.default.resolve(decoded.result);
            return $22bdea717d82f556$var$_promise.default.resolve(undefined);
        });
    },
    getJobsData: function(options) {
        var RESTController = $22bdea717d82f556$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "cloud_code/jobs/data", null, options);
    },
    startJob: function(name, data, options) {
        var RESTController = $22bdea717d82f556$var$_CoreManager.default.getRESTController();
        var payload = (0, $22bdea717d82f556$var$_encode.default)(data, true);
        return RESTController.request("POST", "jobs/" + name, payload, options);
    }
};
$22bdea717d82f556$var$_CoreManager.default.setCloudController($22bdea717d82f556$var$DefaultController);

});

parcelRequire.register("hnFLk", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");

var $dLJtR = parcelRequire("dLJtR");

var $fgRng = parcelRequire("fgRng");

var $gW71a = parcelRequire("gW71a");

var $dzKYE = parcelRequire("dzKYE");

var $i3o6i = parcelRequire("i3o6i");

var $3bLGW = parcelRequire("3bLGW");



var $iG2ur = parcelRequire("iG2ur");

var $iDZ3d = parcelRequire("iDZ3d");

var $35NIM = parcelRequire("35NIM");

$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca74facc0e37113f$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $ca74facc0e37113f$var$_keys = $iHLHC((parcelRequire("2QmZN")));

var $ca74facc0e37113f$var$_slice = $iHLHC((parcelRequire("a1TrC")));

var $ca74facc0e37113f$var$_assign = $iHLHC((parcelRequire("55aVK")));

var $ca74facc0e37113f$var$_slicedToArray2 = $iHLHC((parcelRequire("ccwCe")));

var $ca74facc0e37113f$var$_entries = $iHLHC((parcelRequire("4Rvnw")));

var $ca74facc0e37113f$var$_every = $iHLHC((parcelRequire("7Xgow")));

var $ca74facc0e37113f$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $ca74facc0e37113f$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $ca74facc0e37113f$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $ca74facc0e37113f$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $ca74facc0e37113f$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $ca74facc0e37113f$var$_map = $iHLHC((parcelRequire("2ETAR")));

var $ca74facc0e37113f$var$_ParseRole = $iHLHC((parcelRequire("7MXHA")));

var $ca74facc0e37113f$var$_ParseUser = $iHLHC((parcelRequire("iQ4JH")));
function $ca74facc0e37113f$var$ownKeys(object, enumerableOnly) {
    var keys = (parcelRequire("2QmZN"))(object);
    if ($3bLGW) {
        var symbols = $3bLGW(object);
        enumerableOnly && (symbols = $i3o6i(symbols).call(symbols, function(sym) {
            return $dzKYE(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ca74facc0e37113f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var _context3, _context4;
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $gW71a(_context3 = $ca74facc0e37113f$var$ownKeys(Object(source), !0)).call(_context3, function(key) {
            (0, $ca74facc0e37113f$var$_defineProperty2.default)(target, key, source[key]);
        }) : $fgRng ? $dLJtR(target, $fgRng(source)) : $gW71a(_context4 = $ca74facc0e37113f$var$ownKeys(Object(source))).call(_context4, function(key) {
            $4i3Tl(target, key, $dzKYE(source, key));
        });
    }
    return target;
}
function $ca74facc0e37113f$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $iDZ3d !== "undefined" && $iG2ur(o) || o["@@iterator"];
    if (!it) {
        if ((parcelRequire("euZIZ"))(o) || (it = $ca74facc0e37113f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $ca74facc0e37113f$var$_unsupportedIterableToArray(o, minLen) {
    var _context2;
    if (!o) return;
    if (typeof o === "string") return $ca74facc0e37113f$var$_arrayLikeToArray(o, minLen);
    var n = (parcelRequire("a1TrC"))(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $35NIM(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ca74facc0e37113f$var$_arrayLikeToArray(o, minLen);
}
function $ca74facc0e37113f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ca74facc0e37113f$var$PUBLIC_KEY = "*";
var $ca74facc0e37113f$var$VALID_PERMISSIONS = new $ca74facc0e37113f$var$_map.default();
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("get", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("find", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("count", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("create", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("update", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("delete", {});
$ca74facc0e37113f$var$VALID_PERMISSIONS.set("addField", {});
var $ca74facc0e37113f$var$VALID_PERMISSIONS_EXTENDED = new $ca74facc0e37113f$var$_map.default();
$ca74facc0e37113f$var$VALID_PERMISSIONS_EXTENDED.set("protectedFields", {});
/**
 * Creates a new CLP.
 * If no argument is given, the CLP has no permissions for anyone.
 * If the argument is a Parse.User or Parse.Role, the CLP will have read and write
 *   permission for only that user or role.
 * If the argument is any other JSON object, that object will be interpretted
 *   as a serialized CLP created with toJSON().
 *
 * <p>A CLP, or Class Level Permissions can be added to any
 * <code>Parse.Schema</code> to restrict access to only a subset of users
 * of your application.</p>
 *
 * <p>
 * For get/count/find/create/update/delete/addField using the following functions:
 *
 * Entity is type Parse.User or Parse.Role or string
 * Role is type Parse.Role or Name of Parse.Role
 *
 * getGetRequiresAuthentication()
 * setGetRequiresAuthentication(allowed: boolean)
 * getGetPointerFields()
 * setGetPointerFields(pointerFields: string[])
 * getGetAccess(entity: Entity)
 * setGetAccess(entity: Entity, allowed: boolean)
 * getPublicGetAccess()
 * setPublicGetAccess(allowed: boolean)
 * getRoleGetAccess(role: Role)
 * setRoleGetAccess(role: Role, allowed: boolean)
 * getFindRequiresAuthentication()
 * setFindRequiresAuthentication(allowed: boolean)
 * getFindPointerFields()
 * setFindPointerFields(pointerFields: string[])
 * getFindAccess(entity: Entity)
 * setFindAccess(entity: Entity, allowed: boolean)
 * getPublicFindAccess()
 * setPublicFindAccess(allowed: boolean)
 * getRoleFindAccess(role: Role)
 * setRoleFindAccess(role: Role, allowed: boolean)
 * getCountRequiresAuthentication()
 * setCountRequiresAuthentication(allowed: boolean)
 * getCountPointerFields()
 * setCountPointerFields(pointerFields: string[])
 * getCountAccess(entity: Entity)
 * setCountAccess(entity: Entity, allowed: boolean)
 * getPublicCountAccess()
 * setPublicCountAccess(allowed: boolean)
 * getRoleCountAccess(role: Role)
 * setRoleCountAccess(role: Role, allowed: boolean)
 * getCreateRequiresAuthentication()
 * setCreateRequiresAuthentication(allowed: boolean)
 * getCreatePointerFields()
 * setCreatePointerFields(pointerFields: string[])
 * getCreateAccess(entity: Entity)
 * setCreateAccess(entity: Entity, allowed: boolean)
 * getPublicCreateAccess()
 * setPublicCreateAccess(allowed: Boolean)
 * getRoleCreateAccess(role: Role)
 * setRoleCreateAccess(role: Role, allowed: boolean)
 * getUpdateRequiresAuthentication()
 * setUpdateRequiresAuthentication(allowed: boolean)
 * getUpdatePointerFields()
 * setUpdatePointerFields(pointerFields: string[])
 * getUpdateAccess(entity: Entity)
 * setUpdateAccess(entity: Entity, allowed: boolean)
 * getPublicUpdateAccess()
 * setPublicUpdateAccess(allowed: boolean)
 * getRoleUpdateAccess(role: Role)
 * setRoleUpdateAccess(role: Role, allowed: boolean)
 * getDeleteRequiresAuthentication()
 * setDeleteRequiresAuthentication(allowed: boolean)
 * getDeletePointerFields()
 * setDeletePointerFields(pointerFields: string[])
 * getDeleteAccess(entity: Entity)
 * setDeleteAccess(entity: Entity, allowed: boolean)
 * getPublicDeleteAccess()
 * setPublicDeleteAccess(allowed: boolean)
 * getRoleDeleteAccess(role: Role)
 * setRoleDeleteAccess(role: Role, allowed: boolean)
 * getAddFieldRequiresAuthentication()
 * setAddFieldRequiresAuthentication(allowed: boolean)
 * getAddFieldPointerFields()
 * setAddFieldPointerFields(pointerFields: string[])
 * getAddFieldAccess(entity: Entity)
 * setAddFieldAccess(entity: Entity, allowed: boolean)
 * getPublicAddFieldAccess()
 * setPublicAddFieldAccess(allowed: boolean)
 * getRoleAddFieldAccess(role: Role)
 * setRoleAddFieldAccess(role: Role, allowed: boolean)
 * </p>
 *
 * @alias Parse.CLP
 */ var $ca74facc0e37113f$var$ParseCLP = /*#__PURE__*/ function() {
    /**
   * @param {(Parse.User | Parse.Role | object)} userId The user to initialize the CLP for
   */ function ParseCLP(userId) {
        var _this = this;
        (0, $ca74facc0e37113f$var$_classCallCheck2.default)(this, ParseCLP);
        (0, $ca74facc0e37113f$var$_defineProperty2.default)(this, "permissionsMap", void 0);
        this.permissionsMap = {}; // Initialize permissions Map with default permissions
        var _iterator = $ca74facc0e37113f$var$_createForOfIteratorHelper((0, $ca74facc0e37113f$var$_entries.default)($ca74facc0e37113f$var$VALID_PERMISSIONS).call($ca74facc0e37113f$var$VALID_PERMISSIONS)), _step;
        try {
            var _loop = function _loop() {
                var _step$value = (0, $ca74facc0e37113f$var$_slicedToArray2.default)(_step.value, 2), operation = _step$value[0], group = _step$value[1];
                _this.permissionsMap[operation] = (0, $ca74facc0e37113f$var$_assign.default)({}, group);
                var action = operation.charAt(0).toUpperCase() + (0, $ca74facc0e37113f$var$_slice.default)(operation).call(operation, 1);
                _this["get".concat(action, "RequiresAuthentication")] = function() {
                    return this._getAccess(operation, "requiresAuthentication");
                };
                _this["set".concat(action, "RequiresAuthentication")] = function(allowed) {
                    this._setAccess(operation, "requiresAuthentication", allowed);
                };
                _this["get".concat(action, "PointerFields")] = function() {
                    return this._getAccess(operation, "pointerFields", false);
                };
                _this["set".concat(action, "PointerFields")] = function(pointerFields) {
                    this._setArrayAccess(operation, "pointerFields", pointerFields);
                };
                _this["get".concat(action, "Access")] = function(entity) {
                    return this._getAccess(operation, entity);
                };
                _this["set".concat(action, "Access")] = function(entity, allowed) {
                    this._setAccess(operation, entity, allowed);
                };
                _this["getPublic".concat(action, "Access")] = function() {
                    return this["get".concat(action, "Access")]($ca74facc0e37113f$var$PUBLIC_KEY);
                };
                _this["setPublic".concat(action, "Access")] = function(allowed) {
                    this["set".concat(action, "Access")]($ca74facc0e37113f$var$PUBLIC_KEY, allowed);
                };
                _this["getRole".concat(action, "Access")] = function(role) {
                    return this["get".concat(action, "Access")](this._getRoleName(role));
                };
                _this["setRole".concat(action, "Access")] = function(role, allowed) {
                    this["set".concat(action, "Access")](this._getRoleName(role), allowed);
                };
            };
            for(_iterator.s(); !(_step = _iterator.n()).done;)_loop();
             // Initialize permissions Map with default extended permissions
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        var _iterator2 = $ca74facc0e37113f$var$_createForOfIteratorHelper((0, $ca74facc0e37113f$var$_entries.default)($ca74facc0e37113f$var$VALID_PERMISSIONS_EXTENDED).call($ca74facc0e37113f$var$VALID_PERMISSIONS_EXTENDED)), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _step2$value = (0, $ca74facc0e37113f$var$_slicedToArray2.default)(_step2.value, 2), operation = _step2$value[0], group = _step2$value[1];
                this.permissionsMap[operation] = (0, $ca74facc0e37113f$var$_assign.default)({}, group);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        if (userId && (0, $ca74facc0e37113f$var$_typeof2.default)(userId) === "object") {
            if (userId instanceof $ca74facc0e37113f$var$_ParseUser.default) {
                this.setReadAccess(userId, true);
                this.setWriteAccess(userId, true);
            } else if (userId instanceof $ca74facc0e37113f$var$_ParseRole.default) {
                this.setRoleReadAccess(userId, true);
                this.setRoleWriteAccess(userId, true);
            } else for(var _permission in userId){
                var _context;
                var users = userId[_permission];
                var isValidPermission = !!$ca74facc0e37113f$var$VALID_PERMISSIONS.get(_permission);
                var isValidPermissionExtended = !!$ca74facc0e37113f$var$VALID_PERMISSIONS_EXTENDED.get(_permission);
                var isValidGroupPermission = (0, $ca74facc0e37113f$var$_includes.default)(_context = [
                    "readUserFields",
                    "writeUserFields"
                ]).call(_context, _permission);
                if (typeof _permission !== "string" || !(isValidPermission || isValidPermissionExtended || isValidGroupPermission)) throw new TypeError("Tried to create an CLP with an invalid permission type.");
                if (isValidGroupPermission) {
                    if ((0, $ca74facc0e37113f$var$_every.default)(users).call(users, function(pointer) {
                        return typeof pointer === "string";
                    })) {
                        this.permissionsMap[_permission] = users;
                        continue;
                    } else throw new TypeError("Tried to create an CLP with an invalid permission value.");
                }
                for(var user in users){
                    var allowed = users[user];
                    if (typeof allowed !== "boolean" && !isValidPermissionExtended && user !== "pointerFields") throw new TypeError("Tried to create an CLP with an invalid permission value.");
                    this.permissionsMap[_permission][user] = allowed;
                }
            }
        } else if (typeof userId === "function") throw new TypeError("ParseCLP constructed with a function. Did you forget ()?");
    }
    /**
   * Returns a JSON-encoded version of the CLP.
   *
   * @returns {object}
   */ (0, $ca74facc0e37113f$var$_createClass2.default)(ParseCLP, [
        {
            key: "toJSON",
            value: function toJSON() /*: PermissionsMap*/ {
                return $ca74facc0e37113f$var$_objectSpread({}, this.permissionsMap);
            }
        },
        {
            key: "equals",
            value: function equals(other) /*: boolean*/ {
                if (!(other instanceof ParseCLP)) return false;
                var permissions = (0, $ca74facc0e37113f$var$_keys.default)(this.permissionsMap);
                var otherPermissions = (0, $ca74facc0e37113f$var$_keys.default)(other.permissionsMap);
                if (permissions.length !== otherPermissions.length) return false;
                for(var _permission2 in this.permissionsMap){
                    if (!other.permissionsMap[_permission2]) return false;
                    var users = (0, $ca74facc0e37113f$var$_keys.default)(this.permissionsMap[_permission2]);
                    var otherUsers = (0, $ca74facc0e37113f$var$_keys.default)(other.permissionsMap[_permission2]);
                    if (users.length !== otherUsers.length) return false;
                    for(var user in this.permissionsMap[_permission2]){
                        if (!other.permissionsMap[_permission2][user]) return false;
                        if (this.permissionsMap[_permission2][user] !== other.permissionsMap[_permission2][user]) return false;
                    }
                }
                return true;
            }
        },
        {
            key: "_getRoleName",
            value: function _getRoleName(role) /*: string*/ {
                var name = role;
                if (role instanceof $ca74facc0e37113f$var$_ParseRole.default) // Normalize to the String name
                name = role.getName();
                if (typeof name !== "string") throw new TypeError("role must be a Parse.Role or a String");
                return "role:".concat(name);
            }
        },
        {
            key: "_parseEntity",
            value: function _parseEntity(entity) {
                var userId = entity;
                if (userId instanceof $ca74facc0e37113f$var$_ParseUser.default) {
                    userId = userId.id;
                    if (!userId) throw new Error("Cannot get access for a Parse.User without an id.");
                } else if (userId instanceof $ca74facc0e37113f$var$_ParseRole.default) userId = this._getRoleName(userId);
                if (typeof userId !== "string") throw new TypeError("userId must be a string.");
                return userId;
            }
        },
        {
            key: "_setAccess",
            value: function _setAccess(permission, userId, allowed) {
                userId = this._parseEntity(userId);
                if (typeof allowed !== "boolean") throw new TypeError("allowed must be either true or false.");
                var permissions = this.permissionsMap[permission][userId];
                if (!permissions) {
                    if (!allowed) // The user already doesn't have this permission, so no action is needed
                    return;
                    else this.permissionsMap[permission][userId] = {};
                }
                if (allowed) this.permissionsMap[permission][userId] = true;
                else delete this.permissionsMap[permission][userId];
            }
        },
        {
            key: "_getAccess",
            value: function _getAccess(permission, userId) /*: boolean | string[]*/ {
                var returnBoolean = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                userId = this._parseEntity(userId);
                var permissions = this.permissionsMap[permission][userId];
                if (returnBoolean) {
                    if (!permissions) return false;
                    return !!this.permissionsMap[permission][userId];
                }
                return permissions;
            }
        },
        {
            key: "_setArrayAccess",
            value: function _setArrayAccess(permission, userId, fields) {
                userId = this._parseEntity(userId);
                var permissions = this.permissionsMap[permission][userId];
                if (!permissions) this.permissionsMap[permission][userId] = [];
                if (!fields || (0, $ca74facc0e37113f$var$_isArray.default)(fields) && fields.length === 0) delete this.permissionsMap[permission][userId];
                else if ((0, $ca74facc0e37113f$var$_isArray.default)(fields) && (0, $ca74facc0e37113f$var$_every.default)(fields).call(fields, function(field) {
                    return typeof field === "string";
                })) this.permissionsMap[permission][userId] = fields;
                else throw new TypeError("fields must be an array of strings or undefined.");
            }
        },
        {
            key: "_setGroupPointerPermission",
            value: function _setGroupPointerPermission(operation, pointerFields) {
                var fields = this.permissionsMap[operation];
                if (!fields) this.permissionsMap[operation] = [];
                if (!pointerFields || (0, $ca74facc0e37113f$var$_isArray.default)(pointerFields) && pointerFields.length === 0) delete this.permissionsMap[operation];
                else if ((0, $ca74facc0e37113f$var$_isArray.default)(pointerFields) && (0, $ca74facc0e37113f$var$_every.default)(pointerFields).call(pointerFields, function(field) {
                    return typeof field === "string";
                })) this.permissionsMap[operation] = pointerFields;
                else throw new TypeError("".concat(operation, ".pointerFields must be an array of strings or undefined."));
            }
        },
        {
            key: "_getGroupPointerPermissions",
            value: function _getGroupPointerPermissions(operation) /*: string[]*/ {
                return this.permissionsMap[operation];
            }
        },
        {
            key: "setReadUserFields",
            value: function setReadUserFields(pointerFields) {
                this._setGroupPointerPermission("readUserFields", pointerFields);
            }
        },
        {
            key: "getReadUserFields",
            value: function getReadUserFields() /*: string[]*/ {
                return this._getGroupPointerPermissions("readUserFields");
            }
        },
        {
            key: "setWriteUserFields",
            value: function setWriteUserFields(pointerFields) {
                this._setGroupPointerPermission("writeUserFields", pointerFields);
            }
        },
        {
            key: "getWriteUserFields",
            value: function getWriteUserFields() /*: string[]*/ {
                return this._getGroupPointerPermissions("writeUserFields");
            }
        },
        {
            key: "setProtectedFields",
            value: function setProtectedFields(userId, fields) {
                this._setArrayAccess("protectedFields", userId, fields);
            }
        },
        {
            key: "getProtectedFields",
            value: function getProtectedFields(userId) /*: string[]*/ {
                return this._getAccess("protectedFields", userId, false);
            }
        },
        {
            key: "setReadAccess",
            value: function setReadAccess(userId, allowed) {
                this._setAccess("find", userId, allowed);
                this._setAccess("get", userId, allowed);
                this._setAccess("count", userId, allowed);
            }
        },
        {
            key: "getReadAccess",
            value: function getReadAccess(userId) /*: boolean*/ {
                return this._getAccess("find", userId) && this._getAccess("get", userId) && this._getAccess("count", userId);
            }
        },
        {
            key: "setWriteAccess",
            value: function setWriteAccess(userId, allowed) {
                this._setAccess("create", userId, allowed);
                this._setAccess("update", userId, allowed);
                this._setAccess("delete", userId, allowed);
                this._setAccess("addField", userId, allowed);
            }
        },
        {
            key: "getWriteAccess",
            value: function getWriteAccess(userId) /*: boolean*/ {
                return this._getAccess("create", userId) && this._getAccess("update", userId) && this._getAccess("delete", userId) && this._getAccess("addField", userId);
            }
        },
        {
            key: "setPublicReadAccess",
            value: function setPublicReadAccess(allowed) {
                this.setReadAccess($ca74facc0e37113f$var$PUBLIC_KEY, allowed);
            }
        },
        {
            key: "getPublicReadAccess",
            value: function getPublicReadAccess() /*: boolean*/ {
                return this.getReadAccess($ca74facc0e37113f$var$PUBLIC_KEY);
            }
        },
        {
            key: "setPublicWriteAccess",
            value: function setPublicWriteAccess(allowed) {
                this.setWriteAccess($ca74facc0e37113f$var$PUBLIC_KEY, allowed);
            }
        },
        {
            key: "getPublicWriteAccess",
            value: function getPublicWriteAccess() /*: boolean*/ {
                return this.getWriteAccess($ca74facc0e37113f$var$PUBLIC_KEY);
            }
        },
        {
            key: "setPublicProtectedFields",
            value: function setPublicProtectedFields(fields) {
                this.setProtectedFields($ca74facc0e37113f$var$PUBLIC_KEY, fields);
            }
        },
        {
            key: "getPublicProtectedFields",
            value: function getPublicProtectedFields() /*: string[]*/ {
                return this.getProtectedFields($ca74facc0e37113f$var$PUBLIC_KEY);
            }
        },
        {
            key: "getRoleReadAccess",
            value: function getRoleReadAccess(role) /*: boolean*/ {
                return this.getReadAccess(this._getRoleName(role));
            }
        },
        {
            key: "getRoleWriteAccess",
            value: function getRoleWriteAccess(role) /*: boolean*/ {
                return this.getWriteAccess(this._getRoleName(role));
            }
        },
        {
            key: "setRoleReadAccess",
            value: function setRoleReadAccess(role, allowed) {
                this.setReadAccess(this._getRoleName(role), allowed);
            }
        },
        {
            key: "setRoleWriteAccess",
            value: function setRoleWriteAccess(role, allowed) {
                this.setWriteAccess(this._getRoleName(role), allowed);
            }
        },
        {
            key: "getRoleProtectedFields",
            value: function getRoleProtectedFields(role) /*: string[]*/ {
                return this.getProtectedFields(this._getRoleName(role));
            }
        },
        {
            key: "setRoleProtectedFields",
            value: function setRoleProtectedFields(role, fields) {
                this.setProtectedFields(this._getRoleName(role), fields);
            }
        }
    ]);
    return ParseCLP;
}();
var $ca74facc0e37113f$var$_default = $ca74facc0e37113f$var$ParseCLP;
module.exports.default = $ca74facc0e37113f$var$_default;

});
parcelRequire.register("55aVK", function(module, exports) {

module.exports = (parcelRequire("4IMRI"));

});
parcelRequire.register("4IMRI", function(module, exports) {

var $cfbrK = parcelRequire("cfbrK");
module.exports = $cfbrK;

});
parcelRequire.register("cfbrK", function(module, exports) {
parcelRequire("jNyCo");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Object.assign;

});
parcelRequire.register("jNyCo", function(module, exports) {

var $ggcsv = parcelRequire("ggcsv");

var $gykNr = parcelRequire("gykNr");
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$ggcsv({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $gykNr
}, {
    assign: $gykNr
});

});
parcelRequire.register("gykNr", function(module, exports) {
"use strict";

var $jeZ4p = parcelRequire("jeZ4p");

var $f518o = parcelRequire("f518o");

var $aELZY = parcelRequire("aELZY");

var $77TPA = parcelRequire("77TPA");

var $3Ut0t = parcelRequire("3Ut0t");

var $4BK7o = parcelRequire("4BK7o");

var $d5uYy = parcelRequire("d5uYy");

var $iJNxK = parcelRequire("iJNxK");

var $lEtn3 = parcelRequire("lEtn3");
// eslint-disable-next-line es/no-object-assign -- safe
var $c0cff40b2410be8f$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $c0cff40b2410be8f$var$defineProperty = Object.defineProperty;
var $c0cff40b2410be8f$var$concat = $f518o([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$c0cff40b2410be8f$var$$assign || $77TPA(function() {
    // should have correct order of operations (Edge bug)
    if ($jeZ4p && $c0cff40b2410be8f$var$$assign({
        b: 1
    }, $c0cff40b2410be8f$var$$assign($c0cff40b2410be8f$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $c0cff40b2410be8f$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $c0cff40b2410be8f$var$$assign({}, A)[symbol] != 7 || $3Ut0t($c0cff40b2410be8f$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $iJNxK(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $4BK7o.f;
    var propertyIsEnumerable = $d5uYy.f;
    while(argumentsLength > index){
        var S = $lEtn3(arguments[index++]);
        var keys = getOwnPropertySymbols ? $c0cff40b2410be8f$var$concat($3Ut0t(S), getOwnPropertySymbols(S)) : $3Ut0t(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$jeZ4p || $aELZY(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $c0cff40b2410be8f$var$$assign;

});





parcelRequire.register("4Rvnw", function(module, exports) {

module.exports = (parcelRequire("lADqs"));

});
parcelRequire.register("lADqs", function(module, exports) {
parcelRequire("jXhxH");

var $aHxiP = parcelRequire("aHxiP");

var $heVlo = parcelRequire("heVlo");

var $8hsAO = parcelRequire("8hsAO");

var $eaqOh = parcelRequire("eaqOh");
var $fb7b8ae7a4e6efd1$var$ArrayPrototype = Array.prototype;
var $fb7b8ae7a4e6efd1$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.entries;
    return it === $fb7b8ae7a4e6efd1$var$ArrayPrototype || $8hsAO($fb7b8ae7a4e6efd1$var$ArrayPrototype, it) && own === $fb7b8ae7a4e6efd1$var$ArrayPrototype.entries || $heVlo($fb7b8ae7a4e6efd1$var$DOMIterables, $aHxiP(it)) ? $eaqOh : own;
};

});
parcelRequire.register("eaqOh", function(module, exports) {

var $6Emw3 = parcelRequire("6Emw3");
module.exports = $6Emw3;

});
parcelRequire.register("6Emw3", function(module, exports) {
parcelRequire("5xrGR");
parcelRequire("iYyco");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").entries;

});




parcelRequire.register("7Xgow", function(module, exports) {

module.exports = (parcelRequire("65nOf"));

});
parcelRequire.register("65nOf", function(module, exports) {

var $lVyCV = parcelRequire("lVyCV");
module.exports = $lVyCV;

});
parcelRequire.register("lVyCV", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $8migK = parcelRequire("8migK");
var $ff69c80067f74ec4$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.every;
    return it === $ff69c80067f74ec4$var$ArrayPrototype || $8hsAO($ff69c80067f74ec4$var$ArrayPrototype, it) && own === $ff69c80067f74ec4$var$ArrayPrototype.every ? $8migK : own;
};

});
parcelRequire.register("8migK", function(module, exports) {
parcelRequire("fY34z");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").every;

});
parcelRequire.register("fY34z", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $igsV9 = parcelRequire("igsV9");
var $b9fed7c9ee572842$require$$every = $igsV9.every;

var $kQPJO = parcelRequire("kQPJO");
var $b9fed7c9ee572842$var$STRICT_METHOD = $kQPJO("every");
// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$ggcsv({
    target: "Array",
    proto: true,
    forced: !$b9fed7c9ee572842$var$STRICT_METHOD
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        return $b9fed7c9ee572842$require$$every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

});





parcelRequire.register("2ETAR", function(module, exports) {

module.exports = (parcelRequire("gXAPd"));

});


parcelRequire.register("5K5Co", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42e59b49f917a38b$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $42e59b49f917a38b$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $42e59b49f917a38b$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $42e59b49f917a38b$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $42e59b49f917a38b$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $42e59b49f917a38b$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $42e59b49f917a38b$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $42e59b49f917a38b$var$_decode = $iHLHC((parcelRequire("42E6z")));

var $42e59b49f917a38b$var$_encode = $iHLHC((parcelRequire("1rsTn")));

var $42e59b49f917a38b$var$_escape2 = $iHLHC((parcelRequire("1JxNp")));

var $42e59b49f917a38b$var$_ParseError = $iHLHC((parcelRequire("6ilM0")));

var $42e59b49f917a38b$var$_Storage = $iHLHC((parcelRequire("7GXKV")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Parse.Config is a local representation of configuration data that
 * can be set from the Parse dashboard.
 *
 * @alias Parse.Config
 */ var $42e59b49f917a38b$var$ParseConfig = /*#__PURE__*/ function() {
    function ParseConfig() {
        (0, $42e59b49f917a38b$var$_classCallCheck2.default)(this, ParseConfig);
        (0, $42e59b49f917a38b$var$_defineProperty2.default)(this, "attributes", void 0);
        (0, $42e59b49f917a38b$var$_defineProperty2.default)(this, "_escapedAttributes", void 0);
        this.attributes = {};
        this._escapedAttributes = {};
    }
    /**
   * Gets the value of an attribute.
   *
   * @param {string} attr The name of an attribute.
   * @returns {*}
   */ (0, $42e59b49f917a38b$var$_createClass2.default)(ParseConfig, [
        {
            key: "get",
            value: function(attr) /*: any*/ {
                return this.attributes[attr];
            }
        },
        {
            key: "escape",
            value: function(attr) /*: string*/ {
                var html = this._escapedAttributes[attr];
                if (html) return html;
                var val = this.attributes[attr];
                var escaped = "";
                if (val != null) escaped = (0, $42e59b49f917a38b$var$_escape2.default)(val.toString());
                this._escapedAttributes[attr] = escaped;
                return escaped;
            }
        }
    ], [
        {
            key: "current",
            value: function() {
                var controller = $42e59b49f917a38b$var$_CoreManager.default.getConfigController();
                return controller.current();
            }
        },
        {
            key: "get",
            value: function() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var controller = $42e59b49f917a38b$var$_CoreManager.default.getConfigController();
                return controller.get(options);
            }
        },
        {
            key: "save",
            value: function(attrs, masterKeyOnlyFlags) {
                var controller = $42e59b49f917a38b$var$_CoreManager.default.getConfigController(); //To avoid a mismatch with the local and the cloud config we get a new version
                return controller.save(attrs, masterKeyOnlyFlags).then(function() {
                    return controller.get({
                        useMasterKey: true
                    });
                }, function(error) {
                    return $42e59b49f917a38b$var$_promise.default.reject(error);
                });
            }
        },
        {
            key: "_clearCache",
            value: function() {
                $42e59b49f917a38b$var$currentConfig = null;
            }
        }
    ]);
    return ParseConfig;
}();
var $42e59b49f917a38b$var$currentConfig = null;
var $42e59b49f917a38b$var$CURRENT_CONFIG_KEY = "currentConfig";
function $42e59b49f917a38b$var$decodePayload(data) {
    try {
        var json = JSON.parse(data);
        if (json && (0, $42e59b49f917a38b$var$_typeof2.default)(json) === "object") return (0, $42e59b49f917a38b$var$_decode.default)(json);
    } catch (e) {
        return null;
    }
}
var $42e59b49f917a38b$var$DefaultController = {
    current: function() {
        if ($42e59b49f917a38b$var$currentConfig) return $42e59b49f917a38b$var$currentConfig;
        var config = new $42e59b49f917a38b$var$ParseConfig();
        var storagePath = $42e59b49f917a38b$var$_Storage.default.generatePath($42e59b49f917a38b$var$CURRENT_CONFIG_KEY);
        if (!$42e59b49f917a38b$var$_Storage.default.async()) {
            var configData = $42e59b49f917a38b$var$_Storage.default.getItem(storagePath);
            if (configData) {
                var attributes = $42e59b49f917a38b$var$decodePayload(configData);
                if (attributes) {
                    config.attributes = attributes;
                    $42e59b49f917a38b$var$currentConfig = config;
                }
            }
            return config;
        } // Return a promise for async storage controllers
        return $42e59b49f917a38b$var$_Storage.default.getItemAsync(storagePath).then(function(configData) {
            if (configData) {
                var _attributes = $42e59b49f917a38b$var$decodePayload(configData);
                if (_attributes) {
                    config.attributes = _attributes;
                    $42e59b49f917a38b$var$currentConfig = config;
                }
            }
            return config;
        });
    },
    get: function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var RESTController = $42e59b49f917a38b$var$_CoreManager.default.getRESTController();
        return RESTController.request("GET", "config", {}, options).then(function(response) {
            if (!response || !response.params) {
                var error = new $42e59b49f917a38b$var$_ParseError.default($42e59b49f917a38b$var$_ParseError.default.INVALID_JSON, "Config JSON response invalid.");
                return $42e59b49f917a38b$var$_promise.default.reject(error);
            }
            var config = new $42e59b49f917a38b$var$ParseConfig();
            config.attributes = {};
            for(var attr in response.params)config.attributes[attr] = (0, $42e59b49f917a38b$var$_decode.default)(response.params[attr]);
            $42e59b49f917a38b$var$currentConfig = config;
            return $42e59b49f917a38b$var$_Storage.default.setItemAsync($42e59b49f917a38b$var$_Storage.default.generatePath($42e59b49f917a38b$var$CURRENT_CONFIG_KEY), (0, $42e59b49f917a38b$var$_stringify.default)(response.params)).then(function() {
                return config;
            });
        });
    },
    save: function(attrs, masterKeyOnlyFlags) {
        var RESTController = $42e59b49f917a38b$var$_CoreManager.default.getRESTController();
        var encodedAttrs = {};
        for(var _key in attrs)encodedAttrs[_key] = (0, $42e59b49f917a38b$var$_encode.default)(attrs[_key]);
        return RESTController.request("PUT", "config", {
            params: encodedAttrs,
            masterKeyOnly: masterKeyOnlyFlags
        }, {
            useMasterKey: true
        }).then(function(response) {
            if (response && response.result) return $42e59b49f917a38b$var$_promise.default.resolve();
            else {
                var error = new $42e59b49f917a38b$var$_ParseError.default($42e59b49f917a38b$var$_ParseError.default.INTERNAL_SERVER_ERROR, "Error occured updating Config.");
                return $42e59b49f917a38b$var$_promise.default.reject(error);
            }
        });
    }
};
$42e59b49f917a38b$var$_CoreManager.default.setConfigController($42e59b49f917a38b$var$DefaultController);
var $42e59b49f917a38b$var$_default = $42e59b49f917a38b$var$ParseConfig;
module.exports.default = $42e59b49f917a38b$var$_default;

});

parcelRequire.register("iRjYO", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbacacd35a49d2da$var$_ParseUser = $iHLHC((parcelRequire("iQ4JH")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow-weak
 */ /* global FB */ var $dbacacd35a49d2da$var$initialized = false;
var $dbacacd35a49d2da$var$requestedPermissions;
var $dbacacd35a49d2da$var$initOptions;
var $dbacacd35a49d2da$var$provider = {
    authenticate: function(options) {
        var _this = this;
        if (typeof FB === "undefined") options.error(this, "Facebook SDK not found.");
        FB.login(function(response) {
            if (response.authResponse) {
                if (options.success) options.success(_this, {
                    id: response.authResponse.userID,
                    access_token: response.authResponse.accessToken,
                    expiration_date: new Date(response.authResponse.expiresIn * 1000 + new Date().getTime()).toJSON()
                });
            } else if (options.error) options.error(_this, response);
        }, {
            scope: $dbacacd35a49d2da$var$requestedPermissions
        });
    },
    restoreAuthentication: function(authData) {
        if (authData) {
            var newOptions = {};
            if ($dbacacd35a49d2da$var$initOptions) for(var key in $dbacacd35a49d2da$var$initOptions)newOptions[key] = $dbacacd35a49d2da$var$initOptions[key];
             // Suppress checks for login status from the browser.
            newOptions.status = false; // If the user doesn't match the one known by the FB SDK, log out.
            // Most of the time, the users will match -- it's only in cases where
            // the FB SDK knows of a different user than the one being restored
            // from a Parse User that logged in with username/password.
            var existingResponse = FB.getAuthResponse();
            if (existingResponse && existingResponse.userID !== authData.id) FB.logout();
            FB.init(newOptions);
        }
        return true;
    },
    getAuthType: function() {
        return "facebook";
    },
    deauthenticate: function() {
        this.restoreAuthentication(null);
    }
};
/**
 * Provides a set of utilities for using Parse with Facebook.
 *
 * @class Parse.FacebookUtils
 * @static
 * @hideconstructor
 */ var $dbacacd35a49d2da$var$FacebookUtils = {
    /**
   * Initializes Parse Facebook integration.  Call this function after you
   * have loaded the Facebook Javascript SDK with the same parameters
   * as you would pass to<code>
   * <a href=
   * "https://developers.facebook.com/docs/reference/javascript/FB.init/">
   * FB.init()</a></code>.  Parse.FacebookUtils will invoke FB.init() for you
   * with these arguments.
   *
   * @function init
   * @name Parse.FacebookUtils.init
   * @param {object} options Facebook options argument as described here:
   *   <a href=
   *   "https://developers.facebook.com/docs/reference/javascript/FB.init/">
   *   FB.init()</a>. The status flag will be coerced to 'false' because it
   *   interferes with Parse Facebook integration. Call FB.getLoginStatus()
   *   explicitly if this behavior is required by your application.
   */ init: function(options) {
        if (typeof FB === "undefined") throw new Error("The Facebook JavaScript SDK must be loaded before calling init.");
        $dbacacd35a49d2da$var$initOptions = {};
        if (options) for(var key in options)$dbacacd35a49d2da$var$initOptions[key] = options[key];
        if ($dbacacd35a49d2da$var$initOptions.status && typeof console !== "undefined") {
            var warn = console.warn || console.log || function() {}; // eslint-disable-line no-console
            warn.call(console, 'The "status" flag passed into FB.init, when set to true, can interfere with Parse Facebook integration, so it has been suppressed. Please call FB.getLoginStatus() explicitly if you require this behavior.');
        }
        $dbacacd35a49d2da$var$initOptions.status = false;
        FB.init($dbacacd35a49d2da$var$initOptions);
        $dbacacd35a49d2da$var$_ParseUser.default._registerAuthenticationProvider($dbacacd35a49d2da$var$provider);
        $dbacacd35a49d2da$var$initialized = true;
    },
    /**
   * Gets whether the user has their account linked to Facebook.
   *
   * @function isLinked
   * @name Parse.FacebookUtils.isLinked
   * @param {Parse.User} user User to check for a facebook link.
   *     The user must be logged in on this device.
   * @returns {boolean} <code>true</code> if the user has their account
   *     linked to Facebook.
   */ isLinked: function(user) {
        return user._isLinked("facebook");
    },
    /**
   * Logs in a user using Facebook. This method delegates to the Facebook
   * SDK to authenticate the user, and then automatically logs in (or
   * creates, in the case where it is a new user) a Parse.User.
   *
   * Standard API:
   *
   * <code>logIn(permission: string, authData: Object);</code>
   *
   * Advanced API: Used for handling your own oAuth tokens
   * {@link https://docs.parseplatform.org/rest/guide/#linking-users}
   *
   * <code>logIn(authData: Object, options?: Object);</code>
   *
   * @function logIn
   * @name Parse.FacebookUtils.logIn
   * @param {(string | object)} permissions The permissions required for Facebook
   *    log in.  This is a comma-separated string of permissions.
   *    Alternatively, supply a Facebook authData object as described in our
   *    REST API docs if you want to handle getting facebook auth tokens
   *    yourself.
   * @param {object} options MasterKey / SessionToken. Alternatively can be used for authData if permissions is a string
   * @returns {Promise}
   */ logIn: function(permissions, options) {
        if (!permissions || typeof permissions === "string") {
            if (!$dbacacd35a49d2da$var$initialized) throw new Error("You must initialize FacebookUtils before calling logIn.");
            $dbacacd35a49d2da$var$requestedPermissions = permissions;
            return $dbacacd35a49d2da$var$_ParseUser.default.logInWith("facebook", options);
        }
        return $dbacacd35a49d2da$var$_ParseUser.default.logInWith("facebook", {
            authData: permissions
        }, options);
    },
    /**
   * Links Facebook to an existing PFUser. This method delegates to the
   * Facebook SDK to authenticate the user, and then automatically links
   * the account to the Parse.User.
   *
   * Standard API:
   *
   * <code>link(user: Parse.User, permission: string, authData?: Object);</code>
   *
   * Advanced API: Used for handling your own oAuth tokens
   * {@link https://docs.parseplatform.org/rest/guide/#linking-users}
   *
   * <code>link(user: Parse.User, authData: Object, options?: FullOptions);</code>
   *
   * @function link
   * @name Parse.FacebookUtils.link
   * @param {Parse.User} user User to link to Facebook. This must be the
   *     current user.
   * @param {(string | object)} permissions The permissions required for Facebook
   *    log in.  This is a comma-separated string of permissions.
   *    Alternatively, supply a Facebook authData object as described in our
   *    REST API docs if you want to handle getting facebook auth tokens
   *    yourself.
   * @param {object} options MasterKey / SessionToken. Alternatively can be used for authData if permissions is a string
   * @returns {Promise}
   */ link: function(user, permissions, options) {
        if (!permissions || typeof permissions === "string") {
            if (!$dbacacd35a49d2da$var$initialized) throw new Error("You must initialize FacebookUtils before calling link.");
            $dbacacd35a49d2da$var$requestedPermissions = permissions;
            return user.linkWith("facebook", options);
        }
        return user.linkWith("facebook", {
            authData: permissions
        }, options);
    },
    /**
   * Unlinks the Parse.User from a Facebook account.
   *
   * @function unlink
   * @name Parse.FacebookUtils.unlink
   * @param {Parse.User} user User to unlink from Facebook. This must be the
   *     current user.
   * @param {object} options Standard options object with success and error
   *    callbacks.
   * @returns {Promise}
   */ unlink: function(user, options) {
        if (!$dbacacd35a49d2da$var$initialized) throw new Error("You must initialize FacebookUtils before calling unlink.");
        return user._unlinkFrom("facebook", options);
    },
    // Used for testing purposes
    _getAuthProvider: function() {
        return $dbacacd35a49d2da$var$provider;
    }
};
var $dbacacd35a49d2da$var$_default = $dbacacd35a49d2da$var$FacebookUtils;
module.exports.default = $dbacacd35a49d2da$var$_default;

});

parcelRequire.register("7nsYD", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");

var $oM1qX = parcelRequire("oM1qX");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55f12897a4ddbde5$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $55f12897a4ddbde5$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $55f12897a4ddbde5$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $55f12897a4ddbde5$var$_inherits2 = $iHLHC((parcelRequire("cNDsY")));

var $55f12897a4ddbde5$var$_possibleConstructorReturn2 = $iHLHC((parcelRequire("1C8Dw")));

var $55f12897a4ddbde5$var$_getPrototypeOf2 = $iHLHC((parcelRequire("kptbe")));

var $55f12897a4ddbde5$var$_ParseObject2 = $iHLHC((parcelRequire("fMBjE")));
function $55f12897a4ddbde5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $55f12897a4ddbde5$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $55f12897a4ddbde5$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $55f12897a4ddbde5$var$_getPrototypeOf2.default)(this).constructor;
            result = $oM1qX(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $55f12897a4ddbde5$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $55f12897a4ddbde5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$oM1qX) return false;
    if ($oM1qX.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($oM1qX(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $55f12897a4ddbde5$var$Installation = /*#__PURE__*/ function(_ParseObject) {
    (0, $55f12897a4ddbde5$var$_inherits2.default)(Installation, _ParseObject);
    var _super = $55f12897a4ddbde5$var$_createSuper(Installation);
    function Installation(attributes) {
        var _this;
        (0, $55f12897a4ddbde5$var$_classCallCheck2.default)(this, Installation);
        _this = _super.call(this, "_Installation");
        if (attributes && (0, $55f12897a4ddbde5$var$_typeof2.default)(attributes) === "object") {
            if (!_this.set(attributes || {})) throw new Error("Can't create an invalid Installation");
        }
        return _this;
    }
    return (0, $55f12897a4ddbde5$var$_createClass2.default)(Installation);
}($55f12897a4ddbde5$var$_ParseObject2.default);
module.exports.default = $55f12897a4ddbde5$var$Installation;
$55f12897a4ddbde5$var$_ParseObject2.default.registerSubclass("_Installation", $55f12897a4ddbde5$var$Installation);

});

parcelRequire.register("xW8Bi", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4wehD = parcelRequire("4wehD");


var $dQJQf = parcelRequire("dQJQf");

var $6iqUa = parcelRequire("6iqUa");

var $gW71a = parcelRequire("gW71a");

var $kOp5W = parcelRequire("kOp5W");

var $jQ6K5 = parcelRequire("jQ6K5");

var $4i3Tl = parcelRequire("4i3Tl");


var $iG2ur = parcelRequire("iG2ur");

var $iDZ3d = parcelRequire("iDZ3d");


var $a1TrC = parcelRequire("a1TrC");

var $06602e1f258d0b04$var$_find = $iHLHC((parcelRequire("c61hX")));

var $06602e1f258d0b04$var$_from = $iHLHC((parcelRequire("35NIM")));

var $06602e1f258d0b04$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $06602e1f258d0b04$var$_isArray = $iHLHC((parcelRequire("euZIZ")));

var $06602e1f258d0b04$var$_regenerator = $iHLHC((parcelRequire("1fDhY")));

var $06602e1f258d0b04$var$_keys2 = $iHLHC((parcelRequire("e9nT0")));

var $06602e1f258d0b04$var$_startsWith = $iHLHC((parcelRequire("hNmgD")));

var $06602e1f258d0b04$var$_keys3 = $iHLHC((parcelRequire("2QmZN")));

var $06602e1f258d0b04$var$_includes = $iHLHC((parcelRequire("dNrmj")));

var $06602e1f258d0b04$var$_filter = $iHLHC((parcelRequire("i3o6i")));

var $06602e1f258d0b04$var$_concat = $iHLHC((parcelRequire("oorJA")));

var $06602e1f258d0b04$var$_set = $iHLHC((parcelRequire("a4Pit")));

var $06602e1f258d0b04$var$_toConsumableArray2 = $iHLHC((parcelRequire("h3AFy")));

var $06602e1f258d0b04$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $06602e1f258d0b04$var$_slicedToArray2 = $iHLHC((parcelRequire("ccwCe")));

var $06602e1f258d0b04$var$_asyncToGenerator2 = $iHLHC((parcelRequire("kkHAR")));

var $06602e1f258d0b04$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $06602e1f258d0b04$var$_ParseQuery = $iHLHC((parcelRequire("4FVCr")));

var $klpRA = parcelRequire("klpRA");
function $06602e1f258d0b04$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $06602e1f258d0b04$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $iDZ3d ? $iDZ3d : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $4i3Tl(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $jQ6K5(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $kOp5W, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $jQ6K5(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context19;
        $gW71a(_context19 = [
            "next",
            "throw",
            "return"
        ]).call(_context19, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $6iqUa(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], $gW71a(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return $dQJQf ? $dQJQf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $jQ6K5(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("iH0WI")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $4wehD(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context20;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, $gW71a(_context20 = this.tryEntries).call(_context20, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$a1TrC(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $06602e1f258d0b04$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $iDZ3d !== "undefined" && $iG2ur(o) || o["@@iterator"];
    if (!it) {
        if ((parcelRequire("euZIZ"))(o) || (it = $06602e1f258d0b04$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $06602e1f258d0b04$var$_unsupportedIterableToArray(o, minLen) {
    var _context18;
    if (!o) return;
    if (typeof o === "string") return $06602e1f258d0b04$var$_arrayLikeToArray(o, minLen);
    var n = $a1TrC(_context18 = Object.prototype.toString.call(o)).call(_context18, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return (parcelRequire("35NIM"))(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $06602e1f258d0b04$var$_arrayLikeToArray(o, minLen);
}
function $06602e1f258d0b04$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Provides a local datastore which can be used to store and retrieve <code>Parse.Object</code>. <br />
 * To enable this functionality, call <code>Parse.enableLocalDatastore()</code>.
 *
 * Pin object to add to local datastore
 *
 * <pre>await object.pin();</pre>
 * <pre>await object.pinWithName('pinName');</pre>
 *
 * Query pinned objects
 *
 * <pre>query.fromLocalDatastore();</pre>
 * <pre>query.fromPin();</pre>
 * <pre>query.fromPinWithName();</pre>
 *
 * <pre>const localObjects = await query.find();</pre>
 *
 * @class Parse.LocalDatastore
 * @static
 */ var $06602e1f258d0b04$var$LocalDatastore = {
    isEnabled: false,
    isSyncing: false,
    fromPinWithName: function(name) /*: Promise<Array<Object>>*/ {
        var controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.fromPinWithName(name);
    },
    pinWithName: function(name, value) /*: Promise<void>*/ {
        var controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.pinWithName(name, value);
    },
    unPinWithName: function(name) /*: Promise<void>*/ {
        var controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.unPinWithName(name);
    },
    _getAllContents: function() /*: Promise<Object>*/ {
        var controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.getAllContents();
    },
    // Use for testing
    _getRawStorage: function() /*: Promise<Object>*/ {
        var controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.getRawStorage();
    },
    _clear: function() /*: Promise<void>*/ {
        var controller = $06602e1f258d0b04$var$_CoreManager.default.getLocalDatastoreController();
        return controller.clear();
    },
    // Pin the object and children recursively
    // Saves the object and children key to Pin Name
    _handlePinAllWithName: function(name, objects) /*: Promise<void>*/ {
        var _this = this;
        return (0, $06602e1f258d0b04$var$_asyncToGenerator2.default)(/*#__PURE__*/ $06602e1f258d0b04$var$_regeneratorRuntime().mark(function _callee() {
            var _context;
            var pinName, toPinPromises, objectKeys, _iterator, _step, parent, children, parentKey, json, objectKey, fromPinPromise, _yield$Promise$all, _yield$Promise$all2, pinned, toPin;
            return $06602e1f258d0b04$var$_regeneratorRuntime().wrap(function _callee$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        pinName = _this.getPinName(name);
                        toPinPromises = [];
                        objectKeys = [];
                        _iterator = $06602e1f258d0b04$var$_createForOfIteratorHelper(objects);
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                parent = _step.value;
                                children = _this._getChildren(parent);
                                parentKey = _this.getKeyForObject(parent);
                                json = parent._toFullJSON(undefined, true);
                                if (parent._localId) json._localId = parent._localId;
                                children[parentKey] = json;
                                for(objectKey in children){
                                    objectKeys.push(objectKey);
                                    toPinPromises.push(_this.pinWithName(objectKey, [
                                        children[objectKey]
                                    ]));
                                }
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                        fromPinPromise = _this.fromPinWithName(pinName);
                        _context2.next = 8;
                        return $06602e1f258d0b04$var$_promise.default.all([
                            fromPinPromise,
                            toPinPromises
                        ]);
                    case 8:
                        _yield$Promise$all = _context2.sent;
                        _yield$Promise$all2 = (0, $06602e1f258d0b04$var$_slicedToArray2.default)(_yield$Promise$all, 1);
                        pinned = _yield$Promise$all2[0];
                        toPin = (0, $06602e1f258d0b04$var$_toConsumableArray2.default)(new $06602e1f258d0b04$var$_set.default((0, $06602e1f258d0b04$var$_concat.default)(_context = []).call(_context, (0, $06602e1f258d0b04$var$_toConsumableArray2.default)(pinned || []), objectKeys)));
                        return _context2.abrupt("return", _this.pinWithName(pinName, toPin));
                    case 13:
                    case "end":
                        return _context2.stop();
                }
            }, _callee);
        }))();
    },
    // Removes object and children keys from pin name
    // Keeps the object and children pinned
    _handleUnPinAllWithName: function _handleUnPinAllWithName(name, objects) {
        var _this2 = this;
        return (0, $06602e1f258d0b04$var$_asyncToGenerator2.default)(/*#__PURE__*/ $06602e1f258d0b04$var$_regeneratorRuntime().mark(function _callee2() {
            var localDatastore, pinName, promises, objectKeys, _iterator2, _step2, _objectKeys, _context3, parent, children, parentKey, pinned, _iterator3, _step3, objectKey, hasReference, key, pinnedObjects;
            return $06602e1f258d0b04$var$_regeneratorRuntime().wrap(function _callee2$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        _context4.next = 2;
                        return _this2._getAllContents();
                    case 2:
                        localDatastore = _context4.sent;
                        pinName = _this2.getPinName(name);
                        promises = [];
                        objectKeys = [];
                        _iterator2 = $06602e1f258d0b04$var$_createForOfIteratorHelper(objects);
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                parent = _step2.value;
                                children = _this2._getChildren(parent);
                                parentKey = _this2.getKeyForObject(parent);
                                (_objectKeys = objectKeys).push.apply(_objectKeys, (0, $06602e1f258d0b04$var$_concat.default)(_context3 = [
                                    parentKey
                                ]).call(_context3, (0, $06602e1f258d0b04$var$_toConsumableArray2.default)((0, $06602e1f258d0b04$var$_keys3.default)(children))));
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                        objectKeys = (0, $06602e1f258d0b04$var$_toConsumableArray2.default)(new $06602e1f258d0b04$var$_set.default(objectKeys));
                        pinned = localDatastore[pinName] || [];
                        pinned = (0, $06602e1f258d0b04$var$_filter.default)(pinned).call(pinned, function(item) {
                            return !(0, $06602e1f258d0b04$var$_includes.default)(objectKeys).call(objectKeys, item);
                        });
                        if (pinned.length == 0) {
                            promises.push(_this2.unPinWithName(pinName));
                            delete localDatastore[pinName];
                        } else {
                            promises.push(_this2.pinWithName(pinName, pinned));
                            localDatastore[pinName] = pinned;
                        }
                        _iterator3 = $06602e1f258d0b04$var$_createForOfIteratorHelper(objectKeys);
                        _context4.prev = 13;
                        _iterator3.s();
                    case 15:
                        if ((_step3 = _iterator3.n()).done) {
                            _context4.next = 31;
                            break;
                        }
                        objectKey = _step3.value;
                        hasReference = false;
                        _context4.t0 = (0, $06602e1f258d0b04$var$_keys2.default)($06602e1f258d0b04$var$_regenerator.default).call($06602e1f258d0b04$var$_regenerator.default, localDatastore);
                    case 19:
                        if ((_context4.t1 = _context4.t0()).done) {
                            _context4.next = 28;
                            break;
                        }
                        key = _context4.t1.value;
                        if (!(key === $klpRA.DEFAULT_PIN || (0, $06602e1f258d0b04$var$_startsWith.default)(key).call(key, $klpRA.PIN_PREFIX))) {
                            _context4.next = 26;
                            break;
                        }
                        pinnedObjects = localDatastore[key] || [];
                        if (!(0, $06602e1f258d0b04$var$_includes.default)(pinnedObjects).call(pinnedObjects, objectKey)) {
                            _context4.next = 26;
                            break;
                        }
                        hasReference = true;
                        return _context4.abrupt("break", 28);
                    case 26:
                        _context4.next = 19;
                        break;
                    case 28:
                        if (!hasReference) promises.push(_this2.unPinWithName(objectKey));
                    case 29:
                        _context4.next = 15;
                        break;
                    case 31:
                        _context4.next = 36;
                        break;
                    case 33:
                        _context4.prev = 33;
                        _context4.t2 = _context4["catch"](13);
                        _iterator3.e(_context4.t2);
                    case 36:
                        _context4.prev = 36;
                        _iterator3.f();
                        return _context4.finish(36);
                    case 39:
                        return _context4.abrupt("return", $06602e1f258d0b04$var$_promise.default.all(promises));
                    case 40:
                    case "end":
                        return _context4.stop();
                }
            }, _callee2, null, [
                [
                    13,
                    33,
                    36,
                    39
                ]
            ]);
        }))();
    },
    // Retrieve all pointer fields from object recursively
    _getChildren: function _getChildren(object) {
        var encountered = {};
        var json = object._toFullJSON(undefined, true);
        for(var key in json)if (json[key] && json[key].__type && json[key].__type === "Object") this._traverse(json[key], encountered);
        return encountered;
    },
    _traverse: function _traverse(object, encountered) {
        if (!object.objectId) return;
        else {
            var objectKey = this.getKeyForObject(object);
            if (encountered[objectKey]) return;
            encountered[objectKey] = object;
        }
        for(var key in object){
            var json = object[key];
            if (!object[key]) json = object;
            if (json.__type && json.__type === "Object") this._traverse(json, encountered);
        }
    },
    // Transform keys in pin name to objects
    _serializeObjectsFromPinName: function _serializeObjectsFromPinName(name) {
        var _this3 = this;
        return (0, $06602e1f258d0b04$var$_asyncToGenerator2.default)(/*#__PURE__*/ $06602e1f258d0b04$var$_regeneratorRuntime().mark(function _callee3() {
            var _context5, _concatInstanceProper, _context6;
            var localDatastore, allObjects, key, pinName, pinned, promises, objects;
            return $06602e1f258d0b04$var$_regeneratorRuntime().wrap(function _callee3$(_context7) {
                while(true)switch(_context7.prev = _context7.next){
                    case 0:
                        _context7.next = 2;
                        return _this3._getAllContents();
                    case 2:
                        localDatastore = _context7.sent;
                        allObjects = [];
                        for(key in localDatastore)if ((0, $06602e1f258d0b04$var$_startsWith.default)(key).call(key, $klpRA.OBJECT_PREFIX)) allObjects.push(localDatastore[key][0]);
                        if (name) {
                            _context7.next = 7;
                            break;
                        }
                        return _context7.abrupt("return", allObjects);
                    case 7:
                        pinName = _this3.getPinName(name);
                        pinned = localDatastore[pinName];
                        if ((0, $06602e1f258d0b04$var$_isArray.default)(pinned)) {
                            _context7.next = 11;
                            break;
                        }
                        return _context7.abrupt("return", []);
                    case 11:
                        promises = (0, $06602e1f258d0b04$var$_map.default)(pinned).call(pinned, function(objectKey) {
                            return _this3.fromPinWithName(objectKey);
                        });
                        _context7.next = 14;
                        return $06602e1f258d0b04$var$_promise.default.all(promises);
                    case 14:
                        objects = _context7.sent;
                        objects = (_concatInstanceProper = (0, $06602e1f258d0b04$var$_concat.default)(_context5 = [])).call.apply(_concatInstanceProper, (0, $06602e1f258d0b04$var$_concat.default)(_context6 = [
                            _context5
                        ]).call(_context6, (0, $06602e1f258d0b04$var$_toConsumableArray2.default)(objects)));
                        return _context7.abrupt("return", (0, $06602e1f258d0b04$var$_filter.default)(objects).call(objects, function(object) {
                            return object != null;
                        }));
                    case 17:
                    case "end":
                        return _context7.stop();
                }
            }, _callee3);
        }))();
    },
    // Replaces object pointers with pinned pointers
    // The object pointers may contain old data
    // Uses Breadth First Search Algorithm
    _serializeObject: function _serializeObject(objectKey, localDatastore) {
        var _this4 = this;
        return (0, $06602e1f258d0b04$var$_asyncToGenerator2.default)(/*#__PURE__*/ $06602e1f258d0b04$var$_regeneratorRuntime().mark(function _callee4() {
            var LDS, root, queue, meta, uniqueId, nodeId, subTreeRoot, field, value, key, pointer;
            return $06602e1f258d0b04$var$_regeneratorRuntime().wrap(function _callee4$(_context8) {
                while(true)switch(_context8.prev = _context8.next){
                    case 0:
                        LDS = localDatastore;
                        if (LDS) {
                            _context8.next = 5;
                            break;
                        }
                        _context8.next = 4;
                        return _this4._getAllContents();
                    case 4:
                        LDS = _context8.sent;
                    case 5:
                        if (!(!LDS[objectKey] || LDS[objectKey].length === 0)) {
                            _context8.next = 7;
                            break;
                        }
                        return _context8.abrupt("return", null);
                    case 7:
                        root = LDS[objectKey][0];
                        queue = [];
                        meta = {};
                        uniqueId = 0;
                        meta[uniqueId] = root;
                        queue.push(uniqueId);
                        while(queue.length !== 0){
                            nodeId = queue.shift();
                            subTreeRoot = meta[nodeId];
                            for(field in subTreeRoot){
                                value = subTreeRoot[field];
                                if (value.__type && value.__type === "Object") {
                                    key = _this4.getKeyForObject(value);
                                    if (LDS[key] && LDS[key].length > 0) {
                                        pointer = LDS[key][0];
                                        uniqueId++;
                                        meta[uniqueId] = pointer;
                                        subTreeRoot[field] = pointer;
                                        queue.push(uniqueId);
                                    }
                                }
                            }
                        }
                        return _context8.abrupt("return", root);
                    case 15:
                    case "end":
                        return _context8.stop();
                }
            }, _callee4);
        }))();
    },
    // Called when an object is save / fetched
    // Update object pin value
    _updateObjectIfPinned: function _updateObjectIfPinned(object) /*: Promise<void>*/ {
        var _this5 = this;
        return (0, $06602e1f258d0b04$var$_asyncToGenerator2.default)(/*#__PURE__*/ $06602e1f258d0b04$var$_regeneratorRuntime().mark(function _callee5() {
            var objectKey, pinned;
            return $06602e1f258d0b04$var$_regeneratorRuntime().wrap(function _callee5$(_context9) {
                while(true)switch(_context9.prev = _context9.next){
                    case 0:
                        if (_this5.isEnabled) {
                            _context9.next = 2;
                            break;
                        }
                        return _context9.abrupt("return");
                    case 2:
                        objectKey = _this5.getKeyForObject(object);
                        _context9.next = 5;
                        return _this5.fromPinWithName(objectKey);
                    case 5:
                        pinned = _context9.sent;
                        if (!(!pinned || pinned.length === 0)) {
                            _context9.next = 8;
                            break;
                        }
                        return _context9.abrupt("return");
                    case 8:
                        return _context9.abrupt("return", _this5.pinWithName(objectKey, [
                            object._toFullJSON()
                        ]));
                    case 9:
                    case "end":
                        return _context9.stop();
                }
            }, _callee5);
        }))();
    },
    // Called when object is destroyed
    // Unpin object and remove all references from pin names
    // TODO: Destroy children?
    _destroyObjectIfPinned: function _destroyObjectIfPinned(object) {
        var _this6 = this;
        return (0, $06602e1f258d0b04$var$_asyncToGenerator2.default)(/*#__PURE__*/ $06602e1f258d0b04$var$_regeneratorRuntime().mark(function _callee6() {
            var localDatastore, objectKey, pin, promises, key, pinned;
            return $06602e1f258d0b04$var$_regeneratorRuntime().wrap(function _callee6$(_context10) {
                while(true)switch(_context10.prev = _context10.next){
                    case 0:
                        if (_this6.isEnabled) {
                            _context10.next = 2;
                            break;
                        }
                        return _context10.abrupt("return");
                    case 2:
                        _context10.next = 4;
                        return _this6._getAllContents();
                    case 4:
                        localDatastore = _context10.sent;
                        objectKey = _this6.getKeyForObject(object);
                        pin = localDatastore[objectKey];
                        if (pin) {
                            _context10.next = 9;
                            break;
                        }
                        return _context10.abrupt("return");
                    case 9:
                        promises = [
                            _this6.unPinWithName(objectKey)
                        ];
                        delete localDatastore[objectKey];
                        for(key in localDatastore)if (key === $klpRA.DEFAULT_PIN || (0, $06602e1f258d0b04$var$_startsWith.default)(key).call(key, $klpRA.PIN_PREFIX)) {
                            pinned = localDatastore[key] || [];
                            if ((0, $06602e1f258d0b04$var$_includes.default)(pinned).call(pinned, objectKey)) {
                                pinned = (0, $06602e1f258d0b04$var$_filter.default)(pinned).call(pinned, function(item) {
                                    return item !== objectKey;
                                });
                                if (pinned.length == 0) {
                                    promises.push(_this6.unPinWithName(key));
                                    delete localDatastore[key];
                                } else {
                                    promises.push(_this6.pinWithName(key, pinned));
                                    localDatastore[key] = pinned;
                                }
                            }
                        }
                        return _context10.abrupt("return", $06602e1f258d0b04$var$_promise.default.all(promises));
                    case 13:
                    case "end":
                        return _context10.stop();
                }
            }, _callee6);
        }))();
    },
    // Update pin and references of the unsaved object
    _updateLocalIdForObject: function _updateLocalIdForObject(localId, object) {
        var _this7 = this;
        return (0, $06602e1f258d0b04$var$_asyncToGenerator2.default)(/*#__PURE__*/ $06602e1f258d0b04$var$_regeneratorRuntime().mark(function _callee7() {
            var _context11, _context12;
            var localKey, objectKey, unsaved, promises, localDatastore, key, pinned;
            return $06602e1f258d0b04$var$_regeneratorRuntime().wrap(function _callee7$(_context13) {
                while(true)switch(_context13.prev = _context13.next){
                    case 0:
                        if (_this7.isEnabled) {
                            _context13.next = 2;
                            break;
                        }
                        return _context13.abrupt("return");
                    case 2:
                        localKey = (0, $06602e1f258d0b04$var$_concat.default)(_context11 = (0, $06602e1f258d0b04$var$_concat.default)(_context12 = "".concat($klpRA.OBJECT_PREFIX)).call(_context12, object.className, "_")).call(_context11, localId);
                        objectKey = _this7.getKeyForObject(object);
                        _context13.next = 6;
                        return _this7.fromPinWithName(localKey);
                    case 6:
                        unsaved = _context13.sent;
                        if (!(!unsaved || unsaved.length === 0)) {
                            _context13.next = 9;
                            break;
                        }
                        return _context13.abrupt("return");
                    case 9:
                        promises = [
                            _this7.unPinWithName(localKey),
                            _this7.pinWithName(objectKey, unsaved)
                        ];
                        _context13.next = 12;
                        return _this7._getAllContents();
                    case 12:
                        localDatastore = _context13.sent;
                        for(key in localDatastore)if (key === $klpRA.DEFAULT_PIN || (0, $06602e1f258d0b04$var$_startsWith.default)(key).call(key, $klpRA.PIN_PREFIX)) {
                            pinned = localDatastore[key] || [];
                            if ((0, $06602e1f258d0b04$var$_includes.default)(pinned).call(pinned, localKey)) {
                                pinned = (0, $06602e1f258d0b04$var$_filter.default)(pinned).call(pinned, function(item) {
                                    return item !== localKey;
                                });
                                pinned.push(objectKey);
                                promises.push(_this7.pinWithName(key, pinned));
                                localDatastore[key] = pinned;
                            }
                        }
                        return _context13.abrupt("return", $06602e1f258d0b04$var$_promise.default.all(promises));
                    case 15:
                    case "end":
                        return _context13.stop();
                }
            }, _callee7);
        }))();
    },
    /**
   * Updates Local Datastore from Server
   *
   * <pre>
   * await Parse.LocalDatastore.updateFromServer();
   * </pre>
   *
   * @function updateFromServer
   * @name Parse.LocalDatastore.updateFromServer
   * @static
   */ updateFromServer: function updateFromServer() {
        var _this8 = this;
        return (0, $06602e1f258d0b04$var$_asyncToGenerator2.default)(/*#__PURE__*/ $06602e1f258d0b04$var$_regeneratorRuntime().mark(function _callee8() {
            var _context14;
            var localDatastore, keys, key, pointersHash, _i, _keys, _key, _key$split, _key$split2, className, objectId, queryPromises, responses, objects, pinPromises;
            return $06602e1f258d0b04$var$_regeneratorRuntime().wrap(function _callee8$(_context15) {
                while(true)switch(_context15.prev = _context15.next){
                    case 0:
                        if (!(!_this8.checkIfEnabled() || _this8.isSyncing)) {
                            _context15.next = 2;
                            break;
                        }
                        return _context15.abrupt("return");
                    case 2:
                        _context15.next = 4;
                        return _this8._getAllContents();
                    case 4:
                        localDatastore = _context15.sent;
                        keys = [];
                        for(key in localDatastore)if ((0, $06602e1f258d0b04$var$_startsWith.default)(key).call(key, $klpRA.OBJECT_PREFIX)) keys.push(key);
                        if (!(keys.length === 0)) {
                            _context15.next = 9;
                            break;
                        }
                        return _context15.abrupt("return");
                    case 9:
                        _this8.isSyncing = true;
                        pointersHash = {};
                        _i = 0, _keys = keys;
                    case 12:
                        if (!(_i < _keys.length)) {
                            _context15.next = 23;
                            break;
                        }
                        _key = _keys[_i]; // Ignore the OBJECT_PREFIX
                        _key$split = _key.split("_"), _key$split2 = (0, $06602e1f258d0b04$var$_slicedToArray2.default)(_key$split, 4), className = _key$split2[2], objectId = _key$split2[3]; // User key is split into [ 'Parse', 'LDS', '', 'User', 'objectId' ]
                        if (_key.split("_").length === 5 && _key.split("_")[3] === "User") {
                            className = "_User";
                            objectId = _key.split("_")[4];
                        }
                        if (!(0, $06602e1f258d0b04$var$_startsWith.default)(objectId).call(objectId, "local")) {
                            _context15.next = 18;
                            break;
                        }
                        return _context15.abrupt("continue", 20);
                    case 18:
                        if (!(className in pointersHash)) pointersHash[className] = new $06602e1f258d0b04$var$_set.default();
                        pointersHash[className].add(objectId);
                    case 20:
                        _i++;
                        _context15.next = 12;
                        break;
                    case 23:
                        queryPromises = (0, $06602e1f258d0b04$var$_map.default)(_context14 = (0, $06602e1f258d0b04$var$_keys3.default)(pointersHash)).call(_context14, function(className) {
                            var objectIds = (0, $06602e1f258d0b04$var$_from.default)(pointersHash[className]);
                            var query = new $06602e1f258d0b04$var$_ParseQuery.default(className);
                            query.limit(objectIds.length);
                            if (objectIds.length === 1) query.equalTo("objectId", objectIds[0]);
                            else query.containedIn("objectId", objectIds);
                            return (0, $06602e1f258d0b04$var$_find.default)(query).call(query);
                        });
                        _context15.prev = 24;
                        _context15.next = 27;
                        return $06602e1f258d0b04$var$_promise.default.all(queryPromises);
                    case 27:
                        responses = _context15.sent;
                        objects = (0, $06602e1f258d0b04$var$_concat.default)([]).apply([], responses);
                        pinPromises = (0, $06602e1f258d0b04$var$_map.default)(objects).call(objects, function(object) {
                            var objectKey = _this8.getKeyForObject(object);
                            return _this8.pinWithName(objectKey, object._toFullJSON());
                        });
                        _context15.next = 32;
                        return $06602e1f258d0b04$var$_promise.default.all(pinPromises);
                    case 32:
                        _this8.isSyncing = false;
                        _context15.next = 39;
                        break;
                    case 35:
                        _context15.prev = 35;
                        _context15.t0 = _context15["catch"](24);
                        console.error("Error syncing LocalDatastore: ", _context15.t0);
                        _this8.isSyncing = false;
                    case 39:
                    case "end":
                        return _context15.stop();
                }
            }, _callee8, null, [
                [
                    24,
                    35
                ]
            ]);
        }))();
    },
    getKeyForObject: function getKeyForObject(object) {
        var _context16, _context17;
        var objectId = object.objectId || object._getId();
        return (0, $06602e1f258d0b04$var$_concat.default)(_context16 = (0, $06602e1f258d0b04$var$_concat.default)(_context17 = "".concat($klpRA.OBJECT_PREFIX)).call(_context17, object.className, "_")).call(_context16, objectId);
    },
    getPinName: function getPinName(pinName) {
        if (!pinName || pinName === $klpRA.DEFAULT_PIN) return $klpRA.DEFAULT_PIN;
        return $klpRA.PIN_PREFIX + pinName;
    },
    checkIfEnabled: function checkIfEnabled() {
        if (!this.isEnabled) console.error("Parse.enableLocalDatastore() must be called first");
        return this.isEnabled;
    }
};
module.exports = $06602e1f258d0b04$var$LocalDatastore;

$06602e1f258d0b04$var$_CoreManager.default.setLocalDatastoreController((parcelRequire("e3Muo")));
$06602e1f258d0b04$var$_CoreManager.default.setLocalDatastore($06602e1f258d0b04$var$LocalDatastore);

});
parcelRequire.register("1fDhY", function(module, exports) {

module.exports = (parcelRequire("luWlP"));

});
parcelRequire.register("luWlP", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fa69a9a3405c626c$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = $fa69a9a3405c626c$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $fa69a9a3405c626c$var$runtime;
    else Function("r", "regeneratorRuntime = r")($fa69a9a3405c626c$var$runtime);
}

});


parcelRequire.register("a4Pit", function(module, exports) {

module.exports = (parcelRequire("3MfDS"));

});
parcelRequire.register("3MfDS", function(module, exports) {

var $lWhsD = parcelRequire("lWhsD");
parcelRequire("jXhxH");
module.exports = $lWhsD;

});
parcelRequire.register("lWhsD", function(module, exports) {
parcelRequire("5xrGR");
parcelRequire("iYyco");
parcelRequire("4YSU4");
parcelRequire("ja2zQ");

var $ly30u = parcelRequire("ly30u");
module.exports = $ly30u.Set;

});
parcelRequire.register("4YSU4", function(module, exports) {
// TODO: Remove this module from `core-js@4` since it's replaced to module below
parcelRequire("fAKHb");

});
parcelRequire.register("fAKHb", function(module, exports) {
"use strict";

var $30YqS = parcelRequire("30YqS");

var $1q3vw = parcelRequire("1q3vw");
// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
$30YqS("Set", function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $1q3vw);

});





parcelRequire.register("e3Muo", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $euZIZ = parcelRequire("euZIZ");

var $iG2ur = parcelRequire("iG2ur");

var $35NIM = parcelRequire("35NIM");

var $a1TrC = parcelRequire("a1TrC");

var $4wehD = parcelRequire("4wehD");


var $dQJQf = parcelRequire("dQJQf");

var $6iqUa = parcelRequire("6iqUa");

var $gW71a = parcelRequire("gW71a");

var $kOp5W = parcelRequire("kOp5W");

var $jQ6K5 = parcelRequire("jQ6K5");

var $4i3Tl = parcelRequire("4i3Tl");

var $iDZ3d = parcelRequire("iDZ3d");

var $a3c6f5769a56405c$var$_map = $iHLHC((parcelRequire("2VoQi")));

var $a3c6f5769a56405c$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $a3c6f5769a56405c$var$_reduce = $iHLHC((parcelRequire("juKR7")));

var $a3c6f5769a56405c$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $a3c6f5769a56405c$var$_asyncToGenerator2 = $iHLHC((parcelRequire("kkHAR")));

var $klpRA = parcelRequire("klpRA");

var $a3c6f5769a56405c$var$_Storage = $iHLHC((parcelRequire("7GXKV")));
function $a3c6f5769a56405c$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $iDZ3d !== "undefined" && $iG2ur(o) || o["@@iterator"];
    if (!it) {
        if ($euZIZ(o) || (it = $a3c6f5769a56405c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $a3c6f5769a56405c$var$_unsupportedIterableToArray(o, minLen) {
    var _context9;
    if (!o) return;
    if (typeof o === "string") return $a3c6f5769a56405c$var$_arrayLikeToArray(o, minLen);
    var n = $a1TrC(_context9 = Object.prototype.toString.call(o)).call(_context9, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $35NIM(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a3c6f5769a56405c$var$_arrayLikeToArray(o, minLen);
}
function $a3c6f5769a56405c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a3c6f5769a56405c$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $a3c6f5769a56405c$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $iDZ3d ? $iDZ3d : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $4i3Tl(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $jQ6K5(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $kOp5W, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $jQ6K5(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context7;
        $gW71a(_context7 = [
            "next",
            "throw",
            "return"
        ]).call(_context7, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $6iqUa(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], $gW71a(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return $dQJQf ? $dQJQf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $jQ6K5(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("iH0WI")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $4wehD(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context8;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, $gW71a(_context8 = this.tryEntries).call(_context8, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$a1TrC(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
var $a3c6f5769a56405c$var$LocalDatastoreController = {
    fromPinWithName: function(name) /*: Array<Object>*/ {
        return (0, $a3c6f5769a56405c$var$_asyncToGenerator2.default)(/*#__PURE__*/ $a3c6f5769a56405c$var$_regeneratorRuntime().mark(function _callee() {
            var values, objects;
            return $a3c6f5769a56405c$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return $a3c6f5769a56405c$var$_Storage.default.getItemAsync(name);
                    case 2:
                        values = _context.sent;
                        if (values) {
                            _context.next = 5;
                            break;
                        }
                        return _context.abrupt("return", []);
                    case 5:
                        objects = JSON.parse(values);
                        return _context.abrupt("return", objects);
                    case 7:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }))();
    },
    pinWithName: function pinWithName(name, value) {
        var values = (0, $a3c6f5769a56405c$var$_stringify.default)(value);
        return $a3c6f5769a56405c$var$_Storage.default.setItemAsync(name, values);
    },
    unPinWithName: function unPinWithName(name) {
        return $a3c6f5769a56405c$var$_Storage.default.removeItemAsync(name);
    },
    getAllContents: function getAllContents() /*: Object*/ {
        return (0, $a3c6f5769a56405c$var$_asyncToGenerator2.default)(/*#__PURE__*/ $a3c6f5769a56405c$var$_regeneratorRuntime().mark(function _callee3() {
            var keys;
            return $a3c6f5769a56405c$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _context3.next = 2;
                        return $a3c6f5769a56405c$var$_Storage.default.getAllKeysAsync();
                    case 2:
                        keys = _context3.sent;
                        return _context3.abrupt("return", (0, $a3c6f5769a56405c$var$_reduce.default)(keys).call(keys, /*#__PURE__*/ function() {
                            var _ref = (0, $a3c6f5769a56405c$var$_asyncToGenerator2.default)(/*#__PURE__*/ $a3c6f5769a56405c$var$_regeneratorRuntime().mark(function _callee2(previousPromise, key) {
                                var LDS, value;
                                return $a3c6f5769a56405c$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            _context2.next = 2;
                                            return previousPromise;
                                        case 2:
                                            LDS = _context2.sent;
                                            if (!(0, $klpRA.isLocalDatastoreKey)(key)) {
                                                _context2.next = 8;
                                                break;
                                            }
                                            _context2.next = 6;
                                            return $a3c6f5769a56405c$var$_Storage.default.getItemAsync(key);
                                        case 6:
                                            value = _context2.sent;
                                            try {
                                                LDS[key] = JSON.parse(value);
                                            } catch (error) {
                                                console.error("Error getAllContents: ", error);
                                            }
                                        case 8:
                                            return _context2.abrupt("return", LDS);
                                        case 9:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2);
                            }));
                            return function(_x, _x2) {
                                return _ref.apply(this, arguments);
                            };
                        }(), $a3c6f5769a56405c$var$_promise.default.resolve({})));
                    case 4:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }))();
    },
    // Used for testing
    getRawStorage: function getRawStorage() /*: Object*/ {
        return (0, $a3c6f5769a56405c$var$_asyncToGenerator2.default)(/*#__PURE__*/ $a3c6f5769a56405c$var$_regeneratorRuntime().mark(function _callee5() {
            var keys;
            return $a3c6f5769a56405c$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                while(true)switch(_context5.prev = _context5.next){
                    case 0:
                        _context5.next = 2;
                        return $a3c6f5769a56405c$var$_Storage.default.getAllKeysAsync();
                    case 2:
                        keys = _context5.sent;
                        return _context5.abrupt("return", (0, $a3c6f5769a56405c$var$_reduce.default)(keys).call(keys, /*#__PURE__*/ function() {
                            var _ref2 = (0, $a3c6f5769a56405c$var$_asyncToGenerator2.default)(/*#__PURE__*/ $a3c6f5769a56405c$var$_regeneratorRuntime().mark(function _callee4(previousPromise, key) {
                                var LDS, value;
                                return $a3c6f5769a56405c$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                                    while(true)switch(_context4.prev = _context4.next){
                                        case 0:
                                            _context4.next = 2;
                                            return previousPromise;
                                        case 2:
                                            LDS = _context4.sent;
                                            _context4.next = 5;
                                            return $a3c6f5769a56405c$var$_Storage.default.getItemAsync(key);
                                        case 5:
                                            value = _context4.sent;
                                            LDS[key] = value;
                                            return _context4.abrupt("return", LDS);
                                        case 8:
                                        case "end":
                                            return _context4.stop();
                                    }
                                }, _callee4);
                            }));
                            return function(_x3, _x4) {
                                return _ref2.apply(this, arguments);
                            };
                        }(), $a3c6f5769a56405c$var$_promise.default.resolve({})));
                    case 4:
                    case "end":
                        return _context5.stop();
                }
            }, _callee5);
        }))();
    },
    clear: function clear() /*: Promise*/ {
        var _this = this;
        return (0, $a3c6f5769a56405c$var$_asyncToGenerator2.default)(/*#__PURE__*/ $a3c6f5769a56405c$var$_regeneratorRuntime().mark(function _callee6() {
            var keys, toRemove, _iterator, _step, key, promises;
            return $a3c6f5769a56405c$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        _context6.next = 2;
                        return $a3c6f5769a56405c$var$_Storage.default.getAllKeysAsync();
                    case 2:
                        keys = _context6.sent;
                        toRemove = [];
                        _iterator = $a3c6f5769a56405c$var$_createForOfIteratorHelper(keys);
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                key = _step.value;
                                if ((0, $klpRA.isLocalDatastoreKey)(key)) toRemove.push(key);
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                        promises = (0, $a3c6f5769a56405c$var$_map.default)(toRemove).call(toRemove, _this.unPinWithName);
                        return _context6.abrupt("return", $a3c6f5769a56405c$var$_promise.default.all(promises));
                    case 8:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6);
        }))();
    }
};
module.exports = $a3c6f5769a56405c$var$LocalDatastoreController;

});
parcelRequire.register("juKR7", function(module, exports) {

module.exports = (parcelRequire("fS0Mn"));

});
parcelRequire.register("fS0Mn", function(module, exports) {

var $esgII = parcelRequire("esgII");
module.exports = $esgII;

});
parcelRequire.register("esgII", function(module, exports) {

var $8hsAO = parcelRequire("8hsAO");

var $lwUuh = parcelRequire("lwUuh");
var $a860a680aeb007a8$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    var own = it.reduce;
    return it === $a860a680aeb007a8$var$ArrayPrototype || $8hsAO($a860a680aeb007a8$var$ArrayPrototype, it) && own === $a860a680aeb007a8$var$ArrayPrototype.reduce ? $lwUuh : own;
};

});
parcelRequire.register("lwUuh", function(module, exports) {
parcelRequire("fYgah");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").reduce;

});
parcelRequire.register("fYgah", function(module, exports) {
"use strict";

var $ggcsv = parcelRequire("ggcsv");

var $58e8C = parcelRequire("58e8C");
var $ba08ff9d98725f1d$require$$reduce = $58e8C.left;

var $kQPJO = parcelRequire("kQPJO");

var $1MzR6 = parcelRequire("1MzR6");

var $4jpM3 = parcelRequire("4jpM3");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $ba08ff9d98725f1d$var$CHROME_BUG = !$4jpM3 && $1MzR6 > 79 && $1MzR6 < 83;
var $ba08ff9d98725f1d$var$FORCED = $ba08ff9d98725f1d$var$CHROME_BUG || !$kQPJO("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$ggcsv({
    target: "Array",
    proto: true,
    forced: $ba08ff9d98725f1d$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $ba08ff9d98725f1d$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});

});
parcelRequire.register("58e8C", function(module, exports) {

var $8GsPx = parcelRequire("8GsPx");

var $iJNxK = parcelRequire("iJNxK");

var $lEtn3 = parcelRequire("lEtn3");

var $6ocdr = parcelRequire("6ocdr");
var $3bc8aa9cdc885836$var$$TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $3bc8aa9cdc885836$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $8GsPx(callbackfn);
        var O = $iJNxK(that);
        var self = $lEtn3(O);
        var length = $6ocdr(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $3bc8aa9cdc885836$var$$TypeError("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
module.exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $3bc8aa9cdc885836$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $3bc8aa9cdc885836$var$createMethod(true)
};

});








parcelRequire.register("3Jcx2", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.getPushStatus = $2b6f4ba7aa35a323$var$getPushStatus;
module.exports.send = $2b6f4ba7aa35a323$var$send;

var $2b6f4ba7aa35a323$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $2b6f4ba7aa35a323$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $2b6f4ba7aa35a323$var$_ParseQuery = $iHLHC((parcelRequire("4FVCr")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ /**
 * Contains functions to deal with Push in Parse.
 *
 * @class Parse.Push
 * @static
 * @hideconstructor
 */ /**
 * Sends a push notification.
 * **Available in Cloud Code only.**
 *
 * See {@link https://docs.parseplatform.org/js/guide/#push-notifications Push Notification Guide}
 *
 * @function send
 * @name Parse.Push.send
 * @param {object} data -  The data of the push notification. Valid fields
 * are:
 *   <ol>
 *     <li>channels - An Array of channels to push to.</li>
 *     <li>push_time - A Date object for when to send the push.</li>
 *     <li>expiration_time -  A Date object for when to expire
 *         the push.</li>
 *     <li>expiration_interval - The seconds from now to expire the push.</li>
 *     <li>where - A Parse.Query over Parse.Installation that is used to match
 *         a set of installations to push to.</li>
 *     <li>data - The data to send as part of the push.</li>
 *   <ol>
 * @param {object} options Valid options
 * are:<ul>
 *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
 *     be used for this request.
 * </ul>
 * @returns {Promise} A promise that is fulfilled when the push request
 *     completes.
 */ function $2b6f4ba7aa35a323$var$send(data) /*: Promise*/ {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (data.where && data.where instanceof $2b6f4ba7aa35a323$var$_ParseQuery.default) data.where = data.where.toJSON().where;
    if (data.push_time && (0, $2b6f4ba7aa35a323$var$_typeof2.default)(data.push_time) === "object") data.push_time = data.push_time.toJSON();
    if (data.expiration_time && (0, $2b6f4ba7aa35a323$var$_typeof2.default)(data.expiration_time) === "object") data.expiration_time = data.expiration_time.toJSON();
    if (data.expiration_time && data.expiration_interval) throw new Error("expiration_time and expiration_interval cannot both be set.");
    var pushOptions = {
        useMasterKey: true
    };
    if (options.hasOwnProperty("useMasterKey")) pushOptions.useMasterKey = options.useMasterKey;
    return $2b6f4ba7aa35a323$var$_CoreManager.default.getPushController().send(data, pushOptions);
}
/**
 * Gets push status by Id
 *
 * @function getPushStatus
 * @name Parse.Push.getPushStatus
 * @param {string} pushStatusId The Id of Push Status.
 * @param {object} options Valid options
 * are:<ul>
 *   <li>useMasterKey: In Cloud Code and Node only, causes the Master Key to
 *     be used for this request.
 * </ul>
 * @returns {Parse.Object} Status of Push.
 */ function $2b6f4ba7aa35a323$var$getPushStatus(pushStatusId) /*: Promise<string>*/ {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var pushOptions = {
        useMasterKey: true
    };
    if (options.hasOwnProperty("useMasterKey")) pushOptions.useMasterKey = options.useMasterKey;
    var query = new $2b6f4ba7aa35a323$var$_ParseQuery.default("_PushStatus");
    return query.get(pushStatusId, pushOptions);
}
var $2b6f4ba7aa35a323$var$DefaultController = {
    send: function(data, options) {
        return $2b6f4ba7aa35a323$var$_CoreManager.default.getRESTController().request("POST", "push", data, options);
    }
};
$2b6f4ba7aa35a323$var$_CoreManager.default.setPushController($2b6f4ba7aa35a323$var$DefaultController);

});

parcelRequire.register("9xpH4", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f1b205d05a5e925$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $6f1b205d05a5e925$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $6f1b205d05a5e925$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $6f1b205d05a5e925$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $6f1b205d05a5e925$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $6f1b205d05a5e925$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $6f1b205d05a5e925$var$_ParseCLP = $iHLHC((parcelRequire("hnFLk")));
/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */ var $6f1b205d05a5e925$var$FIELD_TYPES = [
    "String",
    "Number",
    "Boolean",
    "Date",
    "File",
    "GeoPoint",
    "Polygon",
    "Array",
    "Object",
    "Pointer",
    "Relation"
];
/*:: type FieldOptions = {
  required: boolean,
  defaultValue: mixed,
};*/ /**
 * A Parse.Schema object is for handling schema data from Parse.
 * <p>All the schemas methods require MasterKey.
 *
 * When adding fields, you may set required and default values. (Requires Parse Server 3.7.0+)
 *
 * <pre>
 * const options = { required: true, defaultValue: 'hello world' };
 * const schema = new Parse.Schema('MyClass');
 * schema.addString('field', options);
 * schema.addIndex('index_name', { 'field': 1 });
 * schema.save();
 * </pre>
 * </p>
 *
 * @alias Parse.Schema
 */ var $6f1b205d05a5e925$var$ParseSchema = /*#__PURE__*/ function() {
    /**
   * @param {string} className Parse Class string.
   */ function ParseSchema(className) {
        (0, $6f1b205d05a5e925$var$_classCallCheck2.default)(this, ParseSchema);
        (0, $6f1b205d05a5e925$var$_defineProperty2.default)(this, "className", void 0);
        (0, $6f1b205d05a5e925$var$_defineProperty2.default)(this, "_fields", void 0);
        (0, $6f1b205d05a5e925$var$_defineProperty2.default)(this, "_indexes", void 0);
        (0, $6f1b205d05a5e925$var$_defineProperty2.default)(this, "_clp", void 0);
        if (typeof className === "string") {
            if (className === "User" && $6f1b205d05a5e925$var$_CoreManager.default.get("PERFORM_USER_REWRITE")) this.className = "_User";
            else this.className = className;
        }
        this._fields = {};
        this._indexes = {};
    }
    /**
   * Static method to get all schemas
   *
   * @returns {Promise} A promise that is resolved with the result when
   * the query completes.
   */ (0, $6f1b205d05a5e925$var$_createClass2.default)(ParseSchema, [
        {
            key: "get",
            value: /**
     * Get the Schema from Parse
     *
     * @returns {Promise} A promise that is resolved with the result when
     * the query completes.
     */ function() {
                this.assertClassName();
                var controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
                return controller.get(this.className).then(function(response) {
                    if (!response) throw new Error("Schema not found.");
                    return response;
                });
            }
        },
        {
            key: "save",
            value: function() {
                this.assertClassName();
                var controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
                var params = {
                    className: this.className,
                    fields: this._fields,
                    indexes: this._indexes,
                    classLevelPermissions: this._clp
                };
                return controller.create(this.className, params);
            }
        },
        {
            key: "update",
            value: function() {
                this.assertClassName();
                var controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
                var params = {
                    className: this.className,
                    fields: this._fields,
                    indexes: this._indexes,
                    classLevelPermissions: this._clp
                };
                this._fields = {};
                this._indexes = {};
                return controller.update(this.className, params);
            }
        },
        {
            key: "delete",
            value: function() {
                this.assertClassName();
                var controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
                return controller.delete(this.className);
            }
        },
        {
            key: "purge",
            value: function() {
                this.assertClassName();
                var controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
                return controller.purge(this.className);
            }
        },
        {
            key: "assertClassName",
            value: function() {
                if (!this.className) throw new Error("You must set a Class Name before making any request.");
            }
        },
        {
            key: "setCLP",
            value: function(clp) {
                if (clp instanceof $6f1b205d05a5e925$var$_ParseCLP.default) this._clp = clp.toJSON();
                else this._clp = clp;
                return this;
            }
        },
        {
            key: "addField",
            value: function(name, type) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                type = type || "String";
                if (!name) throw new Error("field name may not be null.");
                if ((0, $6f1b205d05a5e925$var$_indexOf.default)($6f1b205d05a5e925$var$FIELD_TYPES).call($6f1b205d05a5e925$var$FIELD_TYPES, type) === -1) throw new Error("".concat(type, " is not a valid type."));
                if (type === "Pointer") return this.addPointer(name, options.targetClass, options);
                if (type === "Relation") return this.addRelation(name, options.targetClass, options);
                var fieldOptions = {
                    type: type
                };
                if (typeof options.required === "boolean") fieldOptions.required = options.required;
                if (options.defaultValue !== undefined) fieldOptions.defaultValue = options.defaultValue;
                if (type === "Date") {
                    if (options && options.defaultValue) fieldOptions.defaultValue = {
                        __type: "Date",
                        iso: new Date(options.defaultValue)
                    };
                }
                this._fields[name] = fieldOptions;
                return this;
            }
        },
        {
            key: "addIndex",
            value: function(name, index) {
                if (!name) throw new Error("index name may not be null.");
                if (!index) throw new Error("index may not be null.");
                this._indexes[name] = index;
                return this;
            }
        },
        {
            key: "addString",
            value: function(name, options) {
                return this.addField(name, "String", options);
            }
        },
        {
            key: "addNumber",
            value: function(name, options) {
                return this.addField(name, "Number", options);
            }
        },
        {
            key: "addBoolean",
            value: function(name, options) {
                return this.addField(name, "Boolean", options);
            }
        },
        {
            key: "addDate",
            value: function(name, options) {
                return this.addField(name, "Date", options);
            }
        },
        {
            key: "addFile",
            value: function(name, options) {
                return this.addField(name, "File", options);
            }
        },
        {
            key: "addGeoPoint",
            value: function(name, options) {
                return this.addField(name, "GeoPoint", options);
            }
        },
        {
            key: "addPolygon",
            value: function(name, options) {
                return this.addField(name, "Polygon", options);
            }
        },
        {
            key: "addArray",
            value: function(name, options) {
                return this.addField(name, "Array", options);
            }
        },
        {
            key: "addObject",
            value: function(name, options) {
                return this.addField(name, "Object", options);
            }
        },
        {
            key: "addPointer",
            value: function(name, targetClass) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                if (!name) throw new Error("field name may not be null.");
                if (!targetClass) throw new Error("You need to set the targetClass of the Pointer.");
                var fieldOptions = {
                    type: "Pointer",
                    targetClass: targetClass
                };
                if (typeof options.required === "boolean") fieldOptions.required = options.required;
                if (options.defaultValue !== undefined) {
                    fieldOptions.defaultValue = options.defaultValue;
                    if (options.defaultValue instanceof $6f1b205d05a5e925$var$_ParseObject.default) fieldOptions.defaultValue = options.defaultValue.toPointer();
                }
                this._fields[name] = fieldOptions;
                return this;
            }
        },
        {
            key: "addRelation",
            value: function(name, targetClass) {
                if (!name) throw new Error("field name may not be null.");
                if (!targetClass) throw new Error("You need to set the targetClass of the Relation.");
                this._fields[name] = {
                    type: "Relation",
                    targetClass: targetClass
                };
                return this;
            }
        },
        {
            key: "deleteField",
            value: function(name) {
                this._fields[name] = {
                    __op: "Delete"
                };
                return this;
            }
        },
        {
            key: "deleteIndex",
            value: function(name) {
                this._indexes[name] = {
                    __op: "Delete"
                };
                return this;
            }
        }
    ], [
        {
            key: "all",
            value: function() {
                var controller = $6f1b205d05a5e925$var$_CoreManager.default.getSchemaController();
                return controller.get("").then(function(response) {
                    if (response.results.length === 0) throw new Error("Schema not found.");
                    return response.results;
                });
            }
        }
    ]);
    return ParseSchema;
}();
var $6f1b205d05a5e925$var$DefaultController = {
    send: function(className, method) /*: Promise*/ {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var RESTController = $6f1b205d05a5e925$var$_CoreManager.default.getRESTController();
        return RESTController.request(method, "schemas/".concat(className), params, {
            useMasterKey: true
        });
    },
    get: function(className) /*: Promise*/ {
        return this.send(className, "GET");
    },
    create: function(className, params) /*: Promise*/ {
        return this.send(className, "POST", params);
    },
    update: function(className, params) /*: Promise*/ {
        return this.send(className, "PUT", params);
    },
    delete: function(className) /*: Promise*/ {
        return this.send(className, "DELETE");
    },
    purge: function(className) /*: Promise*/ {
        var RESTController = $6f1b205d05a5e925$var$_CoreManager.default.getRESTController();
        return RESTController.request("DELETE", "purge/".concat(className), {}, {
            useMasterKey: true
        });
    }
};
$6f1b205d05a5e925$var$_CoreManager.default.setSchemaController($6f1b205d05a5e925$var$DefaultController);
var $6f1b205d05a5e925$var$_default = $6f1b205d05a5e925$var$ParseSchema;
module.exports.default = $6f1b205d05a5e925$var$_default;

});

parcelRequire.register("heN8G", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $a1TrC = parcelRequire("a1TrC");

var $4wehD = parcelRequire("4wehD");


var $dQJQf = parcelRequire("dQJQf");

var $6iqUa = parcelRequire("6iqUa");

var $gW71a = parcelRequire("gW71a");

var $kOp5W = parcelRequire("kOp5W");

var $jQ6K5 = parcelRequire("jQ6K5");

var $4i3Tl = parcelRequire("4i3Tl");

var $iDZ3d = parcelRequire("iDZ3d");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c8c9dc7513081513$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $c8c9dc7513081513$var$_promise = $iHLHC((parcelRequire("iH0WI")));

var $c8c9dc7513081513$var$_slicedToArray2 = $iHLHC((parcelRequire("ccwCe")));

var $c8c9dc7513081513$var$_asyncToGenerator2 = $iHLHC((parcelRequire("kkHAR")));

var $c8c9dc7513081513$var$_EventEmitter = $iHLHC((parcelRequire("2GgHs")));

var $c8c9dc7513081513$var$_LiveQueryClient = $iHLHC((parcelRequire("b2fSd")));

var $c8c9dc7513081513$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));
function $c8c9dc7513081513$var$_regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ $c8c9dc7513081513$var$_regeneratorRuntime = function() {
        return exports1;
    };
    var exports1 = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof $iDZ3d ? $iDZ3d : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return $4i3Tl(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = $jQ6K5(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports1.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = $kOp5W, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = $jQ6K5(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        var _context4;
        $gW71a(_context4 = [
            "next",
            "throw",
            "return"
        ]).call(_context4, function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $6iqUa(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], $gW71a(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports1.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports1.mark = function(genFun) {
        return $dQJQf ? $dQJQf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = $jQ6K5(Gp), genFun;
    }, exports1.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports1.AsyncIterator = AsyncIterator, exports1.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = (parcelRequire("iH0WI")));
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports1.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports1.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return $4wehD(keys).call(keys), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports1.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            var _context5;
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, $gW71a(_context5 = this.tryEntries).call(_context5, resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+$a1TrC(name).call(name, 1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports1;
}
function $c8c9dc7513081513$var$getLiveQueryClient() /*: LiveQueryClient*/ {
    return $c8c9dc7513081513$var$_CoreManager.default.getLiveQueryController().getDefaultLiveQueryClient();
}
/**
 * We expose three events to help you monitor the status of the WebSocket connection:
 *
 * <p>Open - When we establish the WebSocket connection to the LiveQuery server, you'll get this event.
 *
 * <pre>
 * Parse.LiveQuery.on('open', () => {
 *
 * });</pre></p>
 *
 * <p>Close - When we lose the WebSocket connection to the LiveQuery server, you'll get this event.
 *
 * <pre>
 * Parse.LiveQuery.on('close', () => {
 *
 * });</pre></p>
 *
 * <p>Error - When some network error or LiveQuery server error happens, you'll get this event.
 *
 * <pre>
 * Parse.LiveQuery.on('error', (error) => {
 *
 * });</pre></p>
 *
 * @class Parse.LiveQuery
 * @static
 */ var $c8c9dc7513081513$var$LiveQuery = new $c8c9dc7513081513$var$_EventEmitter.default();
/**
 * After open is called, the LiveQuery will try to send a connect request
 * to the LiveQuery server.
 */ $c8c9dc7513081513$var$LiveQuery.open = /*#__PURE__*/ (0, $c8c9dc7513081513$var$_asyncToGenerator2.default)(/*#__PURE__*/ $c8c9dc7513081513$var$_regeneratorRuntime().mark(function _callee() {
    var liveQueryClient;
    return $c8c9dc7513081513$var$_regeneratorRuntime().wrap(function _callee$(_context) {
        while(true)switch(_context.prev = _context.next){
            case 0:
                _context.next = 2;
                return $c8c9dc7513081513$var$getLiveQueryClient();
            case 2:
                liveQueryClient = _context.sent;
                liveQueryClient.open();
            case 4:
            case "end":
                return _context.stop();
        }
    }, _callee);
}));
/**
 * When you're done using LiveQuery, you can call Parse.LiveQuery.close().
 * This function will close the WebSocket connection to the LiveQuery server,
 * cancel the auto reconnect, and unsubscribe all subscriptions based on it.
 * If you call query.subscribe() after this, we'll create a new WebSocket
 * connection to the LiveQuery server.
 */ $c8c9dc7513081513$var$LiveQuery.close = /*#__PURE__*/ (0, $c8c9dc7513081513$var$_asyncToGenerator2.default)(/*#__PURE__*/ $c8c9dc7513081513$var$_regeneratorRuntime().mark(function _callee2() {
    var liveQueryClient;
    return $c8c9dc7513081513$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                _context2.next = 2;
                return $c8c9dc7513081513$var$getLiveQueryClient();
            case 2:
                liveQueryClient = _context2.sent;
                liveQueryClient.close();
            case 4:
            case "end":
                return _context2.stop();
        }
    }, _callee2);
})); // Register a default onError callback to make sure we do not crash on error
$c8c9dc7513081513$var$LiveQuery.on("error", function() {});
var $c8c9dc7513081513$var$_default = $c8c9dc7513081513$var$LiveQuery;
module.exports.default = $c8c9dc7513081513$var$_default;
var $c8c9dc7513081513$var$defaultLiveQueryClient;
var $c8c9dc7513081513$var$DefaultLiveQueryController = {
    setDefaultLiveQueryClient: function setDefaultLiveQueryClient(liveQueryClient) {
        $c8c9dc7513081513$var$defaultLiveQueryClient = liveQueryClient;
    },
    getDefaultLiveQueryClient: function getDefaultLiveQueryClient() /*: Promise<LiveQueryClient>*/ {
        return (0, $c8c9dc7513081513$var$_asyncToGenerator2.default)(/*#__PURE__*/ $c8c9dc7513081513$var$_regeneratorRuntime().mark(function _callee3() {
            var _yield$Promise$all, _yield$Promise$all2, currentUser, installationId, sessionToken, liveQueryServerURL, serverURL, protocol, host, applicationId, javascriptKey, masterKey;
            return $c8c9dc7513081513$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        if (!$c8c9dc7513081513$var$defaultLiveQueryClient) {
                            _context3.next = 2;
                            break;
                        }
                        return _context3.abrupt("return", $c8c9dc7513081513$var$defaultLiveQueryClient);
                    case 2:
                        _context3.next = 4;
                        return $c8c9dc7513081513$var$_promise.default.all([
                            $c8c9dc7513081513$var$_CoreManager.default.getUserController().currentUserAsync(),
                            $c8c9dc7513081513$var$_CoreManager.default.getInstallationController().currentInstallationId()
                        ]);
                    case 4:
                        _yield$Promise$all = _context3.sent;
                        _yield$Promise$all2 = (0, $c8c9dc7513081513$var$_slicedToArray2.default)(_yield$Promise$all, 2);
                        currentUser = _yield$Promise$all2[0];
                        installationId = _yield$Promise$all2[1];
                        sessionToken = currentUser ? currentUser.getSessionToken() : undefined;
                        liveQueryServerURL = $c8c9dc7513081513$var$_CoreManager.default.get("LIVEQUERY_SERVER_URL");
                        if (!(liveQueryServerURL && (0, $c8c9dc7513081513$var$_indexOf.default)(liveQueryServerURL).call(liveQueryServerURL, "ws") !== 0)) {
                            _context3.next = 12;
                            break;
                        }
                        throw new Error("You need to set a proper Parse LiveQuery server url before using LiveQueryClient");
                    case 12:
                        // If we can not find Parse.liveQueryServerURL, we try to extract it from Parse.serverURL
                        if (!liveQueryServerURL) {
                            serverURL = $c8c9dc7513081513$var$_CoreManager.default.get("SERVER_URL");
                            protocol = (0, $c8c9dc7513081513$var$_indexOf.default)(serverURL).call(serverURL, "https") === 0 ? "wss://" : "ws://";
                            host = serverURL.replace(/^https?:\/\//, "");
                            liveQueryServerURL = protocol + host;
                            $c8c9dc7513081513$var$_CoreManager.default.set("LIVEQUERY_SERVER_URL", liveQueryServerURL);
                        }
                        applicationId = $c8c9dc7513081513$var$_CoreManager.default.get("APPLICATION_ID");
                        javascriptKey = $c8c9dc7513081513$var$_CoreManager.default.get("JAVASCRIPT_KEY");
                        masterKey = $c8c9dc7513081513$var$_CoreManager.default.get("MASTER_KEY");
                        $c8c9dc7513081513$var$defaultLiveQueryClient = new $c8c9dc7513081513$var$_LiveQueryClient.default({
                            applicationId: applicationId,
                            serverURL: liveQueryServerURL,
                            javascriptKey: javascriptKey,
                            masterKey: masterKey,
                            sessionToken: sessionToken,
                            installationId: installationId
                        });
                        $c8c9dc7513081513$var$defaultLiveQueryClient.on("error", function(error) {
                            $c8c9dc7513081513$var$LiveQuery.emit("error", error);
                        });
                        $c8c9dc7513081513$var$defaultLiveQueryClient.on("open", function() {
                            $c8c9dc7513081513$var$LiveQuery.emit("open");
                        });
                        $c8c9dc7513081513$var$defaultLiveQueryClient.on("close", function() {
                            $c8c9dc7513081513$var$LiveQuery.emit("close");
                        });
                        return _context3.abrupt("return", $c8c9dc7513081513$var$defaultLiveQueryClient);
                    case 21:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }))();
    },
    _clearCachedDefaultClient: function _clearCachedDefaultClient() {
        $c8c9dc7513081513$var$defaultLiveQueryClient = null;
    }
};
$c8c9dc7513081513$var$_CoreManager.default.setLiveQueryController($c8c9dc7513081513$var$DefaultLiveQueryController);

});
parcelRequire.register("2GgHs", function(module, exports) {
"use strict";

/**
 * Copyright (c) 2015-present, Parse, LLC.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * This is a simple wrapper to unify EventEmitter implementations across platforms.
 */ module.exports = (parcelRequire("jMc9N")).EventEmitter;
var $1f3c754b23a00446$var$EventEmitter;

});
parcelRequire.register("jMc9N", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $e65bee21a7cdc3da$var$R = typeof Reflect === "object" ? Reflect : null;
var $e65bee21a7cdc3da$var$ReflectApply = $e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.apply === "function" ? $e65bee21a7cdc3da$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $e65bee21a7cdc3da$var$ReflectOwnKeys;
if ($e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.ownKeys === "function") $e65bee21a7cdc3da$var$ReflectOwnKeys = $e65bee21a7cdc3da$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $e65bee21a7cdc3da$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $e65bee21a7cdc3da$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $e65bee21a7cdc3da$var$EventEmitter() {
    $e65bee21a7cdc3da$var$EventEmitter.init.call(this);
}
module.exports = $e65bee21a7cdc3da$var$EventEmitter;
module.exports.once = $e65bee21a7cdc3da$var$once;
// Backwards-compat with node 0.10.x
$e65bee21a7cdc3da$var$EventEmitter.EventEmitter = $e65bee21a7cdc3da$var$EventEmitter;
$e65bee21a7cdc3da$var$EventEmitter.prototype._events = undefined;
$e65bee21a7cdc3da$var$EventEmitter.prototype._eventsCount = 0;
$e65bee21a7cdc3da$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $e65bee21a7cdc3da$var$defaultMaxListeners = 10;
function $e65bee21a7cdc3da$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($e65bee21a7cdc3da$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $e65bee21a7cdc3da$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $e65bee21a7cdc3da$var$defaultMaxListeners = arg;
    }
});
$e65bee21a7cdc3da$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$e65bee21a7cdc3da$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $e65bee21a7cdc3da$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $e65bee21a7cdc3da$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $e65bee21a7cdc3da$var$_getMaxListeners(this);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $e65bee21a7cdc3da$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $e65bee21a7cdc3da$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$e65bee21a7cdc3da$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $e65bee21a7cdc3da$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $e65bee21a7cdc3da$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $e65bee21a7cdc3da$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, false);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.on = $e65bee21a7cdc3da$var$EventEmitter.prototype.addListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, true);
};
function $e65bee21a7cdc3da$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $e65bee21a7cdc3da$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $e65bee21a7cdc3da$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.once = function once(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.on(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.prependListener(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $e65bee21a7cdc3da$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.off = $e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $e65bee21a7cdc3da$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $e65bee21a7cdc3da$var$unwrapListeners(evlistener) : $e65bee21a7cdc3da$var$arrayClone(evlistener, evlistener.length);
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, true);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, false);
};
$e65bee21a7cdc3da$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $e65bee21a7cdc3da$var$listenerCount.call(emitter, type);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.listenerCount = $e65bee21a7cdc3da$var$listenerCount;
function $e65bee21a7cdc3da$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $e65bee21a7cdc3da$var$ReflectOwnKeys(this._events) : [];
};
function $e65bee21a7cdc3da$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $e65bee21a7cdc3da$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $e65bee21a7cdc3da$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $e65bee21a7cdc3da$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRequire.register("b2fSd", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");

var $euZIZ = parcelRequire("euZIZ");

var $iG2ur = parcelRequire("iG2ur");

var $iDZ3d = parcelRequire("iDZ3d");

var $35NIM = parcelRequire("35NIM");

var $a1TrC = parcelRequire("a1TrC");

var $oM1qX = parcelRequire("oM1qX");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $808c31c11c66dd58$var$_typeof2 = $iHLHC((parcelRequire("6iqUa")));

var $808c31c11c66dd58$var$_bind = $iHLHC((parcelRequire("h3iZF")));

var $808c31c11c66dd58$var$_setTimeout2 = $iHLHC((parcelRequire("3Poce")));

var $808c31c11c66dd58$var$_values = $iHLHC((parcelRequire("34k5C")));

var $808c31c11c66dd58$var$_forEach = $iHLHC((parcelRequire("gW71a")));

var $808c31c11c66dd58$var$_stringify = $iHLHC((parcelRequire("4qY0x")));

var $808c31c11c66dd58$var$_keys = $iHLHC((parcelRequire("e9nT0")));

var $808c31c11c66dd58$var$_map = $iHLHC((parcelRequire("2ETAR")));

var $808c31c11c66dd58$var$_indexOf = $iHLHC((parcelRequire("9l1BE")));

var $808c31c11c66dd58$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $808c31c11c66dd58$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $808c31c11c66dd58$var$_assertThisInitialized2 = $iHLHC((parcelRequire("ePpfW")));

var $808c31c11c66dd58$var$_inherits2 = $iHLHC((parcelRequire("cNDsY")));

var $808c31c11c66dd58$var$_possibleConstructorReturn2 = $iHLHC((parcelRequire("1C8Dw")));

var $808c31c11c66dd58$var$_getPrototypeOf2 = $iHLHC((parcelRequire("kptbe")));

var $808c31c11c66dd58$var$_defineProperty2 = $iHLHC((parcelRequire("4cByw")));

var $808c31c11c66dd58$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $808c31c11c66dd58$var$_EventEmitter2 = $iHLHC((parcelRequire("2GgHs")));

var $808c31c11c66dd58$var$_ParseObject = $iHLHC((parcelRequire("fMBjE")));

var $808c31c11c66dd58$var$_LiveQuerySubscription = $iHLHC((parcelRequire("kuTrw")));

var $9FsFR = parcelRequire("9FsFR");
function $808c31c11c66dd58$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof $iDZ3d !== "undefined" && $iG2ur(o) || o["@@iterator"];
    if (!it) {
        if ($euZIZ(o) || (it = $808c31c11c66dd58$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $808c31c11c66dd58$var$_unsupportedIterableToArray(o, minLen) {
    var _context6;
    if (!o) return;
    if (typeof o === "string") return $808c31c11c66dd58$var$_arrayLikeToArray(o, minLen);
    var n = $a1TrC(_context6 = Object.prototype.toString.call(o)).call(_context6, 8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return $35NIM(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $808c31c11c66dd58$var$_arrayLikeToArray(o, minLen);
}
function $808c31c11c66dd58$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $808c31c11c66dd58$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $808c31c11c66dd58$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $808c31c11c66dd58$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $808c31c11c66dd58$var$_getPrototypeOf2.default)(this).constructor;
            result = $oM1qX(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $808c31c11c66dd58$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $808c31c11c66dd58$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$oM1qX) return false;
    if ($oM1qX.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($oM1qX(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
} // The LiveQuery client inner state
var $808c31c11c66dd58$var$CLIENT_STATE = {
    INITIALIZED: "initialized",
    CONNECTING: "connecting",
    CONNECTED: "connected",
    CLOSED: "closed",
    RECONNECTING: "reconnecting",
    DISCONNECTED: "disconnected"
}; // The event type the LiveQuery client should sent to server
var $808c31c11c66dd58$var$OP_TYPES = {
    CONNECT: "connect",
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
    ERROR: "error"
}; // The event we get back from LiveQuery server
var $808c31c11c66dd58$var$OP_EVENTS = {
    CONNECTED: "connected",
    SUBSCRIBED: "subscribed",
    UNSUBSCRIBED: "unsubscribed",
    ERROR: "error",
    CREATE: "create",
    UPDATE: "update",
    ENTER: "enter",
    LEAVE: "leave",
    DELETE: "delete"
}; // The event the LiveQuery client should emit
var $808c31c11c66dd58$var$CLIENT_EMMITER_TYPES = {
    CLOSE: "close",
    ERROR: "error",
    OPEN: "open"
}; // The event the LiveQuery subscription should emit
var $808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES = {
    OPEN: "open",
    CLOSE: "close",
    ERROR: "error",
    CREATE: "create",
    UPDATE: "update",
    ENTER: "enter",
    LEAVE: "leave",
    DELETE: "delete"
};
var $808c31c11c66dd58$var$generateInterval = function(k) {
    return Math.random() * Math.min(30, Math.pow(2, k) - 1) * 1000;
};
/**
 * Creates a new LiveQueryClient.
 * Extends events.EventEmitter
 * <a href="https://nodejs.org/api/events.html#events_class_eventemitter">cloud functions</a>.
 *
 * A wrapper of a standard WebSocket client. We add several useful methods to
 * help you connect/disconnect to LiveQueryServer, subscribe/unsubscribe a ParseQuery easily.
 *
 * javascriptKey and masterKey are used for verifying the LiveQueryClient when it tries
 * to connect to the LiveQuery server
 *
 * We expose three events to help you monitor the status of the LiveQueryClient.
 *
 * <pre>
 * let Parse = require('parse/node');
 * let LiveQueryClient = Parse.LiveQueryClient;
 * let client = new LiveQueryClient({
 *   applicationId: '',
 *   serverURL: '',
 *   javascriptKey: '',
 *   masterKey: ''
 *  });
 * </pre>
 *
 * Open - When we establish the WebSocket connection to the LiveQuery server, you'll get this event.
 * <pre>
 * client.on('open', () => {
 *
 * });</pre>
 *
 * Close - When we lose the WebSocket connection to the LiveQuery server, you'll get this event.
 * <pre>
 * client.on('close', () => {
 *
 * });</pre>
 *
 * Error - When some network error or LiveQuery server error happens, you'll get this event.
 * <pre>
 * client.on('error', (error) => {
 *
 * });</pre>
 *
 * @alias Parse.LiveQueryClient
 */ var $808c31c11c66dd58$var$LiveQueryClient = /*#__PURE__*/ function(_EventEmitter) {
    (0, $808c31c11c66dd58$var$_inherits2.default)(LiveQueryClient, _EventEmitter);
    var _super = $808c31c11c66dd58$var$_createSuper(LiveQueryClient);
    /**
   * @param {object} options
   * @param {string} options.applicationId - applicationId of your Parse app
   * @param {string} options.serverURL - <b>the URL of your LiveQuery server</b>
   * @param {string} options.javascriptKey (optional)
   * @param {string} options.masterKey (optional) Your Parse Master Key. (Node.js only!)
   * @param {string} options.sessionToken (optional)
   * @param {string} options.installationId (optional)
   */ function LiveQueryClient(_ref) {
        var _this;
        var applicationId = _ref.applicationId, serverURL = _ref.serverURL, javascriptKey = _ref.javascriptKey, masterKey = _ref.masterKey, sessionToken = _ref.sessionToken, installationId = _ref.installationId;
        (0, $808c31c11c66dd58$var$_classCallCheck2.default)(this, LiveQueryClient);
        _this = _super.call(this);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "attempts", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "id", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "requestId", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "applicationId", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "serverURL", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "javascriptKey", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "masterKey", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "sessionToken", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "installationId", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "additionalProperties", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "connectPromise", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "subscriptions", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "socket", void 0);
        (0, $808c31c11c66dd58$var$_defineProperty2.default)((0, $808c31c11c66dd58$var$_assertThisInitialized2.default)(_this), "state", void 0);
        if (!serverURL || (0, $808c31c11c66dd58$var$_indexOf.default)(serverURL).call(serverURL, "ws") !== 0) throw new Error("You need to set a proper Parse LiveQuery server url before using LiveQueryClient");
        _this.reconnectHandle = null;
        _this.attempts = 1;
        _this.id = 0;
        _this.requestId = 1;
        _this.serverURL = serverURL;
        _this.applicationId = applicationId;
        _this.javascriptKey = javascriptKey || undefined;
        _this.masterKey = masterKey || undefined;
        _this.sessionToken = sessionToken || undefined;
        _this.installationId = installationId || undefined;
        _this.additionalProperties = true;
        _this.connectPromise = (0, $9FsFR.resolvingPromise)();
        _this.subscriptions = new $808c31c11c66dd58$var$_map.default();
        _this.state = $808c31c11c66dd58$var$CLIENT_STATE.INITIALIZED; // adding listener so process does not crash
        // best practice is for developer to register their own listener
        _this.on("error", function() {});
        return _this;
    }
    (0, $808c31c11c66dd58$var$_createClass2.default)(LiveQueryClient, [
        {
            key: "shouldOpen",
            value: function() /*: any*/ {
                return this.state === $808c31c11c66dd58$var$CLIENT_STATE.INITIALIZED || this.state === $808c31c11c66dd58$var$CLIENT_STATE.DISCONNECTED;
            }
        },
        {
            key: "subscribe",
            value: function(query, sessionToken) /*: LiveQuerySubscription*/ {
                var _this2 = this;
                if (!query) return;
                var className = query.className;
                var queryJSON = query.toJSON();
                var where = queryJSON.where;
                var fields = (0, $808c31c11c66dd58$var$_keys.default)(queryJSON) ? (0, $808c31c11c66dd58$var$_keys.default)(queryJSON).split(",") : undefined;
                var subscribeRequest = {
                    op: $808c31c11c66dd58$var$OP_TYPES.SUBSCRIBE,
                    requestId: this.requestId,
                    query: {
                        className: className,
                        where: where,
                        fields: fields
                    }
                };
                if (sessionToken) subscribeRequest.sessionToken = sessionToken;
                var subscription = new $808c31c11c66dd58$var$_LiveQuerySubscription.default(this.requestId, query, sessionToken);
                this.subscriptions.set(this.requestId, subscription);
                this.requestId += 1;
                this.connectPromise.then(function() {
                    _this2.socket.send((0, $808c31c11c66dd58$var$_stringify.default)(subscribeRequest));
                });
                return subscription;
            }
        },
        {
            key: "unsubscribe",
            value: function(subscription) {
                var _this3 = this;
                if (!subscription) return;
                this.subscriptions.delete(subscription.id);
                var unsubscribeRequest = {
                    op: $808c31c11c66dd58$var$OP_TYPES.UNSUBSCRIBE,
                    requestId: subscription.id
                };
                this.connectPromise.then(function() {
                    _this3.socket.send((0, $808c31c11c66dd58$var$_stringify.default)(unsubscribeRequest));
                });
            }
        },
        {
            key: "open",
            value: function() {
                var _this4 = this;
                var WebSocketImplementation = $808c31c11c66dd58$var$_CoreManager.default.getWebSocketController();
                if (!WebSocketImplementation) {
                    this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.ERROR, "Can not find WebSocket implementation");
                    return;
                }
                if (this.state !== $808c31c11c66dd58$var$CLIENT_STATE.RECONNECTING) this.state = $808c31c11c66dd58$var$CLIENT_STATE.CONNECTING;
                this.socket = new WebSocketImplementation(this.serverURL); // Bind WebSocket callbacks
                this.socket.onopen = function() {
                    _this4._handleWebSocketOpen();
                };
                this.socket.onmessage = function(event) {
                    _this4._handleWebSocketMessage(event);
                };
                this.socket.onclose = function() {
                    _this4._handleWebSocketClose();
                };
                this.socket.onerror = function(error) {
                    _this4._handleWebSocketError(error);
                };
            }
        },
        {
            key: "resubscribe",
            value: function() {
                var _context, _this5 = this;
                (0, $808c31c11c66dd58$var$_forEach.default)(_context = this.subscriptions).call(_context, function(subscription, requestId) {
                    var query = subscription.query;
                    var queryJSON = query.toJSON();
                    var where = queryJSON.where;
                    var fields = (0, $808c31c11c66dd58$var$_keys.default)(queryJSON) ? (0, $808c31c11c66dd58$var$_keys.default)(queryJSON).split(",") : undefined;
                    var className = query.className;
                    var sessionToken = subscription.sessionToken;
                    var subscribeRequest = {
                        op: $808c31c11c66dd58$var$OP_TYPES.SUBSCRIBE,
                        requestId: requestId,
                        query: {
                            className: className,
                            where: where,
                            fields: fields
                        }
                    };
                    if (sessionToken) subscribeRequest.sessionToken = sessionToken;
                    _this5.connectPromise.then(function() {
                        _this5.socket.send((0, $808c31c11c66dd58$var$_stringify.default)(subscribeRequest));
                    });
                });
            }
        },
        {
            key: "close",
            value: function() {
                var _context2;
                if (this.state === $808c31c11c66dd58$var$CLIENT_STATE.INITIALIZED || this.state === $808c31c11c66dd58$var$CLIENT_STATE.DISCONNECTED) return;
                this.state = $808c31c11c66dd58$var$CLIENT_STATE.DISCONNECTED;
                this.socket.close(); // Notify each subscription about the close
                var _iterator = $808c31c11c66dd58$var$_createForOfIteratorHelper((0, $808c31c11c66dd58$var$_values.default)(_context2 = this.subscriptions).call(_context2)), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var subscription = _step.value;
                        subscription.subscribed = false;
                        subscription.emit($808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES.CLOSE);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                this._handleReset();
                this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.CLOSE);
            } // ensure we start with valid state if connect is called again after close
        },
        {
            key: "_handleReset",
            value: function() {
                this.attempts = 1;
                this.id = 0;
                this.requestId = 1;
                this.connectPromise = (0, $9FsFR.resolvingPromise)();
                this.subscriptions = new $808c31c11c66dd58$var$_map.default();
            }
        },
        {
            key: "_handleWebSocketOpen",
            value: function() {
                this.attempts = 1;
                var connectRequest = {
                    op: $808c31c11c66dd58$var$OP_TYPES.CONNECT,
                    applicationId: this.applicationId,
                    javascriptKey: this.javascriptKey,
                    masterKey: this.masterKey,
                    sessionToken: this.sessionToken
                };
                if (this.additionalProperties) connectRequest.installationId = this.installationId;
                this.socket.send((0, $808c31c11c66dd58$var$_stringify.default)(connectRequest));
            }
        },
        {
            key: "_handleWebSocketMessage",
            value: function(event) {
                var data = event.data;
                if (typeof data === "string") data = JSON.parse(data);
                var subscription = null;
                if (data.requestId) subscription = this.subscriptions.get(data.requestId);
                var response = {
                    clientId: data.clientId,
                    installationId: data.installationId
                };
                switch(data.op){
                    case $808c31c11c66dd58$var$OP_EVENTS.CONNECTED:
                        if (this.state === $808c31c11c66dd58$var$CLIENT_STATE.RECONNECTING) this.resubscribe();
                        this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.OPEN);
                        this.id = data.clientId;
                        this.connectPromise.resolve();
                        this.state = $808c31c11c66dd58$var$CLIENT_STATE.CONNECTED;
                        break;
                    case $808c31c11c66dd58$var$OP_EVENTS.SUBSCRIBED:
                        if (subscription) {
                            subscription.subscribed = true;
                            subscription.subscribePromise.resolve();
                            (0, $808c31c11c66dd58$var$_setTimeout2.default)(function() {
                                return subscription.emit($808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES.OPEN, response);
                            }, 200);
                        }
                        break;
                    case $808c31c11c66dd58$var$OP_EVENTS.ERROR:
                        if (data.requestId) {
                            if (subscription) {
                                subscription.subscribePromise.resolve();
                                (0, $808c31c11c66dd58$var$_setTimeout2.default)(function() {
                                    return subscription.emit($808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES.ERROR, data.error);
                                }, 200);
                            }
                        } else this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.ERROR, data.error);
                        if (data.error === "Additional properties not allowed") this.additionalProperties = false;
                        if (data.reconnect) this._handleReconnect();
                        break;
                    case $808c31c11c66dd58$var$OP_EVENTS.UNSUBSCRIBED:
                        break;
                    default:
                        // create, update, enter, leave, delete cases
                        if (!subscription) break;
                        var override = false;
                        if (data.original) {
                            override = true;
                            delete data.original.__type; // Check for removed fields
                            for(var field in data.original)if (!(field in data.object)) data.object[field] = undefined;
                            data.original = $808c31c11c66dd58$var$_ParseObject.default.fromJSON(data.original, false);
                        }
                        delete data.object.__type;
                        var parseObject = $808c31c11c66dd58$var$_ParseObject.default.fromJSON(data.object, !(subscription.query && subscription.query._select) ? override : false);
                        if (data.original) subscription.emit(data.op, parseObject, data.original, response);
                        else subscription.emit(data.op, parseObject, response);
                        var localDatastore = $808c31c11c66dd58$var$_CoreManager.default.getLocalDatastore();
                        if (override && localDatastore.isEnabled) localDatastore._updateObjectIfPinned(parseObject).then(function() {});
                }
            }
        },
        {
            key: "_handleWebSocketClose",
            value: function() {
                var _context3;
                if (this.state === $808c31c11c66dd58$var$CLIENT_STATE.DISCONNECTED) return;
                this.state = $808c31c11c66dd58$var$CLIENT_STATE.CLOSED;
                this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.CLOSE); // Notify each subscription about the close
                var _iterator2 = $808c31c11c66dd58$var$_createForOfIteratorHelper((0, $808c31c11c66dd58$var$_values.default)(_context3 = this.subscriptions).call(_context3)), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var subscription = _step2.value;
                        subscription.emit($808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES.CLOSE);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                this._handleReconnect();
            }
        },
        {
            key: "_handleWebSocketError",
            value: function(error) {
                var _context4;
                this.emit($808c31c11c66dd58$var$CLIENT_EMMITER_TYPES.ERROR, error);
                var _iterator3 = $808c31c11c66dd58$var$_createForOfIteratorHelper((0, $808c31c11c66dd58$var$_values.default)(_context4 = this.subscriptions).call(_context4)), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var subscription = _step3.value;
                        subscription.emit($808c31c11c66dd58$var$SUBSCRIPTION_EMMITER_TYPES.ERROR, error);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                this._handleReconnect();
            }
        },
        {
            key: "_handleReconnect",
            value: function() {
                var _context5, _this6 = this; // if closed or currently reconnecting we stop attempting to reconnect
                if (this.state === $808c31c11c66dd58$var$CLIENT_STATE.DISCONNECTED) return;
                this.state = $808c31c11c66dd58$var$CLIENT_STATE.RECONNECTING;
                var time = $808c31c11c66dd58$var$generateInterval(this.attempts); // handle case when both close/error occur at frequent rates we ensure we do not reconnect unnecessarily.
                // we're unable to distinguish different between close/error when we're unable to reconnect therefore
                // we try to reconnect in both cases
                // server side ws and browser WebSocket behave differently in when close/error get triggered
                if (this.reconnectHandle) clearTimeout(this.reconnectHandle);
                this.reconnectHandle = (0, $808c31c11c66dd58$var$_setTimeout2.default)((0, $808c31c11c66dd58$var$_bind.default)(_context5 = function() {
                    _this6.attempts++;
                    _this6.connectPromise = (0, $9FsFR.resolvingPromise)();
                    _this6.open();
                }).call(_context5, this), time);
            }
        }
    ]);
    return LiveQueryClient;
}($808c31c11c66dd58$var$_EventEmitter2.default);
$808c31c11c66dd58$var$_CoreManager.default.setWebSocketController(typeof WebSocket === "function" || (typeof WebSocket === "undefined" ? "undefined" : (0, $808c31c11c66dd58$var$_typeof2.default)(WebSocket)) === "object" ? WebSocket : null);
var $808c31c11c66dd58$var$_default = $808c31c11c66dd58$var$LiveQueryClient;
module.exports.default = $808c31c11c66dd58$var$_default;

});
parcelRequire.register("h3iZF", function(module, exports) {

module.exports = (parcelRequire("gn22P"));

});

parcelRequire.register("34k5C", function(module, exports) {

module.exports = (parcelRequire("hNbrN"));

});
parcelRequire.register("hNbrN", function(module, exports) {
parcelRequire("jXhxH");

var $aHxiP = parcelRequire("aHxiP");

var $heVlo = parcelRequire("heVlo");

var $8hsAO = parcelRequire("8hsAO");

var $1dIem = parcelRequire("1dIem");
var $cf3fe47887d7907b$var$ArrayPrototype = Array.prototype;
var $cf3fe47887d7907b$var$DOMIterables = {
    DOMTokenList: true,
    NodeList: true
};
module.exports = function(it) {
    var own = it.values;
    return it === $cf3fe47887d7907b$var$ArrayPrototype || $8hsAO($cf3fe47887d7907b$var$ArrayPrototype, it) && own === $cf3fe47887d7907b$var$ArrayPrototype.values || $heVlo($cf3fe47887d7907b$var$DOMIterables, $aHxiP(it)) ? $1dIem : own;
};

});
parcelRequire.register("1dIem", function(module, exports) {

var $1UTMd = parcelRequire("1UTMd");
module.exports = $1UTMd;

});
parcelRequire.register("1UTMd", function(module, exports) {
parcelRequire("5xrGR");
parcelRequire("iYyco");

var $99rwM = parcelRequire("99rwM");
module.exports = $99rwM("Array").values;

});




parcelRequire.register("kuTrw", function(module, exports) {
"use strict";

var $iHLHC = parcelRequire("iHLHC");

var $4i3Tl = parcelRequire("4i3Tl");

var $oM1qX = parcelRequire("oM1qX");
$4i3Tl(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eec19dd1bc8a0491$var$_classCallCheck2 = $iHLHC((parcelRequire("B9w5B")));

var $eec19dd1bc8a0491$var$_createClass2 = $iHLHC((parcelRequire("HRw7E")));

var $eec19dd1bc8a0491$var$_inherits2 = $iHLHC((parcelRequire("cNDsY")));

var $eec19dd1bc8a0491$var$_possibleConstructorReturn2 = $iHLHC((parcelRequire("1C8Dw")));

var $eec19dd1bc8a0491$var$_getPrototypeOf2 = $iHLHC((parcelRequire("kptbe")));

var $eec19dd1bc8a0491$var$_EventEmitter2 = $iHLHC((parcelRequire("2GgHs")));

var $eec19dd1bc8a0491$var$_CoreManager = $iHLHC((parcelRequire("73D0B")));

var $9FsFR = parcelRequire("9FsFR");
function $eec19dd1bc8a0491$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $eec19dd1bc8a0491$var$_isNativeReflectConstruct();
    return function() {
        var Super = (0, $eec19dd1bc8a0491$var$_getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $eec19dd1bc8a0491$var$_getPrototypeOf2.default)(this).constructor;
            result = $oM1qX(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $eec19dd1bc8a0491$var$_possibleConstructorReturn2.default)(this, result);
    };
}
function $eec19dd1bc8a0491$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !$oM1qX) return false;
    if ($oM1qX.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call($oM1qX(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Creates a new LiveQuery Subscription.
 * Extends events.EventEmitter
 * <a href="https://nodejs.org/api/events.html#events_class_eventemitter">cloud functions</a>.
 *
 * <p>Response Object - Contains data from the client that made the request
 * <ul>
 * <li>clientId</li>
 * <li>installationId - requires Parse Server 4.0.0+</li>
 * </ul>
 * </p>
 *
 * <p>Open Event - When you call query.subscribe(), we send a subscribe request to
 * the LiveQuery server, when we get the confirmation from the LiveQuery server,
 * this event will be emitted. When the client loses WebSocket connection to the
 * LiveQuery server, we will try to auto reconnect the LiveQuery server. If we
 * reconnect the LiveQuery server and successfully resubscribe the ParseQuery,
 * you'll also get this event.
 *
 * <pre>
 * subscription.on('open', (response) => {
 *
 * });</pre></p>
 *
 * <p>Create Event - When a new ParseObject is created and it fulfills the ParseQuery you subscribe,
 * you'll get this event. The object is the ParseObject which is created.
 *
 * <pre>
 * subscription.on('create', (object, response) => {
 *
 * });</pre></p>
 *
 * <p>Update Event - When an existing ParseObject (original) which fulfills the ParseQuery you subscribe
 * is updated (The ParseObject fulfills the ParseQuery before and after changes),
 * you'll get this event. The object is the ParseObject which is updated.
 * Its content is the latest value of the ParseObject.
 *
 * Parse-Server 3.1.3+ Required for original object parameter
 *
 * <pre>
 * subscription.on('update', (object, original, response) => {
 *
 * });</pre></p>
 *
 * <p>Enter Event - When an existing ParseObject's (original) old value doesn't fulfill the ParseQuery
 * but its new value fulfills the ParseQuery, you'll get this event. The object is the
 * ParseObject which enters the ParseQuery. Its content is the latest value of the ParseObject.
 *
 * Parse-Server 3.1.3+ Required for original object parameter
 *
 * <pre>
 * subscription.on('enter', (object, original, response) => {
 *
 * });</pre></p>
 *
 *
 * <p>Update Event - When an existing ParseObject's old value fulfills the ParseQuery but its new value
 * doesn't fulfill the ParseQuery, you'll get this event. The object is the ParseObject
 * which leaves the ParseQuery. Its content is the latest value of the ParseObject.
 *
 * <pre>
 * subscription.on('leave', (object, response) => {
 *
 * });</pre></p>
 *
 *
 * <p>Delete Event - When an existing ParseObject which fulfills the ParseQuery is deleted, you'll
 * get this event. The object is the ParseObject which is deleted.
 *
 * <pre>
 * subscription.on('delete', (object, response) => {
 *
 * });</pre></p>
 *
 *
 * <p>Close Event - When the client loses the WebSocket connection to the LiveQuery
 * server and we stop receiving events, you'll get this event.
 *
 * <pre>
 * subscription.on('close', () => {
 *
 * });</pre></p>
 *
 * @alias Parse.LiveQuerySubscription
 */ var $eec19dd1bc8a0491$var$Subscription = /*#__PURE__*/ function(_EventEmitter) {
    (0, $eec19dd1bc8a0491$var$_inherits2.default)(Subscription, _EventEmitter);
    var _super = $eec19dd1bc8a0491$var$_createSuper(Subscription);
    /*
   * @param {string} id - subscription id
   * @param {string} query - query to subscribe to
   * @param {string} sessionToken - optional session token
   */ function Subscription(id, query, sessionToken) {
        var _this;
        (0, $eec19dd1bc8a0491$var$_classCallCheck2.default)(this, Subscription);
        _this = _super.call(this);
        _this.id = id;
        _this.query = query;
        _this.sessionToken = sessionToken;
        _this.subscribePromise = (0, $9FsFR.resolvingPromise)();
        _this.subscribed = false; // adding listener so process does not crash
        // best practice is for developer to register their own listener
        _this.on("error", function() {});
        return _this;
    }
    /**
   * Close the subscription
   *
   * @returns {Promise}
   */ (0, $eec19dd1bc8a0491$var$_createClass2.default)(Subscription, [
        {
            key: "unsubscribe",
            value: function() /*: Promise*/ {
                var _this2 = this;
                return $eec19dd1bc8a0491$var$_CoreManager.default.getLiveQueryController().getDefaultLiveQueryClient().then(function(liveQueryClient) {
                    liveQueryClient.unsubscribe(_this2);
                    _this2.emit("close");
                });
            }
        }
    ]);
    return Subscription;
}($eec19dd1bc8a0491$var$_EventEmitter2.default);
var $eec19dd1bc8a0491$var$_default = $eec19dd1bc8a0491$var$Subscription;
module.exports.default = $eec19dd1bc8a0491$var$_default;

});



parcelRequire.register("b4vvz", function(module, exports) {
"use strict";

var $e9nT0 = parcelRequire("e9nT0");

var $iU2mB = parcelRequire("iU2mB");
/**
 * @flow
 */ /* global window */ if (typeof window !== "undefined" && window.indexedDB) {
    var $80f8824c7b0efbe1$var$ParseStore = (0, $iU2mB.createStore)("parseDB", "parseStore");
    var $80f8824c7b0efbe1$var$IndexedDBStorageController = {
        async: 1,
        getItemAsync: function(path) {
            return (0, $iU2mB.get)(path, $80f8824c7b0efbe1$var$ParseStore);
        },
        setItemAsync: function(path, value) {
            return (0, $iU2mB.set)(path, value, $80f8824c7b0efbe1$var$ParseStore);
        },
        removeItemAsync: function(path) {
            return (0, $iU2mB.del)(path, $80f8824c7b0efbe1$var$ParseStore);
        },
        getAllKeysAsync: function() {
            return $e9nT0($iU2mB)($80f8824c7b0efbe1$var$ParseStore);
        },
        clear: function() {
            return (0, $iU2mB.clear)($80f8824c7b0efbe1$var$ParseStore);
        }
    };
    module.exports = $80f8824c7b0efbe1$var$IndexedDBStorageController;
} else // IndexedDB not supported
module.exports = undefined;

});
parcelRequire.register("iU2mB", function(module, exports) {

$parcel$export(module.exports, "promisifyRequest", function () { return $dc2f4a51b83babfd$export$b327150396135fe7; });
$parcel$export(module.exports, "createStore", function () { return $dc2f4a51b83babfd$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "get", function () { return $dc2f4a51b83babfd$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $dc2f4a51b83babfd$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "setMany", function () { return $dc2f4a51b83babfd$export$daa0a5170277c7a8; });
$parcel$export(module.exports, "getMany", function () { return $dc2f4a51b83babfd$export$5df405cccea42673; });
$parcel$export(module.exports, "update", function () { return $dc2f4a51b83babfd$export$722fbec263ad908a; });
$parcel$export(module.exports, "del", function () { return $dc2f4a51b83babfd$export$1d2f21e549771e67; });
$parcel$export(module.exports, "delMany", function () { return $dc2f4a51b83babfd$export$c8aa84257229cac8; });
$parcel$export(module.exports, "clear", function () { return $dc2f4a51b83babfd$export$42ffd38884aecdac; });
$parcel$export(module.exports, "keys", function () { return $dc2f4a51b83babfd$export$ed97f33186d4b816; });
$parcel$export(module.exports, "values", function () { return $dc2f4a51b83babfd$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "entries", function () { return $dc2f4a51b83babfd$export$3e9f948b41964866; });

var $4lSFI = parcelRequire("4lSFI");
function $dc2f4a51b83babfd$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $dc2f4a51b83babfd$export$f51a9068ac82ea43(dbName, storeName) {
    var dbp = (0, $4lSFI.default)().then(function() {
        var request = indexedDB.open(dbName);
        request.onupgradeneeded = function() {
            return request.result.createObjectStore(storeName);
        };
        return $dc2f4a51b83babfd$export$b327150396135fe7(request);
    });
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $dc2f4a51b83babfd$var$defaultGetStoreFunc;
function $dc2f4a51b83babfd$var$defaultGetStore() {
    if (!$dc2f4a51b83babfd$var$defaultGetStoreFunc) $dc2f4a51b83babfd$var$defaultGetStoreFunc = $dc2f4a51b83babfd$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $dc2f4a51b83babfd$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $dc2f4a51b83babfd$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($dc2f4a51b83babfd$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
function $dc2f4a51b83babfd$var$eachCursor(customStore, callback) {
    return customStore("readonly", function(store) {
        // This would be store.getAllKeys(), but it isn't supported by Edge or Safari.
        // And openKeyCursor isn't supported by Safari.
        store.openCursor().onsuccess = function() {
            if (!this.result) return;
            callback(this.result);
            this.result.continue();
        };
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    var items = [];
    return $dc2f4a51b83babfd$var$eachCursor(customStore, function(cursor) {
        return items.push(cursor.key);
    }).then(function() {
        return items;
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    var items = [];
    return $dc2f4a51b83babfd$var$eachCursor(customStore, function(cursor) {
        return items.push(cursor.value);
    }).then(function() {
        return items;
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    var items = [];
    return $dc2f4a51b83babfd$var$eachCursor(customStore, function(cursor) {
        return items.push([
            cursor.key,
            cursor.value
        ]);
    }).then(function() {
        return items;
    });
}

});
parcelRequire.register("4lSFI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32b38843ac10bba4$export$2e2bcd8739ae039; });
/**
 * Work around Safari 14 IndexedDB open bug.
 *
 * Safari has a horrible bug where IDB requests can hang while the browser is starting up. https://bugs.webkit.org/show_bug.cgi?id=226547
 * The only solution is to keep nudging it until it's awake.
 */ function $32b38843ac10bba4$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    // No point putting other browsers or older versions of Safari through this mess.
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
var $32b38843ac10bba4$export$2e2bcd8739ae039 = $32b38843ac10bba4$var$idbReady;

});






//# sourceMappingURL=youshouldnotbehere.f0aefe0e.js.map
